;(function() {
      function Bb(i) {
        return i &&
          i.__esModule &&
          Object.prototype.hasOwnProperty.call(i, 'default')
          ? i.default
          : i;
      }
      var uc = { exports: {} },
        ol = {};
      /**
       * @license React
       * react-jsx-runtime.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var $h;
      function Rb() {
        if ($h) return ol;
        $h = 1;
        var i = Symbol.for('react.transitional.element'),
          l = Symbol.for('react.fragment');
        function s(r, c, u) {
          var h = null;
          if (
            (u !== void 0 && (h = '' + u),
            c.key !== void 0 && (h = '' + c.key),
            'key' in c)
          ) {
            u = {};
            for (var m in c) m !== 'key' && (u[m] = c[m]);
          } else u = c;
          return (
            (c = u.ref),
            {
              $$typeof: i,
              type: r,
              key: h,
              ref: c !== void 0 ? c : null,
              props: u,
            }
          );
        }
        return ((ol.Fragment = l), (ol.jsx = s), (ol.jsxs = s), ol);
      }
      var qh;
      function Db() {
        return (qh || ((qh = 1), (uc.exports = Rb())), uc.exports);
      }
      var g = Db(),
        dc = { exports: {} },
        he = {};
      /**
       * @license React
       * react.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Ph;
      function Lb() {
        if (Ph) return he;
        Ph = 1;
        var i = Symbol.for('react.transitional.element'),
          l = Symbol.for('react.portal'),
          s = Symbol.for('react.fragment'),
          r = Symbol.for('react.strict_mode'),
          c = Symbol.for('react.profiler'),
          u = Symbol.for('react.consumer'),
          h = Symbol.for('react.context'),
          m = Symbol.for('react.forward_ref'),
          f = Symbol.for('react.suspense'),
          p = Symbol.for('react.memo'),
          y = Symbol.for('react.lazy'),
          S = Symbol.iterator;
        function w(N) {
          return N === null || typeof N != 'object'
            ? null
            : ((N = (S && N[S]) || N['@@iterator']),
              typeof N == 'function' ? N : null);
        }
        var x = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          T = Object.assign,
          A = {};
        function j(N, I, ee) {
          ((this.props = N),
            (this.context = I),
            (this.refs = A),
            (this.updater = ee || x));
        }
        ((j.prototype.isReactComponent = {}),
          (j.prototype.setState = function (N, I) {
            if (typeof N != 'object' && typeof N != 'function' && N != null)
              throw Error(
                'takes an object of state variables to update or a function which returns an object of state variables.'
              );
            this.updater.enqueueSetState(this, N, I, 'setState');
          }),
          (j.prototype.forceUpdate = function (N) {
            this.updater.enqueueForceUpdate(this, N, 'forceUpdate');
          }));
        function G() {}
        G.prototype = j.prototype;
        function L(N, I, ee) {
          ((this.props = N),
            (this.context = I),
            (this.refs = A),
            (this.updater = ee || x));
        }
        var H = (L.prototype = new G());
        ((H.constructor = L), T(H, j.prototype), (H.isPureReactComponent = !0));
        var $ = Array.isArray,
          D = { H: null, A: null, T: null, S: null, V: null },
          U = Object.prototype.hasOwnProperty;
        function X(N, I, ee, J, le, Te) {
          return (
            (ee = Te.ref),
            {
              $$typeof: i,
              type: N,
              key: I,
              ref: ee !== void 0 ? ee : null,
              props: Te,
            }
          );
        }
        function q(N, I) {
          return X(N.type, I, void 0, void 0, void 0, N.props);
        }
        function se(N) {
          return typeof N == 'object' && N !== null && N.$$typeof === i;
        }
        function F(N) {
          var I = { '=': '=0', ':': '=2' };
          return (
            '$' +
            N.replace(/[=:]/g, function (ee) {
              return I[ee];
            })
          );
        }
        var W = /\/+/g;
        function ae(N, I) {
          return typeof N == 'object' && N !== null && N.key != null
            ? F('' + N.key)
            : I.toString(36);
        }
        function ye() {}
        function Se(N) {
          switch (N.status) {
            case 'fulfilled':
              return N.value;
            case 'rejected':
              throw N.reason;
            default:
              switch (
                (typeof N.status == 'string'
                  ? N.then(ye, ye)
                  : ((N.status = 'pending'),
                    N.then(
                      function (I) {
                        N.status === 'pending' &&
                          ((N.status = 'fulfilled'), (N.value = I));
                      },
                      function (I) {
                        N.status === 'pending' &&
                          ((N.status = 'rejected'), (N.reason = I));
                      }
                    )),
                N.status)
              ) {
                case 'fulfilled':
                  return N.value;
                case 'rejected':
                  throw N.reason;
              }
          }
          throw N;
        }
        function Ne(N, I, ee, J, le) {
          var Te = typeof N;
          (Te === 'undefined' || Te === 'boolean') && (N = null);
          var fe = !1;
          if (N === null) fe = !0;
          else
            switch (Te) {
              case 'bigint':
              case 'string':
              case 'number':
                fe = !0;
                break;
              case 'object':
                switch (N.$$typeof) {
                  case i:
                  case l:
                    fe = !0;
                    break;
                  case y:
                    return ((fe = N._init), Ne(fe(N._payload), I, ee, J, le));
                }
            }
          if (fe)
            return (
              (le = le(N)),
              (fe = J === '' ? '.' + ae(N, 0) : J),
              $(le)
                ? ((ee = ''),
                  fe != null && (ee = fe.replace(W, '$&/') + '/'),
                  Ne(le, I, ee, '', function (wa) {
                    return wa;
                  }))
                : le != null &&
                  (se(le) &&
                    (le = q(
                      le,
                      ee +
                        (le.key == null || (N && N.key === le.key)
                          ? ''
                          : ('' + le.key).replace(W, '$&/') + '/') +
                        fe
                    )),
                  I.push(le)),
              1
            );
          fe = 0;
          var Tt = J === '' ? '.' : J + ':';
          if ($(N))
            for (var De = 0; De < N.length; De++)
              ((J = N[De]),
                (Te = Tt + ae(J, De)),
                (fe += Ne(J, I, ee, Te, le)));
          else if (((De = w(N)), typeof De == 'function'))
            for (N = De.call(N), De = 0; !(J = N.next()).done; )
              ((J = J.value),
                (Te = Tt + ae(J, De++)),
                (fe += Ne(J, I, ee, Te, le)));
          else if (Te === 'object') {
            if (typeof N.then == 'function') return Ne(Se(N), I, ee, J, le);
            throw (
              (I = String(N)),
              Error(
                'Objects are not valid as a React child (found: ' +
                  (I === '[object Object]'
                    ? 'object with keys {' + Object.keys(N).join(', ') + '}'
                    : I) +
                  '). If you meant to render a collection of children, use an array instead.'
              )
            );
          }
          return fe;
        }
        function z(N, I, ee) {
          if (N == null) return N;
          var J = [],
            le = 0;
          return (
            Ne(N, J, '', '', function (Te) {
              return I.call(ee, Te, le++);
            }),
            J
          );
        }
        function Q(N) {
          if (N._status === -1) {
            var I = N._result;
            ((I = I()),
              I.then(
                function (ee) {
                  (N._status === 0 || N._status === -1) &&
                    ((N._status = 1), (N._result = ee));
                },
                function (ee) {
                  (N._status === 0 || N._status === -1) &&
                    ((N._status = 2), (N._result = ee));
                }
              ),
              N._status === -1 && ((N._status = 0), (N._result = I)));
          }
          if (N._status === 1) return N._result.default;
          throw N._result;
        }
        var K =
          typeof reportError == 'function'
            ? reportError
            : function (N) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var I = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof N == 'object' &&
                      N !== null &&
                      typeof N.message == 'string'
                        ? String(N.message)
                        : String(N),
                    error: N,
                  });
                  if (!window.dispatchEvent(I)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', N);
                  return;
                }
                console.error(N);
              };
        function ie() {}
        return (
          (he.Children = {
            map: z,
            forEach: function (N, I, ee) {
              z(
                N,
                function () {
                  I.apply(this, arguments);
                },
                ee
              );
            },
            count: function (N) {
              var I = 0;
              return (
                z(N, function () {
                  I++;
                }),
                I
              );
            },
            toArray: function (N) {
              return (
                z(N, function (I) {
                  return I;
                }) || []
              );
            },
            only: function (N) {
              if (!se(N))
                throw Error(
                  'React.Children.only expected to receive a single React element child.'
                );
              return N;
            },
          }),
          (he.Component = j),
          (he.Fragment = s),
          (he.Profiler = c),
          (he.PureComponent = L),
          (he.StrictMode = r),
          (he.Suspense = f),
          (he.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            D),
          (he.__COMPILER_RUNTIME = {
            __proto__: null,
            c: function (N) {
              return D.H.useMemoCache(N);
            },
          }),
          (he.cache = function (N) {
            return function () {
              return N.apply(null, arguments);
            };
          }),
          (he.cloneElement = function (N, I, ee) {
            if (N == null)
              throw Error(
                'The argument must be a React element, but you passed ' +
                  N +
                  '.'
              );
            var J = T({}, N.props),
              le = N.key,
              Te = void 0;
            if (I != null)
              for (fe in (I.ref !== void 0 && (Te = void 0),
              I.key !== void 0 && (le = '' + I.key),
              I))
                !U.call(I, fe) ||
                  fe === 'key' ||
                  fe === '__self' ||
                  fe === '__source' ||
                  (fe === 'ref' && I.ref === void 0) ||
                  (J[fe] = I[fe]);
            var fe = arguments.length - 2;
            if (fe === 1) J.children = ee;
            else if (1 < fe) {
              for (var Tt = Array(fe), De = 0; De < fe; De++)
                Tt[De] = arguments[De + 2];
              J.children = Tt;
            }
            return X(N.type, le, void 0, void 0, Te, J);
          }),
          (he.createContext = function (N) {
            return (
              (N = {
                $$typeof: h,
                _currentValue: N,
                _currentValue2: N,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }),
              (N.Provider = N),
              (N.Consumer = { $$typeof: u, _context: N }),
              N
            );
          }),
          (he.createElement = function (N, I, ee) {
            var J,
              le = {},
              Te = null;
            if (I != null)
              for (J in (I.key !== void 0 && (Te = '' + I.key), I))
                U.call(I, J) &&
                  J !== 'key' &&
                  J !== '__self' &&
                  J !== '__source' &&
                  (le[J] = I[J]);
            var fe = arguments.length - 2;
            if (fe === 1) le.children = ee;
            else if (1 < fe) {
              for (var Tt = Array(fe), De = 0; De < fe; De++)
                Tt[De] = arguments[De + 2];
              le.children = Tt;
            }
            if (N && N.defaultProps)
              for (J in ((fe = N.defaultProps), fe))
                le[J] === void 0 && (le[J] = fe[J]);
            return X(N, Te, void 0, void 0, null, le);
          }),
          (he.createRef = function () {
            return { current: null };
          }),
          (he.forwardRef = function (N) {
            return { $$typeof: m, render: N };
          }),
          (he.isValidElement = se),
          (he.lazy = function (N) {
            return {
              $$typeof: y,
              _payload: { _status: -1, _result: N },
              _init: Q,
            };
          }),
          (he.memo = function (N, I) {
            return { $$typeof: p, type: N, compare: I === void 0 ? null : I };
          }),
          (he.startTransition = function (N) {
            var I = D.T,
              ee = {};
            D.T = ee;
            try {
              var J = N(),
                le = D.S;
              (le !== null && le(ee, J),
                typeof J == 'object' &&
                  J !== null &&
                  typeof J.then == 'function' &&
                  J.then(ie, K));
            } catch (Te) {
              K(Te);
            } finally {
              D.T = I;
            }
          }),
          (he.unstable_useCacheRefresh = function () {
            return D.H.useCacheRefresh();
          }),
          (he.use = function (N) {
            return D.H.use(N);
          }),
          (he.useActionState = function (N, I, ee) {
            return D.H.useActionState(N, I, ee);
          }),
          (he.useCallback = function (N, I) {
            return D.H.useCallback(N, I);
          }),
          (he.useContext = function (N) {
            return D.H.useContext(N);
          }),
          (he.useDebugValue = function () {}),
          (he.useDeferredValue = function (N, I) {
            return D.H.useDeferredValue(N, I);
          }),
          (he.useEffect = function (N, I, ee) {
            var J = D.H;
            if (typeof ee == 'function')
              throw Error(
                'useEffect CRUD overload is not enabled in this build of React.'
              );
            return J.useEffect(N, I);
          }),
          (he.useId = function () {
            return D.H.useId();
          }),
          (he.useImperativeHandle = function (N, I, ee) {
            return D.H.useImperativeHandle(N, I, ee);
          }),
          (he.useInsertionEffect = function (N, I) {
            return D.H.useInsertionEffect(N, I);
          }),
          (he.useLayoutEffect = function (N, I) {
            return D.H.useLayoutEffect(N, I);
          }),
          (he.useMemo = function (N, I) {
            return D.H.useMemo(N, I);
          }),
          (he.useOptimistic = function (N, I) {
            return D.H.useOptimistic(N, I);
          }),
          (he.useReducer = function (N, I, ee) {
            return D.H.useReducer(N, I, ee);
          }),
          (he.useRef = function (N) {
            return D.H.useRef(N);
          }),
          (he.useState = function (N) {
            return D.H.useState(N);
          }),
          (he.useSyncExternalStore = function (N, I, ee) {
            return D.H.useSyncExternalStore(N, I, ee);
          }),
          (he.useTransition = function () {
            return D.H.useTransition();
          }),
          (he.version = '19.1.1'),
          he
        );
      }
      var Yh;
      function Uc() {
        return (Yh || ((Yh = 1), (dc.exports = Lb())), dc.exports);
      }
      var Y = Uc();
      const Fe = Bb(Y);
      var fc = { exports: {} },
        cl = {},
        hc = { exports: {} },
        mc = {};
      /**
       * @license React
       * scheduler.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Kh;
      function zb() {
        return (
          Kh ||
            ((Kh = 1),
            (function (i) {
              function l(z, Q) {
                var K = z.length;
                z.push(Q);
                e: for (; 0 < K; ) {
                  var ie = (K - 1) >>> 1,
                    N = z[ie];
                  if (0 < c(N, Q)) ((z[ie] = Q), (z[K] = N), (K = ie));
                  else break e;
                }
              }
              function s(z) {
                return z.length === 0 ? null : z[0];
              }
              function r(z) {
                if (z.length === 0) return null;
                var Q = z[0],
                  K = z.pop();
                if (K !== Q) {
                  z[0] = K;
                  e: for (var ie = 0, N = z.length, I = N >>> 1; ie < I; ) {
                    var ee = 2 * (ie + 1) - 1,
                      J = z[ee],
                      le = ee + 1,
                      Te = z[le];
                    if (0 > c(J, K))
                      le < N && 0 > c(Te, J)
                        ? ((z[ie] = Te), (z[le] = K), (ie = le))
                        : ((z[ie] = J), (z[ee] = K), (ie = ee));
                    else if (le < N && 0 > c(Te, K))
                      ((z[ie] = Te), (z[le] = K), (ie = le));
                    else break e;
                  }
                }
                return Q;
              }
              function c(z, Q) {
                var K = z.sortIndex - Q.sortIndex;
                return K !== 0 ? K : z.id - Q.id;
              }
              if (
                ((i.unstable_now = void 0),
                typeof performance == 'object' &&
                  typeof performance.now == 'function')
              ) {
                var u = performance;
                i.unstable_now = function () {
                  return u.now();
                };
              } else {
                var h = Date,
                  m = h.now();
                i.unstable_now = function () {
                  return h.now() - m;
                };
              }
              var f = [],
                p = [],
                y = 1,
                S = null,
                w = 3,
                x = !1,
                T = !1,
                A = !1,
                j = !1,
                G = typeof setTimeout == 'function' ? setTimeout : null,
                L = typeof clearTimeout == 'function' ? clearTimeout : null,
                H = typeof setImmediate < 'u' ? setImmediate : null;
              function $(z) {
                for (var Q = s(p); Q !== null; ) {
                  if (Q.callback === null) r(p);
                  else if (Q.startTime <= z)
                    (r(p), (Q.sortIndex = Q.expirationTime), l(f, Q));
                  else break;
                  Q = s(p);
                }
              }
              function D(z) {
                if (((A = !1), $(z), !T))
                  if (s(f) !== null) ((T = !0), U || ((U = !0), ae()));
                  else {
                    var Q = s(p);
                    Q !== null && Ne(D, Q.startTime - z);
                  }
              }
              var U = !1,
                X = -1,
                q = 5,
                se = -1;
              function F() {
                return j ? !0 : !(i.unstable_now() - se < q);
              }
              function W() {
                if (((j = !1), U)) {
                  var z = i.unstable_now();
                  se = z;
                  var Q = !0;
                  try {
                    e: {
                      ((T = !1), A && ((A = !1), L(X), (X = -1)), (x = !0));
                      var K = w;
                      try {
                        t: {
                          for (
                            $(z), S = s(f);
                            S !== null && !(S.expirationTime > z && F());
                          ) {
                            var ie = S.callback;
                            if (typeof ie == 'function') {
                              ((S.callback = null), (w = S.priorityLevel));
                              var N = ie(S.expirationTime <= z);
                              if (
                                ((z = i.unstable_now()), typeof N == 'function')
                              ) {
                                ((S.callback = N), $(z), (Q = !0));
                                break t;
                              }
                              (S === s(f) && r(f), $(z));
                            } else r(f);
                            S = s(f);
                          }
                          if (S !== null) Q = !0;
                          else {
                            var I = s(p);
                            (I !== null && Ne(D, I.startTime - z), (Q = !1));
                          }
                        }
                        break e;
                      } finally {
                        ((S = null), (w = K), (x = !1));
                      }
                      Q = void 0;
                    }
                  } finally {
                    Q ? ae() : (U = !1);
                  }
                }
              }
              var ae;
              if (typeof H == 'function')
                ae = function () {
                  H(W);
                };
              else if (typeof MessageChannel < 'u') {
                var ye = new MessageChannel(),
                  Se = ye.port2;
                ((ye.port1.onmessage = W),
                  (ae = function () {
                    Se.postMessage(null);
                  }));
              } else
                ae = function () {
                  G(W, 0);
                };
              function Ne(z, Q) {
                X = G(function () {
                  z(i.unstable_now());
                }, Q);
              }
              ((i.unstable_IdlePriority = 5),
                (i.unstable_ImmediatePriority = 1),
                (i.unstable_LowPriority = 4),
                (i.unstable_NormalPriority = 3),
                (i.unstable_Profiling = null),
                (i.unstable_UserBlockingPriority = 2),
                (i.unstable_cancelCallback = function (z) {
                  z.callback = null;
                }),
                (i.unstable_forceFrameRate = function (z) {
                  0 > z || 125 < z
                    ? console.error(
                        'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                      )
                    : (q = 0 < z ? Math.floor(1e3 / z) : 5);
                }),
                (i.unstable_getCurrentPriorityLevel = function () {
                  return w;
                }),
                (i.unstable_next = function (z) {
                  switch (w) {
                    case 1:
                    case 2:
                    case 3:
                      var Q = 3;
                      break;
                    default:
                      Q = w;
                  }
                  var K = w;
                  w = Q;
                  try {
                    return z();
                  } finally {
                    w = K;
                  }
                }),
                (i.unstable_requestPaint = function () {
                  j = !0;
                }),
                (i.unstable_runWithPriority = function (z, Q) {
                  switch (z) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                      break;
                    default:
                      z = 3;
                  }
                  var K = w;
                  w = z;
                  try {
                    return Q();
                  } finally {
                    w = K;
                  }
                }),
                (i.unstable_scheduleCallback = function (z, Q, K) {
                  var ie = i.unstable_now();
                  switch (
                    (typeof K == 'object' && K !== null
                      ? ((K = K.delay),
                        (K = typeof K == 'number' && 0 < K ? ie + K : ie))
                      : (K = ie),
                    z)
                  ) {
                    case 1:
                      var N = -1;
                      break;
                    case 2:
                      N = 250;
                      break;
                    case 5:
                      N = 1073741823;
                      break;
                    case 4:
                      N = 1e4;
                      break;
                    default:
                      N = 5e3;
                  }
                  return (
                    (N = K + N),
                    (z = {
                      id: y++,
                      callback: Q,
                      priorityLevel: z,
                      startTime: K,
                      expirationTime: N,
                      sortIndex: -1,
                    }),
                    K > ie
                      ? ((z.sortIndex = K),
                        l(p, z),
                        s(f) === null &&
                          z === s(p) &&
                          (A ? (L(X), (X = -1)) : (A = !0), Ne(D, K - ie)))
                      : ((z.sortIndex = N),
                        l(f, z),
                        T || x || ((T = !0), U || ((U = !0), ae()))),
                    z
                  );
                }),
                (i.unstable_shouldYield = F),
                (i.unstable_wrapCallback = function (z) {
                  var Q = w;
                  return function () {
                    var K = w;
                    w = Q;
                    try {
                      return z.apply(this, arguments);
                    } finally {
                      w = K;
                    }
                  };
                }));
            })(mc)),
          mc
        );
      }
      var Xh;
      function Hb() {
        return (Xh || ((Xh = 1), (hc.exports = zb())), hc.exports);
      }
      var pc = { exports: {} },
        ct = {};
      /**
       * @license React
       * react-dom.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Qh;
      function Ub() {
        if (Qh) return ct;
        Qh = 1;
        var i = Uc();
        function l(f) {
          var p = 'https://react.dev/errors/' + f;
          if (1 < arguments.length) {
            p += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var y = 2; y < arguments.length; y++)
              p += '&args[]=' + encodeURIComponent(arguments[y]);
          }
          return (
            'Minified React error #' +
            f +
            '; visit ' +
            p +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function s() {}
        var r = {
            d: {
              f: s,
              r: function () {
                throw Error(l(522));
              },
              D: s,
              C: s,
              L: s,
              m: s,
              X: s,
              S: s,
              M: s,
            },
            p: 0,
            findDOMNode: null,
          },
          c = Symbol.for('react.portal');
        function u(f, p, y) {
          var S =
            3 < arguments.length && arguments[3] !== void 0
              ? arguments[3]
              : null;
          return {
            $$typeof: c,
            key: S == null ? null : '' + S,
            children: f,
            containerInfo: p,
            implementation: y,
          };
        }
        var h =
          i.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function m(f, p) {
          if (f === 'font') return '';
          if (typeof p == 'string') return p === 'use-credentials' ? p : '';
        }
        return (
          (ct.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r),
          (ct.createPortal = function (f, p) {
            var y =
              2 < arguments.length && arguments[2] !== void 0
                ? arguments[2]
                : null;
            if (
              !p ||
              (p.nodeType !== 1 && p.nodeType !== 9 && p.nodeType !== 11)
            )
              throw Error(l(299));
            return u(f, p, null, y);
          }),
          (ct.flushSync = function (f) {
            var p = h.T,
              y = r.p;
            try {
              if (((h.T = null), (r.p = 2), f)) return f();
            } finally {
              ((h.T = p), (r.p = y), r.d.f());
            }
          }),
          (ct.preconnect = function (f, p) {
            typeof f == 'string' &&
              (p
                ? ((p = p.crossOrigin),
                  (p =
                    typeof p == 'string'
                      ? p === 'use-credentials'
                        ? p
                        : ''
                      : void 0))
                : (p = null),
              r.d.C(f, p));
          }),
          (ct.prefetchDNS = function (f) {
            typeof f == 'string' && r.d.D(f);
          }),
          (ct.preinit = function (f, p) {
            if (typeof f == 'string' && p && typeof p.as == 'string') {
              var y = p.as,
                S = m(y, p.crossOrigin),
                w = typeof p.integrity == 'string' ? p.integrity : void 0,
                x =
                  typeof p.fetchPriority == 'string' ? p.fetchPriority : void 0;
              y === 'style'
                ? r.d.S(
                    f,
                    typeof p.precedence == 'string' ? p.precedence : void 0,
                    { crossOrigin: S, integrity: w, fetchPriority: x }
                  )
                : y === 'script' &&
                  r.d.X(f, {
                    crossOrigin: S,
                    integrity: w,
                    fetchPriority: x,
                    nonce: typeof p.nonce == 'string' ? p.nonce : void 0,
                  });
            }
          }),
          (ct.preinitModule = function (f, p) {
            if (typeof f == 'string')
              if (typeof p == 'object' && p !== null) {
                if (p.as == null || p.as === 'script') {
                  var y = m(p.as, p.crossOrigin);
                  r.d.M(f, {
                    crossOrigin: y,
                    integrity:
                      typeof p.integrity == 'string' ? p.integrity : void 0,
                    nonce: typeof p.nonce == 'string' ? p.nonce : void 0,
                  });
                }
              } else p == null && r.d.M(f);
          }),
          (ct.preload = function (f, p) {
            if (
              typeof f == 'string' &&
              typeof p == 'object' &&
              p !== null &&
              typeof p.as == 'string'
            ) {
              var y = p.as,
                S = m(y, p.crossOrigin);
              r.d.L(f, y, {
                crossOrigin: S,
                integrity:
                  typeof p.integrity == 'string' ? p.integrity : void 0,
                nonce: typeof p.nonce == 'string' ? p.nonce : void 0,
                type: typeof p.type == 'string' ? p.type : void 0,
                fetchPriority:
                  typeof p.fetchPriority == 'string' ? p.fetchPriority : void 0,
                referrerPolicy:
                  typeof p.referrerPolicy == 'string'
                    ? p.referrerPolicy
                    : void 0,
                imageSrcSet:
                  typeof p.imageSrcSet == 'string' ? p.imageSrcSet : void 0,
                imageSizes:
                  typeof p.imageSizes == 'string' ? p.imageSizes : void 0,
                media: typeof p.media == 'string' ? p.media : void 0,
              });
            }
          }),
          (ct.preloadModule = function (f, p) {
            if (typeof f == 'string')
              if (p) {
                var y = m(p.as, p.crossOrigin);
                r.d.m(f, {
                  as:
                    typeof p.as == 'string' && p.as !== 'script'
                      ? p.as
                      : void 0,
                  crossOrigin: y,
                  integrity:
                    typeof p.integrity == 'string' ? p.integrity : void 0,
                });
              } else r.d.m(f);
          }),
          (ct.requestFormReset = function (f) {
            r.d.r(f);
          }),
          (ct.unstable_batchedUpdates = function (f, p) {
            return f(p);
          }),
          (ct.useFormState = function (f, p, y) {
            return h.H.useFormState(f, p, y);
          }),
          (ct.useFormStatus = function () {
            return h.H.useHostTransitionStatus();
          }),
          (ct.version = '19.1.1'),
          ct
        );
      }
      var Zh;
      function Rm() {
        if (Zh) return pc.exports;
        Zh = 1;
        function i() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(i);
            } catch (l) {
              console.error(l);
            }
        }
        return (i(), (pc.exports = Ub()), pc.exports);
      }
      /**
       * @license React
       * react-dom-client.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Wh;
      function Ib() {
        if (Wh) return cl;
        Wh = 1;
        var i = Hb(),
          l = Uc(),
          s = Rm();
        function r(e) {
          var t = 'https://react.dev/errors/' + e;
          if (1 < arguments.length) {
            t += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var a = 2; a < arguments.length; a++)
              t += '&args[]=' + encodeURIComponent(arguments[a]);
          }
          return (
            'Minified React error #' +
            e +
            '; visit ' +
            t +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function c(e) {
          return !(
            !e ||
            (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
          );
        }
        function u(e) {
          var t = e,
            a = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do
              ((t = e),
                (t.flags & 4098) !== 0 && (a = t.return),
                (e = t.return));
            while (e);
          }
          return t.tag === 3 ? a : null;
        }
        function h(e) {
          if (e.tag === 13) {
            var t = e.memoizedState;
            if (
              (t === null &&
                ((e = e.alternate), e !== null && (t = e.memoizedState)),
              t !== null)
            )
              return t.dehydrated;
          }
          return null;
        }
        function m(e) {
          if (u(e) !== e) throw Error(r(188));
        }
        function f(e) {
          var t = e.alternate;
          if (!t) {
            if (((t = u(e)), t === null)) throw Error(r(188));
            return t !== e ? null : e;
          }
          for (var a = e, n = t; ; ) {
            var o = a.return;
            if (o === null) break;
            var d = o.alternate;
            if (d === null) {
              if (((n = o.return), n !== null)) {
                a = n;
                continue;
              }
              break;
            }
            if (o.child === d.child) {
              for (d = o.child; d; ) {
                if (d === a) return (m(o), e);
                if (d === n) return (m(o), t);
                d = d.sibling;
              }
              throw Error(r(188));
            }
            if (a.return !== n.return) ((a = o), (n = d));
            else {
              for (var b = !1, v = o.child; v; ) {
                if (v === a) {
                  ((b = !0), (a = o), (n = d));
                  break;
                }
                if (v === n) {
                  ((b = !0), (n = o), (a = d));
                  break;
                }
                v = v.sibling;
              }
              if (!b) {
                for (v = d.child; v; ) {
                  if (v === a) {
                    ((b = !0), (a = d), (n = o));
                    break;
                  }
                  if (v === n) {
                    ((b = !0), (n = d), (a = o));
                    break;
                  }
                  v = v.sibling;
                }
                if (!b) throw Error(r(189));
              }
            }
            if (a.alternate !== n) throw Error(r(190));
          }
          if (a.tag !== 3) throw Error(r(188));
          return a.stateNode.current === a ? e : t;
        }
        function p(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e;
          for (e = e.child; e !== null; ) {
            if (((t = p(e)), t !== null)) return t;
            e = e.sibling;
          }
          return null;
        }
        var y = Object.assign,
          S = Symbol.for('react.element'),
          w = Symbol.for('react.transitional.element'),
          x = Symbol.for('react.portal'),
          T = Symbol.for('react.fragment'),
          A = Symbol.for('react.strict_mode'),
          j = Symbol.for('react.profiler'),
          G = Symbol.for('react.provider'),
          L = Symbol.for('react.consumer'),
          H = Symbol.for('react.context'),
          $ = Symbol.for('react.forward_ref'),
          D = Symbol.for('react.suspense'),
          U = Symbol.for('react.suspense_list'),
          X = Symbol.for('react.memo'),
          q = Symbol.for('react.lazy'),
          se = Symbol.for('react.activity'),
          F = Symbol.for('react.memo_cache_sentinel'),
          W = Symbol.iterator;
        function ae(e) {
          return e === null || typeof e != 'object'
            ? null
            : ((e = (W && e[W]) || e['@@iterator']),
              typeof e == 'function' ? e : null);
        }
        var ye = Symbol.for('react.client.reference');
        function Se(e) {
          if (e == null) return null;
          if (typeof e == 'function')
            return e.$$typeof === ye ? null : e.displayName || e.name || null;
          if (typeof e == 'string') return e;
          switch (e) {
            case T:
              return 'Fragment';
            case j:
              return 'Profiler';
            case A:
              return 'StrictMode';
            case D:
              return 'Suspense';
            case U:
              return 'SuspenseList';
            case se:
              return 'Activity';
          }
          if (typeof e == 'object')
            switch (e.$$typeof) {
              case x:
                return 'Portal';
              case H:
                return (e.displayName || 'Context') + '.Provider';
              case L:
                return (e._context.displayName || 'Context') + '.Consumer';
              case $:
                var t = e.render;
                return (
                  (e = e.displayName),
                  e ||
                    ((e = t.displayName || t.name || ''),
                    (e = e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
                  e
                );
              case X:
                return (
                  (t = e.displayName || null),
                  t !== null ? t : Se(e.type) || 'Memo'
                );
              case q:
                ((t = e._payload), (e = e._init));
                try {
                  return Se(e(t));
                } catch {}
            }
          return null;
        }
        var Ne = Array.isArray,
          z = l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          Q = s.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          K = { pending: !1, data: null, method: null, action: null },
          ie = [],
          N = -1;
        function I(e) {
          return { current: e };
        }
        function ee(e) {
          0 > N || ((e.current = ie[N]), (ie[N] = null), N--);
        }
        function J(e, t) {
          (N++, (ie[N] = e.current), (e.current = t));
        }
        var le = I(null),
          Te = I(null),
          fe = I(null),
          Tt = I(null);
        function De(e, t) {
          switch ((J(fe, t), J(Te, e), J(le, null), t.nodeType)) {
            case 9:
            case 11:
              e = (e = t.documentElement) && (e = e.namespaceURI) ? bh(e) : 0;
              break;
            default:
              if (((e = t.tagName), (t = t.namespaceURI)))
                ((t = bh(t)), (e = vh(t, e)));
              else
                switch (e) {
                  case 'svg':
                    e = 1;
                    break;
                  case 'math':
                    e = 2;
                    break;
                  default:
                    e = 0;
                }
          }
          (ee(le), J(le, e));
        }
        function wa() {
          (ee(le), ee(Te), ee(fe));
        }
        function Xs(e) {
          e.memoizedState !== null && J(Tt, e);
          var t = le.current,
            a = vh(t, e.type);
          t !== a && (J(Te, e), J(le, a));
        }
        function yl(e) {
          (Te.current === e && (ee(le), ee(Te)),
            Tt.current === e && (ee(Tt), (il._currentValue = K)));
        }
        var Qs = Object.prototype.hasOwnProperty,
          Zs = i.unstable_scheduleCallback,
          Ws = i.unstable_cancelCallback,
          up = i.unstable_shouldYield,
          dp = i.unstable_requestPaint,
          Zt = i.unstable_now,
          fp = i.unstable_getCurrentPriorityLevel,
          Zc = i.unstable_ImmediatePriority,
          Wc = i.unstable_UserBlockingPriority,
          Sl = i.unstable_NormalPriority,
          hp = i.unstable_LowPriority,
          Fc = i.unstable_IdlePriority,
          mp = i.log,
          pp = i.unstable_setDisableYieldValue,
          dn = null,
          wt = null;
        function Ea(e) {
          if (
            (typeof mp == 'function' && pp(e),
            wt && typeof wt.setStrictMode == 'function')
          )
            try {
              wt.setStrictMode(dn, e);
            } catch {}
        }
        var Et = Math.clz32 ? Math.clz32 : vp,
          gp = Math.log,
          bp = Math.LN2;
        function vp(e) {
          return ((e >>>= 0), e === 0 ? 32 : (31 - ((gp(e) / bp) | 0)) | 0);
        }
        var xl = 256,
          Tl = 4194304;
        function Ja(e) {
          var t = e & 42;
          if (t !== 0) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
              return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return e & 4194048;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return e & 62914560;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function wl(e, t, a) {
          var n = e.pendingLanes;
          if (n === 0) return 0;
          var o = 0,
            d = e.suspendedLanes,
            b = e.pingedLanes;
          e = e.warmLanes;
          var v = n & 134217727;
          return (
            v !== 0
              ? ((n = v & ~d),
                n !== 0
                  ? (o = Ja(n))
                  : ((b &= v),
                    b !== 0
                      ? (o = Ja(b))
                      : a || ((a = v & ~e), a !== 0 && (o = Ja(a)))))
              : ((v = n & ~d),
                v !== 0
                  ? (o = Ja(v))
                  : b !== 0
                    ? (o = Ja(b))
                    : a || ((a = n & ~e), a !== 0 && (o = Ja(a)))),
            o === 0
              ? 0
              : t !== 0 &&
                  t !== o &&
                  (t & d) === 0 &&
                  ((d = o & -o),
                  (a = t & -t),
                  d >= a || (d === 32 && (a & 4194048) !== 0))
                ? t
                : o
          );
        }
        function fn(e, t) {
          return (
            (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0
          );
        }
        function yp(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
              return t + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1;
            default:
              return -1;
          }
        }
        function Jc() {
          var e = xl;
          return ((xl <<= 1), (xl & 4194048) === 0 && (xl = 256), e);
        }
        function eu() {
          var e = Tl;
          return ((Tl <<= 1), (Tl & 62914560) === 0 && (Tl = 4194304), e);
        }
        function Fs(e) {
          for (var t = [], a = 0; 31 > a; a++) t.push(e);
          return t;
        }
        function hn(e, t) {
          ((e.pendingLanes |= t),
            t !== 268435456 &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0)));
        }
        function Sp(e, t, a, n, o, d) {
          var b = e.pendingLanes;
          ((e.pendingLanes = a),
            (e.suspendedLanes = 0),
            (e.pingedLanes = 0),
            (e.warmLanes = 0),
            (e.expiredLanes &= a),
            (e.entangledLanes &= a),
            (e.errorRecoveryDisabledLanes &= a),
            (e.shellSuspendCounter = 0));
          var v = e.entanglements,
            E = e.expirationTimes,
            O = e.hiddenUpdates;
          for (a = b & ~a; 0 < a; ) {
            var V = 31 - Et(a),
              P = 1 << V;
            ((v[V] = 0), (E[V] = -1));
            var B = O[V];
            if (B !== null)
              for (O[V] = null, V = 0; V < B.length; V++) {
                var R = B[V];
                R !== null && (R.lane &= -536870913);
              }
            a &= ~P;
          }
          (n !== 0 && tu(e, n, 0),
            d !== 0 &&
              o === 0 &&
              e.tag !== 0 &&
              (e.suspendedLanes |= d & ~(b & ~t)));
        }
        function tu(e, t, a) {
          ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
          var n = 31 - Et(t);
          ((e.entangledLanes |= t),
            (e.entanglements[n] =
              e.entanglements[n] | 1073741824 | (a & 4194090)));
        }
        function au(e, t) {
          var a = (e.entangledLanes |= t);
          for (e = e.entanglements; a; ) {
            var n = 31 - Et(a),
              o = 1 << n;
            ((o & t) | (e[n] & t) && (e[n] |= t), (a &= ~o));
          }
        }
        function Js(e) {
          switch (e) {
            case 2:
              e = 1;
              break;
            case 8:
              e = 4;
              break;
            case 32:
              e = 16;
              break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              e = 128;
              break;
            case 268435456:
              e = 134217728;
              break;
            default:
              e = 0;
          }
          return e;
        }
        function er(e) {
          return (
            (e &= -e),
            2 < e ? (8 < e ? ((e & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
          );
        }
        function iu() {
          var e = Q.p;
          return e !== 0
            ? e
            : ((e = window.event), e === void 0 ? 32 : Hh(e.type));
        }
        function xp(e, t) {
          var a = Q.p;
          try {
            return ((Q.p = e), t());
          } finally {
            Q.p = a;
          }
        }
        var Na = Math.random().toString(36).slice(2),
          rt = '__reactFiber$' + Na,
          mt = '__reactProps$' + Na,
          Ti = '__reactContainer$' + Na,
          tr = '__reactEvents$' + Na,
          Tp = '__reactListeners$' + Na,
          wp = '__reactHandles$' + Na,
          nu = '__reactResources$' + Na,
          mn = '__reactMarker$' + Na;
        function ar(e) {
          (delete e[rt],
            delete e[mt],
            delete e[tr],
            delete e[Tp],
            delete e[wp]);
        }
        function wi(e) {
          var t = e[rt];
          if (t) return t;
          for (var a = e.parentNode; a; ) {
            if ((t = a[Ti] || a[rt])) {
              if (
                ((a = t.alternate),
                t.child !== null || (a !== null && a.child !== null))
              )
                for (e = Th(e); e !== null; ) {
                  if ((a = e[rt])) return a;
                  e = Th(e);
                }
              return t;
            }
            ((e = a), (a = e.parentNode));
          }
          return null;
        }
        function Ei(e) {
          if ((e = e[rt] || e[Ti])) {
            var t = e.tag;
            if (
              t === 5 ||
              t === 6 ||
              t === 13 ||
              t === 26 ||
              t === 27 ||
              t === 3
            )
              return e;
          }
          return null;
        }
        function pn(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
          throw Error(r(33));
        }
        function Ni(e) {
          var t = e[nu];
          return (
            t ||
              (t = e[nu] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function Je(e) {
          e[mn] = !0;
        }
        var lu = new Set(),
          su = {};
        function ei(e, t) {
          (_i(e, t), _i(e + 'Capture', t));
        }
        function _i(e, t) {
          for (su[e] = t, e = 0; e < t.length; e++) lu.add(t[e]);
        }
        var Ep = RegExp(
            '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
          ),
          ru = {},
          ou = {};
        function Np(e) {
          return Qs.call(ou, e)
            ? !0
            : Qs.call(ru, e)
              ? !1
              : Ep.test(e)
                ? (ou[e] = !0)
                : ((ru[e] = !0), !1);
        }
        function El(e, t, a) {
          if (Np(t))
            if (a === null) e.removeAttribute(t);
            else {
              switch (typeof a) {
                case 'undefined':
                case 'function':
                case 'symbol':
                  e.removeAttribute(t);
                  return;
                case 'boolean':
                  var n = t.toLowerCase().slice(0, 5);
                  if (n !== 'data-' && n !== 'aria-') {
                    e.removeAttribute(t);
                    return;
                  }
              }
              e.setAttribute(t, '' + a);
            }
        }
        function Nl(e, t, a) {
          if (a === null) e.removeAttribute(t);
          else {
            switch (typeof a) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(t);
                return;
            }
            e.setAttribute(t, '' + a);
          }
        }
        function la(e, t, a, n) {
          if (n === null) e.removeAttribute(a);
          else {
            switch (typeof n) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(a);
                return;
            }
            e.setAttributeNS(t, a, '' + n);
          }
        }
        var ir, cu;
        function Ai(e) {
          if (ir === void 0)
            try {
              throw Error();
            } catch (a) {
              var t = a.stack.trim().match(/\n( *(at )?)/);
              ((ir = (t && t[1]) || ''),
                (cu =
                  -1 <
                  a.stack.indexOf(`
    at`)
                    ? ' (<anonymous>)'
                    : -1 < a.stack.indexOf('@')
                      ? '@unknown:0:0'
                      : ''));
            }
          return (
            `
` +
            ir +
            e +
            cu
          );
        }
        var nr = !1;
        function lr(e, t) {
          if (!e || nr) return '';
          nr = !0;
          var a = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var n = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var P = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(P.prototype, 'props', {
                        set: function () {
                          throw Error();
                        },
                      }),
                      typeof Reflect == 'object' && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(P, []);
                      } catch (R) {
                        var B = R;
                      }
                      Reflect.construct(e, [], P);
                    } else {
                      try {
                        P.call();
                      } catch (R) {
                        B = R;
                      }
                      e.call(P.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (R) {
                      B = R;
                    }
                    (P = e()) &&
                      typeof P.catch == 'function' &&
                      P.catch(function () {});
                  }
                } catch (R) {
                  if (R && B && typeof R.stack == 'string')
                    return [R.stack, B.stack];
                }
                return [null, null];
              },
            };
            n.DetermineComponentFrameRoot.displayName =
              'DetermineComponentFrameRoot';
            var o = Object.getOwnPropertyDescriptor(
              n.DetermineComponentFrameRoot,
              'name'
            );
            o &&
              o.configurable &&
              Object.defineProperty(n.DetermineComponentFrameRoot, 'name', {
                value: 'DetermineComponentFrameRoot',
              });
            var d = n.DetermineComponentFrameRoot(),
              b = d[0],
              v = d[1];
            if (b && v) {
              var E = b.split(`
`),
                O = v.split(`
`);
              for (
                o = n = 0;
                n < E.length && !E[n].includes('DetermineComponentFrameRoot');
              )
                n++;
              for (
                ;
                o < O.length && !O[o].includes('DetermineComponentFrameRoot');
              )
                o++;
              if (n === E.length || o === O.length)
                for (
                  n = E.length - 1, o = O.length - 1;
                  1 <= n && 0 <= o && E[n] !== O[o];
                )
                  o--;
              for (; 1 <= n && 0 <= o; n--, o--)
                if (E[n] !== O[o]) {
                  if (n !== 1 || o !== 1)
                    do
                      if ((n--, o--, 0 > o || E[n] !== O[o])) {
                        var V =
                          `
` + E[n].replace(' at new ', ' at ');
                        return (
                          e.displayName &&
                            V.includes('<anonymous>') &&
                            (V = V.replace('<anonymous>', e.displayName)),
                          V
                        );
                      }
                    while (1 <= n && 0 <= o);
                  break;
                }
            }
          } finally {
            ((nr = !1), (Error.prepareStackTrace = a));
          }
          return (a = e ? e.displayName || e.name : '') ? Ai(a) : '';
        }
        function _p(e) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return Ai(e.type);
            case 16:
              return Ai('Lazy');
            case 13:
              return Ai('Suspense');
            case 19:
              return Ai('SuspenseList');
            case 0:
            case 15:
              return lr(e.type, !1);
            case 11:
              return lr(e.type.render, !1);
            case 1:
              return lr(e.type, !0);
            case 31:
              return Ai('Activity');
            default:
              return '';
          }
        }
        function uu(e) {
          try {
            var t = '';
            do ((t += _p(e)), (e = e.return));
            while (e);
            return t;
          } catch (a) {
            return (
              `
Error generating stack: ` +
              a.message +
              `
` +
              a.stack
            );
          }
        }
        function zt(e) {
          switch (typeof e) {
            case 'bigint':
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
              return e;
            case 'object':
              return e;
            default:
              return '';
          }
        }
        function du(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            e.toLowerCase() === 'input' &&
            (t === 'checkbox' || t === 'radio')
          );
        }
        function Ap(e) {
          var t = du(e) ? 'checked' : 'value',
            a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
            n = '' + e[t];
          if (
            !e.hasOwnProperty(t) &&
            typeof a < 'u' &&
            typeof a.get == 'function' &&
            typeof a.set == 'function'
          ) {
            var o = a.get,
              d = a.set;
            return (
              Object.defineProperty(e, t, {
                configurable: !0,
                get: function () {
                  return o.call(this);
                },
                set: function (b) {
                  ((n = '' + b), d.call(this, b));
                },
              }),
              Object.defineProperty(e, t, { enumerable: a.enumerable }),
              {
                getValue: function () {
                  return n;
                },
                setValue: function (b) {
                  n = '' + b;
                },
                stopTracking: function () {
                  ((e._valueTracker = null), delete e[t]);
                },
              }
            );
          }
        }
        function _l(e) {
          e._valueTracker || (e._valueTracker = Ap(e));
        }
        function fu(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var a = t.getValue(),
            n = '';
          return (
            e && (n = du(e) ? (e.checked ? 'true' : 'false') : e.value),
            (e = n),
            e !== a ? (t.setValue(e), !0) : !1
          );
        }
        function Al(e) {
          if (
            ((e = e || (typeof document < 'u' ? document : void 0)),
            typeof e > 'u')
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch {
            return e.body;
          }
        }
        var Mp = /[\n"\\]/g;
        function Ht(e) {
          return e.replace(Mp, function (t) {
            return '\\' + t.charCodeAt(0).toString(16) + ' ';
          });
        }
        function sr(e, t, a, n, o, d, b, v) {
          ((e.name = ''),
            b != null &&
            typeof b != 'function' &&
            typeof b != 'symbol' &&
            typeof b != 'boolean'
              ? (e.type = b)
              : e.removeAttribute('type'),
            t != null
              ? b === 'number'
                ? ((t === 0 && e.value === '') || e.value != t) &&
                  (e.value = '' + zt(t))
                : e.value !== '' + zt(t) && (e.value = '' + zt(t))
              : (b !== 'submit' && b !== 'reset') || e.removeAttribute('value'),
            t != null
              ? rr(e, b, zt(t))
              : a != null
                ? rr(e, b, zt(a))
                : n != null && e.removeAttribute('value'),
            o == null && d != null && (e.defaultChecked = !!d),
            o != null &&
              (e.checked = o && typeof o != 'function' && typeof o != 'symbol'),
            v != null &&
            typeof v != 'function' &&
            typeof v != 'symbol' &&
            typeof v != 'boolean'
              ? (e.name = '' + zt(v))
              : e.removeAttribute('name'));
        }
        function hu(e, t, a, n, o, d, b, v) {
          if (
            (d != null &&
              typeof d != 'function' &&
              typeof d != 'symbol' &&
              typeof d != 'boolean' &&
              (e.type = d),
            t != null || a != null)
          ) {
            if (!((d !== 'submit' && d !== 'reset') || t != null)) return;
            ((a = a != null ? '' + zt(a) : ''),
              (t = t != null ? '' + zt(t) : a),
              v || t === e.value || (e.value = t),
              (e.defaultValue = t));
          }
          ((n = n ?? o),
            (n = typeof n != 'function' && typeof n != 'symbol' && !!n),
            (e.checked = v ? e.checked : !!n),
            (e.defaultChecked = !!n),
            b != null &&
              typeof b != 'function' &&
              typeof b != 'symbol' &&
              typeof b != 'boolean' &&
              (e.name = b));
        }
        function rr(e, t, a) {
          (t === 'number' && Al(e.ownerDocument) === e) ||
            e.defaultValue === '' + a ||
            (e.defaultValue = '' + a);
        }
        function Mi(e, t, a, n) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < a.length; o++) t['$' + a[o]] = !0;
            for (a = 0; a < e.length; a++)
              ((o = t.hasOwnProperty('$' + e[a].value)),
                e[a].selected !== o && (e[a].selected = o),
                o && n && (e[a].defaultSelected = !0));
          } else {
            for (a = '' + zt(a), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === a) {
                ((e[o].selected = !0), n && (e[o].defaultSelected = !0));
                return;
              }
              t !== null || e[o].disabled || (t = e[o]);
            }
            t !== null && (t.selected = !0);
          }
        }
        function mu(e, t, a) {
          if (
            t != null &&
            ((t = '' + zt(t)), t !== e.value && (e.value = t), a == null)
          ) {
            e.defaultValue !== t && (e.defaultValue = t);
            return;
          }
          e.defaultValue = a != null ? '' + zt(a) : '';
        }
        function pu(e, t, a, n) {
          if (t == null) {
            if (n != null) {
              if (a != null) throw Error(r(92));
              if (Ne(n)) {
                if (1 < n.length) throw Error(r(93));
                n = n[0];
              }
              a = n;
            }
            (a == null && (a = ''), (t = a));
          }
          ((a = zt(t)),
            (e.defaultValue = a),
            (n = e.textContent),
            n === a && n !== '' && n !== null && (e.value = n));
        }
        function ji(e, t) {
          if (t) {
            var a = e.firstChild;
            if (a && a === e.lastChild && a.nodeType === 3) {
              a.nodeValue = t;
              return;
            }
          }
          e.textContent = t;
        }
        var jp = new Set(
          'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
            ' '
          )
        );
        function gu(e, t, a) {
          var n = t.indexOf('--') === 0;
          a == null || typeof a == 'boolean' || a === ''
            ? n
              ? e.setProperty(t, '')
              : t === 'float'
                ? (e.cssFloat = '')
                : (e[t] = '')
            : n
              ? e.setProperty(t, a)
              : typeof a != 'number' || a === 0 || jp.has(t)
                ? t === 'float'
                  ? (e.cssFloat = a)
                  : (e[t] = ('' + a).trim())
                : (e[t] = a + 'px');
        }
        function bu(e, t, a) {
          if (t != null && typeof t != 'object') throw Error(r(62));
          if (((e = e.style), a != null)) {
            for (var n in a)
              !a.hasOwnProperty(n) ||
                (t != null && t.hasOwnProperty(n)) ||
                (n.indexOf('--') === 0
                  ? e.setProperty(n, '')
                  : n === 'float'
                    ? (e.cssFloat = '')
                    : (e[n] = ''));
            for (var o in t)
              ((n = t[o]), t.hasOwnProperty(o) && a[o] !== n && gu(e, o, n));
          } else for (var d in t) t.hasOwnProperty(d) && gu(e, d, t[d]);
        }
        function or(e) {
          if (e.indexOf('-') === -1) return !1;
          switch (e) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return !1;
            default:
              return !0;
          }
        }
        var Cp = new Map([
            ['acceptCharset', 'accept-charset'],
            ['htmlFor', 'for'],
            ['httpEquiv', 'http-equiv'],
            ['crossOrigin', 'crossorigin'],
            ['accentHeight', 'accent-height'],
            ['alignmentBaseline', 'alignment-baseline'],
            ['arabicForm', 'arabic-form'],
            ['baselineShift', 'baseline-shift'],
            ['capHeight', 'cap-height'],
            ['clipPath', 'clip-path'],
            ['clipRule', 'clip-rule'],
            ['colorInterpolation', 'color-interpolation'],
            ['colorInterpolationFilters', 'color-interpolation-filters'],
            ['colorProfile', 'color-profile'],
            ['colorRendering', 'color-rendering'],
            ['dominantBaseline', 'dominant-baseline'],
            ['enableBackground', 'enable-background'],
            ['fillOpacity', 'fill-opacity'],
            ['fillRule', 'fill-rule'],
            ['floodColor', 'flood-color'],
            ['floodOpacity', 'flood-opacity'],
            ['fontFamily', 'font-family'],
            ['fontSize', 'font-size'],
            ['fontSizeAdjust', 'font-size-adjust'],
            ['fontStretch', 'font-stretch'],
            ['fontStyle', 'font-style'],
            ['fontVariant', 'font-variant'],
            ['fontWeight', 'font-weight'],
            ['glyphName', 'glyph-name'],
            ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
            ['glyphOrientationVertical', 'glyph-orientation-vertical'],
            ['horizAdvX', 'horiz-adv-x'],
            ['horizOriginX', 'horiz-origin-x'],
            ['imageRendering', 'image-rendering'],
            ['letterSpacing', 'letter-spacing'],
            ['lightingColor', 'lighting-color'],
            ['markerEnd', 'marker-end'],
            ['markerMid', 'marker-mid'],
            ['markerStart', 'marker-start'],
            ['overlinePosition', 'overline-position'],
            ['overlineThickness', 'overline-thickness'],
            ['paintOrder', 'paint-order'],
            ['panose-1', 'panose-1'],
            ['pointerEvents', 'pointer-events'],
            ['renderingIntent', 'rendering-intent'],
            ['shapeRendering', 'shape-rendering'],
            ['stopColor', 'stop-color'],
            ['stopOpacity', 'stop-opacity'],
            ['strikethroughPosition', 'strikethrough-position'],
            ['strikethroughThickness', 'strikethrough-thickness'],
            ['strokeDasharray', 'stroke-dasharray'],
            ['strokeDashoffset', 'stroke-dashoffset'],
            ['strokeLinecap', 'stroke-linecap'],
            ['strokeLinejoin', 'stroke-linejoin'],
            ['strokeMiterlimit', 'stroke-miterlimit'],
            ['strokeOpacity', 'stroke-opacity'],
            ['strokeWidth', 'stroke-width'],
            ['textAnchor', 'text-anchor'],
            ['textDecoration', 'text-decoration'],
            ['textRendering', 'text-rendering'],
            ['transformOrigin', 'transform-origin'],
            ['underlinePosition', 'underline-position'],
            ['underlineThickness', 'underline-thickness'],
            ['unicodeBidi', 'unicode-bidi'],
            ['unicodeRange', 'unicode-range'],
            ['unitsPerEm', 'units-per-em'],
            ['vAlphabetic', 'v-alphabetic'],
            ['vHanging', 'v-hanging'],
            ['vIdeographic', 'v-ideographic'],
            ['vMathematical', 'v-mathematical'],
            ['vectorEffect', 'vector-effect'],
            ['vertAdvY', 'vert-adv-y'],
            ['vertOriginX', 'vert-origin-x'],
            ['vertOriginY', 'vert-origin-y'],
            ['wordSpacing', 'word-spacing'],
            ['writingMode', 'writing-mode'],
            ['xmlnsXlink', 'xmlns:xlink'],
            ['xHeight', 'x-height'],
          ]),
          Op =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function Ml(e) {
          return Op.test('' + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        var cr = null;
        function ur(e) {
          return (
            (e = e.target || e.srcElement || window),
            e.correspondingUseElement && (e = e.correspondingUseElement),
            e.nodeType === 3 ? e.parentNode : e
          );
        }
        var Ci = null,
          Oi = null;
        function vu(e) {
          var t = Ei(e);
          if (t && (e = t.stateNode)) {
            var a = e[mt] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case 'input':
                if (
                  (sr(
                    e,
                    a.value,
                    a.defaultValue,
                    a.defaultValue,
                    a.checked,
                    a.defaultChecked,
                    a.type,
                    a.name
                  ),
                  (t = a.name),
                  a.type === 'radio' && t != null)
                ) {
                  for (a = e; a.parentNode; ) a = a.parentNode;
                  for (
                    a = a.querySelectorAll(
                      'input[name="' + Ht('' + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < a.length;
                    t++
                  ) {
                    var n = a[t];
                    if (n !== e && n.form === e.form) {
                      var o = n[mt] || null;
                      if (!o) throw Error(r(90));
                      sr(
                        n,
                        o.value,
                        o.defaultValue,
                        o.defaultValue,
                        o.checked,
                        o.defaultChecked,
                        o.type,
                        o.name
                      );
                    }
                  }
                  for (t = 0; t < a.length; t++)
                    ((n = a[t]), n.form === e.form && fu(n));
                }
                break e;
              case 'textarea':
                mu(e, a.value, a.defaultValue);
                break e;
              case 'select':
                ((t = a.value), t != null && Mi(e, !!a.multiple, t, !1));
            }
          }
        }
        var dr = !1;
        function yu(e, t, a) {
          if (dr) return e(t, a);
          dr = !0;
          try {
            var n = e(t);
            return n;
          } finally {
            if (
              ((dr = !1),
              (Ci !== null || Oi !== null) &&
                (hs(), Ci && ((t = Ci), (e = Oi), (Oi = Ci = null), vu(t), e)))
            )
              for (t = 0; t < e.length; t++) vu(e[t]);
          }
        }
        function gn(e, t) {
          var a = e.stateNode;
          if (a === null) return null;
          var n = a[mt] || null;
          if (n === null) return null;
          a = n[t];
          e: switch (t) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              ((n = !n.disabled) ||
                ((e = e.type),
                (n = !(
                  e === 'button' ||
                  e === 'input' ||
                  e === 'select' ||
                  e === 'textarea'
                ))),
                (e = !n));
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (a && typeof a != 'function') throw Error(r(231, t, typeof a));
          return a;
        }
        var sa = !(
            typeof window > 'u' ||
            typeof window.document > 'u' ||
            typeof window.document.createElement > 'u'
          ),
          fr = !1;
        if (sa)
          try {
            var bn = {};
            (Object.defineProperty(bn, 'passive', {
              get: function () {
                fr = !0;
              },
            }),
              window.addEventListener('test', bn, bn),
              window.removeEventListener('test', bn, bn));
          } catch {
            fr = !1;
          }
        var _a = null,
          hr = null,
          jl = null;
        function Su() {
          if (jl) return jl;
          var e,
            t = hr,
            a = t.length,
            n,
            o = 'value' in _a ? _a.value : _a.textContent,
            d = o.length;
          for (e = 0; e < a && t[e] === o[e]; e++);
          var b = a - e;
          for (n = 1; n <= b && t[a - n] === o[d - n]; n++);
          return (jl = o.slice(e, 1 < n ? 1 - n : void 0));
        }
        function Cl(e) {
          var t = e.keyCode;
          return (
            'charCode' in e
              ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
              : (e = t),
            e === 10 && (e = 13),
            32 <= e || e === 13 ? e : 0
          );
        }
        function Ol() {
          return !0;
        }
        function xu() {
          return !1;
        }
        function pt(e) {
          function t(a, n, o, d, b) {
            ((this._reactName = a),
              (this._targetInst = o),
              (this.type = n),
              (this.nativeEvent = d),
              (this.target = b),
              (this.currentTarget = null));
            for (var v in e)
              e.hasOwnProperty(v) && ((a = e[v]), (this[v] = a ? a(d) : d[v]));
            return (
              (this.isDefaultPrevented = (
                d.defaultPrevented != null
                  ? d.defaultPrevented
                  : d.returnValue === !1
              )
                ? Ol
                : xu),
              (this.isPropagationStopped = xu),
              this
            );
          }
          return (
            y(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var a = this.nativeEvent;
                a &&
                  (a.preventDefault
                    ? a.preventDefault()
                    : typeof a.returnValue != 'unknown' && (a.returnValue = !1),
                  (this.isDefaultPrevented = Ol));
              },
              stopPropagation: function () {
                var a = this.nativeEvent;
                a &&
                  (a.stopPropagation
                    ? a.stopPropagation()
                    : typeof a.cancelBubble != 'unknown' &&
                      (a.cancelBubble = !0),
                  (this.isPropagationStopped = Ol));
              },
              persist: function () {},
              isPersistent: Ol,
            }),
            t
          );
        }
        var ti = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          Bl = pt(ti),
          vn = y({}, ti, { view: 0, detail: 0 }),
          Bp = pt(vn),
          mr,
          pr,
          yn,
          Rl = y({}, vn, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: br,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return e.relatedTarget === void 0
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return 'movementX' in e
                ? e.movementX
                : (e !== yn &&
                    (yn && e.type === 'mousemove'
                      ? ((mr = e.screenX - yn.screenX),
                        (pr = e.screenY - yn.screenY))
                      : (pr = mr = 0),
                    (yn = e)),
                  mr);
            },
            movementY: function (e) {
              return 'movementY' in e ? e.movementY : pr;
            },
          }),
          Tu = pt(Rl),
          Rp = y({}, Rl, { dataTransfer: 0 }),
          Dp = pt(Rp),
          Lp = y({}, vn, { relatedTarget: 0 }),
          gr = pt(Lp),
          zp = y({}, ti, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0,
          }),
          Hp = pt(zp),
          Up = y({}, ti, {
            clipboardData: function (e) {
              return 'clipboardData' in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          Ip = pt(Up),
          Gp = y({}, ti, { data: 0 }),
          wu = pt(Gp),
          Vp = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified',
          },
          kp = {
            8: 'Backspace',
            9: 'Tab',
            12: 'Clear',
            13: 'Enter',
            16: 'Shift',
            17: 'Control',
            18: 'Alt',
            19: 'Pause',
            20: 'CapsLock',
            27: 'Escape',
            32: ' ',
            33: 'PageUp',
            34: 'PageDown',
            35: 'End',
            36: 'Home',
            37: 'ArrowLeft',
            38: 'ArrowUp',
            39: 'ArrowRight',
            40: 'ArrowDown',
            45: 'Insert',
            46: 'Delete',
            112: 'F1',
            113: 'F2',
            114: 'F3',
            115: 'F4',
            116: 'F5',
            117: 'F6',
            118: 'F7',
            119: 'F8',
            120: 'F9',
            121: 'F10',
            122: 'F11',
            123: 'F12',
            144: 'NumLock',
            145: 'ScrollLock',
            224: 'Meta',
          },
          $p = {
            Alt: 'altKey',
            Control: 'ctrlKey',
            Meta: 'metaKey',
            Shift: 'shiftKey',
          };
        function qp(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : (e = $p[e])
              ? !!t[e]
              : !1;
        }
        function br() {
          return qp;
        }
        var Pp = y({}, vn, {
            key: function (e) {
              if (e.key) {
                var t = Vp[e.key] || e.key;
                if (t !== 'Unidentified') return t;
              }
              return e.type === 'keypress'
                ? ((e = Cl(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
                : e.type === 'keydown' || e.type === 'keyup'
                  ? kp[e.keyCode] || 'Unidentified'
                  : '';
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: br,
            charCode: function (e) {
              return e.type === 'keypress' ? Cl(e) : 0;
            },
            keyCode: function (e) {
              return e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
            },
            which: function (e) {
              return e.type === 'keypress'
                ? Cl(e)
                : e.type === 'keydown' || e.type === 'keyup'
                  ? e.keyCode
                  : 0;
            },
          }),
          Yp = pt(Pp),
          Kp = y({}, Rl, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0,
          }),
          Eu = pt(Kp),
          Xp = y({}, vn, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: br,
          }),
          Qp = pt(Xp),
          Zp = y({}, ti, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          Wp = pt(Zp),
          Fp = y({}, Rl, {
            deltaX: function (e) {
              return 'deltaX' in e
                ? e.deltaX
                : 'wheelDeltaX' in e
                  ? -e.wheelDeltaX
                  : 0;
            },
            deltaY: function (e) {
              return 'deltaY' in e
                ? e.deltaY
                : 'wheelDeltaY' in e
                  ? -e.wheelDeltaY
                  : 'wheelDelta' in e
                    ? -e.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Jp = pt(Fp),
          eg = y({}, ti, { newState: 0, oldState: 0 }),
          tg = pt(eg),
          ag = [9, 13, 27, 32],
          vr = sa && 'CompositionEvent' in window,
          Sn = null;
        sa && 'documentMode' in document && (Sn = document.documentMode);
        var ig = sa && 'TextEvent' in window && !Sn,
          Nu = sa && (!vr || (Sn && 8 < Sn && 11 >= Sn)),
          _u = ' ',
          Au = !1;
        function Mu(e, t) {
          switch (e) {
            case 'keyup':
              return ag.indexOf(t.keyCode) !== -1;
            case 'keydown':
              return t.keyCode !== 229;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
              return !0;
            default:
              return !1;
          }
        }
        function ju(e) {
          return (
            (e = e.detail),
            typeof e == 'object' && 'data' in e ? e.data : null
          );
        }
        var Bi = !1;
        function ng(e, t) {
          switch (e) {
            case 'compositionend':
              return ju(t);
            case 'keypress':
              return t.which !== 32 ? null : ((Au = !0), _u);
            case 'textInput':
              return ((e = t.data), e === _u && Au ? null : e);
            default:
              return null;
          }
        }
        function lg(e, t) {
          if (Bi)
            return e === 'compositionend' || (!vr && Mu(e, t))
              ? ((e = Su()), (jl = hr = _a = null), (Bi = !1), e)
              : null;
          switch (e) {
            case 'paste':
              return null;
            case 'keypress':
              if (
                !(t.ctrlKey || t.altKey || t.metaKey) ||
                (t.ctrlKey && t.altKey)
              ) {
                if (t.char && 1 < t.char.length) return t.char;
                if (t.which) return String.fromCharCode(t.which);
              }
              return null;
            case 'compositionend':
              return Nu && t.locale !== 'ko' ? null : t.data;
            default:
              return null;
          }
        }
        var sg = {
          color: !0,
          date: !0,
          datetime: !0,
          'datetime-local': !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function Cu(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return t === 'input' ? !!sg[e.type] : t === 'textarea';
        }
        function Ou(e, t, a, n) {
          (Ci ? (Oi ? Oi.push(n) : (Oi = [n])) : (Ci = n),
            (t = ys(t, 'onChange')),
            0 < t.length &&
              ((a = new Bl('onChange', 'change', null, a, n)),
              e.push({ event: a, listeners: t })));
        }
        var xn = null,
          Tn = null;
        function rg(e) {
          fh(e, 0);
        }
        function Dl(e) {
          var t = pn(e);
          if (fu(t)) return e;
        }
        function Bu(e, t) {
          if (e === 'change') return t;
        }
        var Ru = !1;
        if (sa) {
          var yr;
          if (sa) {
            var Sr = 'oninput' in document;
            if (!Sr) {
              var Du = document.createElement('div');
              (Du.setAttribute('oninput', 'return;'),
                (Sr = typeof Du.oninput == 'function'));
            }
            yr = Sr;
          } else yr = !1;
          Ru = yr && (!document.documentMode || 9 < document.documentMode);
        }
        function Lu() {
          xn && (xn.detachEvent('onpropertychange', zu), (Tn = xn = null));
        }
        function zu(e) {
          if (e.propertyName === 'value' && Dl(Tn)) {
            var t = [];
            (Ou(t, Tn, e, ur(e)), yu(rg, t));
          }
        }
        function og(e, t, a) {
          e === 'focusin'
            ? (Lu(), (xn = t), (Tn = a), xn.attachEvent('onpropertychange', zu))
            : e === 'focusout' && Lu();
        }
        function cg(e) {
          if (e === 'selectionchange' || e === 'keyup' || e === 'keydown')
            return Dl(Tn);
        }
        function ug(e, t) {
          if (e === 'click') return Dl(t);
        }
        function dg(e, t) {
          if (e === 'input' || e === 'change') return Dl(t);
        }
        function fg(e, t) {
          return (
            (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t)
          );
        }
        var Nt = typeof Object.is == 'function' ? Object.is : fg;
        function wn(e, t) {
          if (Nt(e, t)) return !0;
          if (
            typeof e != 'object' ||
            e === null ||
            typeof t != 'object' ||
            t === null
          )
            return !1;
          var a = Object.keys(e),
            n = Object.keys(t);
          if (a.length !== n.length) return !1;
          for (n = 0; n < a.length; n++) {
            var o = a[n];
            if (!Qs.call(t, o) || !Nt(e[o], t[o])) return !1;
          }
          return !0;
        }
        function Hu(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function Uu(e, t) {
          var a = Hu(e);
          e = 0;
          for (var n; a; ) {
            if (a.nodeType === 3) {
              if (((n = e + a.textContent.length), e <= t && n >= t))
                return { node: a, offset: t - e };
              e = n;
            }
            e: {
              for (; a; ) {
                if (a.nextSibling) {
                  a = a.nextSibling;
                  break e;
                }
                a = a.parentNode;
              }
              a = void 0;
            }
            a = Hu(a);
          }
        }
        function Iu(e, t) {
          return e && t
            ? e === t
              ? !0
              : e && e.nodeType === 3
                ? !1
                : t && t.nodeType === 3
                  ? Iu(e, t.parentNode)
                  : 'contains' in e
                    ? e.contains(t)
                    : e.compareDocumentPosition
                      ? !!(e.compareDocumentPosition(t) & 16)
                      : !1
            : !1;
        }
        function Gu(e) {
          e =
            e != null &&
            e.ownerDocument != null &&
            e.ownerDocument.defaultView != null
              ? e.ownerDocument.defaultView
              : window;
          for (var t = Al(e.document); t instanceof e.HTMLIFrameElement; ) {
            try {
              var a = typeof t.contentWindow.location.href == 'string';
            } catch {
              a = !1;
            }
            if (a) e = t.contentWindow;
            else break;
            t = Al(e.document);
          }
          return t;
        }
        function xr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            ((t === 'input' &&
              (e.type === 'text' ||
                e.type === 'search' ||
                e.type === 'tel' ||
                e.type === 'url' ||
                e.type === 'password')) ||
              t === 'textarea' ||
              e.contentEditable === 'true')
          );
        }
        var hg =
            sa && 'documentMode' in document && 11 >= document.documentMode,
          Ri = null,
          Tr = null,
          En = null,
          wr = !1;
        function Vu(e, t, a) {
          var n =
            a.window === a
              ? a.document
              : a.nodeType === 9
                ? a
                : a.ownerDocument;
          wr ||
            Ri == null ||
            Ri !== Al(n) ||
            ((n = Ri),
            'selectionStart' in n && xr(n)
              ? (n = { start: n.selectionStart, end: n.selectionEnd })
              : ((n = (
                  (n.ownerDocument && n.ownerDocument.defaultView) ||
                  window
                ).getSelection()),
                (n = {
                  anchorNode: n.anchorNode,
                  anchorOffset: n.anchorOffset,
                  focusNode: n.focusNode,
                  focusOffset: n.focusOffset,
                })),
            (En && wn(En, n)) ||
              ((En = n),
              (n = ys(Tr, 'onSelect')),
              0 < n.length &&
                ((t = new Bl('onSelect', 'select', null, t, a)),
                e.push({ event: t, listeners: n }),
                (t.target = Ri))));
        }
        function ai(e, t) {
          var a = {};
          return (
            (a[e.toLowerCase()] = t.toLowerCase()),
            (a['Webkit' + e] = 'webkit' + t),
            (a['Moz' + e] = 'moz' + t),
            a
          );
        }
        var Di = {
            animationend: ai('Animation', 'AnimationEnd'),
            animationiteration: ai('Animation', 'AnimationIteration'),
            animationstart: ai('Animation', 'AnimationStart'),
            transitionrun: ai('Transition', 'TransitionRun'),
            transitionstart: ai('Transition', 'TransitionStart'),
            transitioncancel: ai('Transition', 'TransitionCancel'),
            transitionend: ai('Transition', 'TransitionEnd'),
          },
          Er = {},
          ku = {};
        sa &&
          ((ku = document.createElement('div').style),
          'AnimationEvent' in window ||
            (delete Di.animationend.animation,
            delete Di.animationiteration.animation,
            delete Di.animationstart.animation),
          'TransitionEvent' in window || delete Di.transitionend.transition);
        function ii(e) {
          if (Er[e]) return Er[e];
          if (!Di[e]) return e;
          var t = Di[e],
            a;
          for (a in t)
            if (t.hasOwnProperty(a) && a in ku) return (Er[e] = t[a]);
          return e;
        }
        var $u = ii('animationend'),
          qu = ii('animationiteration'),
          Pu = ii('animationstart'),
          mg = ii('transitionrun'),
          pg = ii('transitionstart'),
          gg = ii('transitioncancel'),
          Yu = ii('transitionend'),
          Ku = new Map(),
          Nr =
            'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
              ' '
            );
        Nr.push('scrollEnd');
        function Yt(e, t) {
          (Ku.set(e, t), ei(t, [e]));
        }
        var Xu = new WeakMap();
        function Ut(e, t) {
          if (typeof e == 'object' && e !== null) {
            var a = Xu.get(e);
            return a !== void 0
              ? a
              : ((t = { value: e, source: t, stack: uu(t) }), Xu.set(e, t), t);
          }
          return { value: e, source: t, stack: uu(t) };
        }
        var It = [],
          Li = 0,
          _r = 0;
        function Ll() {
          for (var e = Li, t = (_r = Li = 0); t < e; ) {
            var a = It[t];
            It[t++] = null;
            var n = It[t];
            It[t++] = null;
            var o = It[t];
            It[t++] = null;
            var d = It[t];
            if (((It[t++] = null), n !== null && o !== null)) {
              var b = n.pending;
              (b === null ? (o.next = o) : ((o.next = b.next), (b.next = o)),
                (n.pending = o));
            }
            d !== 0 && Qu(a, o, d);
          }
        }
        function zl(e, t, a, n) {
          ((It[Li++] = e),
            (It[Li++] = t),
            (It[Li++] = a),
            (It[Li++] = n),
            (_r |= n),
            (e.lanes |= n),
            (e = e.alternate),
            e !== null && (e.lanes |= n));
        }
        function Ar(e, t, a, n) {
          return (zl(e, t, a, n), Hl(e));
        }
        function zi(e, t) {
          return (zl(e, null, null, t), Hl(e));
        }
        function Qu(e, t, a) {
          e.lanes |= a;
          var n = e.alternate;
          n !== null && (n.lanes |= a);
          for (var o = !1, d = e.return; d !== null; )
            ((d.childLanes |= a),
              (n = d.alternate),
              n !== null && (n.childLanes |= a),
              d.tag === 22 &&
                ((e = d.stateNode),
                e === null || e._visibility & 1 || (o = !0)),
              (e = d),
              (d = d.return));
          return e.tag === 3
            ? ((d = e.stateNode),
              o &&
                t !== null &&
                ((o = 31 - Et(a)),
                (e = d.hiddenUpdates),
                (n = e[o]),
                n === null ? (e[o] = [t]) : n.push(t),
                (t.lane = a | 536870912)),
              d)
            : null;
        }
        function Hl(e) {
          if (50 < Qn) throw ((Qn = 0), (Do = null), Error(r(185)));
          for (var t = e.return; t !== null; ) ((e = t), (t = e.return));
          return e.tag === 3 ? e.stateNode : null;
        }
        var Hi = {};
        function bg(e, t, a, n) {
          ((this.tag = e),
            (this.key = a),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = n),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null));
        }
        function _t(e, t, a, n) {
          return new bg(e, t, a, n);
        }
        function Mr(e) {
          return ((e = e.prototype), !(!e || !e.isReactComponent));
        }
        function ra(e, t) {
          var a = e.alternate;
          return (
            a === null
              ? ((a = _t(e.tag, t, e.key, e.mode)),
                (a.elementType = e.elementType),
                (a.type = e.type),
                (a.stateNode = e.stateNode),
                (a.alternate = e),
                (e.alternate = a))
              : ((a.pendingProps = t),
                (a.type = e.type),
                (a.flags = 0),
                (a.subtreeFlags = 0),
                (a.deletions = null)),
            (a.flags = e.flags & 65011712),
            (a.childLanes = e.childLanes),
            (a.lanes = e.lanes),
            (a.child = e.child),
            (a.memoizedProps = e.memoizedProps),
            (a.memoizedState = e.memoizedState),
            (a.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (a.dependencies =
              t === null
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (a.sibling = e.sibling),
            (a.index = e.index),
            (a.ref = e.ref),
            (a.refCleanup = e.refCleanup),
            a
          );
        }
        function Zu(e, t) {
          e.flags &= 65011714;
          var a = e.alternate;
          return (
            a === null
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = a.childLanes),
                (e.lanes = a.lanes),
                (e.child = a.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = a.memoizedProps),
                (e.memoizedState = a.memoizedState),
                (e.updateQueue = a.updateQueue),
                (e.type = a.type),
                (t = a.dependencies),
                (e.dependencies =
                  t === null
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function Ul(e, t, a, n, o, d) {
          var b = 0;
          if (((n = e), typeof e == 'function')) Mr(e) && (b = 1);
          else if (typeof e == 'string')
            b = yb(e, a, le.current)
              ? 26
              : e === 'html' || e === 'head' || e === 'body'
                ? 27
                : 5;
          else
            e: switch (e) {
              case se:
                return (
                  (e = _t(31, a, t, o)),
                  (e.elementType = se),
                  (e.lanes = d),
                  e
                );
              case T:
                return ni(a.children, o, d, t);
              case A:
                ((b = 8), (o |= 24));
                break;
              case j:
                return (
                  (e = _t(12, a, t, o | 2)),
                  (e.elementType = j),
                  (e.lanes = d),
                  e
                );
              case D:
                return (
                  (e = _t(13, a, t, o)),
                  (e.elementType = D),
                  (e.lanes = d),
                  e
                );
              case U:
                return (
                  (e = _t(19, a, t, o)),
                  (e.elementType = U),
                  (e.lanes = d),
                  e
                );
              default:
                if (typeof e == 'object' && e !== null)
                  switch (e.$$typeof) {
                    case G:
                    case H:
                      b = 10;
                      break e;
                    case L:
                      b = 9;
                      break e;
                    case $:
                      b = 11;
                      break e;
                    case X:
                      b = 14;
                      break e;
                    case q:
                      ((b = 16), (n = null));
                      break e;
                  }
                ((b = 29),
                  (a = Error(r(130, e === null ? 'null' : typeof e, ''))),
                  (n = null));
            }
          return (
            (t = _t(b, a, t, o)),
            (t.elementType = e),
            (t.type = n),
            (t.lanes = d),
            t
          );
        }
        function ni(e, t, a, n) {
          return ((e = _t(7, e, n, t)), (e.lanes = a), e);
        }
        function jr(e, t, a) {
          return ((e = _t(6, e, null, t)), (e.lanes = a), e);
        }
        function Cr(e, t, a) {
          return (
            (t = _t(4, e.children !== null ? e.children : [], e.key, t)),
            (t.lanes = a),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        var Ui = [],
          Ii = 0,
          Il = null,
          Gl = 0,
          Gt = [],
          Vt = 0,
          li = null,
          oa = 1,
          ca = '';
        function si(e, t) {
          ((Ui[Ii++] = Gl), (Ui[Ii++] = Il), (Il = e), (Gl = t));
        }
        function Wu(e, t, a) {
          ((Gt[Vt++] = oa), (Gt[Vt++] = ca), (Gt[Vt++] = li), (li = e));
          var n = oa;
          e = ca;
          var o = 32 - Et(n) - 1;
          ((n &= ~(1 << o)), (a += 1));
          var d = 32 - Et(t) + o;
          if (30 < d) {
            var b = o - (o % 5);
            ((d = (n & ((1 << b) - 1)).toString(32)),
              (n >>= b),
              (o -= b),
              (oa = (1 << (32 - Et(t) + o)) | (a << o) | n),
              (ca = d + e));
          } else ((oa = (1 << d) | (a << o) | n), (ca = e));
        }
        function Or(e) {
          e.return !== null && (si(e, 1), Wu(e, 1, 0));
        }
        function Br(e) {
          for (; e === Il; )
            ((Il = Ui[--Ii]),
              (Ui[Ii] = null),
              (Gl = Ui[--Ii]),
              (Ui[Ii] = null));
          for (; e === li; )
            ((li = Gt[--Vt]),
              (Gt[Vt] = null),
              (ca = Gt[--Vt]),
              (Gt[Vt] = null),
              (oa = Gt[--Vt]),
              (Gt[Vt] = null));
        }
        var ut = null,
          Ve = null,
          _e = !1,
          ri = null,
          Wt = !1,
          Rr = Error(r(519));
        function oi(e) {
          var t = Error(r(418, ''));
          throw (An(Ut(t, e)), Rr);
        }
        function Fu(e) {
          var t = e.stateNode,
            a = e.type,
            n = e.memoizedProps;
          switch (((t[rt] = e), (t[mt] = n), a)) {
            case 'dialog':
              (be('cancel', t), be('close', t));
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              be('load', t);
              break;
            case 'video':
            case 'audio':
              for (a = 0; a < Wn.length; a++) be(Wn[a], t);
              break;
            case 'source':
              be('error', t);
              break;
            case 'img':
            case 'image':
            case 'link':
              (be('error', t), be('load', t));
              break;
            case 'details':
              be('toggle', t);
              break;
            case 'input':
              (be('invalid', t),
                hu(
                  t,
                  n.value,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name,
                  !0
                ),
                _l(t));
              break;
            case 'select':
              be('invalid', t);
              break;
            case 'textarea':
              (be('invalid', t),
                pu(t, n.value, n.defaultValue, n.children),
                _l(t));
          }
          ((a = n.children),
            (typeof a != 'string' &&
              typeof a != 'number' &&
              typeof a != 'bigint') ||
            t.textContent === '' + a ||
            n.suppressHydrationWarning === !0 ||
            gh(t.textContent, a)
              ? (n.popover != null && (be('beforetoggle', t), be('toggle', t)),
                n.onScroll != null && be('scroll', t),
                n.onScrollEnd != null && be('scrollend', t),
                n.onClick != null && (t.onclick = Ss),
                (t = !0))
              : (t = !1),
            t || oi(e));
        }
        function Ju(e) {
          for (ut = e.return; ut; )
            switch (ut.tag) {
              case 5:
              case 13:
                Wt = !1;
                return;
              case 27:
              case 3:
                Wt = !0;
                return;
              default:
                ut = ut.return;
            }
        }
        function Nn(e) {
          if (e !== ut) return !1;
          if (!_e) return (Ju(e), (_e = !0), !1);
          var t = e.tag,
            a;
          if (
            ((a = t !== 3 && t !== 27) &&
              ((a = t === 5) &&
                ((a = e.type),
                (a =
                  !(a !== 'form' && a !== 'button') ||
                  Zo(e.type, e.memoizedProps))),
              (a = !a)),
            a && Ve && oi(e),
            Ju(e),
            t === 13)
          ) {
            if (
              ((e = e.memoizedState),
              (e = e !== null ? e.dehydrated : null),
              !e)
            )
              throw Error(r(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (e.nodeType === 8)
                  if (((a = e.data), a === '/$')) {
                    if (t === 0) {
                      Ve = Xt(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else (a !== '$' && a !== '$!' && a !== '$?') || t++;
                e = e.nextSibling;
              }
              Ve = null;
            }
          } else
            t === 27
              ? ((t = Ve),
                ka(e.type) ? ((e = ec), (ec = null), (Ve = e)) : (Ve = t))
              : (Ve = ut ? Xt(e.stateNode.nextSibling) : null);
          return !0;
        }
        function _n() {
          ((Ve = ut = null), (_e = !1));
        }
        function ed() {
          var e = ri;
          return (
            e !== null &&
              (vt === null ? (vt = e) : vt.push.apply(vt, e), (ri = null)),
            e
          );
        }
        function An(e) {
          ri === null ? (ri = [e]) : ri.push(e);
        }
        var Dr = I(null),
          ci = null,
          ua = null;
        function Aa(e, t, a) {
          (J(Dr, t._currentValue), (t._currentValue = a));
        }
        function da(e) {
          ((e._currentValue = Dr.current), ee(Dr));
        }
        function Lr(e, t, a) {
          for (; e !== null; ) {
            var n = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), n !== null && (n.childLanes |= t))
                : n !== null && (n.childLanes & t) !== t && (n.childLanes |= t),
              e === a)
            )
              break;
            e = e.return;
          }
        }
        function zr(e, t, a, n) {
          var o = e.child;
          for (o !== null && (o.return = e); o !== null; ) {
            var d = o.dependencies;
            if (d !== null) {
              var b = o.child;
              d = d.firstContext;
              e: for (; d !== null; ) {
                var v = d;
                d = o;
                for (var E = 0; E < t.length; E++)
                  if (v.context === t[E]) {
                    ((d.lanes |= a),
                      (v = d.alternate),
                      v !== null && (v.lanes |= a),
                      Lr(d.return, a, e),
                      n || (b = null));
                    break e;
                  }
                d = v.next;
              }
            } else if (o.tag === 18) {
              if (((b = o.return), b === null)) throw Error(r(341));
              ((b.lanes |= a),
                (d = b.alternate),
                d !== null && (d.lanes |= a),
                Lr(b, a, e),
                (b = null));
            } else b = o.child;
            if (b !== null) b.return = o;
            else
              for (b = o; b !== null; ) {
                if (b === e) {
                  b = null;
                  break;
                }
                if (((o = b.sibling), o !== null)) {
                  ((o.return = b.return), (b = o));
                  break;
                }
                b = b.return;
              }
            o = b;
          }
        }
        function Mn(e, t, a, n) {
          e = null;
          for (var o = t, d = !1; o !== null; ) {
            if (!d) {
              if ((o.flags & 524288) !== 0) d = !0;
              else if ((o.flags & 262144) !== 0) break;
            }
            if (o.tag === 10) {
              var b = o.alternate;
              if (b === null) throw Error(r(387));
              if (((b = b.memoizedProps), b !== null)) {
                var v = o.type;
                Nt(o.pendingProps.value, b.value) ||
                  (e !== null ? e.push(v) : (e = [v]));
              }
            } else if (o === Tt.current) {
              if (((b = o.alternate), b === null)) throw Error(r(387));
              b.memoizedState.memoizedState !== o.memoizedState.memoizedState &&
                (e !== null ? e.push(il) : (e = [il]));
            }
            o = o.return;
          }
          (e !== null && zr(t, e, a, n), (t.flags |= 262144));
        }
        function Vl(e) {
          for (e = e.firstContext; e !== null; ) {
            if (!Nt(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function ui(e) {
          ((ci = e),
            (ua = null),
            (e = e.dependencies),
            e !== null && (e.firstContext = null));
        }
        function ot(e) {
          return td(ci, e);
        }
        function kl(e, t) {
          return (ci === null && ui(e), td(e, t));
        }
        function td(e, t) {
          var a = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: a, next: null }), ua === null)
          ) {
            if (e === null) throw Error(r(308));
            ((ua = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288));
          } else ua = ua.next = t;
          return a;
        }
        var vg =
            typeof AbortController < 'u'
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (a, n) {
                        e.push(n);
                      },
                    });
                  this.abort = function () {
                    ((t.aborted = !0),
                      e.forEach(function (a) {
                        return a();
                      }));
                  };
                },
          yg = i.unstable_scheduleCallback,
          Sg = i.unstable_NormalPriority,
          Ze = {
            $$typeof: H,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Hr() {
          return { controller: new vg(), data: new Map(), refCount: 0 };
        }
        function jn(e) {
          (e.refCount--,
            e.refCount === 0 &&
              yg(Sg, function () {
                e.controller.abort();
              }));
        }
        var Cn = null,
          Ur = 0,
          Gi = 0,
          Vi = null;
        function xg(e, t) {
          if (Cn === null) {
            var a = (Cn = []);
            ((Ur = 0),
              (Gi = Vo()),
              (Vi = {
                status: 'pending',
                value: void 0,
                then: function (n) {
                  a.push(n);
                },
              }));
          }
          return (Ur++, t.then(ad, ad), t);
        }
        function ad() {
          if (--Ur === 0 && Cn !== null) {
            Vi !== null && (Vi.status = 'fulfilled');
            var e = Cn;
            ((Cn = null), (Gi = 0), (Vi = null));
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        function Tg(e, t) {
          var a = [],
            n = {
              status: 'pending',
              value: null,
              reason: null,
              then: function (o) {
                a.push(o);
              },
            };
          return (
            e.then(
              function () {
                ((n.status = 'fulfilled'), (n.value = t));
                for (var o = 0; o < a.length; o++) (0, a[o])(t);
              },
              function (o) {
                for (
                  n.status = 'rejected', n.reason = o, o = 0;
                  o < a.length;
                  o++
                )
                  (0, a[o])(void 0);
              }
            ),
            n
          );
        }
        var id = z.S;
        z.S = function (e, t) {
          (typeof t == 'object' &&
            t !== null &&
            typeof t.then == 'function' &&
            xg(e, t),
            id !== null && id(e, t));
        };
        var di = I(null);
        function Ir() {
          var e = di.current;
          return e !== null ? e : Re.pooledCache;
        }
        function $l(e, t) {
          t === null ? J(di, di.current) : J(di, t.pool);
        }
        function nd() {
          var e = Ir();
          return e === null ? null : { parent: Ze._currentValue, pool: e };
        }
        var On = Error(r(460)),
          ld = Error(r(474)),
          ql = Error(r(542)),
          Gr = { then: function () {} };
        function sd(e) {
          return ((e = e.status), e === 'fulfilled' || e === 'rejected');
        }
        function Pl() {}
        function rd(e, t, a) {
          switch (
            ((a = e[a]),
            a === void 0 ? e.push(t) : a !== t && (t.then(Pl, Pl), (t = a)),
            t.status)
          ) {
            case 'fulfilled':
              return t.value;
            case 'rejected':
              throw ((e = t.reason), cd(e), e);
            default:
              if (typeof t.status == 'string') t.then(Pl, Pl);
              else {
                if (((e = Re), e !== null && 100 < e.shellSuspendCounter))
                  throw Error(r(482));
                ((e = t),
                  (e.status = 'pending'),
                  e.then(
                    function (n) {
                      if (t.status === 'pending') {
                        var o = t;
                        ((o.status = 'fulfilled'), (o.value = n));
                      }
                    },
                    function (n) {
                      if (t.status === 'pending') {
                        var o = t;
                        ((o.status = 'rejected'), (o.reason = n));
                      }
                    }
                  ));
              }
              switch (t.status) {
                case 'fulfilled':
                  return t.value;
                case 'rejected':
                  throw ((e = t.reason), cd(e), e);
              }
              throw ((Bn = t), On);
          }
        }
        var Bn = null;
        function od() {
          if (Bn === null) throw Error(r(459));
          var e = Bn;
          return ((Bn = null), e);
        }
        function cd(e) {
          if (e === On || e === ql) throw Error(r(483));
        }
        var Ma = !1;
        function Vr(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function kr(e, t) {
          ((e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              }));
        }
        function ja(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function Ca(e, t, a) {
          var n = e.updateQueue;
          if (n === null) return null;
          if (((n = n.shared), (Ae & 2) !== 0)) {
            var o = n.pending;
            return (
              o === null ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (n.pending = t),
              (t = Hl(e)),
              Qu(e, null, a),
              t
            );
          }
          return (zl(e, n, t, a), Hl(e));
        }
        function Rn(e, t, a) {
          if (
            ((t = t.updateQueue),
            t !== null && ((t = t.shared), (a & 4194048) !== 0))
          ) {
            var n = t.lanes;
            ((n &= e.pendingLanes), (a |= n), (t.lanes = a), au(e, a));
          }
        }
        function $r(e, t) {
          var a = e.updateQueue,
            n = e.alternate;
          if (n !== null && ((n = n.updateQueue), a === n)) {
            var o = null,
              d = null;
            if (((a = a.firstBaseUpdate), a !== null)) {
              do {
                var b = {
                  lane: a.lane,
                  tag: a.tag,
                  payload: a.payload,
                  callback: null,
                  next: null,
                };
                (d === null ? (o = d = b) : (d = d.next = b), (a = a.next));
              } while (a !== null);
              d === null ? (o = d = t) : (d = d.next = t);
            } else o = d = t;
            ((a = {
              baseState: n.baseState,
              firstBaseUpdate: o,
              lastBaseUpdate: d,
              shared: n.shared,
              callbacks: n.callbacks,
            }),
              (e.updateQueue = a));
            return;
          }
          ((e = a.lastBaseUpdate),
            e === null ? (a.firstBaseUpdate = t) : (e.next = t),
            (a.lastBaseUpdate = t));
        }
        var qr = !1;
        function Dn() {
          if (qr) {
            var e = Vi;
            if (e !== null) throw e;
          }
        }
        function Ln(e, t, a, n) {
          qr = !1;
          var o = e.updateQueue;
          Ma = !1;
          var d = o.firstBaseUpdate,
            b = o.lastBaseUpdate,
            v = o.shared.pending;
          if (v !== null) {
            o.shared.pending = null;
            var E = v,
              O = E.next;
            ((E.next = null), b === null ? (d = O) : (b.next = O), (b = E));
            var V = e.alternate;
            V !== null &&
              ((V = V.updateQueue),
              (v = V.lastBaseUpdate),
              v !== b &&
                (v === null ? (V.firstBaseUpdate = O) : (v.next = O),
                (V.lastBaseUpdate = E)));
          }
          if (d !== null) {
            var P = o.baseState;
            ((b = 0), (V = O = E = null), (v = d));
            do {
              var B = v.lane & -536870913,
                R = B !== v.lane;
              if (R ? (xe & B) === B : (n & B) === B) {
                (B !== 0 && B === Gi && (qr = !0),
                  V !== null &&
                    (V = V.next =
                      {
                        lane: 0,
                        tag: v.tag,
                        payload: v.payload,
                        callback: null,
                        next: null,
                      }));
                e: {
                  var ce = e,
                    re = v;
                  B = t;
                  var Oe = a;
                  switch (re.tag) {
                    case 1:
                      if (((ce = re.payload), typeof ce == 'function')) {
                        P = ce.call(Oe, P, B);
                        break e;
                      }
                      P = ce;
                      break e;
                    case 3:
                      ce.flags = (ce.flags & -65537) | 128;
                    case 0:
                      if (
                        ((ce = re.payload),
                        (B = typeof ce == 'function' ? ce.call(Oe, P, B) : ce),
                        B == null)
                      )
                        break e;
                      P = y({}, P, B);
                      break e;
                    case 2:
                      Ma = !0;
                  }
                }
                ((B = v.callback),
                  B !== null &&
                    ((e.flags |= 64),
                    R && (e.flags |= 8192),
                    (R = o.callbacks),
                    R === null ? (o.callbacks = [B]) : R.push(B)));
              } else
                ((R = {
                  lane: B,
                  tag: v.tag,
                  payload: v.payload,
                  callback: v.callback,
                  next: null,
                }),
                  V === null ? ((O = V = R), (E = P)) : (V = V.next = R),
                  (b |= B));
              if (((v = v.next), v === null)) {
                if (((v = o.shared.pending), v === null)) break;
                ((R = v),
                  (v = R.next),
                  (R.next = null),
                  (o.lastBaseUpdate = R),
                  (o.shared.pending = null));
              }
            } while (!0);
            (V === null && (E = P),
              (o.baseState = E),
              (o.firstBaseUpdate = O),
              (o.lastBaseUpdate = V),
              d === null && (o.shared.lanes = 0),
              (Ua |= b),
              (e.lanes = b),
              (e.memoizedState = P));
          }
        }
        function ud(e, t) {
          if (typeof e != 'function') throw Error(r(191, e));
          e.call(t);
        }
        function dd(e, t) {
          var a = e.callbacks;
          if (a !== null)
            for (e.callbacks = null, e = 0; e < a.length; e++) ud(a[e], t);
        }
        var ki = I(null),
          Yl = I(0);
        function fd(e, t) {
          ((e = va), J(Yl, e), J(ki, t), (va = e | t.baseLanes));
        }
        function Pr() {
          (J(Yl, va), J(ki, ki.current));
        }
        function Yr() {
          ((va = Yl.current), ee(ki), ee(Yl));
        }
        var Oa = 0,
          me = null,
          je = null,
          Xe = null,
          Kl = !1,
          $i = !1,
          fi = !1,
          Xl = 0,
          zn = 0,
          qi = null,
          wg = 0;
        function Pe() {
          throw Error(r(321));
        }
        function Kr(e, t) {
          if (t === null) return !1;
          for (var a = 0; a < t.length && a < e.length; a++)
            if (!Nt(e[a], t[a])) return !1;
          return !0;
        }
        function Xr(e, t, a, n, o, d) {
          return (
            (Oa = d),
            (me = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (z.H = e === null || e.memoizedState === null ? Qd : Zd),
            (fi = !1),
            (d = a(n, o)),
            (fi = !1),
            $i && (d = md(t, a, n, o)),
            hd(e),
            d
          );
        }
        function hd(e) {
          z.H = es;
          var t = je !== null && je.next !== null;
          if (
            ((Oa = 0),
            (Xe = je = me = null),
            (Kl = !1),
            (zn = 0),
            (qi = null),
            t)
          )
            throw Error(r(300));
          e === null ||
            et ||
            ((e = e.dependencies), e !== null && Vl(e) && (et = !0));
        }
        function md(e, t, a, n) {
          me = e;
          var o = 0;
          do {
            if (($i && (qi = null), (zn = 0), ($i = !1), 25 <= o))
              throw Error(r(301));
            if (((o += 1), (Xe = je = null), e.updateQueue != null)) {
              var d = e.updateQueue;
              ((d.lastEffect = null),
                (d.events = null),
                (d.stores = null),
                d.memoCache != null && (d.memoCache.index = 0));
            }
            ((z.H = Cg), (d = t(a, n)));
          } while ($i);
          return d;
        }
        function Eg() {
          var e = z.H,
            t = e.useState()[0];
          return (
            (t = typeof t.then == 'function' ? Hn(t) : t),
            (e = e.useState()[0]),
            (je !== null ? je.memoizedState : null) !== e && (me.flags |= 1024),
            t
          );
        }
        function Qr() {
          var e = Xl !== 0;
          return ((Xl = 0), e);
        }
        function Zr(e, t, a) {
          ((t.updateQueue = e.updateQueue),
            (t.flags &= -2053),
            (e.lanes &= ~a));
        }
        function Wr(e) {
          if (Kl) {
            for (e = e.memoizedState; e !== null; ) {
              var t = e.queue;
              (t !== null && (t.pending = null), (e = e.next));
            }
            Kl = !1;
          }
          ((Oa = 0),
            (Xe = je = me = null),
            ($i = !1),
            (zn = Xl = 0),
            (qi = null));
        }
        function gt() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            Xe === null ? (me.memoizedState = Xe = e) : (Xe = Xe.next = e),
            Xe
          );
        }
        function Qe() {
          if (je === null) {
            var e = me.alternate;
            e = e !== null ? e.memoizedState : null;
          } else e = je.next;
          var t = Xe === null ? me.memoizedState : Xe.next;
          if (t !== null) ((Xe = t), (je = e));
          else {
            if (e === null)
              throw me.alternate === null ? Error(r(467)) : Error(r(310));
            ((je = e),
              (e = {
                memoizedState: je.memoizedState,
                baseState: je.baseState,
                baseQueue: je.baseQueue,
                queue: je.queue,
                next: null,
              }),
              Xe === null ? (me.memoizedState = Xe = e) : (Xe = Xe.next = e));
          }
          return Xe;
        }
        function Fr() {
          return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null,
          };
        }
        function Hn(e) {
          var t = zn;
          return (
            (zn += 1),
            qi === null && (qi = []),
            (e = rd(qi, e, t)),
            (t = me),
            (Xe === null ? t.memoizedState : Xe.next) === null &&
              ((t = t.alternate),
              (z.H = t === null || t.memoizedState === null ? Qd : Zd)),
            e
          );
        }
        function Ql(e) {
          if (e !== null && typeof e == 'object') {
            if (typeof e.then == 'function') return Hn(e);
            if (e.$$typeof === H) return ot(e);
          }
          throw Error(r(438, String(e)));
        }
        function Jr(e) {
          var t = null,
            a = me.updateQueue;
          if ((a !== null && (t = a.memoCache), t == null)) {
            var n = me.alternate;
            n !== null &&
              ((n = n.updateQueue),
              n !== null &&
                ((n = n.memoCache),
                n != null &&
                  (t = {
                    data: n.data.map(function (o) {
                      return o.slice();
                    }),
                    index: 0,
                  })));
          }
          if (
            (t == null && (t = { data: [], index: 0 }),
            a === null && ((a = Fr()), (me.updateQueue = a)),
            (a.memoCache = t),
            (a = t.data[t.index]),
            a === void 0)
          )
            for (a = t.data[t.index] = Array(e), n = 0; n < e; n++) a[n] = F;
          return (t.index++, a);
        }
        function fa(e, t) {
          return typeof t == 'function' ? t(e) : t;
        }
        function Zl(e) {
          var t = Qe();
          return eo(t, je, e);
        }
        function eo(e, t, a) {
          var n = e.queue;
          if (n === null) throw Error(r(311));
          n.lastRenderedReducer = a;
          var o = e.baseQueue,
            d = n.pending;
          if (d !== null) {
            if (o !== null) {
              var b = o.next;
              ((o.next = d.next), (d.next = b));
            }
            ((t.baseQueue = o = d), (n.pending = null));
          }
          if (((d = e.baseState), o === null)) e.memoizedState = d;
          else {
            t = o.next;
            var v = (b = null),
              E = null,
              O = t,
              V = !1;
            do {
              var P = O.lane & -536870913;
              if (P !== O.lane ? (xe & P) === P : (Oa & P) === P) {
                var B = O.revertLane;
                if (B === 0)
                  (E !== null &&
                    (E = E.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: O.action,
                        hasEagerState: O.hasEagerState,
                        eagerState: O.eagerState,
                        next: null,
                      }),
                    P === Gi && (V = !0));
                else if ((Oa & B) === B) {
                  ((O = O.next), B === Gi && (V = !0));
                  continue;
                } else
                  ((P = {
                    lane: 0,
                    revertLane: O.revertLane,
                    action: O.action,
                    hasEagerState: O.hasEagerState,
                    eagerState: O.eagerState,
                    next: null,
                  }),
                    E === null ? ((v = E = P), (b = d)) : (E = E.next = P),
                    (me.lanes |= B),
                    (Ua |= B));
                ((P = O.action),
                  fi && a(d, P),
                  (d = O.hasEagerState ? O.eagerState : a(d, P)));
              } else
                ((B = {
                  lane: P,
                  revertLane: O.revertLane,
                  action: O.action,
                  hasEagerState: O.hasEagerState,
                  eagerState: O.eagerState,
                  next: null,
                }),
                  E === null ? ((v = E = B), (b = d)) : (E = E.next = B),
                  (me.lanes |= P),
                  (Ua |= P));
              O = O.next;
            } while (O !== null && O !== t);
            if (
              (E === null ? (b = d) : (E.next = v),
              !Nt(d, e.memoizedState) &&
                ((et = !0), V && ((a = Vi), a !== null)))
            )
              throw a;
            ((e.memoizedState = d),
              (e.baseState = b),
              (e.baseQueue = E),
              (n.lastRenderedState = d));
          }
          return (o === null && (n.lanes = 0), [e.memoizedState, n.dispatch]);
        }
        function to(e) {
          var t = Qe(),
            a = t.queue;
          if (a === null) throw Error(r(311));
          a.lastRenderedReducer = e;
          var n = a.dispatch,
            o = a.pending,
            d = t.memoizedState;
          if (o !== null) {
            a.pending = null;
            var b = (o = o.next);
            do ((d = e(d, b.action)), (b = b.next));
            while (b !== o);
            (Nt(d, t.memoizedState) || (et = !0),
              (t.memoizedState = d),
              t.baseQueue === null && (t.baseState = d),
              (a.lastRenderedState = d));
          }
          return [d, n];
        }
        function pd(e, t, a) {
          var n = me,
            o = Qe(),
            d = _e;
          if (d) {
            if (a === void 0) throw Error(r(407));
            a = a();
          } else a = t();
          var b = !Nt((je || o).memoizedState, a);
          (b && ((o.memoizedState = a), (et = !0)), (o = o.queue));
          var v = vd.bind(null, n, o, e);
          if (
            (Un(2048, 8, v, [e]),
            o.getSnapshot !== t ||
              b ||
              (Xe !== null && Xe.memoizedState.tag & 1))
          ) {
            if (
              ((n.flags |= 2048),
              Pi(9, Wl(), bd.bind(null, n, o, a, t), null),
              Re === null)
            )
              throw Error(r(349));
            d || (Oa & 124) !== 0 || gd(n, t, a);
          }
          return a;
        }
        function gd(e, t, a) {
          ((e.flags |= 16384),
            (e = { getSnapshot: t, value: a }),
            (t = me.updateQueue),
            t === null
              ? ((t = Fr()), (me.updateQueue = t), (t.stores = [e]))
              : ((a = t.stores), a === null ? (t.stores = [e]) : a.push(e)));
        }
        function bd(e, t, a, n) {
          ((t.value = a), (t.getSnapshot = n), yd(t) && Sd(e));
        }
        function vd(e, t, a) {
          return a(function () {
            yd(t) && Sd(e);
          });
        }
        function yd(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var a = t();
            return !Nt(e, a);
          } catch {
            return !0;
          }
        }
        function Sd(e) {
          var t = zi(e, 2);
          t !== null && Ot(t, e, 2);
        }
        function ao(e) {
          var t = gt();
          if (typeof e == 'function') {
            var a = e;
            if (((e = a()), fi)) {
              Ea(!0);
              try {
                a();
              } finally {
                Ea(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: fa,
              lastRenderedState: e,
            }),
            t
          );
        }
        function xd(e, t, a, n) {
          return (
            (e.baseState = a),
            eo(e, je, typeof n == 'function' ? n : fa)
          );
        }
        function Ng(e, t, a, n, o) {
          if (Jl(e)) throw Error(r(485));
          if (((e = t.action), e !== null)) {
            var d = {
              payload: o,
              action: e,
              next: null,
              isTransition: !0,
              status: 'pending',
              value: null,
              reason: null,
              listeners: [],
              then: function (b) {
                d.listeners.push(b);
              },
            };
            (z.T !== null ? a(!0) : (d.isTransition = !1),
              n(d),
              (a = t.pending),
              a === null
                ? ((d.next = t.pending = d), Td(t, d))
                : ((d.next = a.next), (t.pending = a.next = d)));
          }
        }
        function Td(e, t) {
          var a = t.action,
            n = t.payload,
            o = e.state;
          if (t.isTransition) {
            var d = z.T,
              b = {};
            z.T = b;
            try {
              var v = a(o, n),
                E = z.S;
              (E !== null && E(b, v), wd(e, t, v));
            } catch (O) {
              io(e, t, O);
            } finally {
              z.T = d;
            }
          } else
            try {
              ((d = a(o, n)), wd(e, t, d));
            } catch (O) {
              io(e, t, O);
            }
        }
        function wd(e, t, a) {
          a !== null && typeof a == 'object' && typeof a.then == 'function'
            ? a.then(
                function (n) {
                  Ed(e, t, n);
                },
                function (n) {
                  return io(e, t, n);
                }
              )
            : Ed(e, t, a);
        }
        function Ed(e, t, a) {
          ((t.status = 'fulfilled'),
            (t.value = a),
            Nd(t),
            (e.state = a),
            (t = e.pending),
            t !== null &&
              ((a = t.next),
              a === t
                ? (e.pending = null)
                : ((a = a.next), (t.next = a), Td(e, a))));
        }
        function io(e, t, a) {
          var n = e.pending;
          if (((e.pending = null), n !== null)) {
            n = n.next;
            do ((t.status = 'rejected'), (t.reason = a), Nd(t), (t = t.next));
            while (t !== n);
          }
          e.action = null;
        }
        function Nd(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function _d(e, t) {
          return t;
        }
        function Ad(e, t) {
          if (_e) {
            var a = Re.formState;
            if (a !== null) {
              e: {
                var n = me;
                if (_e) {
                  if (Ve) {
                    t: {
                      for (var o = Ve, d = Wt; o.nodeType !== 8; ) {
                        if (!d) {
                          o = null;
                          break t;
                        }
                        if (((o = Xt(o.nextSibling)), o === null)) {
                          o = null;
                          break t;
                        }
                      }
                      ((d = o.data), (o = d === 'F!' || d === 'F' ? o : null));
                    }
                    if (o) {
                      ((Ve = Xt(o.nextSibling)), (n = o.data === 'F!'));
                      break e;
                    }
                  }
                  oi(n);
                }
                n = !1;
              }
              n && (t = a[0]);
            }
          }
          return (
            (a = gt()),
            (a.memoizedState = a.baseState = t),
            (n = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: _d,
              lastRenderedState: t,
            }),
            (a.queue = n),
            (a = Yd.bind(null, me, n)),
            (n.dispatch = a),
            (n = ao(!1)),
            (d = oo.bind(null, me, !1, n.queue)),
            (n = gt()),
            (o = { state: t, dispatch: null, action: e, pending: null }),
            (n.queue = o),
            (a = Ng.bind(null, me, o, d, a)),
            (o.dispatch = a),
            (n.memoizedState = e),
            [t, a, !1]
          );
        }
        function Md(e) {
          var t = Qe();
          return jd(t, je, e);
        }
        function jd(e, t, a) {
          if (
            ((t = eo(e, t, _d)[0]),
            (e = Zl(fa)[0]),
            typeof t == 'object' && t !== null && typeof t.then == 'function')
          )
            try {
              var n = Hn(t);
            } catch (b) {
              throw b === On ? ql : b;
            }
          else n = t;
          t = Qe();
          var o = t.queue,
            d = o.dispatch;
          return (
            a !== t.memoizedState &&
              ((me.flags |= 2048), Pi(9, Wl(), _g.bind(null, o, a), null)),
            [n, d, e]
          );
        }
        function _g(e, t) {
          e.action = t;
        }
        function Cd(e) {
          var t = Qe(),
            a = je;
          if (a !== null) return jd(t, a, e);
          (Qe(), (t = t.memoizedState), (a = Qe()));
          var n = a.queue.dispatch;
          return ((a.memoizedState = e), [t, n, !1]);
        }
        function Pi(e, t, a, n) {
          return (
            (e = { tag: e, create: a, deps: n, inst: t, next: null }),
            (t = me.updateQueue),
            t === null && ((t = Fr()), (me.updateQueue = t)),
            (a = t.lastEffect),
            a === null
              ? (t.lastEffect = e.next = e)
              : ((n = a.next), (a.next = e), (e.next = n), (t.lastEffect = e)),
            e
          );
        }
        function Wl() {
          return { destroy: void 0, resource: void 0 };
        }
        function Od() {
          return Qe().memoizedState;
        }
        function Fl(e, t, a, n) {
          var o = gt();
          ((n = n === void 0 ? null : n),
            (me.flags |= e),
            (o.memoizedState = Pi(1 | t, Wl(), a, n)));
        }
        function Un(e, t, a, n) {
          var o = Qe();
          n = n === void 0 ? null : n;
          var d = o.memoizedState.inst;
          je !== null && n !== null && Kr(n, je.memoizedState.deps)
            ? (o.memoizedState = Pi(t, d, a, n))
            : ((me.flags |= e), (o.memoizedState = Pi(1 | t, d, a, n)));
        }
        function Bd(e, t) {
          Fl(8390656, 8, e, t);
        }
        function Rd(e, t) {
          Un(2048, 8, e, t);
        }
        function Dd(e, t) {
          return Un(4, 2, e, t);
        }
        function Ld(e, t) {
          return Un(4, 4, e, t);
        }
        function zd(e, t) {
          if (typeof t == 'function') {
            e = e();
            var a = t(e);
            return function () {
              typeof a == 'function' ? a() : t(null);
            };
          }
          if (t != null)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function Hd(e, t, a) {
          ((a = a != null ? a.concat([e]) : null),
            Un(4, 4, zd.bind(null, t, e), a));
        }
        function no() {}
        function Ud(e, t) {
          var a = Qe();
          t = t === void 0 ? null : t;
          var n = a.memoizedState;
          return t !== null && Kr(t, n[1])
            ? n[0]
            : ((a.memoizedState = [e, t]), e);
        }
        function Id(e, t) {
          var a = Qe();
          t = t === void 0 ? null : t;
          var n = a.memoizedState;
          if (t !== null && Kr(t, n[1])) return n[0];
          if (((n = e()), fi)) {
            Ea(!0);
            try {
              e();
            } finally {
              Ea(!1);
            }
          }
          return ((a.memoizedState = [n, t]), n);
        }
        function lo(e, t, a) {
          return a === void 0 || (Oa & 1073741824) !== 0
            ? (e.memoizedState = t)
            : ((e.memoizedState = a),
              (e = $f()),
              (me.lanes |= e),
              (Ua |= e),
              a);
        }
        function Gd(e, t, a, n) {
          return Nt(a, t)
            ? a
            : ki.current !== null
              ? ((e = lo(e, a, n)), Nt(e, t) || (et = !0), e)
              : (Oa & 42) === 0
                ? ((et = !0), (e.memoizedState = a))
                : ((e = $f()), (me.lanes |= e), (Ua |= e), t);
        }
        function Vd(e, t, a, n, o) {
          var d = Q.p;
          Q.p = d !== 0 && 8 > d ? d : 8;
          var b = z.T,
            v = {};
          ((z.T = v), oo(e, !1, t, a));
          try {
            var E = o(),
              O = z.S;
            if (
              (O !== null && O(v, E),
              E !== null && typeof E == 'object' && typeof E.then == 'function')
            ) {
              var V = Tg(E, n);
              In(e, t, V, Ct());
            } else In(e, t, n, Ct());
          } catch (P) {
            In(
              e,
              t,
              { then: function () {}, status: 'rejected', reason: P },
              Ct()
            );
          } finally {
            ((Q.p = d), (z.T = b));
          }
        }
        function Ag() {}
        function so(e, t, a, n) {
          if (e.tag !== 5) throw Error(r(476));
          var o = kd(e).queue;
          Vd(
            e,
            o,
            t,
            K,
            a === null
              ? Ag
              : function () {
                  return ($d(e), a(n));
                }
          );
        }
        function kd(e) {
          var t = e.memoizedState;
          if (t !== null) return t;
          t = {
            memoizedState: K,
            baseState: K,
            baseQueue: null,
            queue: {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: fa,
              lastRenderedState: K,
            },
            next: null,
          };
          var a = {};
          return (
            (t.next = {
              memoizedState: a,
              baseState: a,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: fa,
                lastRenderedState: a,
              },
              next: null,
            }),
            (e.memoizedState = t),
            (e = e.alternate),
            e !== null && (e.memoizedState = t),
            t
          );
        }
        function $d(e) {
          var t = kd(e).next.queue;
          In(e, t, {}, Ct());
        }
        function ro() {
          return ot(il);
        }
        function qd() {
          return Qe().memoizedState;
        }
        function Pd() {
          return Qe().memoizedState;
        }
        function Mg(e) {
          for (var t = e.return; t !== null; ) {
            switch (t.tag) {
              case 24:
              case 3:
                var a = Ct();
                e = ja(a);
                var n = Ca(t, e, a);
                (n !== null && (Ot(n, t, a), Rn(n, t, a)),
                  (t = { cache: Hr() }),
                  (e.payload = t));
                return;
            }
            t = t.return;
          }
        }
        function jg(e, t, a) {
          var n = Ct();
          ((a = {
            lane: n,
            revertLane: 0,
            action: a,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Jl(e)
              ? Kd(t, a)
              : ((a = Ar(e, t, a, n)),
                a !== null && (Ot(a, e, n), Xd(a, t, n))));
        }
        function Yd(e, t, a) {
          var n = Ct();
          In(e, t, a, n);
        }
        function In(e, t, a, n) {
          var o = {
            lane: n,
            revertLane: 0,
            action: a,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (Jl(e)) Kd(t, o);
          else {
            var d = e.alternate;
            if (
              e.lanes === 0 &&
              (d === null || d.lanes === 0) &&
              ((d = t.lastRenderedReducer), d !== null)
            )
              try {
                var b = t.lastRenderedState,
                  v = d(b, a);
                if (((o.hasEagerState = !0), (o.eagerState = v), Nt(v, b)))
                  return (zl(e, t, o, 0), Re === null && Ll(), !1);
              } catch {
              } finally {
              }
            if (((a = Ar(e, t, o, n)), a !== null))
              return (Ot(a, e, n), Xd(a, t, n), !0);
          }
          return !1;
        }
        function oo(e, t, a, n) {
          if (
            ((n = {
              lane: 2,
              revertLane: Vo(),
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            Jl(e))
          ) {
            if (t) throw Error(r(479));
          } else ((t = Ar(e, a, n, 2)), t !== null && Ot(t, e, 2));
        }
        function Jl(e) {
          var t = e.alternate;
          return e === me || (t !== null && t === me);
        }
        function Kd(e, t) {
          $i = Kl = !0;
          var a = e.pending;
          (a === null ? (t.next = t) : ((t.next = a.next), (a.next = t)),
            (e.pending = t));
        }
        function Xd(e, t, a) {
          if ((a & 4194048) !== 0) {
            var n = t.lanes;
            ((n &= e.pendingLanes), (a |= n), (t.lanes = a), au(e, a));
          }
        }
        var es = {
            readContext: ot,
            use: Ql,
            useCallback: Pe,
            useContext: Pe,
            useEffect: Pe,
            useImperativeHandle: Pe,
            useLayoutEffect: Pe,
            useInsertionEffect: Pe,
            useMemo: Pe,
            useReducer: Pe,
            useRef: Pe,
            useState: Pe,
            useDebugValue: Pe,
            useDeferredValue: Pe,
            useTransition: Pe,
            useSyncExternalStore: Pe,
            useId: Pe,
            useHostTransitionStatus: Pe,
            useFormState: Pe,
            useActionState: Pe,
            useOptimistic: Pe,
            useMemoCache: Pe,
            useCacheRefresh: Pe,
          },
          Qd = {
            readContext: ot,
            use: Ql,
            useCallback: function (e, t) {
              return ((gt().memoizedState = [e, t === void 0 ? null : t]), e);
            },
            useContext: ot,
            useEffect: Bd,
            useImperativeHandle: function (e, t, a) {
              ((a = a != null ? a.concat([e]) : null),
                Fl(4194308, 4, zd.bind(null, t, e), a));
            },
            useLayoutEffect: function (e, t) {
              return Fl(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              Fl(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var a = gt();
              t = t === void 0 ? null : t;
              var n = e();
              if (fi) {
                Ea(!0);
                try {
                  e();
                } finally {
                  Ea(!1);
                }
              }
              return ((a.memoizedState = [n, t]), n);
            },
            useReducer: function (e, t, a) {
              var n = gt();
              if (a !== void 0) {
                var o = a(t);
                if (fi) {
                  Ea(!0);
                  try {
                    a(t);
                  } finally {
                    Ea(!1);
                  }
                }
              } else o = t;
              return (
                (n.memoizedState = n.baseState = o),
                (e = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: o,
                }),
                (n.queue = e),
                (e = e.dispatch = jg.bind(null, me, e)),
                [n.memoizedState, e]
              );
            },
            useRef: function (e) {
              var t = gt();
              return ((e = { current: e }), (t.memoizedState = e));
            },
            useState: function (e) {
              e = ao(e);
              var t = e.queue,
                a = Yd.bind(null, me, t);
              return ((t.dispatch = a), [e.memoizedState, a]);
            },
            useDebugValue: no,
            useDeferredValue: function (e, t) {
              var a = gt();
              return lo(a, e, t);
            },
            useTransition: function () {
              var e = ao(!1);
              return (
                (e = Vd.bind(null, me, e.queue, !0, !1)),
                (gt().memoizedState = e),
                [!1, e]
              );
            },
            useSyncExternalStore: function (e, t, a) {
              var n = me,
                o = gt();
              if (_e) {
                if (a === void 0) throw Error(r(407));
                a = a();
              } else {
                if (((a = t()), Re === null)) throw Error(r(349));
                (xe & 124) !== 0 || gd(n, t, a);
              }
              o.memoizedState = a;
              var d = { value: a, getSnapshot: t };
              return (
                (o.queue = d),
                Bd(vd.bind(null, n, d, e), [e]),
                (n.flags |= 2048),
                Pi(9, Wl(), bd.bind(null, n, d, a, t), null),
                a
              );
            },
            useId: function () {
              var e = gt(),
                t = Re.identifierPrefix;
              if (_e) {
                var a = ca,
                  n = oa;
                ((a = (n & ~(1 << (32 - Et(n) - 1))).toString(32) + a),
                  (t = '«' + t + 'R' + a),
                  (a = Xl++),
                  0 < a && (t += 'H' + a.toString(32)),
                  (t += '»'));
              } else ((a = wg++), (t = '«' + t + 'r' + a.toString(32) + '»'));
              return (e.memoizedState = t);
            },
            useHostTransitionStatus: ro,
            useFormState: Ad,
            useActionState: Ad,
            useOptimistic: function (e) {
              var t = gt();
              t.memoizedState = t.baseState = e;
              var a = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (t.queue = a),
                (t = oo.bind(null, me, !0, a)),
                (a.dispatch = t),
                [e, t]
              );
            },
            useMemoCache: Jr,
            useCacheRefresh: function () {
              return (gt().memoizedState = Mg.bind(null, me));
            },
          },
          Zd = {
            readContext: ot,
            use: Ql,
            useCallback: Ud,
            useContext: ot,
            useEffect: Rd,
            useImperativeHandle: Hd,
            useInsertionEffect: Dd,
            useLayoutEffect: Ld,
            useMemo: Id,
            useReducer: Zl,
            useRef: Od,
            useState: function () {
              return Zl(fa);
            },
            useDebugValue: no,
            useDeferredValue: function (e, t) {
              var a = Qe();
              return Gd(a, je.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Zl(fa)[0],
                t = Qe().memoizedState;
              return [typeof e == 'boolean' ? e : Hn(e), t];
            },
            useSyncExternalStore: pd,
            useId: qd,
            useHostTransitionStatus: ro,
            useFormState: Md,
            useActionState: Md,
            useOptimistic: function (e, t) {
              var a = Qe();
              return xd(a, je, e, t);
            },
            useMemoCache: Jr,
            useCacheRefresh: Pd,
          },
          Cg = {
            readContext: ot,
            use: Ql,
            useCallback: Ud,
            useContext: ot,
            useEffect: Rd,
            useImperativeHandle: Hd,
            useInsertionEffect: Dd,
            useLayoutEffect: Ld,
            useMemo: Id,
            useReducer: to,
            useRef: Od,
            useState: function () {
              return to(fa);
            },
            useDebugValue: no,
            useDeferredValue: function (e, t) {
              var a = Qe();
              return je === null ? lo(a, e, t) : Gd(a, je.memoizedState, e, t);
            },
            useTransition: function () {
              var e = to(fa)[0],
                t = Qe().memoizedState;
              return [typeof e == 'boolean' ? e : Hn(e), t];
            },
            useSyncExternalStore: pd,
            useId: qd,
            useHostTransitionStatus: ro,
            useFormState: Cd,
            useActionState: Cd,
            useOptimistic: function (e, t) {
              var a = Qe();
              return je !== null
                ? xd(a, je, e, t)
                : ((a.baseState = e), [e, a.queue.dispatch]);
            },
            useMemoCache: Jr,
            useCacheRefresh: Pd,
          },
          Yi = null,
          Gn = 0;
        function ts(e) {
          var t = Gn;
          return ((Gn += 1), Yi === null && (Yi = []), rd(Yi, e, t));
        }
        function Vn(e, t) {
          ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
        }
        function as(e, t) {
          throw t.$$typeof === S
            ? Error(r(525))
            : ((e = Object.prototype.toString.call(t)),
              Error(
                r(
                  31,
                  e === '[object Object]'
                    ? 'object with keys {' + Object.keys(t).join(', ') + '}'
                    : e
                )
              ));
        }
        function Wd(e) {
          var t = e._init;
          return t(e._payload);
        }
        function Fd(e) {
          function t(M, _) {
            if (e) {
              var C = M.deletions;
              C === null ? ((M.deletions = [_]), (M.flags |= 16)) : C.push(_);
            }
          }
          function a(M, _) {
            if (!e) return null;
            for (; _ !== null; ) (t(M, _), (_ = _.sibling));
            return null;
          }
          function n(M) {
            for (var _ = new Map(); M !== null; )
              (M.key !== null ? _.set(M.key, M) : _.set(M.index, M),
                (M = M.sibling));
            return _;
          }
          function o(M, _) {
            return ((M = ra(M, _)), (M.index = 0), (M.sibling = null), M);
          }
          function d(M, _, C) {
            return (
              (M.index = C),
              e
                ? ((C = M.alternate),
                  C !== null
                    ? ((C = C.index), C < _ ? ((M.flags |= 67108866), _) : C)
                    : ((M.flags |= 67108866), _))
                : ((M.flags |= 1048576), _)
            );
          }
          function b(M) {
            return (e && M.alternate === null && (M.flags |= 67108866), M);
          }
          function v(M, _, C, k) {
            return _ === null || _.tag !== 6
              ? ((_ = jr(C, M.mode, k)), (_.return = M), _)
              : ((_ = o(_, C)), (_.return = M), _);
          }
          function E(M, _, C, k) {
            var te = C.type;
            return te === T
              ? V(M, _, C.props.children, k, C.key)
              : _ !== null &&
                  (_.elementType === te ||
                    (typeof te == 'object' &&
                      te !== null &&
                      te.$$typeof === q &&
                      Wd(te) === _.type))
                ? ((_ = o(_, C.props)), Vn(_, C), (_.return = M), _)
                : ((_ = Ul(C.type, C.key, C.props, null, M.mode, k)),
                  Vn(_, C),
                  (_.return = M),
                  _);
          }
          function O(M, _, C, k) {
            return _ === null ||
              _.tag !== 4 ||
              _.stateNode.containerInfo !== C.containerInfo ||
              _.stateNode.implementation !== C.implementation
              ? ((_ = Cr(C, M.mode, k)), (_.return = M), _)
              : ((_ = o(_, C.children || [])), (_.return = M), _);
          }
          function V(M, _, C, k, te) {
            return _ === null || _.tag !== 7
              ? ((_ = ni(C, M.mode, k, te)), (_.return = M), _)
              : ((_ = o(_, C)), (_.return = M), _);
          }
          function P(M, _, C) {
            if (
              (typeof _ == 'string' && _ !== '') ||
              typeof _ == 'number' ||
              typeof _ == 'bigint'
            )
              return ((_ = jr('' + _, M.mode, C)), (_.return = M), _);
            if (typeof _ == 'object' && _ !== null) {
              switch (_.$$typeof) {
                case w:
                  return (
                    (C = Ul(_.type, _.key, _.props, null, M.mode, C)),
                    Vn(C, _),
                    (C.return = M),
                    C
                  );
                case x:
                  return ((_ = Cr(_, M.mode, C)), (_.return = M), _);
                case q:
                  var k = _._init;
                  return ((_ = k(_._payload)), P(M, _, C));
              }
              if (Ne(_) || ae(_))
                return ((_ = ni(_, M.mode, C, null)), (_.return = M), _);
              if (typeof _.then == 'function') return P(M, ts(_), C);
              if (_.$$typeof === H) return P(M, kl(M, _), C);
              as(M, _);
            }
            return null;
          }
          function B(M, _, C, k) {
            var te = _ !== null ? _.key : null;
            if (
              (typeof C == 'string' && C !== '') ||
              typeof C == 'number' ||
              typeof C == 'bigint'
            )
              return te !== null ? null : v(M, _, '' + C, k);
            if (typeof C == 'object' && C !== null) {
              switch (C.$$typeof) {
                case w:
                  return C.key === te ? E(M, _, C, k) : null;
                case x:
                  return C.key === te ? O(M, _, C, k) : null;
                case q:
                  return ((te = C._init), (C = te(C._payload)), B(M, _, C, k));
              }
              if (Ne(C) || ae(C))
                return te !== null ? null : V(M, _, C, k, null);
              if (typeof C.then == 'function') return B(M, _, ts(C), k);
              if (C.$$typeof === H) return B(M, _, kl(M, C), k);
              as(M, C);
            }
            return null;
          }
          function R(M, _, C, k, te) {
            if (
              (typeof k == 'string' && k !== '') ||
              typeof k == 'number' ||
              typeof k == 'bigint'
            )
              return ((M = M.get(C) || null), v(_, M, '' + k, te));
            if (typeof k == 'object' && k !== null) {
              switch (k.$$typeof) {
                case w:
                  return (
                    (M = M.get(k.key === null ? C : k.key) || null),
                    E(_, M, k, te)
                  );
                case x:
                  return (
                    (M = M.get(k.key === null ? C : k.key) || null),
                    O(_, M, k, te)
                  );
                case q:
                  var pe = k._init;
                  return ((k = pe(k._payload)), R(M, _, C, k, te));
              }
              if (Ne(k) || ae(k))
                return ((M = M.get(C) || null), V(_, M, k, te, null));
              if (typeof k.then == 'function') return R(M, _, C, ts(k), te);
              if (k.$$typeof === H) return R(M, _, C, kl(_, k), te);
              as(_, k);
            }
            return null;
          }
          function ce(M, _, C, k) {
            for (
              var te = null, pe = null, ne = _, oe = (_ = 0), at = null;
              ne !== null && oe < C.length;
              oe++
            ) {
              ne.index > oe ? ((at = ne), (ne = null)) : (at = ne.sibling);
              var we = B(M, ne, C[oe], k);
              if (we === null) {
                ne === null && (ne = at);
                break;
              }
              (e && ne && we.alternate === null && t(M, ne),
                (_ = d(we, _, oe)),
                pe === null ? (te = we) : (pe.sibling = we),
                (pe = we),
                (ne = at));
            }
            if (oe === C.length) return (a(M, ne), _e && si(M, oe), te);
            if (ne === null) {
              for (; oe < C.length; oe++)
                ((ne = P(M, C[oe], k)),
                  ne !== null &&
                    ((_ = d(ne, _, oe)),
                    pe === null ? (te = ne) : (pe.sibling = ne),
                    (pe = ne)));
              return (_e && si(M, oe), te);
            }
            for (ne = n(ne); oe < C.length; oe++)
              ((at = R(ne, M, oe, C[oe], k)),
                at !== null &&
                  (e &&
                    at.alternate !== null &&
                    ne.delete(at.key === null ? oe : at.key),
                  (_ = d(at, _, oe)),
                  pe === null ? (te = at) : (pe.sibling = at),
                  (pe = at)));
            return (
              e &&
                ne.forEach(function (Ka) {
                  return t(M, Ka);
                }),
              _e && si(M, oe),
              te
            );
          }
          function re(M, _, C, k) {
            if (C == null) throw Error(r(151));
            for (
              var te = null,
                pe = null,
                ne = _,
                oe = (_ = 0),
                at = null,
                we = C.next();
              ne !== null && !we.done;
              oe++, we = C.next()
            ) {
              ne.index > oe ? ((at = ne), (ne = null)) : (at = ne.sibling);
              var Ka = B(M, ne, we.value, k);
              if (Ka === null) {
                ne === null && (ne = at);
                break;
              }
              (e && ne && Ka.alternate === null && t(M, ne),
                (_ = d(Ka, _, oe)),
                pe === null ? (te = Ka) : (pe.sibling = Ka),
                (pe = Ka),
                (ne = at));
            }
            if (we.done) return (a(M, ne), _e && si(M, oe), te);
            if (ne === null) {
              for (; !we.done; oe++, we = C.next())
                ((we = P(M, we.value, k)),
                  we !== null &&
                    ((_ = d(we, _, oe)),
                    pe === null ? (te = we) : (pe.sibling = we),
                    (pe = we)));
              return (_e && si(M, oe), te);
            }
            for (ne = n(ne); !we.done; oe++, we = C.next())
              ((we = R(ne, M, oe, we.value, k)),
                we !== null &&
                  (e &&
                    we.alternate !== null &&
                    ne.delete(we.key === null ? oe : we.key),
                  (_ = d(we, _, oe)),
                  pe === null ? (te = we) : (pe.sibling = we),
                  (pe = we)));
            return (
              e &&
                ne.forEach(function (Ob) {
                  return t(M, Ob);
                }),
              _e && si(M, oe),
              te
            );
          }
          function Oe(M, _, C, k) {
            if (
              (typeof C == 'object' &&
                C !== null &&
                C.type === T &&
                C.key === null &&
                (C = C.props.children),
              typeof C == 'object' && C !== null)
            ) {
              switch (C.$$typeof) {
                case w:
                  e: {
                    for (var te = C.key; _ !== null; ) {
                      if (_.key === te) {
                        if (((te = C.type), te === T)) {
                          if (_.tag === 7) {
                            (a(M, _.sibling),
                              (k = o(_, C.props.children)),
                              (k.return = M),
                              (M = k));
                            break e;
                          }
                        } else if (
                          _.elementType === te ||
                          (typeof te == 'object' &&
                            te !== null &&
                            te.$$typeof === q &&
                            Wd(te) === _.type)
                        ) {
                          (a(M, _.sibling),
                            (k = o(_, C.props)),
                            Vn(k, C),
                            (k.return = M),
                            (M = k));
                          break e;
                        }
                        a(M, _);
                        break;
                      } else t(M, _);
                      _ = _.sibling;
                    }
                    C.type === T
                      ? ((k = ni(C.props.children, M.mode, k, C.key)),
                        (k.return = M),
                        (M = k))
                      : ((k = Ul(C.type, C.key, C.props, null, M.mode, k)),
                        Vn(k, C),
                        (k.return = M),
                        (M = k));
                  }
                  return b(M);
                case x:
                  e: {
                    for (te = C.key; _ !== null; ) {
                      if (_.key === te)
                        if (
                          _.tag === 4 &&
                          _.stateNode.containerInfo === C.containerInfo &&
                          _.stateNode.implementation === C.implementation
                        ) {
                          (a(M, _.sibling),
                            (k = o(_, C.children || [])),
                            (k.return = M),
                            (M = k));
                          break e;
                        } else {
                          a(M, _);
                          break;
                        }
                      else t(M, _);
                      _ = _.sibling;
                    }
                    ((k = Cr(C, M.mode, k)), (k.return = M), (M = k));
                  }
                  return b(M);
                case q:
                  return ((te = C._init), (C = te(C._payload)), Oe(M, _, C, k));
              }
              if (Ne(C)) return ce(M, _, C, k);
              if (ae(C)) {
                if (((te = ae(C)), typeof te != 'function'))
                  throw Error(r(150));
                return ((C = te.call(C)), re(M, _, C, k));
              }
              if (typeof C.then == 'function') return Oe(M, _, ts(C), k);
              if (C.$$typeof === H) return Oe(M, _, kl(M, C), k);
              as(M, C);
            }
            return (typeof C == 'string' && C !== '') ||
              typeof C == 'number' ||
              typeof C == 'bigint'
              ? ((C = '' + C),
                _ !== null && _.tag === 6
                  ? (a(M, _.sibling), (k = o(_, C)), (k.return = M), (M = k))
                  : (a(M, _), (k = jr(C, M.mode, k)), (k.return = M), (M = k)),
                b(M))
              : a(M, _);
          }
          return function (M, _, C, k) {
            try {
              Gn = 0;
              var te = Oe(M, _, C, k);
              return ((Yi = null), te);
            } catch (ne) {
              if (ne === On || ne === ql) throw ne;
              var pe = _t(29, ne, null, M.mode);
              return ((pe.lanes = k), (pe.return = M), pe);
            } finally {
            }
          };
        }
        var Ki = Fd(!0),
          Jd = Fd(!1),
          kt = I(null),
          Ft = null;
        function Ba(e) {
          var t = e.alternate;
          (J(We, We.current & 1),
            J(kt, e),
            Ft === null &&
              (t === null || ki.current !== null || t.memoizedState !== null) &&
              (Ft = e));
        }
        function ef(e) {
          if (e.tag === 22) {
            if ((J(We, We.current), J(kt, e), Ft === null)) {
              var t = e.alternate;
              t !== null && t.memoizedState !== null && (Ft = e);
            }
          } else Ra();
        }
        function Ra() {
          (J(We, We.current), J(kt, kt.current));
        }
        function ha(e) {
          (ee(kt), Ft === e && (Ft = null), ee(We));
        }
        var We = I(0);
        function is(e) {
          for (var t = e; t !== null; ) {
            if (t.tag === 13) {
              var a = t.memoizedState;
              if (
                a !== null &&
                ((a = a.dehydrated), a === null || a.data === '$?' || Jo(a))
              )
                return t;
            } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
              if ((t.flags & 128) !== 0) return t;
            } else if (t.child !== null) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === e) break;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) return null;
              t = t.return;
            }
            ((t.sibling.return = t.return), (t = t.sibling));
          }
          return null;
        }
        function co(e, t, a, n) {
          ((t = e.memoizedState),
            (a = a(n, t)),
            (a = a == null ? t : y({}, t, a)),
            (e.memoizedState = a),
            e.lanes === 0 && (e.updateQueue.baseState = a));
        }
        var uo = {
          enqueueSetState: function (e, t, a) {
            e = e._reactInternals;
            var n = Ct(),
              o = ja(n);
            ((o.payload = t),
              a != null && (o.callback = a),
              (t = Ca(e, o, n)),
              t !== null && (Ot(t, e, n), Rn(t, e, n)));
          },
          enqueueReplaceState: function (e, t, a) {
            e = e._reactInternals;
            var n = Ct(),
              o = ja(n);
            ((o.tag = 1),
              (o.payload = t),
              a != null && (o.callback = a),
              (t = Ca(e, o, n)),
              t !== null && (Ot(t, e, n), Rn(t, e, n)));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var a = Ct(),
              n = ja(a);
            ((n.tag = 2),
              t != null && (n.callback = t),
              (t = Ca(e, n, a)),
              t !== null && (Ot(t, e, a), Rn(t, e, a)));
          },
        };
        function tf(e, t, a, n, o, d, b) {
          return (
            (e = e.stateNode),
            typeof e.shouldComponentUpdate == 'function'
              ? e.shouldComponentUpdate(n, d, b)
              : t.prototype && t.prototype.isPureReactComponent
                ? !wn(a, n) || !wn(o, d)
                : !0
          );
        }
        function af(e, t, a, n) {
          ((e = t.state),
            typeof t.componentWillReceiveProps == 'function' &&
              t.componentWillReceiveProps(a, n),
            typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
              t.UNSAFE_componentWillReceiveProps(a, n),
            t.state !== e && uo.enqueueReplaceState(t, t.state, null));
        }
        function hi(e, t) {
          var a = t;
          if ('ref' in t) {
            a = {};
            for (var n in t) n !== 'ref' && (a[n] = t[n]);
          }
          if ((e = e.defaultProps)) {
            a === t && (a = y({}, a));
            for (var o in e) a[o] === void 0 && (a[o] = e[o]);
          }
          return a;
        }
        var ns =
          typeof reportError == 'function'
            ? reportError
            : function (e) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var t = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof e == 'object' &&
                      e !== null &&
                      typeof e.message == 'string'
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', e);
                  return;
                }
                console.error(e);
              };
        function nf(e) {
          ns(e);
        }
        function lf(e) {
          console.error(e);
        }
        function sf(e) {
          ns(e);
        }
        function ls(e, t) {
          try {
            var a = e.onUncaughtError;
            a(t.value, { componentStack: t.stack });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function rf(e, t, a) {
          try {
            var n = e.onCaughtError;
            n(a.value, {
              componentStack: a.stack,
              errorBoundary: t.tag === 1 ? t.stateNode : null,
            });
          } catch (o) {
            setTimeout(function () {
              throw o;
            });
          }
        }
        function fo(e, t, a) {
          return (
            (a = ja(a)),
            (a.tag = 3),
            (a.payload = { element: null }),
            (a.callback = function () {
              ls(e, t);
            }),
            a
          );
        }
        function of(e) {
          return ((e = ja(e)), (e.tag = 3), e);
        }
        function cf(e, t, a, n) {
          var o = a.type.getDerivedStateFromError;
          if (typeof o == 'function') {
            var d = n.value;
            ((e.payload = function () {
              return o(d);
            }),
              (e.callback = function () {
                rf(t, a, n);
              }));
          }
          var b = a.stateNode;
          b !== null &&
            typeof b.componentDidCatch == 'function' &&
            (e.callback = function () {
              (rf(t, a, n),
                typeof o != 'function' &&
                  (Ia === null ? (Ia = new Set([this])) : Ia.add(this)));
              var v = n.stack;
              this.componentDidCatch(n.value, {
                componentStack: v !== null ? v : '',
              });
            });
        }
        function Og(e, t, a, n, o) {
          if (
            ((a.flags |= 32768),
            n !== null && typeof n == 'object' && typeof n.then == 'function')
          ) {
            if (
              ((t = a.alternate),
              t !== null && Mn(t, a, o, !0),
              (a = kt.current),
              a !== null)
            ) {
              switch (a.tag) {
                case 13:
                  return (
                    Ft === null
                      ? zo()
                      : a.alternate === null && ke === 0 && (ke = 3),
                    (a.flags &= -257),
                    (a.flags |= 65536),
                    (a.lanes = o),
                    n === Gr
                      ? (a.flags |= 16384)
                      : ((t = a.updateQueue),
                        t === null ? (a.updateQueue = new Set([n])) : t.add(n),
                        Uo(e, n, o)),
                    !1
                  );
                case 22:
                  return (
                    (a.flags |= 65536),
                    n === Gr
                      ? (a.flags |= 16384)
                      : ((t = a.updateQueue),
                        t === null
                          ? ((t = {
                              transitions: null,
                              markerInstances: null,
                              retryQueue: new Set([n]),
                            }),
                            (a.updateQueue = t))
                          : ((a = t.retryQueue),
                            a === null
                              ? (t.retryQueue = new Set([n]))
                              : a.add(n)),
                        Uo(e, n, o)),
                    !1
                  );
              }
              throw Error(r(435, a.tag));
            }
            return (Uo(e, n, o), zo(), !1);
          }
          if (_e)
            return (
              (t = kt.current),
              t !== null
                ? ((t.flags & 65536) === 0 && (t.flags |= 256),
                  (t.flags |= 65536),
                  (t.lanes = o),
                  n !== Rr && ((e = Error(r(422), { cause: n })), An(Ut(e, a))))
                : (n !== Rr &&
                    ((t = Error(r(423), { cause: n })), An(Ut(t, a))),
                  (e = e.current.alternate),
                  (e.flags |= 65536),
                  (o &= -o),
                  (e.lanes |= o),
                  (n = Ut(n, a)),
                  (o = fo(e.stateNode, n, o)),
                  $r(e, o),
                  ke !== 4 && (ke = 2)),
              !1
            );
          var d = Error(r(520), { cause: n });
          if (
            ((d = Ut(d, a)),
            Xn === null ? (Xn = [d]) : Xn.push(d),
            ke !== 4 && (ke = 2),
            t === null)
          )
            return !0;
          ((n = Ut(n, a)), (a = t));
          do {
            switch (a.tag) {
              case 3:
                return (
                  (a.flags |= 65536),
                  (e = o & -o),
                  (a.lanes |= e),
                  (e = fo(a.stateNode, n, e)),
                  $r(a, e),
                  !1
                );
              case 1:
                if (
                  ((t = a.type),
                  (d = a.stateNode),
                  (a.flags & 128) === 0 &&
                    (typeof t.getDerivedStateFromError == 'function' ||
                      (d !== null &&
                        typeof d.componentDidCatch == 'function' &&
                        (Ia === null || !Ia.has(d)))))
                )
                  return (
                    (a.flags |= 65536),
                    (o &= -o),
                    (a.lanes |= o),
                    (o = of(o)),
                    cf(o, e, a, n),
                    $r(a, o),
                    !1
                  );
            }
            a = a.return;
          } while (a !== null);
          return !1;
        }
        var uf = Error(r(461)),
          et = !1;
        function nt(e, t, a, n) {
          t.child = e === null ? Jd(t, null, a, n) : Ki(t, e.child, a, n);
        }
        function df(e, t, a, n, o) {
          a = a.render;
          var d = t.ref;
          if ('ref' in n) {
            var b = {};
            for (var v in n) v !== 'ref' && (b[v] = n[v]);
          } else b = n;
          return (
            ui(t),
            (n = Xr(e, t, a, b, d, o)),
            (v = Qr()),
            e !== null && !et
              ? (Zr(e, t, o), ma(e, t, o))
              : (_e && v && Or(t), (t.flags |= 1), nt(e, t, n, o), t.child)
          );
        }
        function ff(e, t, a, n, o) {
          if (e === null) {
            var d = a.type;
            return typeof d == 'function' &&
              !Mr(d) &&
              d.defaultProps === void 0 &&
              a.compare === null
              ? ((t.tag = 15), (t.type = d), hf(e, t, d, n, o))
              : ((e = Ul(a.type, null, n, t, t.mode, o)),
                (e.ref = t.ref),
                (e.return = t),
                (t.child = e));
          }
          if (((d = e.child), !So(e, o))) {
            var b = d.memoizedProps;
            if (
              ((a = a.compare),
              (a = a !== null ? a : wn),
              a(b, n) && e.ref === t.ref)
            )
              return ma(e, t, o);
          }
          return (
            (t.flags |= 1),
            (e = ra(d, n)),
            (e.ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function hf(e, t, a, n, o) {
          if (e !== null) {
            var d = e.memoizedProps;
            if (wn(d, n) && e.ref === t.ref)
              if (((et = !1), (t.pendingProps = n = d), So(e, o)))
                (e.flags & 131072) !== 0 && (et = !0);
              else return ((t.lanes = e.lanes), ma(e, t, o));
          }
          return ho(e, t, a, n, o);
        }
        function mf(e, t, a) {
          var n = t.pendingProps,
            o = n.children,
            d = e !== null ? e.memoizedState : null;
          if (n.mode === 'hidden') {
            if ((t.flags & 128) !== 0) {
              if (((n = d !== null ? d.baseLanes | a : a), e !== null)) {
                for (o = t.child = e.child, d = 0; o !== null; )
                  ((d = d | o.lanes | o.childLanes), (o = o.sibling));
                t.childLanes = d & ~n;
              } else ((t.childLanes = 0), (t.child = null));
              return pf(e, t, n, a);
            }
            if ((a & 536870912) !== 0)
              ((t.memoizedState = { baseLanes: 0, cachePool: null }),
                e !== null && $l(t, d !== null ? d.cachePool : null),
                d !== null ? fd(t, d) : Pr(),
                ef(t));
            else
              return (
                (t.lanes = t.childLanes = 536870912),
                pf(e, t, d !== null ? d.baseLanes | a : a, a)
              );
          } else
            d !== null
              ? ($l(t, d.cachePool), fd(t, d), Ra(), (t.memoizedState = null))
              : (e !== null && $l(t, null), Pr(), Ra());
          return (nt(e, t, o, a), t.child);
        }
        function pf(e, t, a, n) {
          var o = Ir();
          return (
            (o = o === null ? null : { parent: Ze._currentValue, pool: o }),
            (t.memoizedState = { baseLanes: a, cachePool: o }),
            e !== null && $l(t, null),
            Pr(),
            ef(t),
            e !== null && Mn(e, t, n, !0),
            null
          );
        }
        function ss(e, t) {
          var a = t.ref;
          if (a === null) e !== null && e.ref !== null && (t.flags |= 4194816);
          else {
            if (typeof a != 'function' && typeof a != 'object')
              throw Error(r(284));
            (e === null || e.ref !== a) && (t.flags |= 4194816);
          }
        }
        function ho(e, t, a, n, o) {
          return (
            ui(t),
            (a = Xr(e, t, a, n, void 0, o)),
            (n = Qr()),
            e !== null && !et
              ? (Zr(e, t, o), ma(e, t, o))
              : (_e && n && Or(t), (t.flags |= 1), nt(e, t, a, o), t.child)
          );
        }
        function gf(e, t, a, n, o, d) {
          return (
            ui(t),
            (t.updateQueue = null),
            (a = md(t, n, a, o)),
            hd(e),
            (n = Qr()),
            e !== null && !et
              ? (Zr(e, t, d), ma(e, t, d))
              : (_e && n && Or(t), (t.flags |= 1), nt(e, t, a, d), t.child)
          );
        }
        function bf(e, t, a, n, o) {
          if ((ui(t), t.stateNode === null)) {
            var d = Hi,
              b = a.contextType;
            (typeof b == 'object' && b !== null && (d = ot(b)),
              (d = new a(n, d)),
              (t.memoizedState =
                d.state !== null && d.state !== void 0 ? d.state : null),
              (d.updater = uo),
              (t.stateNode = d),
              (d._reactInternals = t),
              (d = t.stateNode),
              (d.props = n),
              (d.state = t.memoizedState),
              (d.refs = {}),
              Vr(t),
              (b = a.contextType),
              (d.context = typeof b == 'object' && b !== null ? ot(b) : Hi),
              (d.state = t.memoizedState),
              (b = a.getDerivedStateFromProps),
              typeof b == 'function' &&
                (co(t, a, b, n), (d.state = t.memoizedState)),
              typeof a.getDerivedStateFromProps == 'function' ||
                typeof d.getSnapshotBeforeUpdate == 'function' ||
                (typeof d.UNSAFE_componentWillMount != 'function' &&
                  typeof d.componentWillMount != 'function') ||
                ((b = d.state),
                typeof d.componentWillMount == 'function' &&
                  d.componentWillMount(),
                typeof d.UNSAFE_componentWillMount == 'function' &&
                  d.UNSAFE_componentWillMount(),
                b !== d.state && uo.enqueueReplaceState(d, d.state, null),
                Ln(t, n, d, o),
                Dn(),
                (d.state = t.memoizedState)),
              typeof d.componentDidMount == 'function' && (t.flags |= 4194308),
              (n = !0));
          } else if (e === null) {
            d = t.stateNode;
            var v = t.memoizedProps,
              E = hi(a, v);
            d.props = E;
            var O = d.context,
              V = a.contextType;
            ((b = Hi), typeof V == 'object' && V !== null && (b = ot(V)));
            var P = a.getDerivedStateFromProps;
            ((V =
              typeof P == 'function' ||
              typeof d.getSnapshotBeforeUpdate == 'function'),
              (v = t.pendingProps !== v),
              V ||
                (typeof d.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof d.componentWillReceiveProps != 'function') ||
                ((v || O !== b) && af(t, d, n, b)),
              (Ma = !1));
            var B = t.memoizedState;
            ((d.state = B),
              Ln(t, n, d, o),
              Dn(),
              (O = t.memoizedState),
              v || B !== O || Ma
                ? (typeof P == 'function' &&
                    (co(t, a, P, n), (O = t.memoizedState)),
                  (E = Ma || tf(t, a, E, n, B, O, b))
                    ? (V ||
                        (typeof d.UNSAFE_componentWillMount != 'function' &&
                          typeof d.componentWillMount != 'function') ||
                        (typeof d.componentWillMount == 'function' &&
                          d.componentWillMount(),
                        typeof d.UNSAFE_componentWillMount == 'function' &&
                          d.UNSAFE_componentWillMount()),
                      typeof d.componentDidMount == 'function' &&
                        (t.flags |= 4194308))
                    : (typeof d.componentDidMount == 'function' &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = n),
                      (t.memoizedState = O)),
                  (d.props = n),
                  (d.state = O),
                  (d.context = b),
                  (n = E))
                : (typeof d.componentDidMount == 'function' &&
                    (t.flags |= 4194308),
                  (n = !1)));
          } else {
            ((d = t.stateNode),
              kr(e, t),
              (b = t.memoizedProps),
              (V = hi(a, b)),
              (d.props = V),
              (P = t.pendingProps),
              (B = d.context),
              (O = a.contextType),
              (E = Hi),
              typeof O == 'object' && O !== null && (E = ot(O)),
              (v = a.getDerivedStateFromProps),
              (O =
                typeof v == 'function' ||
                typeof d.getSnapshotBeforeUpdate == 'function') ||
                (typeof d.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof d.componentWillReceiveProps != 'function') ||
                ((b !== P || B !== E) && af(t, d, n, E)),
              (Ma = !1),
              (B = t.memoizedState),
              (d.state = B),
              Ln(t, n, d, o),
              Dn());
            var R = t.memoizedState;
            b !== P ||
            B !== R ||
            Ma ||
            (e !== null && e.dependencies !== null && Vl(e.dependencies))
              ? (typeof v == 'function' &&
                  (co(t, a, v, n), (R = t.memoizedState)),
                (V =
                  Ma ||
                  tf(t, a, V, n, B, R, E) ||
                  (e !== null && e.dependencies !== null && Vl(e.dependencies)))
                  ? (O ||
                      (typeof d.UNSAFE_componentWillUpdate != 'function' &&
                        typeof d.componentWillUpdate != 'function') ||
                      (typeof d.componentWillUpdate == 'function' &&
                        d.componentWillUpdate(n, R, E),
                      typeof d.UNSAFE_componentWillUpdate == 'function' &&
                        d.UNSAFE_componentWillUpdate(n, R, E)),
                    typeof d.componentDidUpdate == 'function' && (t.flags |= 4),
                    typeof d.getSnapshotBeforeUpdate == 'function' &&
                      (t.flags |= 1024))
                  : (typeof d.componentDidUpdate != 'function' ||
                      (b === e.memoizedProps && B === e.memoizedState) ||
                      (t.flags |= 4),
                    typeof d.getSnapshotBeforeUpdate != 'function' ||
                      (b === e.memoizedProps && B === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = n),
                    (t.memoizedState = R)),
                (d.props = n),
                (d.state = R),
                (d.context = E),
                (n = V))
              : (typeof d.componentDidUpdate != 'function' ||
                  (b === e.memoizedProps && B === e.memoizedState) ||
                  (t.flags |= 4),
                typeof d.getSnapshotBeforeUpdate != 'function' ||
                  (b === e.memoizedProps && B === e.memoizedState) ||
                  (t.flags |= 1024),
                (n = !1));
          }
          return (
            (d = n),
            ss(e, t),
            (n = (t.flags & 128) !== 0),
            d || n
              ? ((d = t.stateNode),
                (a =
                  n && typeof a.getDerivedStateFromError != 'function'
                    ? null
                    : d.render()),
                (t.flags |= 1),
                e !== null && n
                  ? ((t.child = Ki(t, e.child, null, o)),
                    (t.child = Ki(t, null, a, o)))
                  : nt(e, t, a, o),
                (t.memoizedState = d.state),
                (e = t.child))
              : (e = ma(e, t, o)),
            e
          );
        }
        function vf(e, t, a, n) {
          return (_n(), (t.flags |= 256), nt(e, t, a, n), t.child);
        }
        var mo = {
          dehydrated: null,
          treeContext: null,
          retryLane: 0,
          hydrationErrors: null,
        };
        function po(e) {
          return { baseLanes: e, cachePool: nd() };
        }
        function go(e, t, a) {
          return ((e = e !== null ? e.childLanes & ~a : 0), t && (e |= $t), e);
        }
        function yf(e, t, a) {
          var n = t.pendingProps,
            o = !1,
            d = (t.flags & 128) !== 0,
            b;
          if (
            ((b = d) ||
              (b =
                e !== null && e.memoizedState === null
                  ? !1
                  : (We.current & 2) !== 0),
            b && ((o = !0), (t.flags &= -129)),
            (b = (t.flags & 32) !== 0),
            (t.flags &= -33),
            e === null)
          ) {
            if (_e) {
              if ((o ? Ba(t) : Ra(), _e)) {
                var v = Ve,
                  E;
                if ((E = v)) {
                  e: {
                    for (E = v, v = Wt; E.nodeType !== 8; ) {
                      if (!v) {
                        v = null;
                        break e;
                      }
                      if (((E = Xt(E.nextSibling)), E === null)) {
                        v = null;
                        break e;
                      }
                    }
                    v = E;
                  }
                  v !== null
                    ? ((t.memoizedState = {
                        dehydrated: v,
                        treeContext:
                          li !== null ? { id: oa, overflow: ca } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      (E = _t(18, null, null, 0)),
                      (E.stateNode = v),
                      (E.return = t),
                      (t.child = E),
                      (ut = t),
                      (Ve = null),
                      (E = !0))
                    : (E = !1);
                }
                E || oi(t);
              }
              if (
                ((v = t.memoizedState),
                v !== null && ((v = v.dehydrated), v !== null))
              )
                return (Jo(v) ? (t.lanes = 32) : (t.lanes = 536870912), null);
              ha(t);
            }
            return (
              (v = n.children),
              (n = n.fallback),
              o
                ? (Ra(),
                  (o = t.mode),
                  (v = rs({ mode: 'hidden', children: v }, o)),
                  (n = ni(n, o, a, null)),
                  (v.return = t),
                  (n.return = t),
                  (v.sibling = n),
                  (t.child = v),
                  (o = t.child),
                  (o.memoizedState = po(a)),
                  (o.childLanes = go(e, b, a)),
                  (t.memoizedState = mo),
                  n)
                : (Ba(t), bo(t, v))
            );
          }
          if (
            ((E = e.memoizedState),
            E !== null && ((v = E.dehydrated), v !== null))
          ) {
            if (d)
              t.flags & 256
                ? (Ba(t), (t.flags &= -257), (t = vo(e, t, a)))
                : t.memoizedState !== null
                  ? (Ra(), (t.child = e.child), (t.flags |= 128), (t = null))
                  : (Ra(),
                    (o = n.fallback),
                    (v = t.mode),
                    (n = rs({ mode: 'visible', children: n.children }, v)),
                    (o = ni(o, v, a, null)),
                    (o.flags |= 2),
                    (n.return = t),
                    (o.return = t),
                    (n.sibling = o),
                    (t.child = n),
                    Ki(t, e.child, null, a),
                    (n = t.child),
                    (n.memoizedState = po(a)),
                    (n.childLanes = go(e, b, a)),
                    (t.memoizedState = mo),
                    (t = o));
            else if ((Ba(t), Jo(v))) {
              if (((b = v.nextSibling && v.nextSibling.dataset), b))
                var O = b.dgst;
              ((b = O),
                (n = Error(r(419))),
                (n.stack = ''),
                (n.digest = b),
                An({ value: n, source: null, stack: null }),
                (t = vo(e, t, a)));
            } else if (
              (et || Mn(e, t, a, !1), (b = (a & e.childLanes) !== 0), et || b)
            ) {
              if (
                ((b = Re),
                b !== null &&
                  ((n = a & -a),
                  (n = (n & 42) !== 0 ? 1 : Js(n)),
                  (n = (n & (b.suspendedLanes | a)) !== 0 ? 0 : n),
                  n !== 0 && n !== E.retryLane))
              )
                throw ((E.retryLane = n), zi(e, n), Ot(b, e, n), uf);
              (v.data === '$?' || zo(), (t = vo(e, t, a)));
            } else
              v.data === '$?'
                ? ((t.flags |= 192), (t.child = e.child), (t = null))
                : ((e = E.treeContext),
                  (Ve = Xt(v.nextSibling)),
                  (ut = t),
                  (_e = !0),
                  (ri = null),
                  (Wt = !1),
                  e !== null &&
                    ((Gt[Vt++] = oa),
                    (Gt[Vt++] = ca),
                    (Gt[Vt++] = li),
                    (oa = e.id),
                    (ca = e.overflow),
                    (li = t)),
                  (t = bo(t, n.children)),
                  (t.flags |= 4096));
            return t;
          }
          return o
            ? (Ra(),
              (o = n.fallback),
              (v = t.mode),
              (E = e.child),
              (O = E.sibling),
              (n = ra(E, { mode: 'hidden', children: n.children })),
              (n.subtreeFlags = E.subtreeFlags & 65011712),
              O !== null
                ? (o = ra(O, o))
                : ((o = ni(o, v, a, null)), (o.flags |= 2)),
              (o.return = t),
              (n.return = t),
              (n.sibling = o),
              (t.child = n),
              (n = o),
              (o = t.child),
              (v = e.child.memoizedState),
              v === null
                ? (v = po(a))
                : ((E = v.cachePool),
                  E !== null
                    ? ((O = Ze._currentValue),
                      (E = E.parent !== O ? { parent: O, pool: O } : E))
                    : (E = nd()),
                  (v = { baseLanes: v.baseLanes | a, cachePool: E })),
              (o.memoizedState = v),
              (o.childLanes = go(e, b, a)),
              (t.memoizedState = mo),
              n)
            : (Ba(t),
              (a = e.child),
              (e = a.sibling),
              (a = ra(a, { mode: 'visible', children: n.children })),
              (a.return = t),
              (a.sibling = null),
              e !== null &&
                ((b = t.deletions),
                b === null
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : b.push(e)),
              (t.child = a),
              (t.memoizedState = null),
              a);
        }
        function bo(e, t) {
          return (
            (t = rs({ mode: 'visible', children: t }, e.mode)),
            (t.return = e),
            (e.child = t)
          );
        }
        function rs(e, t) {
          return (
            (e = _t(22, e, null, t)),
            (e.lanes = 0),
            (e.stateNode = {
              _visibility: 1,
              _pendingMarkers: null,
              _retryCache: null,
              _transitions: null,
            }),
            e
          );
        }
        function vo(e, t, a) {
          return (
            Ki(t, e.child, null, a),
            (e = bo(t, t.pendingProps.children)),
            (e.flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Sf(e, t, a) {
          e.lanes |= t;
          var n = e.alternate;
          (n !== null && (n.lanes |= t), Lr(e.return, t, a));
        }
        function yo(e, t, a, n, o) {
          var d = e.memoizedState;
          d === null
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: n,
                tail: a,
                tailMode: o,
              })
            : ((d.isBackwards = t),
              (d.rendering = null),
              (d.renderingStartTime = 0),
              (d.last = n),
              (d.tail = a),
              (d.tailMode = o));
        }
        function xf(e, t, a) {
          var n = t.pendingProps,
            o = n.revealOrder,
            d = n.tail;
          if ((nt(e, t, n.children, a), (n = We.current), (n & 2) !== 0))
            ((n = (n & 1) | 2), (t.flags |= 128));
          else {
            if (e !== null && (e.flags & 128) !== 0)
              e: for (e = t.child; e !== null; ) {
                if (e.tag === 13) e.memoizedState !== null && Sf(e, a, t);
                else if (e.tag === 19) Sf(e, a, t);
                else if (e.child !== null) {
                  ((e.child.return = e), (e = e.child));
                  continue;
                }
                if (e === t) break e;
                for (; e.sibling === null; ) {
                  if (e.return === null || e.return === t) break e;
                  e = e.return;
                }
                ((e.sibling.return = e.return), (e = e.sibling));
              }
            n &= 1;
          }
          switch ((J(We, n), o)) {
            case 'forwards':
              for (a = t.child, o = null; a !== null; )
                ((e = a.alternate),
                  e !== null && is(e) === null && (o = a),
                  (a = a.sibling));
              ((a = o),
                a === null
                  ? ((o = t.child), (t.child = null))
                  : ((o = a.sibling), (a.sibling = null)),
                yo(t, !1, o, a, d));
              break;
            case 'backwards':
              for (a = null, o = t.child, t.child = null; o !== null; ) {
                if (((e = o.alternate), e !== null && is(e) === null)) {
                  t.child = o;
                  break;
                }
                ((e = o.sibling), (o.sibling = a), (a = o), (o = e));
              }
              yo(t, !0, a, null, d);
              break;
            case 'together':
              yo(t, !1, null, null, void 0);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function ma(e, t, a) {
          if (
            (e !== null && (t.dependencies = e.dependencies),
            (Ua |= t.lanes),
            (a & t.childLanes) === 0)
          )
            if (e !== null) {
              if ((Mn(e, t, a, !1), (a & t.childLanes) === 0)) return null;
            } else return null;
          if (e !== null && t.child !== e.child) throw Error(r(153));
          if (t.child !== null) {
            for (
              e = t.child, a = ra(e, e.pendingProps), t.child = a, a.return = t;
              e.sibling !== null;
            )
              ((e = e.sibling),
                (a = a.sibling = ra(e, e.pendingProps)),
                (a.return = t));
            a.sibling = null;
          }
          return t.child;
        }
        function So(e, t) {
          return (e.lanes & t) !== 0
            ? !0
            : ((e = e.dependencies), !!(e !== null && Vl(e)));
        }
        function Bg(e, t, a) {
          switch (t.tag) {
            case 3:
              (De(t, t.stateNode.containerInfo),
                Aa(t, Ze, e.memoizedState.cache),
                _n());
              break;
            case 27:
            case 5:
              Xs(t);
              break;
            case 4:
              De(t, t.stateNode.containerInfo);
              break;
            case 10:
              Aa(t, t.type, t.memoizedProps.value);
              break;
            case 13:
              var n = t.memoizedState;
              if (n !== null)
                return n.dehydrated !== null
                  ? (Ba(t), (t.flags |= 128), null)
                  : (a & t.child.childLanes) !== 0
                    ? yf(e, t, a)
                    : (Ba(t), (e = ma(e, t, a)), e !== null ? e.sibling : null);
              Ba(t);
              break;
            case 19:
              var o = (e.flags & 128) !== 0;
              if (
                ((n = (a & t.childLanes) !== 0),
                n || (Mn(e, t, a, !1), (n = (a & t.childLanes) !== 0)),
                o)
              ) {
                if (n) return xf(e, t, a);
                t.flags |= 128;
              }
              if (
                ((o = t.memoizedState),
                o !== null &&
                  ((o.rendering = null),
                  (o.tail = null),
                  (o.lastEffect = null)),
                J(We, We.current),
                n)
              )
                break;
              return null;
            case 22:
            case 23:
              return ((t.lanes = 0), mf(e, t, a));
            case 24:
              Aa(t, Ze, e.memoizedState.cache);
          }
          return ma(e, t, a);
        }
        function Tf(e, t, a) {
          if (e !== null)
            if (e.memoizedProps !== t.pendingProps) et = !0;
            else {
              if (!So(e, a) && (t.flags & 128) === 0)
                return ((et = !1), Bg(e, t, a));
              et = (e.flags & 131072) !== 0;
            }
          else
            ((et = !1), _e && (t.flags & 1048576) !== 0 && Wu(t, Gl, t.index));
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                e = t.pendingProps;
                var n = t.elementType,
                  o = n._init;
                if (((n = o(n._payload)), (t.type = n), typeof n == 'function'))
                  Mr(n)
                    ? ((e = hi(n, e)), (t.tag = 1), (t = bf(null, t, n, e, a)))
                    : ((t.tag = 0), (t = ho(null, t, n, e, a)));
                else {
                  if (n != null) {
                    if (((o = n.$$typeof), o === $)) {
                      ((t.tag = 11), (t = df(null, t, n, e, a)));
                      break e;
                    } else if (o === X) {
                      ((t.tag = 14), (t = ff(null, t, n, e, a)));
                      break e;
                    }
                  }
                  throw ((t = Se(n) || n), Error(r(306, t, '')));
                }
              }
              return t;
            case 0:
              return ho(e, t, t.type, t.pendingProps, a);
            case 1:
              return (
                (n = t.type),
                (o = hi(n, t.pendingProps)),
                bf(e, t, n, o, a)
              );
            case 3:
              e: {
                if ((De(t, t.stateNode.containerInfo), e === null))
                  throw Error(r(387));
                n = t.pendingProps;
                var d = t.memoizedState;
                ((o = d.element), kr(e, t), Ln(t, n, null, a));
                var b = t.memoizedState;
                if (
                  ((n = b.cache),
                  Aa(t, Ze, n),
                  n !== d.cache && zr(t, [Ze], a, !0),
                  Dn(),
                  (n = b.element),
                  d.isDehydrated)
                )
                  if (
                    ((d = { element: n, isDehydrated: !1, cache: b.cache }),
                    (t.updateQueue.baseState = d),
                    (t.memoizedState = d),
                    t.flags & 256)
                  ) {
                    t = vf(e, t, n, a);
                    break e;
                  } else if (n !== o) {
                    ((o = Ut(Error(r(424)), t)), An(o), (t = vf(e, t, n, a)));
                    break e;
                  } else {
                    switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                      case 9:
                        e = e.body;
                        break;
                      default:
                        e = e.nodeName === 'HTML' ? e.ownerDocument.body : e;
                    }
                    for (
                      Ve = Xt(e.firstChild),
                        ut = t,
                        _e = !0,
                        ri = null,
                        Wt = !0,
                        a = Jd(t, null, n, a),
                        t.child = a;
                      a;
                    )
                      ((a.flags = (a.flags & -3) | 4096), (a = a.sibling));
                  }
                else {
                  if ((_n(), n === o)) {
                    t = ma(e, t, a);
                    break e;
                  }
                  nt(e, t, n, a);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                ss(e, t),
                e === null
                  ? (a = _h(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = a)
                    : _e ||
                      ((a = t.type),
                      (e = t.pendingProps),
                      (n = xs(fe.current).createElement(a)),
                      (n[rt] = t),
                      (n[mt] = e),
                      st(n, a, e),
                      Je(n),
                      (t.stateNode = n))
                  : (t.memoizedState = _h(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                Xs(t),
                e === null &&
                  _e &&
                  ((n = t.stateNode = wh(t.type, t.pendingProps, fe.current)),
                  (ut = t),
                  (Wt = !0),
                  (o = Ve),
                  ka(t.type) ? ((ec = o), (Ve = Xt(n.firstChild))) : (Ve = o)),
                nt(e, t, t.pendingProps.children, a),
                ss(e, t),
                e === null && (t.flags |= 4194304),
                t.child
              );
            case 5:
              return (
                e === null &&
                  _e &&
                  ((o = n = Ve) &&
                    ((n = sb(n, t.type, t.pendingProps, Wt)),
                    n !== null
                      ? ((t.stateNode = n),
                        (ut = t),
                        (Ve = Xt(n.firstChild)),
                        (Wt = !1),
                        (o = !0))
                      : (o = !1)),
                  o || oi(t)),
                Xs(t),
                (o = t.type),
                (d = t.pendingProps),
                (b = e !== null ? e.memoizedProps : null),
                (n = d.children),
                Zo(o, d)
                  ? (n = null)
                  : b !== null && Zo(o, b) && (t.flags |= 32),
                t.memoizedState !== null &&
                  ((o = Xr(e, t, Eg, null, null, a)), (il._currentValue = o)),
                ss(e, t),
                nt(e, t, n, a),
                t.child
              );
            case 6:
              return (
                e === null &&
                  _e &&
                  ((e = a = Ve) &&
                    ((a = rb(a, t.pendingProps, Wt)),
                    a !== null
                      ? ((t.stateNode = a), (ut = t), (Ve = null), (e = !0))
                      : (e = !1)),
                  e || oi(t)),
                null
              );
            case 13:
              return yf(e, t, a);
            case 4:
              return (
                De(t, t.stateNode.containerInfo),
                (n = t.pendingProps),
                e === null ? (t.child = Ki(t, null, n, a)) : nt(e, t, n, a),
                t.child
              );
            case 11:
              return df(e, t, t.type, t.pendingProps, a);
            case 7:
              return (nt(e, t, t.pendingProps, a), t.child);
            case 8:
              return (nt(e, t, t.pendingProps.children, a), t.child);
            case 12:
              return (nt(e, t, t.pendingProps.children, a), t.child);
            case 10:
              return (
                (n = t.pendingProps),
                Aa(t, t.type, n.value),
                nt(e, t, n.children, a),
                t.child
              );
            case 9:
              return (
                (o = t.type._context),
                (n = t.pendingProps.children),
                ui(t),
                (o = ot(o)),
                (n = n(o)),
                (t.flags |= 1),
                nt(e, t, n, a),
                t.child
              );
            case 14:
              return ff(e, t, t.type, t.pendingProps, a);
            case 15:
              return hf(e, t, t.type, t.pendingProps, a);
            case 19:
              return xf(e, t, a);
            case 31:
              return (
                (n = t.pendingProps),
                (a = t.mode),
                (n = { mode: n.mode, children: n.children }),
                e === null
                  ? ((a = rs(n, a)),
                    (a.ref = t.ref),
                    (t.child = a),
                    (a.return = t),
                    (t = a))
                  : ((a = ra(e.child, n)),
                    (a.ref = t.ref),
                    (t.child = a),
                    (a.return = t),
                    (t = a)),
                t
              );
            case 22:
              return mf(e, t, a);
            case 24:
              return (
                ui(t),
                (n = ot(Ze)),
                e === null
                  ? ((o = Ir()),
                    o === null &&
                      ((o = Re),
                      (d = Hr()),
                      (o.pooledCache = d),
                      d.refCount++,
                      d !== null && (o.pooledCacheLanes |= a),
                      (o = d)),
                    (t.memoizedState = { parent: n, cache: o }),
                    Vr(t),
                    Aa(t, Ze, o))
                  : ((e.lanes & a) !== 0 &&
                      (kr(e, t), Ln(t, null, null, a), Dn()),
                    (o = e.memoizedState),
                    (d = t.memoizedState),
                    o.parent !== n
                      ? ((o = { parent: n, cache: n }),
                        (t.memoizedState = o),
                        t.lanes === 0 &&
                          (t.memoizedState = t.updateQueue.baseState = o),
                        Aa(t, Ze, n))
                      : ((n = d.cache),
                        Aa(t, Ze, n),
                        n !== o.cache && zr(t, [Ze], a, !0))),
                nt(e, t, t.pendingProps.children, a),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(r(156, t.tag));
        }
        function pa(e) {
          e.flags |= 4;
        }
        function wf(e, t) {
          if (t.type !== 'stylesheet' || (t.state.loading & 4) !== 0)
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !Oh(t))) {
            if (
              ((t = kt.current),
              t !== null &&
                ((xe & 4194048) === xe
                  ? Ft !== null
                  : ((xe & 62914560) !== xe && (xe & 536870912) === 0) ||
                    t !== Ft))
            )
              throw ((Bn = Gr), ld);
            e.flags |= 8192;
          }
        }
        function os(e, t) {
          (t !== null && (e.flags |= 4),
            e.flags & 16384 &&
              ((t = e.tag !== 22 ? eu() : 536870912),
              (e.lanes |= t),
              (Wi |= t)));
        }
        function kn(e, t) {
          if (!_e)
            switch (e.tailMode) {
              case 'hidden':
                t = e.tail;
                for (var a = null; t !== null; )
                  (t.alternate !== null && (a = t), (t = t.sibling));
                a === null ? (e.tail = null) : (a.sibling = null);
                break;
              case 'collapsed':
                a = e.tail;
                for (var n = null; a !== null; )
                  (a.alternate !== null && (n = a), (a = a.sibling));
                n === null
                  ? t || e.tail === null
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (n.sibling = null);
            }
        }
        function Ue(e) {
          var t = e.alternate !== null && e.alternate.child === e.child,
            a = 0,
            n = 0;
          if (t)
            for (var o = e.child; o !== null; )
              ((a |= o.lanes | o.childLanes),
                (n |= o.subtreeFlags & 65011712),
                (n |= o.flags & 65011712),
                (o.return = e),
                (o = o.sibling));
          else
            for (o = e.child; o !== null; )
              ((a |= o.lanes | o.childLanes),
                (n |= o.subtreeFlags),
                (n |= o.flags),
                (o.return = e),
                (o = o.sibling));
          return ((e.subtreeFlags |= n), (e.childLanes = a), t);
        }
        function Rg(e, t, a) {
          var n = t.pendingProps;
          switch ((Br(t), t.tag)) {
            case 31:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (Ue(t), null);
            case 1:
              return (Ue(t), null);
            case 3:
              return (
                (a = t.stateNode),
                (n = null),
                e !== null && (n = e.memoizedState.cache),
                t.memoizedState.cache !== n && (t.flags |= 2048),
                da(Ze),
                wa(),
                a.pendingContext &&
                  ((a.context = a.pendingContext), (a.pendingContext = null)),
                (e === null || e.child === null) &&
                  (Nn(t)
                    ? pa(t)
                    : e === null ||
                      (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                      ((t.flags |= 1024), ed())),
                Ue(t),
                null
              );
            case 26:
              return (
                (a = t.memoizedState),
                e === null
                  ? (pa(t),
                    a !== null
                      ? (Ue(t), wf(t, a))
                      : (Ue(t), (t.flags &= -16777217)))
                  : a
                    ? a !== e.memoizedState
                      ? (pa(t), Ue(t), wf(t, a))
                      : (Ue(t), (t.flags &= -16777217))
                    : (e.memoizedProps !== n && pa(t),
                      Ue(t),
                      (t.flags &= -16777217)),
                null
              );
            case 27:
              (yl(t), (a = fe.current));
              var o = t.type;
              if (e !== null && t.stateNode != null)
                e.memoizedProps !== n && pa(t);
              else {
                if (!n) {
                  if (t.stateNode === null) throw Error(r(166));
                  return (Ue(t), null);
                }
                ((e = le.current),
                  Nn(t)
                    ? Fu(t)
                    : ((e = wh(o, n, a)), (t.stateNode = e), pa(t)));
              }
              return (Ue(t), null);
            case 5:
              if ((yl(t), (a = t.type), e !== null && t.stateNode != null))
                e.memoizedProps !== n && pa(t);
              else {
                if (!n) {
                  if (t.stateNode === null) throw Error(r(166));
                  return (Ue(t), null);
                }
                if (((e = le.current), Nn(t))) Fu(t);
                else {
                  switch (((o = xs(fe.current)), e)) {
                    case 1:
                      e = o.createElementNS('http://www.w3.org/2000/svg', a);
                      break;
                    case 2:
                      e = o.createElementNS(
                        'http://www.w3.org/1998/Math/MathML',
                        a
                      );
                      break;
                    default:
                      switch (a) {
                        case 'svg':
                          e = o.createElementNS(
                            'http://www.w3.org/2000/svg',
                            a
                          );
                          break;
                        case 'math':
                          e = o.createElementNS(
                            'http://www.w3.org/1998/Math/MathML',
                            a
                          );
                          break;
                        case 'script':
                          ((e = o.createElement('div')),
                            (e.innerHTML = '<script><\/script>'),
                            (e = e.removeChild(e.firstChild)));
                          break;
                        case 'select':
                          ((e =
                            typeof n.is == 'string'
                              ? o.createElement('select', { is: n.is })
                              : o.createElement('select')),
                            n.multiple
                              ? (e.multiple = !0)
                              : n.size && (e.size = n.size));
                          break;
                        default:
                          e =
                            typeof n.is == 'string'
                              ? o.createElement(a, { is: n.is })
                              : o.createElement(a);
                      }
                  }
                  ((e[rt] = t), (e[mt] = n));
                  e: for (o = t.child; o !== null; ) {
                    if (o.tag === 5 || o.tag === 6) e.appendChild(o.stateNode);
                    else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
                      ((o.child.return = o), (o = o.child));
                      continue;
                    }
                    if (o === t) break e;
                    for (; o.sibling === null; ) {
                      if (o.return === null || o.return === t) break e;
                      o = o.return;
                    }
                    ((o.sibling.return = o.return), (o = o.sibling));
                  }
                  t.stateNode = e;
                  e: switch ((st(e, a, n), a)) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      e = !!n.autoFocus;
                      break e;
                    case 'img':
                      e = !0;
                      break e;
                    default:
                      e = !1;
                  }
                  e && pa(t);
                }
              }
              return (Ue(t), (t.flags &= -16777217), null);
            case 6:
              if (e && t.stateNode != null) e.memoizedProps !== n && pa(t);
              else {
                if (typeof n != 'string' && t.stateNode === null)
                  throw Error(r(166));
                if (((e = fe.current), Nn(t))) {
                  if (
                    ((e = t.stateNode),
                    (a = t.memoizedProps),
                    (n = null),
                    (o = ut),
                    o !== null)
                  )
                    switch (o.tag) {
                      case 27:
                      case 5:
                        n = o.memoizedProps;
                    }
                  ((e[rt] = t),
                    (e = !!(
                      e.nodeValue === a ||
                      (n !== null && n.suppressHydrationWarning === !0) ||
                      gh(e.nodeValue, a)
                    )),
                    e || oi(t));
                } else
                  ((e = xs(e).createTextNode(n)),
                    (e[rt] = t),
                    (t.stateNode = e));
              }
              return (Ue(t), null);
            case 13:
              if (
                ((n = t.memoizedState),
                e === null ||
                  (e.memoizedState !== null &&
                    e.memoizedState.dehydrated !== null))
              ) {
                if (((o = Nn(t)), n !== null && n.dehydrated !== null)) {
                  if (e === null) {
                    if (!o) throw Error(r(318));
                    if (
                      ((o = t.memoizedState),
                      (o = o !== null ? o.dehydrated : null),
                      !o)
                    )
                      throw Error(r(317));
                    o[rt] = t;
                  } else
                    (_n(),
                      (t.flags & 128) === 0 && (t.memoizedState = null),
                      (t.flags |= 4));
                  (Ue(t), (o = !1));
                } else
                  ((o = ed()),
                    e !== null &&
                      e.memoizedState !== null &&
                      (e.memoizedState.hydrationErrors = o),
                    (o = !0));
                if (!o) return t.flags & 256 ? (ha(t), t) : (ha(t), null);
              }
              if ((ha(t), (t.flags & 128) !== 0)) return ((t.lanes = a), t);
              if (
                ((a = n !== null),
                (e = e !== null && e.memoizedState !== null),
                a)
              ) {
                ((n = t.child),
                  (o = null),
                  n.alternate !== null &&
                    n.alternate.memoizedState !== null &&
                    n.alternate.memoizedState.cachePool !== null &&
                    (o = n.alternate.memoizedState.cachePool.pool));
                var d = null;
                (n.memoizedState !== null &&
                  n.memoizedState.cachePool !== null &&
                  (d = n.memoizedState.cachePool.pool),
                  d !== o && (n.flags |= 2048));
              }
              return (
                a !== e && a && (t.child.flags |= 8192),
                os(t, t.updateQueue),
                Ue(t),
                null
              );
            case 4:
              return (
                wa(),
                e === null && Po(t.stateNode.containerInfo),
                Ue(t),
                null
              );
            case 10:
              return (da(t.type), Ue(t), null);
            case 19:
              if ((ee(We), (o = t.memoizedState), o === null))
                return (Ue(t), null);
              if (((n = (t.flags & 128) !== 0), (d = o.rendering), d === null))
                if (n) kn(o, !1);
                else {
                  if (ke !== 0 || (e !== null && (e.flags & 128) !== 0))
                    for (e = t.child; e !== null; ) {
                      if (((d = is(e)), d !== null)) {
                        for (
                          t.flags |= 128,
                            kn(o, !1),
                            e = d.updateQueue,
                            t.updateQueue = e,
                            os(t, e),
                            t.subtreeFlags = 0,
                            e = a,
                            a = t.child;
                          a !== null;
                        )
                          (Zu(a, e), (a = a.sibling));
                        return (J(We, (We.current & 1) | 2), t.child);
                      }
                      e = e.sibling;
                    }
                  o.tail !== null &&
                    Zt() > ds &&
                    ((t.flags |= 128),
                    (n = !0),
                    kn(o, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!n)
                  if (((e = is(d)), e !== null)) {
                    if (
                      ((t.flags |= 128),
                      (n = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      os(t, e),
                      kn(o, !0),
                      o.tail === null &&
                        o.tailMode === 'hidden' &&
                        !d.alternate &&
                        !_e)
                    )
                      return (Ue(t), null);
                  } else
                    2 * Zt() - o.renderingStartTime > ds &&
                      a !== 536870912 &&
                      ((t.flags |= 128),
                      (n = !0),
                      kn(o, !1),
                      (t.lanes = 4194304));
                o.isBackwards
                  ? ((d.sibling = t.child), (t.child = d))
                  : ((e = o.last),
                    e !== null ? (e.sibling = d) : (t.child = d),
                    (o.last = d));
              }
              return o.tail !== null
                ? ((t = o.tail),
                  (o.rendering = t),
                  (o.tail = t.sibling),
                  (o.renderingStartTime = Zt()),
                  (t.sibling = null),
                  (e = We.current),
                  J(We, n ? (e & 1) | 2 : e & 1),
                  t)
                : (Ue(t), null);
            case 22:
            case 23:
              return (
                ha(t),
                Yr(),
                (n = t.memoizedState !== null),
                e !== null
                  ? (e.memoizedState !== null) !== n && (t.flags |= 8192)
                  : n && (t.flags |= 8192),
                n
                  ? (a & 536870912) !== 0 &&
                    (t.flags & 128) === 0 &&
                    (Ue(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                  : Ue(t),
                (a = t.updateQueue),
                a !== null && os(t, a.retryQueue),
                (a = null),
                e !== null &&
                  e.memoizedState !== null &&
                  e.memoizedState.cachePool !== null &&
                  (a = e.memoizedState.cachePool.pool),
                (n = null),
                t.memoizedState !== null &&
                  t.memoizedState.cachePool !== null &&
                  (n = t.memoizedState.cachePool.pool),
                n !== a && (t.flags |= 2048),
                e !== null && ee(di),
                null
              );
            case 24:
              return (
                (a = null),
                e !== null && (a = e.memoizedState.cache),
                t.memoizedState.cache !== a && (t.flags |= 2048),
                da(Ze),
                Ue(t),
                null
              );
            case 25:
              return null;
            case 30:
              return null;
          }
          throw Error(r(156, t.tag));
        }
        function Dg(e, t) {
          switch ((Br(t), t.tag)) {
            case 1:
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 3:
              return (
                da(Ze),
                wa(),
                (e = t.flags),
                (e & 65536) !== 0 && (e & 128) === 0
                  ? ((t.flags = (e & -65537) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return (yl(t), null);
            case 13:
              if (
                (ha(t),
                (e = t.memoizedState),
                e !== null && e.dehydrated !== null)
              ) {
                if (t.alternate === null) throw Error(r(340));
                _n();
              }
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 19:
              return (ee(We), null);
            case 4:
              return (wa(), null);
            case 10:
              return (da(t.type), null);
            case 22:
            case 23:
              return (
                ha(t),
                Yr(),
                e !== null && ee(di),
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 24:
              return (da(Ze), null);
            case 25:
              return null;
            default:
              return null;
          }
        }
        function Ef(e, t) {
          switch ((Br(t), t.tag)) {
            case 3:
              (da(Ze), wa());
              break;
            case 26:
            case 27:
            case 5:
              yl(t);
              break;
            case 4:
              wa();
              break;
            case 13:
              ha(t);
              break;
            case 19:
              ee(We);
              break;
            case 10:
              da(t.type);
              break;
            case 22:
            case 23:
              (ha(t), Yr(), e !== null && ee(di));
              break;
            case 24:
              da(Ze);
          }
        }
        function $n(e, t) {
          try {
            var a = t.updateQueue,
              n = a !== null ? a.lastEffect : null;
            if (n !== null) {
              var o = n.next;
              a = o;
              do {
                if ((a.tag & e) === e) {
                  n = void 0;
                  var d = a.create,
                    b = a.inst;
                  ((n = d()), (b.destroy = n));
                }
                a = a.next;
              } while (a !== o);
            }
          } catch (v) {
            Be(t, t.return, v);
          }
        }
        function Da(e, t, a) {
          try {
            var n = t.updateQueue,
              o = n !== null ? n.lastEffect : null;
            if (o !== null) {
              var d = o.next;
              n = d;
              do {
                if ((n.tag & e) === e) {
                  var b = n.inst,
                    v = b.destroy;
                  if (v !== void 0) {
                    ((b.destroy = void 0), (o = t));
                    var E = a,
                      O = v;
                    try {
                      O();
                    } catch (V) {
                      Be(o, E, V);
                    }
                  }
                }
                n = n.next;
              } while (n !== d);
            }
          } catch (V) {
            Be(t, t.return, V);
          }
        }
        function Nf(e) {
          var t = e.updateQueue;
          if (t !== null) {
            var a = e.stateNode;
            try {
              dd(t, a);
            } catch (n) {
              Be(e, e.return, n);
            }
          }
        }
        function _f(e, t, a) {
          ((a.props = hi(e.type, e.memoizedProps)),
            (a.state = e.memoizedState));
          try {
            a.componentWillUnmount();
          } catch (n) {
            Be(e, t, n);
          }
        }
        function qn(e, t) {
          try {
            var a = e.ref;
            if (a !== null) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var n = e.stateNode;
                  break;
                case 30:
                  n = e.stateNode;
                  break;
                default:
                  n = e.stateNode;
              }
              typeof a == 'function' ? (e.refCleanup = a(n)) : (a.current = n);
            }
          } catch (o) {
            Be(e, t, o);
          }
        }
        function Jt(e, t) {
          var a = e.ref,
            n = e.refCleanup;
          if (a !== null)
            if (typeof n == 'function')
              try {
                n();
              } catch (o) {
                Be(e, t, o);
              } finally {
                ((e.refCleanup = null),
                  (e = e.alternate),
                  e != null && (e.refCleanup = null));
              }
            else if (typeof a == 'function')
              try {
                a(null);
              } catch (o) {
                Be(e, t, o);
              }
            else a.current = null;
        }
        function Af(e) {
          var t = e.type,
            a = e.memoizedProps,
            n = e.stateNode;
          try {
            e: switch (t) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                a.autoFocus && n.focus();
                break e;
              case 'img':
                a.src ? (n.src = a.src) : a.srcSet && (n.srcset = a.srcSet);
            }
          } catch (o) {
            Be(e, e.return, o);
          }
        }
        function xo(e, t, a) {
          try {
            var n = e.stateNode;
            (tb(n, e.type, a, t), (n[mt] = t));
          } catch (o) {
            Be(e, e.return, o);
          }
        }
        function Mf(e) {
          return (
            e.tag === 5 ||
            e.tag === 3 ||
            e.tag === 26 ||
            (e.tag === 27 && ka(e.type)) ||
            e.tag === 4
          );
        }
        function To(e) {
          e: for (;;) {
            for (; e.sibling === null; ) {
              if (e.return === null || Mf(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
            ) {
              if (
                (e.tag === 27 && ka(e.type)) ||
                e.flags & 2 ||
                e.child === null ||
                e.tag === 4
              )
                continue e;
              ((e.child.return = e), (e = e.child));
            }
            if (!(e.flags & 2)) return e.stateNode;
          }
        }
        function wo(e, t, a) {
          var n = e.tag;
          if (n === 5 || n === 6)
            ((e = e.stateNode),
              t
                ? (a.nodeType === 9
                    ? a.body
                    : a.nodeName === 'HTML'
                      ? a.ownerDocument.body
                      : a
                  ).insertBefore(e, t)
                : ((t =
                    a.nodeType === 9
                      ? a.body
                      : a.nodeName === 'HTML'
                        ? a.ownerDocument.body
                        : a),
                  t.appendChild(e),
                  (a = a._reactRootContainer),
                  a != null || t.onclick !== null || (t.onclick = Ss)));
          else if (
            n !== 4 &&
            (n === 27 && ka(e.type) && ((a = e.stateNode), (t = null)),
            (e = e.child),
            e !== null)
          )
            for (wo(e, t, a), e = e.sibling; e !== null; )
              (wo(e, t, a), (e = e.sibling));
        }
        function cs(e, t, a) {
          var n = e.tag;
          if (n === 5 || n === 6)
            ((e = e.stateNode), t ? a.insertBefore(e, t) : a.appendChild(e));
          else if (
            n !== 4 &&
            (n === 27 && ka(e.type) && (a = e.stateNode),
            (e = e.child),
            e !== null)
          )
            for (cs(e, t, a), e = e.sibling; e !== null; )
              (cs(e, t, a), (e = e.sibling));
        }
        function jf(e) {
          var t = e.stateNode,
            a = e.memoizedProps;
          try {
            for (var n = e.type, o = t.attributes; o.length; )
              t.removeAttributeNode(o[0]);
            (st(t, n, a), (t[rt] = e), (t[mt] = a));
          } catch (d) {
            Be(e, e.return, d);
          }
        }
        var ga = !1,
          Ye = !1,
          Eo = !1,
          Cf = typeof WeakSet == 'function' ? WeakSet : Set,
          tt = null;
        function Lg(e, t) {
          if (((e = e.containerInfo), (Xo = As), (e = Gu(e)), xr(e))) {
            if ('selectionStart' in e)
              var a = { start: e.selectionStart, end: e.selectionEnd };
            else {
              a = ((a = e.ownerDocument) && a.defaultView) || window;
              var n = a.getSelection && a.getSelection();
              if (n && n.rangeCount !== 0) {
                a = n.anchorNode;
                var o = n.anchorOffset,
                  d = n.focusNode;
                n = n.focusOffset;
                var b = 0,
                  v = -1,
                  E = -1,
                  O = 0,
                  V = 0,
                  P = e,
                  B = null;
                e: for (;;) {
                  for (
                    var R;
                    P !== a || (o !== 0 && P.nodeType !== 3) || (v = b + o),
                      P !== d || (n !== 0 && P.nodeType !== 3) || (E = b + n),
                      P.nodeType === 3 && (b += P.nodeValue.length),
                      (R = P.firstChild) !== null;
                  )
                    ((B = P), (P = R));
                  for (;;) {
                    if (P === e) break e;
                    if (
                      (B === a && ++O === o && (v = b),
                      B === d && ++V === n && (E = b),
                      (R = P.nextSibling) !== null)
                    )
                      break;
                    ((P = B), (B = P.parentNode));
                  }
                  P = R;
                }
                a = v === -1 || E === -1 ? null : { start: v, end: E };
              } else a = null;
            }
            a = a || { start: 0, end: 0 };
          } else a = null;
          for (
            Qo = { focusedElem: e, selectionRange: a }, As = !1, tt = t;
            tt !== null;
          )
            if (
              ((t = tt),
              (e = t.child),
              (t.subtreeFlags & 1024) !== 0 && e !== null)
            )
              ((e.return = t), (tt = e));
            else
              for (; tt !== null; ) {
                switch (((t = tt), (d = t.alternate), (e = t.flags), t.tag)) {
                  case 0:
                    break;
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if ((e & 1024) !== 0 && d !== null) {
                      ((e = void 0),
                        (a = t),
                        (o = d.memoizedProps),
                        (d = d.memoizedState),
                        (n = a.stateNode));
                      try {
                        var ce = hi(a.type, o);
                        ((e = n.getSnapshotBeforeUpdate(ce, d)),
                          (n.__reactInternalSnapshotBeforeUpdate = e));
                      } catch (re) {
                        Be(a, a.return, re);
                      }
                    }
                    break;
                  case 3:
                    if ((e & 1024) !== 0) {
                      if (
                        ((e = t.stateNode.containerInfo),
                        (a = e.nodeType),
                        a === 9)
                      )
                        Fo(e);
                      else if (a === 1)
                        switch (e.nodeName) {
                          case 'HEAD':
                          case 'HTML':
                          case 'BODY':
                            Fo(e);
                            break;
                          default:
                            e.textContent = '';
                        }
                    }
                    break;
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    if ((e & 1024) !== 0) throw Error(r(163));
                }
                if (((e = t.sibling), e !== null)) {
                  ((e.return = t.return), (tt = e));
                  break;
                }
                tt = t.return;
              }
        }
        function Of(e, t, a) {
          var n = a.flags;
          switch (a.tag) {
            case 0:
            case 11:
            case 15:
              (La(e, a), n & 4 && $n(5, a));
              break;
            case 1:
              if ((La(e, a), n & 4))
                if (((e = a.stateNode), t === null))
                  try {
                    e.componentDidMount();
                  } catch (b) {
                    Be(a, a.return, b);
                  }
                else {
                  var o = hi(a.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      o,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (b) {
                    Be(a, a.return, b);
                  }
                }
              (n & 64 && Nf(a), n & 512 && qn(a, a.return));
              break;
            case 3:
              if ((La(e, a), n & 64 && ((e = a.updateQueue), e !== null))) {
                if (((t = null), a.child !== null))
                  switch (a.child.tag) {
                    case 27:
                    case 5:
                      t = a.child.stateNode;
                      break;
                    case 1:
                      t = a.child.stateNode;
                  }
                try {
                  dd(e, t);
                } catch (b) {
                  Be(a, a.return, b);
                }
              }
              break;
            case 27:
              t === null && n & 4 && jf(a);
            case 26:
            case 5:
              (La(e, a),
                t === null && n & 4 && Af(a),
                n & 512 && qn(a, a.return));
              break;
            case 12:
              La(e, a);
              break;
            case 13:
              (La(e, a),
                n & 4 && Df(e, a),
                n & 64 &&
                  ((e = a.memoizedState),
                  e !== null &&
                    ((e = e.dehydrated),
                    e !== null && ((a = qg.bind(null, a)), ob(e, a)))));
              break;
            case 22:
              if (((n = a.memoizedState !== null || ga), !n)) {
                ((t = (t !== null && t.memoizedState !== null) || Ye),
                  (o = ga));
                var d = Ye;
                ((ga = n),
                  (Ye = t) && !d
                    ? za(e, a, (a.subtreeFlags & 8772) !== 0)
                    : La(e, a),
                  (ga = o),
                  (Ye = d));
              }
              break;
            case 30:
              break;
            default:
              La(e, a);
          }
        }
        function Bf(e) {
          var t = e.alternate;
          (t !== null && ((e.alternate = null), Bf(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            e.tag === 5 && ((t = e.stateNode), t !== null && ar(t)),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null));
        }
        var Le = null,
          bt = !1;
        function ba(e, t, a) {
          for (a = a.child; a !== null; ) (Rf(e, t, a), (a = a.sibling));
        }
        function Rf(e, t, a) {
          if (wt && typeof wt.onCommitFiberUnmount == 'function')
            try {
              wt.onCommitFiberUnmount(dn, a);
            } catch {}
          switch (a.tag) {
            case 26:
              (Ye || Jt(a, t),
                ba(e, t, a),
                a.memoizedState
                  ? a.memoizedState.count--
                  : a.stateNode &&
                    ((a = a.stateNode), a.parentNode.removeChild(a)));
              break;
            case 27:
              Ye || Jt(a, t);
              var n = Le,
                o = bt;
              (ka(a.type) && ((Le = a.stateNode), (bt = !1)),
                ba(e, t, a),
                Jn(a.stateNode),
                (Le = n),
                (bt = o));
              break;
            case 5:
              Ye || Jt(a, t);
            case 6:
              if (
                ((n = Le),
                (o = bt),
                (Le = null),
                ba(e, t, a),
                (Le = n),
                (bt = o),
                Le !== null)
              )
                if (bt)
                  try {
                    (Le.nodeType === 9
                      ? Le.body
                      : Le.nodeName === 'HTML'
                        ? Le.ownerDocument.body
                        : Le
                    ).removeChild(a.stateNode);
                  } catch (d) {
                    Be(a, t, d);
                  }
                else
                  try {
                    Le.removeChild(a.stateNode);
                  } catch (d) {
                    Be(a, t, d);
                  }
              break;
            case 18:
              Le !== null &&
                (bt
                  ? ((e = Le),
                    xh(
                      e.nodeType === 9
                        ? e.body
                        : e.nodeName === 'HTML'
                          ? e.ownerDocument.body
                          : e,
                      a.stateNode
                    ),
                    rl(e))
                  : xh(Le, a.stateNode));
              break;
            case 4:
              ((n = Le),
                (o = bt),
                (Le = a.stateNode.containerInfo),
                (bt = !0),
                ba(e, t, a),
                (Le = n),
                (bt = o));
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              (Ye || Da(2, a, t), Ye || Da(4, a, t), ba(e, t, a));
              break;
            case 1:
              (Ye ||
                (Jt(a, t),
                (n = a.stateNode),
                typeof n.componentWillUnmount == 'function' && _f(a, t, n)),
                ba(e, t, a));
              break;
            case 21:
              ba(e, t, a);
              break;
            case 22:
              ((Ye = (n = Ye) || a.memoizedState !== null),
                ba(e, t, a),
                (Ye = n));
              break;
            default:
              ba(e, t, a);
          }
        }
        function Df(e, t) {
          if (
            t.memoizedState === null &&
            ((e = t.alternate),
            e !== null &&
              ((e = e.memoizedState),
              e !== null && ((e = e.dehydrated), e !== null)))
          )
            try {
              rl(e);
            } catch (a) {
              Be(t, t.return, a);
            }
        }
        function zg(e) {
          switch (e.tag) {
            case 13:
            case 19:
              var t = e.stateNode;
              return (t === null && (t = e.stateNode = new Cf()), t);
            case 22:
              return (
                (e = e.stateNode),
                (t = e._retryCache),
                t === null && (t = e._retryCache = new Cf()),
                t
              );
            default:
              throw Error(r(435, e.tag));
          }
        }
        function No(e, t) {
          var a = zg(e);
          t.forEach(function (n) {
            var o = Pg.bind(null, e, n);
            a.has(n) || (a.add(n), n.then(o, o));
          });
        }
        function At(e, t) {
          var a = t.deletions;
          if (a !== null)
            for (var n = 0; n < a.length; n++) {
              var o = a[n],
                d = e,
                b = t,
                v = b;
              e: for (; v !== null; ) {
                switch (v.tag) {
                  case 27:
                    if (ka(v.type)) {
                      ((Le = v.stateNode), (bt = !1));
                      break e;
                    }
                    break;
                  case 5:
                    ((Le = v.stateNode), (bt = !1));
                    break e;
                  case 3:
                  case 4:
                    ((Le = v.stateNode.containerInfo), (bt = !0));
                    break e;
                }
                v = v.return;
              }
              if (Le === null) throw Error(r(160));
              (Rf(d, b, o),
                (Le = null),
                (bt = !1),
                (d = o.alternate),
                d !== null && (d.return = null),
                (o.return = null));
            }
          if (t.subtreeFlags & 13878)
            for (t = t.child; t !== null; ) (Lf(t, e), (t = t.sibling));
        }
        var Kt = null;
        function Lf(e, t) {
          var a = e.alternate,
            n = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              (At(t, e),
                Mt(e),
                n & 4 && (Da(3, e, e.return), $n(3, e), Da(5, e, e.return)));
              break;
            case 1:
              (At(t, e),
                Mt(e),
                n & 512 && (Ye || a === null || Jt(a, a.return)),
                n & 64 &&
                  ga &&
                  ((e = e.updateQueue),
                  e !== null &&
                    ((n = e.callbacks),
                    n !== null &&
                      ((a = e.shared.hiddenCallbacks),
                      (e.shared.hiddenCallbacks =
                        a === null ? n : a.concat(n))))));
              break;
            case 26:
              var o = Kt;
              if (
                (At(t, e),
                Mt(e),
                n & 512 && (Ye || a === null || Jt(a, a.return)),
                n & 4)
              ) {
                var d = a !== null ? a.memoizedState : null;
                if (((n = e.memoizedState), a === null))
                  if (n === null)
                    if (e.stateNode === null) {
                      e: {
                        ((n = e.type),
                          (a = e.memoizedProps),
                          (o = o.ownerDocument || o));
                        t: switch (n) {
                          case 'title':
                            ((d = o.getElementsByTagName('title')[0]),
                              (!d ||
                                d[mn] ||
                                d[rt] ||
                                d.namespaceURI ===
                                  'http://www.w3.org/2000/svg' ||
                                d.hasAttribute('itemprop')) &&
                                ((d = o.createElement(n)),
                                o.head.insertBefore(
                                  d,
                                  o.querySelector('head > title')
                                )),
                              st(d, n, a),
                              (d[rt] = e),
                              Je(d),
                              (n = d));
                            break e;
                          case 'link':
                            var b = jh('link', 'href', o).get(
                              n + (a.href || '')
                            );
                            if (b) {
                              for (var v = 0; v < b.length; v++)
                                if (
                                  ((d = b[v]),
                                  d.getAttribute('href') ===
                                    (a.href == null || a.href === ''
                                      ? null
                                      : a.href) &&
                                    d.getAttribute('rel') ===
                                      (a.rel == null ? null : a.rel) &&
                                    d.getAttribute('title') ===
                                      (a.title == null ? null : a.title) &&
                                    d.getAttribute('crossorigin') ===
                                      (a.crossOrigin == null
                                        ? null
                                        : a.crossOrigin))
                                ) {
                                  b.splice(v, 1);
                                  break t;
                                }
                            }
                            ((d = o.createElement(n)),
                              st(d, n, a),
                              o.head.appendChild(d));
                            break;
                          case 'meta':
                            if (
                              (b = jh('meta', 'content', o).get(
                                n + (a.content || '')
                              ))
                            ) {
                              for (v = 0; v < b.length; v++)
                                if (
                                  ((d = b[v]),
                                  d.getAttribute('content') ===
                                    (a.content == null
                                      ? null
                                      : '' + a.content) &&
                                    d.getAttribute('name') ===
                                      (a.name == null ? null : a.name) &&
                                    d.getAttribute('property') ===
                                      (a.property == null
                                        ? null
                                        : a.property) &&
                                    d.getAttribute('http-equiv') ===
                                      (a.httpEquiv == null
                                        ? null
                                        : a.httpEquiv) &&
                                    d.getAttribute('charset') ===
                                      (a.charSet == null ? null : a.charSet))
                                ) {
                                  b.splice(v, 1);
                                  break t;
                                }
                            }
                            ((d = o.createElement(n)),
                              st(d, n, a),
                              o.head.appendChild(d));
                            break;
                          default:
                            throw Error(r(468, n));
                        }
                        ((d[rt] = e), Je(d), (n = d));
                      }
                      e.stateNode = n;
                    } else Ch(o, e.type, e.stateNode);
                  else e.stateNode = Mh(o, n, e.memoizedProps);
                else
                  d !== n
                    ? (d === null
                        ? a.stateNode !== null &&
                          ((a = a.stateNode), a.parentNode.removeChild(a))
                        : d.count--,
                      n === null
                        ? Ch(o, e.type, e.stateNode)
                        : Mh(o, n, e.memoizedProps))
                    : n === null &&
                      e.stateNode !== null &&
                      xo(e, e.memoizedProps, a.memoizedProps);
              }
              break;
            case 27:
              (At(t, e),
                Mt(e),
                n & 512 && (Ye || a === null || Jt(a, a.return)),
                a !== null && n & 4 && xo(e, e.memoizedProps, a.memoizedProps));
              break;
            case 5:
              if (
                (At(t, e),
                Mt(e),
                n & 512 && (Ye || a === null || Jt(a, a.return)),
                e.flags & 32)
              ) {
                o = e.stateNode;
                try {
                  ji(o, '');
                } catch (R) {
                  Be(e, e.return, R);
                }
              }
              (n & 4 &&
                e.stateNode != null &&
                ((o = e.memoizedProps),
                xo(e, o, a !== null ? a.memoizedProps : o)),
                n & 1024 && (Eo = !0));
              break;
            case 6:
              if ((At(t, e), Mt(e), n & 4)) {
                if (e.stateNode === null) throw Error(r(162));
                ((n = e.memoizedProps), (a = e.stateNode));
                try {
                  a.nodeValue = n;
                } catch (R) {
                  Be(e, e.return, R);
                }
              }
              break;
            case 3:
              if (
                ((Es = null),
                (o = Kt),
                (Kt = Ts(t.containerInfo)),
                At(t, e),
                (Kt = o),
                Mt(e),
                n & 4 && a !== null && a.memoizedState.isDehydrated)
              )
                try {
                  rl(t.containerInfo);
                } catch (R) {
                  Be(e, e.return, R);
                }
              Eo && ((Eo = !1), zf(e));
              break;
            case 4:
              ((n = Kt),
                (Kt = Ts(e.stateNode.containerInfo)),
                At(t, e),
                Mt(e),
                (Kt = n));
              break;
            case 12:
              (At(t, e), Mt(e));
              break;
            case 13:
              (At(t, e),
                Mt(e),
                e.child.flags & 8192 &&
                  (e.memoizedState !== null) !=
                    (a !== null && a.memoizedState !== null) &&
                  (Oo = Zt()),
                n & 4 &&
                  ((n = e.updateQueue),
                  n !== null && ((e.updateQueue = null), No(e, n))));
              break;
            case 22:
              o = e.memoizedState !== null;
              var E = a !== null && a.memoizedState !== null,
                O = ga,
                V = Ye;
              if (
                ((ga = O || o),
                (Ye = V || E),
                At(t, e),
                (Ye = V),
                (ga = O),
                Mt(e),
                n & 8192)
              )
                e: for (
                  t = e.stateNode,
                    t._visibility = o ? t._visibility & -2 : t._visibility | 1,
                    o && (a === null || E || ga || Ye || mi(e)),
                    a = null,
                    t = e;
                  ;
                ) {
                  if (t.tag === 5 || t.tag === 26) {
                    if (a === null) {
                      E = a = t;
                      try {
                        if (((d = E.stateNode), o))
                          ((b = d.style),
                            typeof b.setProperty == 'function'
                              ? b.setProperty('display', 'none', 'important')
                              : (b.display = 'none'));
                        else {
                          v = E.stateNode;
                          var P = E.memoizedProps.style,
                            B =
                              P != null && P.hasOwnProperty('display')
                                ? P.display
                                : null;
                          v.style.display =
                            B == null || typeof B == 'boolean'
                              ? ''
                              : ('' + B).trim();
                        }
                      } catch (R) {
                        Be(E, E.return, R);
                      }
                    }
                  } else if (t.tag === 6) {
                    if (a === null) {
                      E = t;
                      try {
                        E.stateNode.nodeValue = o ? '' : E.memoizedProps;
                      } catch (R) {
                        Be(E, E.return, R);
                      }
                    }
                  } else if (
                    ((t.tag !== 22 && t.tag !== 23) ||
                      t.memoizedState === null ||
                      t === e) &&
                    t.child !== null
                  ) {
                    ((t.child.return = t), (t = t.child));
                    continue;
                  }
                  if (t === e) break e;
                  for (; t.sibling === null; ) {
                    if (t.return === null || t.return === e) break e;
                    (a === t && (a = null), (t = t.return));
                  }
                  (a === t && (a = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling));
                }
              n & 4 &&
                ((n = e.updateQueue),
                n !== null &&
                  ((a = n.retryQueue),
                  a !== null && ((n.retryQueue = null), No(e, a))));
              break;
            case 19:
              (At(t, e),
                Mt(e),
                n & 4 &&
                  ((n = e.updateQueue),
                  n !== null && ((e.updateQueue = null), No(e, n))));
              break;
            case 30:
              break;
            case 21:
              break;
            default:
              (At(t, e), Mt(e));
          }
        }
        function Mt(e) {
          var t = e.flags;
          if (t & 2) {
            try {
              for (var a, n = e.return; n !== null; ) {
                if (Mf(n)) {
                  a = n;
                  break;
                }
                n = n.return;
              }
              if (a == null) throw Error(r(160));
              switch (a.tag) {
                case 27:
                  var o = a.stateNode,
                    d = To(e);
                  cs(e, d, o);
                  break;
                case 5:
                  var b = a.stateNode;
                  a.flags & 32 && (ji(b, ''), (a.flags &= -33));
                  var v = To(e);
                  cs(e, v, b);
                  break;
                case 3:
                case 4:
                  var E = a.stateNode.containerInfo,
                    O = To(e);
                  wo(e, O, E);
                  break;
                default:
                  throw Error(r(161));
              }
            } catch (V) {
              Be(e, e.return, V);
            }
            e.flags &= -3;
          }
          t & 4096 && (e.flags &= -4097);
        }
        function zf(e) {
          if (e.subtreeFlags & 1024)
            for (e = e.child; e !== null; ) {
              var t = e;
              (zf(t),
                t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
                (e = e.sibling));
            }
        }
        function La(e, t) {
          if (t.subtreeFlags & 8772)
            for (t = t.child; t !== null; )
              (Of(e, t.alternate, t), (t = t.sibling));
        }
        function mi(e) {
          for (e = e.child; e !== null; ) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                (Da(4, t, t.return), mi(t));
                break;
              case 1:
                Jt(t, t.return);
                var a = t.stateNode;
                (typeof a.componentWillUnmount == 'function' &&
                  _f(t, t.return, a),
                  mi(t));
                break;
              case 27:
                Jn(t.stateNode);
              case 26:
              case 5:
                (Jt(t, t.return), mi(t));
                break;
              case 22:
                t.memoizedState === null && mi(t);
                break;
              case 30:
                mi(t);
                break;
              default:
                mi(t);
            }
            e = e.sibling;
          }
        }
        function za(e, t, a) {
          for (
            a = a && (t.subtreeFlags & 8772) !== 0, t = t.child;
            t !== null;
          ) {
            var n = t.alternate,
              o = e,
              d = t,
              b = d.flags;
            switch (d.tag) {
              case 0:
              case 11:
              case 15:
                (za(o, d, a), $n(4, d));
                break;
              case 1:
                if (
                  (za(o, d, a),
                  (n = d),
                  (o = n.stateNode),
                  typeof o.componentDidMount == 'function')
                )
                  try {
                    o.componentDidMount();
                  } catch (O) {
                    Be(n, n.return, O);
                  }
                if (((n = d), (o = n.updateQueue), o !== null)) {
                  var v = n.stateNode;
                  try {
                    var E = o.shared.hiddenCallbacks;
                    if (E !== null)
                      for (
                        o.shared.hiddenCallbacks = null, o = 0;
                        o < E.length;
                        o++
                      )
                        ud(E[o], v);
                  } catch (O) {
                    Be(n, n.return, O);
                  }
                }
                (a && b & 64 && Nf(d), qn(d, d.return));
                break;
              case 27:
                jf(d);
              case 26:
              case 5:
                (za(o, d, a),
                  a && n === null && b & 4 && Af(d),
                  qn(d, d.return));
                break;
              case 12:
                za(o, d, a);
                break;
              case 13:
                (za(o, d, a), a && b & 4 && Df(o, d));
                break;
              case 22:
                (d.memoizedState === null && za(o, d, a), qn(d, d.return));
                break;
              case 30:
                break;
              default:
                za(o, d, a);
            }
            t = t.sibling;
          }
        }
        function _o(e, t) {
          var a = null;
          (e !== null &&
            e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (a = e.memoizedState.cachePool.pool),
            (e = null),
            t.memoizedState !== null &&
              t.memoizedState.cachePool !== null &&
              (e = t.memoizedState.cachePool.pool),
            e !== a && (e != null && e.refCount++, a != null && jn(a)));
        }
        function Ao(e, t) {
          ((e = null),
            t.alternate !== null && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache),
            t !== e && (t.refCount++, e != null && jn(e)));
        }
        function ea(e, t, a, n) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) (Hf(e, t, a, n), (t = t.sibling));
        }
        function Hf(e, t, a, n) {
          var o = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              (ea(e, t, a, n), o & 2048 && $n(9, t));
              break;
            case 1:
              ea(e, t, a, n);
              break;
            case 3:
              (ea(e, t, a, n),
                o & 2048 &&
                  ((e = null),
                  t.alternate !== null && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache),
                  t !== e && (t.refCount++, e != null && jn(e))));
              break;
            case 12:
              if (o & 2048) {
                (ea(e, t, a, n), (e = t.stateNode));
                try {
                  var d = t.memoizedProps,
                    b = d.id,
                    v = d.onPostCommit;
                  typeof v == 'function' &&
                    v(
                      b,
                      t.alternate === null ? 'mount' : 'update',
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (E) {
                  Be(t, t.return, E);
                }
              } else ea(e, t, a, n);
              break;
            case 13:
              ea(e, t, a, n);
              break;
            case 23:
              break;
            case 22:
              ((d = t.stateNode),
                (b = t.alternate),
                t.memoizedState !== null
                  ? d._visibility & 2
                    ? ea(e, t, a, n)
                    : Pn(e, t)
                  : d._visibility & 2
                    ? ea(e, t, a, n)
                    : ((d._visibility |= 2),
                      Xi(e, t, a, n, (t.subtreeFlags & 10256) !== 0)),
                o & 2048 && _o(b, t));
              break;
            case 24:
              (ea(e, t, a, n), o & 2048 && Ao(t.alternate, t));
              break;
            default:
              ea(e, t, a, n);
          }
        }
        function Xi(e, t, a, n, o) {
          for (
            o = o && (t.subtreeFlags & 10256) !== 0, t = t.child;
            t !== null;
          ) {
            var d = e,
              b = t,
              v = a,
              E = n,
              O = b.flags;
            switch (b.tag) {
              case 0:
              case 11:
              case 15:
                (Xi(d, b, v, E, o), $n(8, b));
                break;
              case 23:
                break;
              case 22:
                var V = b.stateNode;
                (b.memoizedState !== null
                  ? V._visibility & 2
                    ? Xi(d, b, v, E, o)
                    : Pn(d, b)
                  : ((V._visibility |= 2), Xi(d, b, v, E, o)),
                  o && O & 2048 && _o(b.alternate, b));
                break;
              case 24:
                (Xi(d, b, v, E, o), o && O & 2048 && Ao(b.alternate, b));
                break;
              default:
                Xi(d, b, v, E, o);
            }
            t = t.sibling;
          }
        }
        function Pn(e, t) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) {
              var a = e,
                n = t,
                o = n.flags;
              switch (n.tag) {
                case 22:
                  (Pn(a, n), o & 2048 && _o(n.alternate, n));
                  break;
                case 24:
                  (Pn(a, n), o & 2048 && Ao(n.alternate, n));
                  break;
                default:
                  Pn(a, n);
              }
              t = t.sibling;
            }
        }
        var Yn = 8192;
        function Qi(e) {
          if (e.subtreeFlags & Yn)
            for (e = e.child; e !== null; ) (Uf(e), (e = e.sibling));
        }
        function Uf(e) {
          switch (e.tag) {
            case 26:
              (Qi(e),
                e.flags & Yn &&
                  e.memoizedState !== null &&
                  xb(Kt, e.memoizedState, e.memoizedProps));
              break;
            case 5:
              Qi(e);
              break;
            case 3:
            case 4:
              var t = Kt;
              ((Kt = Ts(e.stateNode.containerInfo)), Qi(e), (Kt = t));
              break;
            case 22:
              e.memoizedState === null &&
                ((t = e.alternate),
                t !== null && t.memoizedState !== null
                  ? ((t = Yn), (Yn = 16777216), Qi(e), (Yn = t))
                  : Qi(e));
              break;
            default:
              Qi(e);
          }
        }
        function If(e) {
          var t = e.alternate;
          if (t !== null && ((e = t.child), e !== null)) {
            t.child = null;
            do ((t = e.sibling), (e.sibling = null), (e = t));
            while (e !== null);
          }
        }
        function Kn(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var a = 0; a < t.length; a++) {
                var n = t[a];
                ((tt = n), Vf(n, e));
              }
            If(e);
          }
          if (e.subtreeFlags & 10256)
            for (e = e.child; e !== null; ) (Gf(e), (e = e.sibling));
        }
        function Gf(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              (Kn(e), e.flags & 2048 && Da(9, e, e.return));
              break;
            case 3:
              Kn(e);
              break;
            case 12:
              Kn(e);
              break;
            case 22:
              var t = e.stateNode;
              e.memoizedState !== null &&
              t._visibility & 2 &&
              (e.return === null || e.return.tag !== 13)
                ? ((t._visibility &= -3), us(e))
                : Kn(e);
              break;
            default:
              Kn(e);
          }
        }
        function us(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var a = 0; a < t.length; a++) {
                var n = t[a];
                ((tt = n), Vf(n, e));
              }
            If(e);
          }
          for (e = e.child; e !== null; ) {
            switch (((t = e), t.tag)) {
              case 0:
              case 11:
              case 15:
                (Da(8, t, t.return), us(t));
                break;
              case 22:
                ((a = t.stateNode),
                  a._visibility & 2 && ((a._visibility &= -3), us(t)));
                break;
              default:
                us(t);
            }
            e = e.sibling;
          }
        }
        function Vf(e, t) {
          for (; tt !== null; ) {
            var a = tt;
            switch (a.tag) {
              case 0:
              case 11:
              case 15:
                Da(8, a, t);
                break;
              case 23:
              case 22:
                if (
                  a.memoizedState !== null &&
                  a.memoizedState.cachePool !== null
                ) {
                  var n = a.memoizedState.cachePool.pool;
                  n != null && n.refCount++;
                }
                break;
              case 24:
                jn(a.memoizedState.cache);
            }
            if (((n = a.child), n !== null)) ((n.return = a), (tt = n));
            else
              e: for (a = e; tt !== null; ) {
                n = tt;
                var o = n.sibling,
                  d = n.return;
                if ((Bf(n), n === a)) {
                  tt = null;
                  break e;
                }
                if (o !== null) {
                  ((o.return = d), (tt = o));
                  break e;
                }
                tt = d;
              }
          }
        }
        var Hg = {
            getCacheForType: function (e) {
              var t = ot(Ze),
                a = t.data.get(e);
              return (a === void 0 && ((a = e()), t.data.set(e, a)), a);
            },
          },
          Ug = typeof WeakMap == 'function' ? WeakMap : Map,
          Ae = 0,
          Re = null,
          ge = null,
          xe = 0,
          Me = 0,
          jt = null,
          Ha = !1,
          Zi = !1,
          Mo = !1,
          va = 0,
          ke = 0,
          Ua = 0,
          pi = 0,
          jo = 0,
          $t = 0,
          Wi = 0,
          Xn = null,
          vt = null,
          Co = !1,
          Oo = 0,
          ds = 1 / 0,
          fs = null,
          Ia = null,
          lt = 0,
          Ga = null,
          Fi = null,
          Ji = 0,
          Bo = 0,
          Ro = null,
          kf = null,
          Qn = 0,
          Do = null;
        function Ct() {
          if ((Ae & 2) !== 0 && xe !== 0) return xe & -xe;
          if (z.T !== null) {
            var e = Gi;
            return e !== 0 ? e : Vo();
          }
          return iu();
        }
        function $f() {
          $t === 0 && ($t = (xe & 536870912) === 0 || _e ? Jc() : 536870912);
          var e = kt.current;
          return (e !== null && (e.flags |= 32), $t);
        }
        function Ot(e, t, a) {
          (((e === Re && (Me === 2 || Me === 9)) ||
            e.cancelPendingCommit !== null) &&
            (en(e, 0), Va(e, xe, $t, !1)),
            hn(e, a),
            ((Ae & 2) === 0 || e !== Re) &&
              (e === Re &&
                ((Ae & 2) === 0 && (pi |= a), ke === 4 && Va(e, xe, $t, !1)),
              ta(e)));
        }
        function qf(e, t, a) {
          if ((Ae & 6) !== 0) throw Error(r(327));
          var n =
              (!a && (t & 124) === 0 && (t & e.expiredLanes) === 0) || fn(e, t),
            o = n ? Vg(e, t) : Ho(e, t, !0),
            d = n;
          do {
            if (o === 0) {
              Zi && !n && Va(e, t, 0, !1);
              break;
            } else {
              if (((a = e.current.alternate), d && !Ig(a))) {
                ((o = Ho(e, t, !1)), (d = !1));
                continue;
              }
              if (o === 2) {
                if (((d = t), e.errorRecoveryDisabledLanes & d)) var b = 0;
                else
                  ((b = e.pendingLanes & -536870913),
                    (b = b !== 0 ? b : b & 536870912 ? 536870912 : 0));
                if (b !== 0) {
                  t = b;
                  e: {
                    var v = e;
                    o = Xn;
                    var E = v.current.memoizedState.isDehydrated;
                    if (
                      (E && (en(v, b).flags |= 256),
                      (b = Ho(v, b, !1)),
                      b !== 2)
                    ) {
                      if (Mo && !E) {
                        ((v.errorRecoveryDisabledLanes |= d),
                          (pi |= d),
                          (o = 4));
                        break e;
                      }
                      ((d = vt),
                        (vt = o),
                        d !== null &&
                          (vt === null ? (vt = d) : vt.push.apply(vt, d)));
                    }
                    o = b;
                  }
                  if (((d = !1), o !== 2)) continue;
                }
              }
              if (o === 1) {
                (en(e, 0), Va(e, t, 0, !0));
                break;
              }
              e: {
                switch (((n = e), (d = o), d)) {
                  case 0:
                  case 1:
                    throw Error(r(345));
                  case 4:
                    if ((t & 4194048) !== t) break;
                  case 6:
                    Va(n, t, $t, !Ha);
                    break e;
                  case 2:
                    vt = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(r(329));
                }
                if ((t & 62914560) === t && ((o = Oo + 300 - Zt()), 10 < o)) {
                  if ((Va(n, t, $t, !Ha), wl(n, 0, !0) !== 0)) break e;
                  n.timeoutHandle = yh(
                    Pf.bind(
                      null,
                      n,
                      a,
                      vt,
                      fs,
                      Co,
                      t,
                      $t,
                      pi,
                      Wi,
                      Ha,
                      d,
                      2,
                      -0,
                      0
                    ),
                    o
                  );
                  break e;
                }
                Pf(n, a, vt, fs, Co, t, $t, pi, Wi, Ha, d, 0, -0, 0);
              }
            }
            break;
          } while (!0);
          ta(e);
        }
        function Pf(e, t, a, n, o, d, b, v, E, O, V, P, B, R) {
          if (
            ((e.timeoutHandle = -1),
            (P = t.subtreeFlags),
            (P & 8192 || (P & 16785408) === 16785408) &&
              ((al = { stylesheets: null, count: 0, unsuspend: Sb }),
              Uf(t),
              (P = Tb()),
              P !== null))
          ) {
            ((e.cancelPendingCommit = P(
              Ff.bind(null, e, t, d, a, n, o, b, v, E, V, 1, B, R)
            )),
              Va(e, d, b, !O));
            return;
          }
          Ff(e, t, d, a, n, o, b, v, E);
        }
        function Ig(e) {
          for (var t = e; ; ) {
            var a = t.tag;
            if (
              (a === 0 || a === 11 || a === 15) &&
              t.flags & 16384 &&
              ((a = t.updateQueue), a !== null && ((a = a.stores), a !== null))
            )
              for (var n = 0; n < a.length; n++) {
                var o = a[n],
                  d = o.getSnapshot;
                o = o.value;
                try {
                  if (!Nt(d(), o)) return !1;
                } catch {
                  return !1;
                }
              }
            if (((a = t.child), t.subtreeFlags & 16384 && a !== null))
              ((a.return = t), (t = a));
            else {
              if (t === e) break;
              for (; t.sibling === null; ) {
                if (t.return === null || t.return === e) return !0;
                t = t.return;
              }
              ((t.sibling.return = t.return), (t = t.sibling));
            }
          }
          return !0;
        }
        function Va(e, t, a, n) {
          ((t &= ~jo),
            (t &= ~pi),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            n && (e.warmLanes |= t),
            (n = e.expirationTimes));
          for (var o = t; 0 < o; ) {
            var d = 31 - Et(o),
              b = 1 << d;
            ((n[d] = -1), (o &= ~b));
          }
          a !== 0 && tu(e, a, t);
        }
        function hs() {
          return (Ae & 6) === 0 ? (Zn(0), !1) : !0;
        }
        function Lo() {
          if (ge !== null) {
            if (Me === 0) var e = ge.return;
            else
              ((e = ge),
                (ua = ci = null),
                Wr(e),
                (Yi = null),
                (Gn = 0),
                (e = ge));
            for (; e !== null; ) (Ef(e.alternate, e), (e = e.return));
            ge = null;
          }
        }
        function en(e, t) {
          var a = e.timeoutHandle;
          (a !== -1 && ((e.timeoutHandle = -1), ib(a)),
            (a = e.cancelPendingCommit),
            a !== null && ((e.cancelPendingCommit = null), a()),
            Lo(),
            (Re = e),
            (ge = a = ra(e.current, null)),
            (xe = t),
            (Me = 0),
            (jt = null),
            (Ha = !1),
            (Zi = fn(e, t)),
            (Mo = !1),
            (Wi = $t = jo = pi = Ua = ke = 0),
            (vt = Xn = null),
            (Co = !1),
            (t & 8) !== 0 && (t |= t & 32));
          var n = e.entangledLanes;
          if (n !== 0)
            for (e = e.entanglements, n &= t; 0 < n; ) {
              var o = 31 - Et(n),
                d = 1 << o;
              ((t |= e[o]), (n &= ~d));
            }
          return ((va = t), Ll(), a);
        }
        function Yf(e, t) {
          ((me = null),
            (z.H = es),
            t === On || t === ql
              ? ((t = od()), (Me = 3))
              : t === ld
                ? ((t = od()), (Me = 4))
                : (Me =
                    t === uf
                      ? 8
                      : t !== null &&
                          typeof t == 'object' &&
                          typeof t.then == 'function'
                        ? 6
                        : 1),
            (jt = t),
            ge === null && ((ke = 1), ls(e, Ut(t, e.current))));
        }
        function Kf() {
          var e = z.H;
          return ((z.H = es), e === null ? es : e);
        }
        function Xf() {
          var e = z.A;
          return ((z.A = Hg), e);
        }
        function zo() {
          ((ke = 4),
            Ha || ((xe & 4194048) !== xe && kt.current !== null) || (Zi = !0),
            ((Ua & 134217727) === 0 && (pi & 134217727) === 0) ||
              Re === null ||
              Va(Re, xe, $t, !1));
        }
        function Ho(e, t, a) {
          var n = Ae;
          Ae |= 2;
          var o = Kf(),
            d = Xf();
          ((Re !== e || xe !== t) && ((fs = null), en(e, t)), (t = !1));
          var b = ke;
          e: do
            try {
              if (Me !== 0 && ge !== null) {
                var v = ge,
                  E = jt;
                switch (Me) {
                  case 8:
                    (Lo(), (b = 6));
                    break e;
                  case 3:
                  case 2:
                  case 9:
                  case 6:
                    kt.current === null && (t = !0);
                    var O = Me;
                    if (((Me = 0), (jt = null), tn(e, v, E, O), a && Zi)) {
                      b = 0;
                      break e;
                    }
                    break;
                  default:
                    ((O = Me), (Me = 0), (jt = null), tn(e, v, E, O));
                }
              }
              (Gg(), (b = ke));
              break;
            } catch (V) {
              Yf(e, V);
            }
          while (!0);
          return (
            t && e.shellSuspendCounter++,
            (ua = ci = null),
            (Ae = n),
            (z.H = o),
            (z.A = d),
            ge === null && ((Re = null), (xe = 0), Ll()),
            b
          );
        }
        function Gg() {
          for (; ge !== null; ) Qf(ge);
        }
        function Vg(e, t) {
          var a = Ae;
          Ae |= 2;
          var n = Kf(),
            o = Xf();
          Re !== e || xe !== t
            ? ((fs = null), (ds = Zt() + 500), en(e, t))
            : (Zi = fn(e, t));
          e: do
            try {
              if (Me !== 0 && ge !== null) {
                t = ge;
                var d = jt;
                t: switch (Me) {
                  case 1:
                    ((Me = 0), (jt = null), tn(e, t, d, 1));
                    break;
                  case 2:
                  case 9:
                    if (sd(d)) {
                      ((Me = 0), (jt = null), Zf(t));
                      break;
                    }
                    ((t = function () {
                      ((Me !== 2 && Me !== 9) || Re !== e || (Me = 7), ta(e));
                    }),
                      d.then(t, t));
                    break e;
                  case 3:
                    Me = 7;
                    break e;
                  case 4:
                    Me = 5;
                    break e;
                  case 7:
                    sd(d)
                      ? ((Me = 0), (jt = null), Zf(t))
                      : ((Me = 0), (jt = null), tn(e, t, d, 7));
                    break;
                  case 5:
                    var b = null;
                    switch (ge.tag) {
                      case 26:
                        b = ge.memoizedState;
                      case 5:
                      case 27:
                        var v = ge;
                        if (!b || Oh(b)) {
                          ((Me = 0), (jt = null));
                          var E = v.sibling;
                          if (E !== null) ge = E;
                          else {
                            var O = v.return;
                            O !== null ? ((ge = O), ms(O)) : (ge = null);
                          }
                          break t;
                        }
                    }
                    ((Me = 0), (jt = null), tn(e, t, d, 5));
                    break;
                  case 6:
                    ((Me = 0), (jt = null), tn(e, t, d, 6));
                    break;
                  case 8:
                    (Lo(), (ke = 6));
                    break e;
                  default:
                    throw Error(r(462));
                }
              }
              kg();
              break;
            } catch (V) {
              Yf(e, V);
            }
          while (!0);
          return (
            (ua = ci = null),
            (z.H = n),
            (z.A = o),
            (Ae = a),
            ge !== null ? 0 : ((Re = null), (xe = 0), Ll(), ke)
          );
        }
        function kg() {
          for (; ge !== null && !up(); ) Qf(ge);
        }
        function Qf(e) {
          var t = Tf(e.alternate, e, va);
          ((e.memoizedProps = e.pendingProps), t === null ? ms(e) : (ge = t));
        }
        function Zf(e) {
          var t = e,
            a = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = gf(a, t, t.pendingProps, t.type, void 0, xe);
              break;
            case 11:
              t = gf(a, t, t.pendingProps, t.type.render, t.ref, xe);
              break;
            case 5:
              Wr(t);
            default:
              (Ef(a, t), (t = ge = Zu(t, va)), (t = Tf(a, t, va)));
          }
          ((e.memoizedProps = e.pendingProps), t === null ? ms(e) : (ge = t));
        }
        function tn(e, t, a, n) {
          ((ua = ci = null), Wr(t), (Yi = null), (Gn = 0));
          var o = t.return;
          try {
            if (Og(e, o, t, a, xe)) {
              ((ke = 1), ls(e, Ut(a, e.current)), (ge = null));
              return;
            }
          } catch (d) {
            if (o !== null) throw ((ge = o), d);
            ((ke = 1), ls(e, Ut(a, e.current)), (ge = null));
            return;
          }
          t.flags & 32768
            ? (_e || n === 1
                ? (e = !0)
                : Zi || (xe & 536870912) !== 0
                  ? (e = !1)
                  : ((Ha = e = !0),
                    (n === 2 || n === 9 || n === 3 || n === 6) &&
                      ((n = kt.current),
                      n !== null && n.tag === 13 && (n.flags |= 16384))),
              Wf(t, e))
            : ms(t);
        }
        function ms(e) {
          var t = e;
          do {
            if ((t.flags & 32768) !== 0) {
              Wf(t, Ha);
              return;
            }
            e = t.return;
            var a = Rg(t.alternate, t, va);
            if (a !== null) {
              ge = a;
              return;
            }
            if (((t = t.sibling), t !== null)) {
              ge = t;
              return;
            }
            ge = t = e;
          } while (t !== null);
          ke === 0 && (ke = 5);
        }
        function Wf(e, t) {
          do {
            var a = Dg(e.alternate, e);
            if (a !== null) {
              ((a.flags &= 32767), (ge = a));
              return;
            }
            if (
              ((a = e.return),
              a !== null &&
                ((a.flags |= 32768),
                (a.subtreeFlags = 0),
                (a.deletions = null)),
              !t && ((e = e.sibling), e !== null))
            ) {
              ge = e;
              return;
            }
            ge = e = a;
          } while (e !== null);
          ((ke = 6), (ge = null));
        }
        function Ff(e, t, a, n, o, d, b, v, E) {
          e.cancelPendingCommit = null;
          do ps();
          while (lt !== 0);
          if ((Ae & 6) !== 0) throw Error(r(327));
          if (t !== null) {
            if (t === e.current) throw Error(r(177));
            if (
              ((d = t.lanes | t.childLanes),
              (d |= _r),
              Sp(e, a, d, b, v, E),
              e === Re && ((ge = Re = null), (xe = 0)),
              (Fi = t),
              (Ga = e),
              (Ji = a),
              (Bo = d),
              (Ro = o),
              (kf = n),
              (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
                ? ((e.callbackNode = null),
                  (e.callbackPriority = 0),
                  Yg(Sl, function () {
                    return (ih(), null);
                  }))
                : ((e.callbackNode = null), (e.callbackPriority = 0)),
              (n = (t.flags & 13878) !== 0),
              (t.subtreeFlags & 13878) !== 0 || n)
            ) {
              ((n = z.T),
                (z.T = null),
                (o = Q.p),
                (Q.p = 2),
                (b = Ae),
                (Ae |= 4));
              try {
                Lg(e, t);
              } finally {
                ((Ae = b), (Q.p = o), (z.T = n));
              }
            }
            ((lt = 1), Jf(), eh(), th());
          }
        }
        function Jf() {
          if (lt === 1) {
            lt = 0;
            var e = Ga,
              t = Fi,
              a = (t.flags & 13878) !== 0;
            if ((t.subtreeFlags & 13878) !== 0 || a) {
              ((a = z.T), (z.T = null));
              var n = Q.p;
              Q.p = 2;
              var o = Ae;
              Ae |= 4;
              try {
                Lf(t, e);
                var d = Qo,
                  b = Gu(e.containerInfo),
                  v = d.focusedElem,
                  E = d.selectionRange;
                if (
                  b !== v &&
                  v &&
                  v.ownerDocument &&
                  Iu(v.ownerDocument.documentElement, v)
                ) {
                  if (E !== null && xr(v)) {
                    var O = E.start,
                      V = E.end;
                    if ((V === void 0 && (V = O), 'selectionStart' in v))
                      ((v.selectionStart = O),
                        (v.selectionEnd = Math.min(V, v.value.length)));
                    else {
                      var P = v.ownerDocument || document,
                        B = (P && P.defaultView) || window;
                      if (B.getSelection) {
                        var R = B.getSelection(),
                          ce = v.textContent.length,
                          re = Math.min(E.start, ce),
                          Oe = E.end === void 0 ? re : Math.min(E.end, ce);
                        !R.extend && re > Oe && ((b = Oe), (Oe = re), (re = b));
                        var M = Uu(v, re),
                          _ = Uu(v, Oe);
                        if (
                          M &&
                          _ &&
                          (R.rangeCount !== 1 ||
                            R.anchorNode !== M.node ||
                            R.anchorOffset !== M.offset ||
                            R.focusNode !== _.node ||
                            R.focusOffset !== _.offset)
                        ) {
                          var C = P.createRange();
                          (C.setStart(M.node, M.offset),
                            R.removeAllRanges(),
                            re > Oe
                              ? (R.addRange(C), R.extend(_.node, _.offset))
                              : (C.setEnd(_.node, _.offset), R.addRange(C)));
                        }
                      }
                    }
                  }
                  for (P = [], R = v; (R = R.parentNode); )
                    R.nodeType === 1 &&
                      P.push({
                        element: R,
                        left: R.scrollLeft,
                        top: R.scrollTop,
                      });
                  for (
                    typeof v.focus == 'function' && v.focus(), v = 0;
                    v < P.length;
                    v++
                  ) {
                    var k = P[v];
                    ((k.element.scrollLeft = k.left),
                      (k.element.scrollTop = k.top));
                  }
                }
                ((As = !!Xo), (Qo = Xo = null));
              } finally {
                ((Ae = o), (Q.p = n), (z.T = a));
              }
            }
            ((e.current = t), (lt = 2));
          }
        }
        function eh() {
          if (lt === 2) {
            lt = 0;
            var e = Ga,
              t = Fi,
              a = (t.flags & 8772) !== 0;
            if ((t.subtreeFlags & 8772) !== 0 || a) {
              ((a = z.T), (z.T = null));
              var n = Q.p;
              Q.p = 2;
              var o = Ae;
              Ae |= 4;
              try {
                Of(e, t.alternate, t);
              } finally {
                ((Ae = o), (Q.p = n), (z.T = a));
              }
            }
            lt = 3;
          }
        }
        function th() {
          if (lt === 4 || lt === 3) {
            ((lt = 0), dp());
            var e = Ga,
              t = Fi,
              a = Ji,
              n = kf;
            (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
              ? (lt = 5)
              : ((lt = 0), (Fi = Ga = null), ah(e, e.pendingLanes));
            var o = e.pendingLanes;
            if (
              (o === 0 && (Ia = null),
              er(a),
              (t = t.stateNode),
              wt && typeof wt.onCommitFiberRoot == 'function')
            )
              try {
                wt.onCommitFiberRoot(
                  dn,
                  t,
                  void 0,
                  (t.current.flags & 128) === 128
                );
              } catch {}
            if (n !== null) {
              ((t = z.T), (o = Q.p), (Q.p = 2), (z.T = null));
              try {
                for (var d = e.onRecoverableError, b = 0; b < n.length; b++) {
                  var v = n[b];
                  d(v.value, { componentStack: v.stack });
                }
              } finally {
                ((z.T = t), (Q.p = o));
              }
            }
            ((Ji & 3) !== 0 && ps(),
              ta(e),
              (o = e.pendingLanes),
              (a & 4194090) !== 0 && (o & 42) !== 0
                ? e === Do
                  ? Qn++
                  : ((Qn = 0), (Do = e))
                : (Qn = 0),
              Zn(0));
          }
        }
        function ah(e, t) {
          (e.pooledCacheLanes &= t) === 0 &&
            ((t = e.pooledCache), t != null && ((e.pooledCache = null), jn(t)));
        }
        function ps(e) {
          return (Jf(), eh(), th(), ih());
        }
        function ih() {
          if (lt !== 5) return !1;
          var e = Ga,
            t = Bo;
          Bo = 0;
          var a = er(Ji),
            n = z.T,
            o = Q.p;
          try {
            ((Q.p = 32 > a ? 32 : a), (z.T = null), (a = Ro), (Ro = null));
            var d = Ga,
              b = Ji;
            if (((lt = 0), (Fi = Ga = null), (Ji = 0), (Ae & 6) !== 0))
              throw Error(r(331));
            var v = Ae;
            if (
              ((Ae |= 4),
              Gf(d.current),
              Hf(d, d.current, b, a),
              (Ae = v),
              Zn(0),
              wt && typeof wt.onPostCommitFiberRoot == 'function')
            )
              try {
                wt.onPostCommitFiberRoot(dn, d);
              } catch {}
            return !0;
          } finally {
            ((Q.p = o), (z.T = n), ah(e, t));
          }
        }
        function nh(e, t, a) {
          ((t = Ut(a, t)),
            (t = fo(e.stateNode, t, 2)),
            (e = Ca(e, t, 2)),
            e !== null && (hn(e, 2), ta(e)));
        }
        function Be(e, t, a) {
          if (e.tag === 3) nh(e, e, a);
          else
            for (; t !== null; ) {
              if (t.tag === 3) {
                nh(t, e, a);
                break;
              } else if (t.tag === 1) {
                var n = t.stateNode;
                if (
                  typeof t.type.getDerivedStateFromError == 'function' ||
                  (typeof n.componentDidCatch == 'function' &&
                    (Ia === null || !Ia.has(n)))
                ) {
                  ((e = Ut(a, e)),
                    (a = of(2)),
                    (n = Ca(t, a, 2)),
                    n !== null && (cf(a, n, t, e), hn(n, 2), ta(n)));
                  break;
                }
              }
              t = t.return;
            }
        }
        function Uo(e, t, a) {
          var n = e.pingCache;
          if (n === null) {
            n = e.pingCache = new Ug();
            var o = new Set();
            n.set(t, o);
          } else
            ((o = n.get(t)), o === void 0 && ((o = new Set()), n.set(t, o)));
          o.has(a) ||
            ((Mo = !0), o.add(a), (e = $g.bind(null, e, t, a)), t.then(e, e));
        }
        function $g(e, t, a) {
          var n = e.pingCache;
          (n !== null && n.delete(t),
            (e.pingedLanes |= e.suspendedLanes & a),
            (e.warmLanes &= ~a),
            Re === e &&
              (xe & a) === a &&
              (ke === 4 ||
              (ke === 3 && (xe & 62914560) === xe && 300 > Zt() - Oo)
                ? (Ae & 2) === 0 && en(e, 0)
                : (jo |= a),
              Wi === xe && (Wi = 0)),
            ta(e));
        }
        function lh(e, t) {
          (t === 0 && (t = eu()),
            (e = zi(e, t)),
            e !== null && (hn(e, t), ta(e)));
        }
        function qg(e) {
          var t = e.memoizedState,
            a = 0;
          (t !== null && (a = t.retryLane), lh(e, a));
        }
        function Pg(e, t) {
          var a = 0;
          switch (e.tag) {
            case 13:
              var n = e.stateNode,
                o = e.memoizedState;
              o !== null && (a = o.retryLane);
              break;
            case 19:
              n = e.stateNode;
              break;
            case 22:
              n = e.stateNode._retryCache;
              break;
            default:
              throw Error(r(314));
          }
          (n !== null && n.delete(t), lh(e, a));
        }
        function Yg(e, t) {
          return Zs(e, t);
        }
        var gs = null,
          an = null,
          Io = !1,
          bs = !1,
          Go = !1,
          gi = 0;
        function ta(e) {
          (e !== an &&
            e.next === null &&
            (an === null ? (gs = an = e) : (an = an.next = e)),
            (bs = !0),
            Io || ((Io = !0), Xg()));
        }
        function Zn(e, t) {
          if (!Go && bs) {
            Go = !0;
            do
              for (var a = !1, n = gs; n !== null; ) {
                if (e !== 0) {
                  var o = n.pendingLanes;
                  if (o === 0) var d = 0;
                  else {
                    var b = n.suspendedLanes,
                      v = n.pingedLanes;
                    ((d = (1 << (31 - Et(42 | e) + 1)) - 1),
                      (d &= o & ~(b & ~v)),
                      (d =
                        d & 201326741 ? (d & 201326741) | 1 : d ? d | 2 : 0));
                  }
                  d !== 0 && ((a = !0), ch(n, d));
                } else
                  ((d = xe),
                    (d = wl(
                      n,
                      n === Re ? d : 0,
                      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
                    )),
                    (d & 3) === 0 || fn(n, d) || ((a = !0), ch(n, d)));
                n = n.next;
              }
            while (a);
            Go = !1;
          }
        }
        function Kg() {
          sh();
        }
        function sh() {
          bs = Io = !1;
          var e = 0;
          gi !== 0 && (ab() && (e = gi), (gi = 0));
          for (var t = Zt(), a = null, n = gs; n !== null; ) {
            var o = n.next,
              d = rh(n, t);
            (d === 0
              ? ((n.next = null),
                a === null ? (gs = o) : (a.next = o),
                o === null && (an = a))
              : ((a = n), (e !== 0 || (d & 3) !== 0) && (bs = !0)),
              (n = o));
          }
          Zn(e);
        }
        function rh(e, t) {
          for (
            var a = e.suspendedLanes,
              n = e.pingedLanes,
              o = e.expirationTimes,
              d = e.pendingLanes & -62914561;
            0 < d;
          ) {
            var b = 31 - Et(d),
              v = 1 << b,
              E = o[b];
            (E === -1
              ? ((v & a) === 0 || (v & n) !== 0) && (o[b] = yp(v, t))
              : E <= t && (e.expiredLanes |= v),
              (d &= ~v));
          }
          if (
            ((t = Re),
            (a = xe),
            (a = wl(
              e,
              e === t ? a : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            (n = e.callbackNode),
            a === 0 ||
              (e === t && (Me === 2 || Me === 9)) ||
              e.cancelPendingCommit !== null)
          )
            return (
              n !== null && n !== null && Ws(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if ((a & 3) === 0 || fn(e, a)) {
            if (((t = a & -a), t === e.callbackPriority)) return t;
            switch ((n !== null && Ws(n), er(a))) {
              case 2:
              case 8:
                a = Wc;
                break;
              case 32:
                a = Sl;
                break;
              case 268435456:
                a = Fc;
                break;
              default:
                a = Sl;
            }
            return (
              (n = oh.bind(null, e)),
              (a = Zs(a, n)),
              (e.callbackPriority = t),
              (e.callbackNode = a),
              t
            );
          }
          return (
            n !== null && n !== null && Ws(n),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function oh(e, t) {
          if (lt !== 0 && lt !== 5)
            return ((e.callbackNode = null), (e.callbackPriority = 0), null);
          var a = e.callbackNode;
          if (ps() && e.callbackNode !== a) return null;
          var n = xe;
          return (
            (n = wl(
              e,
              e === Re ? n : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            n === 0
              ? null
              : (qf(e, n, t),
                rh(e, Zt()),
                e.callbackNode != null && e.callbackNode === a
                  ? oh.bind(null, e)
                  : null)
          );
        }
        function ch(e, t) {
          if (ps()) return null;
          qf(e, t, !0);
        }
        function Xg() {
          nb(function () {
            (Ae & 6) !== 0 ? Zs(Zc, Kg) : sh();
          });
        }
        function Vo() {
          return (gi === 0 && (gi = Jc()), gi);
        }
        function uh(e) {
          return e == null || typeof e == 'symbol' || typeof e == 'boolean'
            ? null
            : typeof e == 'function'
              ? e
              : Ml('' + e);
        }
        function dh(e, t) {
          var a = t.ownerDocument.createElement('input');
          return (
            (a.name = t.name),
            (a.value = t.value),
            e.id && a.setAttribute('form', e.id),
            t.parentNode.insertBefore(a, t),
            (e = new FormData(e)),
            a.parentNode.removeChild(a),
            e
          );
        }
        function Qg(e, t, a, n, o) {
          if (t === 'submit' && a && a.stateNode === o) {
            var d = uh((o[mt] || null).action),
              b = n.submitter;
            b &&
              ((t = (t = b[mt] || null)
                ? uh(t.formAction)
                : b.getAttribute('formAction')),
              t !== null && ((d = t), (b = null)));
            var v = new Bl('action', 'action', null, n, o);
            e.push({
              event: v,
              listeners: [
                {
                  instance: null,
                  listener: function () {
                    if (n.defaultPrevented) {
                      if (gi !== 0) {
                        var E = b ? dh(o, b) : new FormData(o);
                        so(
                          a,
                          { pending: !0, data: E, method: o.method, action: d },
                          null,
                          E
                        );
                      }
                    } else
                      typeof d == 'function' &&
                        (v.preventDefault(),
                        (E = b ? dh(o, b) : new FormData(o)),
                        so(
                          a,
                          { pending: !0, data: E, method: o.method, action: d },
                          d,
                          E
                        ));
                  },
                  currentTarget: o,
                },
              ],
            });
          }
        }
        for (var ko = 0; ko < Nr.length; ko++) {
          var $o = Nr[ko],
            Zg = $o.toLowerCase(),
            Wg = $o[0].toUpperCase() + $o.slice(1);
          Yt(Zg, 'on' + Wg);
        }
        (Yt($u, 'onAnimationEnd'),
          Yt(qu, 'onAnimationIteration'),
          Yt(Pu, 'onAnimationStart'),
          Yt('dblclick', 'onDoubleClick'),
          Yt('focusin', 'onFocus'),
          Yt('focusout', 'onBlur'),
          Yt(mg, 'onTransitionRun'),
          Yt(pg, 'onTransitionStart'),
          Yt(gg, 'onTransitionCancel'),
          Yt(Yu, 'onTransitionEnd'),
          _i('onMouseEnter', ['mouseout', 'mouseover']),
          _i('onMouseLeave', ['mouseout', 'mouseover']),
          _i('onPointerEnter', ['pointerout', 'pointerover']),
          _i('onPointerLeave', ['pointerout', 'pointerover']),
          ei(
            'onChange',
            'change click focusin focusout input keydown keyup selectionchange'.split(
              ' '
            )
          ),
          ei(
            'onSelect',
            'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
              ' '
            )
          ),
          ei('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste',
          ]),
          ei(
            'onCompositionEnd',
            'compositionend focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          ei(
            'onCompositionStart',
            'compositionstart focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          ei(
            'onCompositionUpdate',
            'compositionupdate focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ));
        var Wn =
            'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
              ' '
            ),
          Fg = new Set(
            'beforetoggle cancel close invalid load scroll scrollend toggle'
              .split(' ')
              .concat(Wn)
          );
        function fh(e, t) {
          t = (t & 4) !== 0;
          for (var a = 0; a < e.length; a++) {
            var n = e[a],
              o = n.event;
            n = n.listeners;
            e: {
              var d = void 0;
              if (t)
                for (var b = n.length - 1; 0 <= b; b--) {
                  var v = n[b],
                    E = v.instance,
                    O = v.currentTarget;
                  if (((v = v.listener), E !== d && o.isPropagationStopped()))
                    break e;
                  ((d = v), (o.currentTarget = O));
                  try {
                    d(o);
                  } catch (V) {
                    ns(V);
                  }
                  ((o.currentTarget = null), (d = E));
                }
              else
                for (b = 0; b < n.length; b++) {
                  if (
                    ((v = n[b]),
                    (E = v.instance),
                    (O = v.currentTarget),
                    (v = v.listener),
                    E !== d && o.isPropagationStopped())
                  )
                    break e;
                  ((d = v), (o.currentTarget = O));
                  try {
                    d(o);
                  } catch (V) {
                    ns(V);
                  }
                  ((o.currentTarget = null), (d = E));
                }
            }
          }
        }
        function be(e, t) {
          var a = t[tr];
          a === void 0 && (a = t[tr] = new Set());
          var n = e + '__bubble';
          a.has(n) || (hh(t, e, 2, !1), a.add(n));
        }
        function qo(e, t, a) {
          var n = 0;
          (t && (n |= 4), hh(a, e, n, t));
        }
        var vs = '_reactListening' + Math.random().toString(36).slice(2);
        function Po(e) {
          if (!e[vs]) {
            ((e[vs] = !0),
              lu.forEach(function (a) {
                a !== 'selectionchange' &&
                  (Fg.has(a) || qo(a, !1, e), qo(a, !0, e));
              }));
            var t = e.nodeType === 9 ? e : e.ownerDocument;
            t === null || t[vs] || ((t[vs] = !0), qo('selectionchange', !1, t));
          }
        }
        function hh(e, t, a, n) {
          switch (Hh(t)) {
            case 2:
              var o = Nb;
              break;
            case 8:
              o = _b;
              break;
            default:
              o = lc;
          }
          ((a = o.bind(null, t, a, e)),
            (o = void 0),
            !fr ||
              (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') ||
              (o = !0),
            n
              ? o !== void 0
                ? e.addEventListener(t, a, { capture: !0, passive: o })
                : e.addEventListener(t, a, !0)
              : o !== void 0
                ? e.addEventListener(t, a, { passive: o })
                : e.addEventListener(t, a, !1));
        }
        function Yo(e, t, a, n, o) {
          var d = n;
          if ((t & 1) === 0 && (t & 2) === 0 && n !== null)
            e: for (;;) {
              if (n === null) return;
              var b = n.tag;
              if (b === 3 || b === 4) {
                var v = n.stateNode.containerInfo;
                if (v === o) break;
                if (b === 4)
                  for (b = n.return; b !== null; ) {
                    var E = b.tag;
                    if ((E === 3 || E === 4) && b.stateNode.containerInfo === o)
                      return;
                    b = b.return;
                  }
                for (; v !== null; ) {
                  if (((b = wi(v)), b === null)) return;
                  if (
                    ((E = b.tag), E === 5 || E === 6 || E === 26 || E === 27)
                  ) {
                    n = d = b;
                    continue e;
                  }
                  v = v.parentNode;
                }
              }
              n = n.return;
            }
          yu(function () {
            var O = d,
              V = ur(a),
              P = [];
            e: {
              var B = Ku.get(e);
              if (B !== void 0) {
                var R = Bl,
                  ce = e;
                switch (e) {
                  case 'keypress':
                    if (Cl(a) === 0) break e;
                  case 'keydown':
                  case 'keyup':
                    R = Yp;
                    break;
                  case 'focusin':
                    ((ce = 'focus'), (R = gr));
                    break;
                  case 'focusout':
                    ((ce = 'blur'), (R = gr));
                    break;
                  case 'beforeblur':
                  case 'afterblur':
                    R = gr;
                    break;
                  case 'click':
                    if (a.button === 2) break e;
                  case 'auxclick':
                  case 'dblclick':
                  case 'mousedown':
                  case 'mousemove':
                  case 'mouseup':
                  case 'mouseout':
                  case 'mouseover':
                  case 'contextmenu':
                    R = Tu;
                    break;
                  case 'drag':
                  case 'dragend':
                  case 'dragenter':
                  case 'dragexit':
                  case 'dragleave':
                  case 'dragover':
                  case 'dragstart':
                  case 'drop':
                    R = Dp;
                    break;
                  case 'touchcancel':
                  case 'touchend':
                  case 'touchmove':
                  case 'touchstart':
                    R = Qp;
                    break;
                  case $u:
                  case qu:
                  case Pu:
                    R = Hp;
                    break;
                  case Yu:
                    R = Wp;
                    break;
                  case 'scroll':
                  case 'scrollend':
                    R = Bp;
                    break;
                  case 'wheel':
                    R = Jp;
                    break;
                  case 'copy':
                  case 'cut':
                  case 'paste':
                    R = Ip;
                    break;
                  case 'gotpointercapture':
                  case 'lostpointercapture':
                  case 'pointercancel':
                  case 'pointerdown':
                  case 'pointermove':
                  case 'pointerout':
                  case 'pointerover':
                  case 'pointerup':
                    R = Eu;
                    break;
                  case 'toggle':
                  case 'beforetoggle':
                    R = tg;
                }
                var re = (t & 4) !== 0,
                  Oe = !re && (e === 'scroll' || e === 'scrollend'),
                  M = re ? (B !== null ? B + 'Capture' : null) : B;
                re = [];
                for (var _ = O, C; _ !== null; ) {
                  var k = _;
                  if (
                    ((C = k.stateNode),
                    (k = k.tag),
                    (k !== 5 && k !== 26 && k !== 27) ||
                      C === null ||
                      M === null ||
                      ((k = gn(_, M)), k != null && re.push(Fn(_, k, C))),
                    Oe)
                  )
                    break;
                  _ = _.return;
                }
                0 < re.length &&
                  ((B = new R(B, ce, null, a, V)),
                  P.push({ event: B, listeners: re }));
              }
            }
            if ((t & 7) === 0) {
              e: {
                if (
                  ((B = e === 'mouseover' || e === 'pointerover'),
                  (R = e === 'mouseout' || e === 'pointerout'),
                  B &&
                    a !== cr &&
                    (ce = a.relatedTarget || a.fromElement) &&
                    (wi(ce) || ce[Ti]))
                )
                  break e;
                if (
                  (R || B) &&
                  ((B =
                    V.window === V
                      ? V
                      : (B = V.ownerDocument)
                        ? B.defaultView || B.parentWindow
                        : window),
                  R
                    ? ((ce = a.relatedTarget || a.toElement),
                      (R = O),
                      (ce = ce ? wi(ce) : null),
                      ce !== null &&
                        ((Oe = u(ce)),
                        (re = ce.tag),
                        ce !== Oe || (re !== 5 && re !== 27 && re !== 6)) &&
                        (ce = null))
                    : ((R = null), (ce = O)),
                  R !== ce)
                ) {
                  if (
                    ((re = Tu),
                    (k = 'onMouseLeave'),
                    (M = 'onMouseEnter'),
                    (_ = 'mouse'),
                    (e === 'pointerout' || e === 'pointerover') &&
                      ((re = Eu),
                      (k = 'onPointerLeave'),
                      (M = 'onPointerEnter'),
                      (_ = 'pointer')),
                    (Oe = R == null ? B : pn(R)),
                    (C = ce == null ? B : pn(ce)),
                    (B = new re(k, _ + 'leave', R, a, V)),
                    (B.target = Oe),
                    (B.relatedTarget = C),
                    (k = null),
                    wi(V) === O &&
                      ((re = new re(M, _ + 'enter', ce, a, V)),
                      (re.target = C),
                      (re.relatedTarget = Oe),
                      (k = re)),
                    (Oe = k),
                    R && ce)
                  )
                    t: {
                      for (re = R, M = ce, _ = 0, C = re; C; C = nn(C)) _++;
                      for (C = 0, k = M; k; k = nn(k)) C++;
                      for (; 0 < _ - C; ) ((re = nn(re)), _--);
                      for (; 0 < C - _; ) ((M = nn(M)), C--);
                      for (; _--; ) {
                        if (re === M || (M !== null && re === M.alternate))
                          break t;
                        ((re = nn(re)), (M = nn(M)));
                      }
                      re = null;
                    }
                  else re = null;
                  (R !== null && mh(P, B, R, re, !1),
                    ce !== null && Oe !== null && mh(P, Oe, ce, re, !0));
                }
              }
              e: {
                if (
                  ((B = O ? pn(O) : window),
                  (R = B.nodeName && B.nodeName.toLowerCase()),
                  R === 'select' || (R === 'input' && B.type === 'file'))
                )
                  var te = Bu;
                else if (Cu(B))
                  if (Ru) te = dg;
                  else {
                    te = cg;
                    var pe = og;
                  }
                else
                  ((R = B.nodeName),
                    !R ||
                    R.toLowerCase() !== 'input' ||
                    (B.type !== 'checkbox' && B.type !== 'radio')
                      ? O && or(O.elementType) && (te = Bu)
                      : (te = ug));
                if (te && (te = te(e, O))) {
                  Ou(P, te, a, V);
                  break e;
                }
                (pe && pe(e, B, O),
                  e === 'focusout' &&
                    O &&
                    B.type === 'number' &&
                    O.memoizedProps.value != null &&
                    rr(B, 'number', B.value));
              }
              switch (((pe = O ? pn(O) : window), e)) {
                case 'focusin':
                  (Cu(pe) || pe.contentEditable === 'true') &&
                    ((Ri = pe), (Tr = O), (En = null));
                  break;
                case 'focusout':
                  En = Tr = Ri = null;
                  break;
                case 'mousedown':
                  wr = !0;
                  break;
                case 'contextmenu':
                case 'mouseup':
                case 'dragend':
                  ((wr = !1), Vu(P, a, V));
                  break;
                case 'selectionchange':
                  if (hg) break;
                case 'keydown':
                case 'keyup':
                  Vu(P, a, V);
              }
              var ne;
              if (vr)
                e: {
                  switch (e) {
                    case 'compositionstart':
                      var oe = 'onCompositionStart';
                      break e;
                    case 'compositionend':
                      oe = 'onCompositionEnd';
                      break e;
                    case 'compositionupdate':
                      oe = 'onCompositionUpdate';
                      break e;
                  }
                  oe = void 0;
                }
              else
                Bi
                  ? Mu(e, a) && (oe = 'onCompositionEnd')
                  : e === 'keydown' &&
                    a.keyCode === 229 &&
                    (oe = 'onCompositionStart');
              (oe &&
                (Nu &&
                  a.locale !== 'ko' &&
                  (Bi || oe !== 'onCompositionStart'
                    ? oe === 'onCompositionEnd' && Bi && (ne = Su())
                    : ((_a = V),
                      (hr = 'value' in _a ? _a.value : _a.textContent),
                      (Bi = !0))),
                (pe = ys(O, oe)),
                0 < pe.length &&
                  ((oe = new wu(oe, e, null, a, V)),
                  P.push({ event: oe, listeners: pe }),
                  ne
                    ? (oe.data = ne)
                    : ((ne = ju(a)), ne !== null && (oe.data = ne)))),
                (ne = ig ? ng(e, a) : lg(e, a)) &&
                  ((oe = ys(O, 'onBeforeInput')),
                  0 < oe.length &&
                    ((pe = new wu('onBeforeInput', 'beforeinput', null, a, V)),
                    P.push({ event: pe, listeners: oe }),
                    (pe.data = ne))),
                Qg(P, e, O, a, V));
            }
            fh(P, t);
          });
        }
        function Fn(e, t, a) {
          return { instance: e, listener: t, currentTarget: a };
        }
        function ys(e, t) {
          for (var a = t + 'Capture', n = []; e !== null; ) {
            var o = e,
              d = o.stateNode;
            if (
              ((o = o.tag),
              (o !== 5 && o !== 26 && o !== 27) ||
                d === null ||
                ((o = gn(e, a)),
                o != null && n.unshift(Fn(e, o, d)),
                (o = gn(e, t)),
                o != null && n.push(Fn(e, o, d))),
              e.tag === 3)
            )
              return n;
            e = e.return;
          }
          return [];
        }
        function nn(e) {
          if (e === null) return null;
          do e = e.return;
          while (e && e.tag !== 5 && e.tag !== 27);
          return e || null;
        }
        function mh(e, t, a, n, o) {
          for (var d = t._reactName, b = []; a !== null && a !== n; ) {
            var v = a,
              E = v.alternate,
              O = v.stateNode;
            if (((v = v.tag), E !== null && E === n)) break;
            ((v !== 5 && v !== 26 && v !== 27) ||
              O === null ||
              ((E = O),
              o
                ? ((O = gn(a, d)), O != null && b.unshift(Fn(a, O, E)))
                : o || ((O = gn(a, d)), O != null && b.push(Fn(a, O, E)))),
              (a = a.return));
          }
          b.length !== 0 && e.push({ event: t, listeners: b });
        }
        var Jg = /\r\n?/g,
          eb = /\u0000|\uFFFD/g;
        function ph(e) {
          return (typeof e == 'string' ? e : '' + e)
            .replace(
              Jg,
              `
`
            )
            .replace(eb, '');
        }
        function gh(e, t) {
          return ((t = ph(t)), ph(e) === t);
        }
        function Ss() {}
        function Ce(e, t, a, n, o, d) {
          switch (a) {
            case 'children':
              typeof n == 'string'
                ? t === 'body' || (t === 'textarea' && n === '') || ji(e, n)
                : (typeof n == 'number' || typeof n == 'bigint') &&
                  t !== 'body' &&
                  ji(e, '' + n);
              break;
            case 'className':
              Nl(e, 'class', n);
              break;
            case 'tabIndex':
              Nl(e, 'tabindex', n);
              break;
            case 'dir':
            case 'role':
            case 'viewBox':
            case 'width':
            case 'height':
              Nl(e, a, n);
              break;
            case 'style':
              bu(e, n, d);
              break;
            case 'data':
              if (t !== 'object') {
                Nl(e, 'data', n);
                break;
              }
            case 'src':
            case 'href':
              if (n === '' && (t !== 'a' || a !== 'href')) {
                e.removeAttribute(a);
                break;
              }
              if (
                n == null ||
                typeof n == 'function' ||
                typeof n == 'symbol' ||
                typeof n == 'boolean'
              ) {
                e.removeAttribute(a);
                break;
              }
              ((n = Ml('' + n)), e.setAttribute(a, n));
              break;
            case 'action':
            case 'formAction':
              if (typeof n == 'function') {
                e.setAttribute(
                  a,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              } else
                typeof d == 'function' &&
                  (a === 'formAction'
                    ? (t !== 'input' && Ce(e, t, 'name', o.name, o, null),
                      Ce(e, t, 'formEncType', o.formEncType, o, null),
                      Ce(e, t, 'formMethod', o.formMethod, o, null),
                      Ce(e, t, 'formTarget', o.formTarget, o, null))
                    : (Ce(e, t, 'encType', o.encType, o, null),
                      Ce(e, t, 'method', o.method, o, null),
                      Ce(e, t, 'target', o.target, o, null)));
              if (n == null || typeof n == 'symbol' || typeof n == 'boolean') {
                e.removeAttribute(a);
                break;
              }
              ((n = Ml('' + n)), e.setAttribute(a, n));
              break;
            case 'onClick':
              n != null && (e.onclick = Ss);
              break;
            case 'onScroll':
              n != null && be('scroll', e);
              break;
            case 'onScrollEnd':
              n != null && be('scrollend', e);
              break;
            case 'dangerouslySetInnerHTML':
              if (n != null) {
                if (typeof n != 'object' || !('__html' in n))
                  throw Error(r(61));
                if (((a = n.__html), a != null)) {
                  if (o.children != null) throw Error(r(60));
                  e.innerHTML = a;
                }
              }
              break;
            case 'multiple':
              e.multiple = n && typeof n != 'function' && typeof n != 'symbol';
              break;
            case 'muted':
              e.muted = n && typeof n != 'function' && typeof n != 'symbol';
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'defaultValue':
            case 'defaultChecked':
            case 'innerHTML':
            case 'ref':
              break;
            case 'autoFocus':
              break;
            case 'xlinkHref':
              if (
                n == null ||
                typeof n == 'function' ||
                typeof n == 'boolean' ||
                typeof n == 'symbol'
              ) {
                e.removeAttribute('xlink:href');
                break;
              }
              ((a = Ml('' + n)),
                e.setAttributeNS(
                  'http://www.w3.org/1999/xlink',
                  'xlink:href',
                  a
                ));
              break;
            case 'contentEditable':
            case 'spellCheck':
            case 'draggable':
            case 'value':
            case 'autoReverse':
            case 'externalResourcesRequired':
            case 'focusable':
            case 'preserveAlpha':
              n != null && typeof n != 'function' && typeof n != 'symbol'
                ? e.setAttribute(a, '' + n)
                : e.removeAttribute(a);
              break;
            case 'inert':
            case 'allowFullScreen':
            case 'async':
            case 'autoPlay':
            case 'controls':
            case 'default':
            case 'defer':
            case 'disabled':
            case 'disablePictureInPicture':
            case 'disableRemotePlayback':
            case 'formNoValidate':
            case 'hidden':
            case 'loop':
            case 'noModule':
            case 'noValidate':
            case 'open':
            case 'playsInline':
            case 'readOnly':
            case 'required':
            case 'reversed':
            case 'scoped':
            case 'seamless':
            case 'itemScope':
              n && typeof n != 'function' && typeof n != 'symbol'
                ? e.setAttribute(a, '')
                : e.removeAttribute(a);
              break;
            case 'capture':
            case 'download':
              n === !0
                ? e.setAttribute(a, '')
                : n !== !1 &&
                    n != null &&
                    typeof n != 'function' &&
                    typeof n != 'symbol'
                  ? e.setAttribute(a, n)
                  : e.removeAttribute(a);
              break;
            case 'cols':
            case 'rows':
            case 'size':
            case 'span':
              n != null &&
              typeof n != 'function' &&
              typeof n != 'symbol' &&
              !isNaN(n) &&
              1 <= n
                ? e.setAttribute(a, n)
                : e.removeAttribute(a);
              break;
            case 'rowSpan':
            case 'start':
              n == null ||
              typeof n == 'function' ||
              typeof n == 'symbol' ||
              isNaN(n)
                ? e.removeAttribute(a)
                : e.setAttribute(a, n);
              break;
            case 'popover':
              (be('beforetoggle', e), be('toggle', e), El(e, 'popover', n));
              break;
            case 'xlinkActuate':
              la(e, 'http://www.w3.org/1999/xlink', 'xlink:actuate', n);
              break;
            case 'xlinkArcrole':
              la(e, 'http://www.w3.org/1999/xlink', 'xlink:arcrole', n);
              break;
            case 'xlinkRole':
              la(e, 'http://www.w3.org/1999/xlink', 'xlink:role', n);
              break;
            case 'xlinkShow':
              la(e, 'http://www.w3.org/1999/xlink', 'xlink:show', n);
              break;
            case 'xlinkTitle':
              la(e, 'http://www.w3.org/1999/xlink', 'xlink:title', n);
              break;
            case 'xlinkType':
              la(e, 'http://www.w3.org/1999/xlink', 'xlink:type', n);
              break;
            case 'xmlBase':
              la(e, 'http://www.w3.org/XML/1998/namespace', 'xml:base', n);
              break;
            case 'xmlLang':
              la(e, 'http://www.w3.org/XML/1998/namespace', 'xml:lang', n);
              break;
            case 'xmlSpace':
              la(e, 'http://www.w3.org/XML/1998/namespace', 'xml:space', n);
              break;
            case 'is':
              El(e, 'is', n);
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              (!(2 < a.length) ||
                (a[0] !== 'o' && a[0] !== 'O') ||
                (a[1] !== 'n' && a[1] !== 'N')) &&
                ((a = Cp.get(a) || a), El(e, a, n));
          }
        }
        function Ko(e, t, a, n, o, d) {
          switch (a) {
            case 'style':
              bu(e, n, d);
              break;
            case 'dangerouslySetInnerHTML':
              if (n != null) {
                if (typeof n != 'object' || !('__html' in n))
                  throw Error(r(61));
                if (((a = n.__html), a != null)) {
                  if (o.children != null) throw Error(r(60));
                  e.innerHTML = a;
                }
              }
              break;
            case 'children':
              typeof n == 'string'
                ? ji(e, n)
                : (typeof n == 'number' || typeof n == 'bigint') &&
                  ji(e, '' + n);
              break;
            case 'onScroll':
              n != null && be('scroll', e);
              break;
            case 'onScrollEnd':
              n != null && be('scrollend', e);
              break;
            case 'onClick':
              n != null && (e.onclick = Ss);
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'innerHTML':
            case 'ref':
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              if (!su.hasOwnProperty(a))
                e: {
                  if (
                    a[0] === 'o' &&
                    a[1] === 'n' &&
                    ((o = a.endsWith('Capture')),
                    (t = a.slice(2, o ? a.length - 7 : void 0)),
                    (d = e[mt] || null),
                    (d = d != null ? d[a] : null),
                    typeof d == 'function' && e.removeEventListener(t, d, o),
                    typeof n == 'function')
                  ) {
                    (typeof d != 'function' &&
                      d !== null &&
                      (a in e
                        ? (e[a] = null)
                        : e.hasAttribute(a) && e.removeAttribute(a)),
                      e.addEventListener(t, n, o));
                    break e;
                  }
                  a in e
                    ? (e[a] = n)
                    : n === !0
                      ? e.setAttribute(a, '')
                      : El(e, a, n);
                }
          }
        }
        function st(e, t, a) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'img':
              (be('error', e), be('load', e));
              var n = !1,
                o = !1,
                d;
              for (d in a)
                if (a.hasOwnProperty(d)) {
                  var b = a[d];
                  if (b != null)
                    switch (d) {
                      case 'src':
                        n = !0;
                        break;
                      case 'srcSet':
                        o = !0;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        throw Error(r(137, t));
                      default:
                        Ce(e, t, d, b, a, null);
                    }
                }
              (o && Ce(e, t, 'srcSet', a.srcSet, a, null),
                n && Ce(e, t, 'src', a.src, a, null));
              return;
            case 'input':
              be('invalid', e);
              var v = (d = b = o = null),
                E = null,
                O = null;
              for (n in a)
                if (a.hasOwnProperty(n)) {
                  var V = a[n];
                  if (V != null)
                    switch (n) {
                      case 'name':
                        o = V;
                        break;
                      case 'type':
                        b = V;
                        break;
                      case 'checked':
                        E = V;
                        break;
                      case 'defaultChecked':
                        O = V;
                        break;
                      case 'value':
                        d = V;
                        break;
                      case 'defaultValue':
                        v = V;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        if (V != null) throw Error(r(137, t));
                        break;
                      default:
                        Ce(e, t, n, V, a, null);
                    }
                }
              (hu(e, d, v, E, O, b, o, !1), _l(e));
              return;
            case 'select':
              (be('invalid', e), (n = b = d = null));
              for (o in a)
                if (a.hasOwnProperty(o) && ((v = a[o]), v != null))
                  switch (o) {
                    case 'value':
                      d = v;
                      break;
                    case 'defaultValue':
                      b = v;
                      break;
                    case 'multiple':
                      n = v;
                    default:
                      Ce(e, t, o, v, a, null);
                  }
              ((t = d),
                (a = b),
                (e.multiple = !!n),
                t != null ? Mi(e, !!n, t, !1) : a != null && Mi(e, !!n, a, !0));
              return;
            case 'textarea':
              (be('invalid', e), (d = o = n = null));
              for (b in a)
                if (a.hasOwnProperty(b) && ((v = a[b]), v != null))
                  switch (b) {
                    case 'value':
                      n = v;
                      break;
                    case 'defaultValue':
                      o = v;
                      break;
                    case 'children':
                      d = v;
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (v != null) throw Error(r(91));
                      break;
                    default:
                      Ce(e, t, b, v, a, null);
                  }
              (pu(e, n, o, d), _l(e));
              return;
            case 'option':
              for (E in a)
                if (a.hasOwnProperty(E) && ((n = a[E]), n != null))
                  switch (E) {
                    case 'selected':
                      e.selected =
                        n && typeof n != 'function' && typeof n != 'symbol';
                      break;
                    default:
                      Ce(e, t, E, n, a, null);
                  }
              return;
            case 'dialog':
              (be('beforetoggle', e),
                be('toggle', e),
                be('cancel', e),
                be('close', e));
              break;
            case 'iframe':
            case 'object':
              be('load', e);
              break;
            case 'video':
            case 'audio':
              for (n = 0; n < Wn.length; n++) be(Wn[n], e);
              break;
            case 'image':
              (be('error', e), be('load', e));
              break;
            case 'details':
              be('toggle', e);
              break;
            case 'embed':
            case 'source':
            case 'link':
              (be('error', e), be('load', e));
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (O in a)
                if (a.hasOwnProperty(O) && ((n = a[O]), n != null))
                  switch (O) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      throw Error(r(137, t));
                    default:
                      Ce(e, t, O, n, a, null);
                  }
              return;
            default:
              if (or(t)) {
                for (V in a)
                  a.hasOwnProperty(V) &&
                    ((n = a[V]), n !== void 0 && Ko(e, t, V, n, a, void 0));
                return;
              }
          }
          for (v in a)
            a.hasOwnProperty(v) &&
              ((n = a[v]), n != null && Ce(e, t, v, n, a, null));
        }
        function tb(e, t, a, n) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'input':
              var o = null,
                d = null,
                b = null,
                v = null,
                E = null,
                O = null,
                V = null;
              for (R in a) {
                var P = a[R];
                if (a.hasOwnProperty(R) && P != null)
                  switch (R) {
                    case 'checked':
                      break;
                    case 'value':
                      break;
                    case 'defaultValue':
                      E = P;
                    default:
                      n.hasOwnProperty(R) || Ce(e, t, R, null, n, P);
                  }
              }
              for (var B in n) {
                var R = n[B];
                if (
                  ((P = a[B]), n.hasOwnProperty(B) && (R != null || P != null))
                )
                  switch (B) {
                    case 'type':
                      d = R;
                      break;
                    case 'name':
                      o = R;
                      break;
                    case 'checked':
                      O = R;
                      break;
                    case 'defaultChecked':
                      V = R;
                      break;
                    case 'value':
                      b = R;
                      break;
                    case 'defaultValue':
                      v = R;
                      break;
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (R != null) throw Error(r(137, t));
                      break;
                    default:
                      R !== P && Ce(e, t, B, R, n, P);
                  }
              }
              sr(e, b, v, E, O, V, d, o);
              return;
            case 'select':
              R = b = v = B = null;
              for (d in a)
                if (((E = a[d]), a.hasOwnProperty(d) && E != null))
                  switch (d) {
                    case 'value':
                      break;
                    case 'multiple':
                      R = E;
                    default:
                      n.hasOwnProperty(d) || Ce(e, t, d, null, n, E);
                  }
              for (o in n)
                if (
                  ((d = n[o]),
                  (E = a[o]),
                  n.hasOwnProperty(o) && (d != null || E != null))
                )
                  switch (o) {
                    case 'value':
                      B = d;
                      break;
                    case 'defaultValue':
                      v = d;
                      break;
                    case 'multiple':
                      b = d;
                    default:
                      d !== E && Ce(e, t, o, d, n, E);
                  }
              ((t = v),
                (a = b),
                (n = R),
                B != null
                  ? Mi(e, !!a, B, !1)
                  : !!n != !!a &&
                    (t != null
                      ? Mi(e, !!a, t, !0)
                      : Mi(e, !!a, a ? [] : '', !1)));
              return;
            case 'textarea':
              R = B = null;
              for (v in a)
                if (
                  ((o = a[v]),
                  a.hasOwnProperty(v) && o != null && !n.hasOwnProperty(v))
                )
                  switch (v) {
                    case 'value':
                      break;
                    case 'children':
                      break;
                    default:
                      Ce(e, t, v, null, n, o);
                  }
              for (b in n)
                if (
                  ((o = n[b]),
                  (d = a[b]),
                  n.hasOwnProperty(b) && (o != null || d != null))
                )
                  switch (b) {
                    case 'value':
                      B = o;
                      break;
                    case 'defaultValue':
                      R = o;
                      break;
                    case 'children':
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (o != null) throw Error(r(91));
                      break;
                    default:
                      o !== d && Ce(e, t, b, o, n, d);
                  }
              mu(e, B, R);
              return;
            case 'option':
              for (var ce in a)
                if (
                  ((B = a[ce]),
                  a.hasOwnProperty(ce) && B != null && !n.hasOwnProperty(ce))
                )
                  switch (ce) {
                    case 'selected':
                      e.selected = !1;
                      break;
                    default:
                      Ce(e, t, ce, null, n, B);
                  }
              for (E in n)
                if (
                  ((B = n[E]),
                  (R = a[E]),
                  n.hasOwnProperty(E) && B !== R && (B != null || R != null))
                )
                  switch (E) {
                    case 'selected':
                      e.selected =
                        B && typeof B != 'function' && typeof B != 'symbol';
                      break;
                    default:
                      Ce(e, t, E, B, n, R);
                  }
              return;
            case 'img':
            case 'link':
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'embed':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'source':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (var re in a)
                ((B = a[re]),
                  a.hasOwnProperty(re) &&
                    B != null &&
                    !n.hasOwnProperty(re) &&
                    Ce(e, t, re, null, n, B));
              for (O in n)
                if (
                  ((B = n[O]),
                  (R = a[O]),
                  n.hasOwnProperty(O) && B !== R && (B != null || R != null))
                )
                  switch (O) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (B != null) throw Error(r(137, t));
                      break;
                    default:
                      Ce(e, t, O, B, n, R);
                  }
              return;
            default:
              if (or(t)) {
                for (var Oe in a)
                  ((B = a[Oe]),
                    a.hasOwnProperty(Oe) &&
                      B !== void 0 &&
                      !n.hasOwnProperty(Oe) &&
                      Ko(e, t, Oe, void 0, n, B));
                for (V in n)
                  ((B = n[V]),
                    (R = a[V]),
                    !n.hasOwnProperty(V) ||
                      B === R ||
                      (B === void 0 && R === void 0) ||
                      Ko(e, t, V, B, n, R));
                return;
              }
          }
          for (var M in a)
            ((B = a[M]),
              a.hasOwnProperty(M) &&
                B != null &&
                !n.hasOwnProperty(M) &&
                Ce(e, t, M, null, n, B));
          for (P in n)
            ((B = n[P]),
              (R = a[P]),
              !n.hasOwnProperty(P) ||
                B === R ||
                (B == null && R == null) ||
                Ce(e, t, P, B, n, R));
        }
        var Xo = null,
          Qo = null;
        function xs(e) {
          return e.nodeType === 9 ? e : e.ownerDocument;
        }
        function bh(e) {
          switch (e) {
            case 'http://www.w3.org/2000/svg':
              return 1;
            case 'http://www.w3.org/1998/Math/MathML':
              return 2;
            default:
              return 0;
          }
        }
        function vh(e, t) {
          if (e === 0)
            switch (t) {
              case 'svg':
                return 1;
              case 'math':
                return 2;
              default:
                return 0;
            }
          return e === 1 && t === 'foreignObject' ? 0 : e;
        }
        function Zo(e, t) {
          return (
            e === 'textarea' ||
            e === 'noscript' ||
            typeof t.children == 'string' ||
            typeof t.children == 'number' ||
            typeof t.children == 'bigint' ||
            (typeof t.dangerouslySetInnerHTML == 'object' &&
              t.dangerouslySetInnerHTML !== null &&
              t.dangerouslySetInnerHTML.__html != null)
          );
        }
        var Wo = null;
        function ab() {
          var e = window.event;
          return e && e.type === 'popstate'
            ? e === Wo
              ? !1
              : ((Wo = e), !0)
            : ((Wo = null), !1);
        }
        var yh = typeof setTimeout == 'function' ? setTimeout : void 0,
          ib = typeof clearTimeout == 'function' ? clearTimeout : void 0,
          Sh = typeof Promise == 'function' ? Promise : void 0,
          nb =
            typeof queueMicrotask == 'function'
              ? queueMicrotask
              : typeof Sh < 'u'
                ? function (e) {
                    return Sh.resolve(null).then(e).catch(lb);
                  }
                : yh;
        function lb(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function ka(e) {
          return e === 'head';
        }
        function xh(e, t) {
          var a = t,
            n = 0,
            o = 0;
          do {
            var d = a.nextSibling;
            if ((e.removeChild(a), d && d.nodeType === 8))
              if (((a = d.data), a === '/$')) {
                if (0 < n && 8 > n) {
                  a = n;
                  var b = e.ownerDocument;
                  if (
                    (a & 1 && Jn(b.documentElement), a & 2 && Jn(b.body), a & 4)
                  )
                    for (a = b.head, Jn(a), b = a.firstChild; b; ) {
                      var v = b.nextSibling,
                        E = b.nodeName;
                      (b[mn] ||
                        E === 'SCRIPT' ||
                        E === 'STYLE' ||
                        (E === 'LINK' &&
                          b.rel.toLowerCase() === 'stylesheet') ||
                        a.removeChild(b),
                        (b = v));
                    }
                }
                if (o === 0) {
                  (e.removeChild(d), rl(t));
                  return;
                }
                o--;
              } else
                a === '$' || a === '$?' || a === '$!'
                  ? o++
                  : (n = a.charCodeAt(0) - 48);
            else n = 0;
            a = d;
          } while (a);
          rl(t);
        }
        function Fo(e) {
          var t = e.firstChild;
          for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
            var a = t;
            switch (((t = t.nextSibling), a.nodeName)) {
              case 'HTML':
              case 'HEAD':
              case 'BODY':
                (Fo(a), ar(a));
                continue;
              case 'SCRIPT':
              case 'STYLE':
                continue;
              case 'LINK':
                if (a.rel.toLowerCase() === 'stylesheet') continue;
            }
            e.removeChild(a);
          }
        }
        function sb(e, t, a, n) {
          for (; e.nodeType === 1; ) {
            var o = a;
            if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
              if (!n && (e.nodeName !== 'INPUT' || e.type !== 'hidden')) break;
            } else if (n) {
              if (!e[mn])
                switch (t) {
                  case 'meta':
                    if (!e.hasAttribute('itemprop')) break;
                    return e;
                  case 'link':
                    if (
                      ((d = e.getAttribute('rel')),
                      d === 'stylesheet' && e.hasAttribute('data-precedence'))
                    )
                      break;
                    if (
                      d !== o.rel ||
                      e.getAttribute('href') !==
                        (o.href == null || o.href === '' ? null : o.href) ||
                      e.getAttribute('crossorigin') !==
                        (o.crossOrigin == null ? null : o.crossOrigin) ||
                      e.getAttribute('title') !==
                        (o.title == null ? null : o.title)
                    )
                      break;
                    return e;
                  case 'style':
                    if (e.hasAttribute('data-precedence')) break;
                    return e;
                  case 'script':
                    if (
                      ((d = e.getAttribute('src')),
                      (d !== (o.src == null ? null : o.src) ||
                        e.getAttribute('type') !==
                          (o.type == null ? null : o.type) ||
                        e.getAttribute('crossorigin') !==
                          (o.crossOrigin == null ? null : o.crossOrigin)) &&
                        d &&
                        e.hasAttribute('async') &&
                        !e.hasAttribute('itemprop'))
                    )
                      break;
                    return e;
                  default:
                    return e;
                }
            } else if (t === 'input' && e.type === 'hidden') {
              var d = o.name == null ? null : '' + o.name;
              if (o.type === 'hidden' && e.getAttribute('name') === d) return e;
            } else return e;
            if (((e = Xt(e.nextSibling)), e === null)) break;
          }
          return null;
        }
        function rb(e, t, a) {
          if (t === '') return null;
          for (; e.nodeType !== 3; )
            if (
              ((e.nodeType !== 1 ||
                e.nodeName !== 'INPUT' ||
                e.type !== 'hidden') &&
                !a) ||
              ((e = Xt(e.nextSibling)), e === null)
            )
              return null;
          return e;
        }
        function Jo(e) {
          return (
            e.data === '$!' ||
            (e.data === '$?' && e.ownerDocument.readyState === 'complete')
          );
        }
        function ob(e, t) {
          var a = e.ownerDocument;
          if (e.data !== '$?' || a.readyState === 'complete') t();
          else {
            var n = function () {
              (t(), a.removeEventListener('DOMContentLoaded', n));
            };
            (a.addEventListener('DOMContentLoaded', n), (e._reactRetry = n));
          }
        }
        function Xt(e) {
          for (; e != null; e = e.nextSibling) {
            var t = e.nodeType;
            if (t === 1 || t === 3) break;
            if (t === 8) {
              if (
                ((t = e.data),
                t === '$' ||
                  t === '$!' ||
                  t === '$?' ||
                  t === 'F!' ||
                  t === 'F')
              )
                break;
              if (t === '/$') return null;
            }
          }
          return e;
        }
        var ec = null;
        function Th(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (e.nodeType === 8) {
              var a = e.data;
              if (a === '$' || a === '$!' || a === '$?') {
                if (t === 0) return e;
                t--;
              } else a === '/$' && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function wh(e, t, a) {
          switch (((t = xs(a)), e)) {
            case 'html':
              if (((e = t.documentElement), !e)) throw Error(r(452));
              return e;
            case 'head':
              if (((e = t.head), !e)) throw Error(r(453));
              return e;
            case 'body':
              if (((e = t.body), !e)) throw Error(r(454));
              return e;
            default:
              throw Error(r(451));
          }
        }
        function Jn(e) {
          for (var t = e.attributes; t.length; ) e.removeAttributeNode(t[0]);
          ar(e);
        }
        var qt = new Map(),
          Eh = new Set();
        function Ts(e) {
          return typeof e.getRootNode == 'function'
            ? e.getRootNode()
            : e.nodeType === 9
              ? e
              : e.ownerDocument;
        }
        var ya = Q.d;
        Q.d = { f: cb, r: ub, D: db, C: fb, L: hb, m: mb, X: gb, S: pb, M: bb };
        function cb() {
          var e = ya.f(),
            t = hs();
          return e || t;
        }
        function ub(e) {
          var t = Ei(e);
          t !== null && t.tag === 5 && t.type === 'form' ? $d(t) : ya.r(e);
        }
        var ln = typeof document > 'u' ? null : document;
        function Nh(e, t, a) {
          var n = ln;
          if (n && typeof t == 'string' && t) {
            var o = Ht(t);
            ((o = 'link[rel="' + e + '"][href="' + o + '"]'),
              typeof a == 'string' && (o += '[crossorigin="' + a + '"]'),
              Eh.has(o) ||
                (Eh.add(o),
                (e = { rel: e, crossOrigin: a, href: t }),
                n.querySelector(o) === null &&
                  ((t = n.createElement('link')),
                  st(t, 'link', e),
                  Je(t),
                  n.head.appendChild(t))));
          }
        }
        function db(e) {
          (ya.D(e), Nh('dns-prefetch', e, null));
        }
        function fb(e, t) {
          (ya.C(e, t), Nh('preconnect', e, t));
        }
        function hb(e, t, a) {
          ya.L(e, t, a);
          var n = ln;
          if (n && e && t) {
            var o = 'link[rel="preload"][as="' + Ht(t) + '"]';
            t === 'image' && a && a.imageSrcSet
              ? ((o += '[imagesrcset="' + Ht(a.imageSrcSet) + '"]'),
                typeof a.imageSizes == 'string' &&
                  (o += '[imagesizes="' + Ht(a.imageSizes) + '"]'))
              : (o += '[href="' + Ht(e) + '"]');
            var d = o;
            switch (t) {
              case 'style':
                d = sn(e);
                break;
              case 'script':
                d = rn(e);
            }
            qt.has(d) ||
              ((e = y(
                {
                  rel: 'preload',
                  href: t === 'image' && a && a.imageSrcSet ? void 0 : e,
                  as: t,
                },
                a
              )),
              qt.set(d, e),
              n.querySelector(o) !== null ||
                (t === 'style' && n.querySelector(el(d))) ||
                (t === 'script' && n.querySelector(tl(d))) ||
                ((t = n.createElement('link')),
                st(t, 'link', e),
                Je(t),
                n.head.appendChild(t)));
          }
        }
        function mb(e, t) {
          ya.m(e, t);
          var a = ln;
          if (a && e) {
            var n = t && typeof t.as == 'string' ? t.as : 'script',
              o =
                'link[rel="modulepreload"][as="' +
                Ht(n) +
                '"][href="' +
                Ht(e) +
                '"]',
              d = o;
            switch (n) {
              case 'audioworklet':
              case 'paintworklet':
              case 'serviceworker':
              case 'sharedworker':
              case 'worker':
              case 'script':
                d = rn(e);
            }
            if (
              !qt.has(d) &&
              ((e = y({ rel: 'modulepreload', href: e }, t)),
              qt.set(d, e),
              a.querySelector(o) === null)
            ) {
              switch (n) {
                case 'audioworklet':
                case 'paintworklet':
                case 'serviceworker':
                case 'sharedworker':
                case 'worker':
                case 'script':
                  if (a.querySelector(tl(d))) return;
              }
              ((n = a.createElement('link')),
                st(n, 'link', e),
                Je(n),
                a.head.appendChild(n));
            }
          }
        }
        function pb(e, t, a) {
          ya.S(e, t, a);
          var n = ln;
          if (n && e) {
            var o = Ni(n).hoistableStyles,
              d = sn(e);
            t = t || 'default';
            var b = o.get(d);
            if (!b) {
              var v = { loading: 0, preload: null };
              if ((b = n.querySelector(el(d)))) v.loading = 5;
              else {
                ((e = y(
                  { rel: 'stylesheet', href: e, 'data-precedence': t },
                  a
                )),
                  (a = qt.get(d)) && tc(e, a));
                var E = (b = n.createElement('link'));
                (Je(E),
                  st(E, 'link', e),
                  (E._p = new Promise(function (O, V) {
                    ((E.onload = O), (E.onerror = V));
                  })),
                  E.addEventListener('load', function () {
                    v.loading |= 1;
                  }),
                  E.addEventListener('error', function () {
                    v.loading |= 2;
                  }),
                  (v.loading |= 4),
                  ws(b, t, n));
              }
              ((b = { type: 'stylesheet', instance: b, count: 1, state: v }),
                o.set(d, b));
            }
          }
        }
        function gb(e, t) {
          ya.X(e, t);
          var a = ln;
          if (a && e) {
            var n = Ni(a).hoistableScripts,
              o = rn(e),
              d = n.get(o);
            d ||
              ((d = a.querySelector(tl(o))),
              d ||
                ((e = y({ src: e, async: !0 }, t)),
                (t = qt.get(o)) && ac(e, t),
                (d = a.createElement('script')),
                Je(d),
                st(d, 'link', e),
                a.head.appendChild(d)),
              (d = { type: 'script', instance: d, count: 1, state: null }),
              n.set(o, d));
          }
        }
        function bb(e, t) {
          ya.M(e, t);
          var a = ln;
          if (a && e) {
            var n = Ni(a).hoistableScripts,
              o = rn(e),
              d = n.get(o);
            d ||
              ((d = a.querySelector(tl(o))),
              d ||
                ((e = y({ src: e, async: !0, type: 'module' }, t)),
                (t = qt.get(o)) && ac(e, t),
                (d = a.createElement('script')),
                Je(d),
                st(d, 'link', e),
                a.head.appendChild(d)),
              (d = { type: 'script', instance: d, count: 1, state: null }),
              n.set(o, d));
          }
        }
        function _h(e, t, a, n) {
          var o = (o = fe.current) ? Ts(o) : null;
          if (!o) throw Error(r(446));
          switch (e) {
            case 'meta':
            case 'title':
              return null;
            case 'style':
              return typeof a.precedence == 'string' &&
                typeof a.href == 'string'
                ? ((t = sn(a.href)),
                  (a = Ni(o).hoistableStyles),
                  (n = a.get(t)),
                  n ||
                    ((n = {
                      type: 'style',
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    a.set(t, n)),
                  n)
                : { type: 'void', instance: null, count: 0, state: null };
            case 'link':
              if (
                a.rel === 'stylesheet' &&
                typeof a.href == 'string' &&
                typeof a.precedence == 'string'
              ) {
                e = sn(a.href);
                var d = Ni(o).hoistableStyles,
                  b = d.get(e);
                if (
                  (b ||
                    ((o = o.ownerDocument || o),
                    (b = {
                      type: 'stylesheet',
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    d.set(e, b),
                    (d = o.querySelector(el(e))) &&
                      !d._p &&
                      ((b.instance = d), (b.state.loading = 5)),
                    qt.has(e) ||
                      ((a = {
                        rel: 'preload',
                        as: 'style',
                        href: a.href,
                        crossOrigin: a.crossOrigin,
                        integrity: a.integrity,
                        media: a.media,
                        hrefLang: a.hrefLang,
                        referrerPolicy: a.referrerPolicy,
                      }),
                      qt.set(e, a),
                      d || vb(o, e, a, b.state))),
                  t && n === null)
                )
                  throw Error(r(528, ''));
                return b;
              }
              if (t && n !== null) throw Error(r(529, ''));
              return null;
            case 'script':
              return (
                (t = a.async),
                (a = a.src),
                typeof a == 'string' &&
                t &&
                typeof t != 'function' &&
                typeof t != 'symbol'
                  ? ((t = rn(a)),
                    (a = Ni(o).hoistableScripts),
                    (n = a.get(t)),
                    n ||
                      ((n = {
                        type: 'script',
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      a.set(t, n)),
                    n)
                  : { type: 'void', instance: null, count: 0, state: null }
              );
            default:
              throw Error(r(444, e));
          }
        }
        function sn(e) {
          return 'href="' + Ht(e) + '"';
        }
        function el(e) {
          return 'link[rel="stylesheet"][' + e + ']';
        }
        function Ah(e) {
          return y({}, e, {
            'data-precedence': e.precedence,
            precedence: null,
          });
        }
        function vb(e, t, a, n) {
          e.querySelector('link[rel="preload"][as="style"][' + t + ']')
            ? (n.loading = 1)
            : ((t = e.createElement('link')),
              (n.preload = t),
              t.addEventListener('load', function () {
                return (n.loading |= 1);
              }),
              t.addEventListener('error', function () {
                return (n.loading |= 2);
              }),
              st(t, 'link', a),
              Je(t),
              e.head.appendChild(t));
        }
        function rn(e) {
          return '[src="' + Ht(e) + '"]';
        }
        function tl(e) {
          return 'script[async]' + e;
        }
        function Mh(e, t, a) {
          if ((t.count++, t.instance === null))
            switch (t.type) {
              case 'style':
                var n = e.querySelector(
                  'style[data-href~="' + Ht(a.href) + '"]'
                );
                if (n) return ((t.instance = n), Je(n), n);
                var o = y({}, a, {
                  'data-href': a.href,
                  'data-precedence': a.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  (n = (e.ownerDocument || e).createElement('style')),
                  Je(n),
                  st(n, 'style', o),
                  ws(n, a.precedence, e),
                  (t.instance = n)
                );
              case 'stylesheet':
                o = sn(a.href);
                var d = e.querySelector(el(o));
                if (d)
                  return ((t.state.loading |= 4), (t.instance = d), Je(d), d);
                ((n = Ah(a)),
                  (o = qt.get(o)) && tc(n, o),
                  (d = (e.ownerDocument || e).createElement('link')),
                  Je(d));
                var b = d;
                return (
                  (b._p = new Promise(function (v, E) {
                    ((b.onload = v), (b.onerror = E));
                  })),
                  st(d, 'link', n),
                  (t.state.loading |= 4),
                  ws(d, a.precedence, e),
                  (t.instance = d)
                );
              case 'script':
                return (
                  (d = rn(a.src)),
                  (o = e.querySelector(tl(d)))
                    ? ((t.instance = o), Je(o), o)
                    : ((n = a),
                      (o = qt.get(d)) && ((n = y({}, a)), ac(n, o)),
                      (e = e.ownerDocument || e),
                      (o = e.createElement('script')),
                      Je(o),
                      st(o, 'link', n),
                      e.head.appendChild(o),
                      (t.instance = o))
                );
              case 'void':
                return null;
              default:
                throw Error(r(443, t.type));
            }
          else
            t.type === 'stylesheet' &&
              (t.state.loading & 4) === 0 &&
              ((n = t.instance),
              (t.state.loading |= 4),
              ws(n, a.precedence, e));
          return t.instance;
        }
        function ws(e, t, a) {
          for (
            var n = a.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              o = n.length ? n[n.length - 1] : null,
              d = o,
              b = 0;
            b < n.length;
            b++
          ) {
            var v = n[b];
            if (v.dataset.precedence === t) d = v;
            else if (d !== o) break;
          }
          d
            ? d.parentNode.insertBefore(e, d.nextSibling)
            : ((t = a.nodeType === 9 ? a.head : a),
              t.insertBefore(e, t.firstChild));
        }
        function tc(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.title == null && (e.title = t.title));
        }
        function ac(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.integrity == null && (e.integrity = t.integrity));
        }
        var Es = null;
        function jh(e, t, a) {
          if (Es === null) {
            var n = new Map(),
              o = (Es = new Map());
            o.set(a, n);
          } else
            ((o = Es), (n = o.get(a)), n || ((n = new Map()), o.set(a, n)));
          if (n.has(e)) return n;
          for (
            n.set(e, null), a = a.getElementsByTagName(e), o = 0;
            o < a.length;
            o++
          ) {
            var d = a[o];
            if (
              !(
                d[mn] ||
                d[rt] ||
                (e === 'link' && d.getAttribute('rel') === 'stylesheet')
              ) &&
              d.namespaceURI !== 'http://www.w3.org/2000/svg'
            ) {
              var b = d.getAttribute(t) || '';
              b = e + b;
              var v = n.get(b);
              v ? v.push(d) : n.set(b, [d]);
            }
          }
          return n;
        }
        function Ch(e, t, a) {
          ((e = e.ownerDocument || e),
            e.head.insertBefore(
              a,
              t === 'title' ? e.querySelector('head > title') : null
            ));
        }
        function yb(e, t, a) {
          if (a === 1 || t.itemProp != null) return !1;
          switch (e) {
            case 'meta':
            case 'title':
              return !0;
            case 'style':
              if (
                typeof t.precedence != 'string' ||
                typeof t.href != 'string' ||
                t.href === ''
              )
                break;
              return !0;
            case 'link':
              if (
                typeof t.rel != 'string' ||
                typeof t.href != 'string' ||
                t.href === '' ||
                t.onLoad ||
                t.onError
              )
                break;
              switch (t.rel) {
                case 'stylesheet':
                  return (
                    (e = t.disabled),
                    typeof t.precedence == 'string' && e == null
                  );
                default:
                  return !0;
              }
            case 'script':
              if (
                t.async &&
                typeof t.async != 'function' &&
                typeof t.async != 'symbol' &&
                !t.onLoad &&
                !t.onError &&
                t.src &&
                typeof t.src == 'string'
              )
                return !0;
          }
          return !1;
        }
        function Oh(e) {
          return !(e.type === 'stylesheet' && (e.state.loading & 3) === 0);
        }
        var al = null;
        function Sb() {}
        function xb(e, t, a) {
          if (al === null) throw Error(r(475));
          var n = al;
          if (
            t.type === 'stylesheet' &&
            (typeof a.media != 'string' ||
              matchMedia(a.media).matches !== !1) &&
            (t.state.loading & 4) === 0
          ) {
            if (t.instance === null) {
              var o = sn(a.href),
                d = e.querySelector(el(o));
              if (d) {
                ((e = d._p),
                  e !== null &&
                    typeof e == 'object' &&
                    typeof e.then == 'function' &&
                    (n.count++, (n = Ns.bind(n)), e.then(n, n)),
                  (t.state.loading |= 4),
                  (t.instance = d),
                  Je(d));
                return;
              }
              ((d = e.ownerDocument || e),
                (a = Ah(a)),
                (o = qt.get(o)) && tc(a, o),
                (d = d.createElement('link')),
                Je(d));
              var b = d;
              ((b._p = new Promise(function (v, E) {
                ((b.onload = v), (b.onerror = E));
              })),
                st(d, 'link', a),
                (t.instance = d));
            }
            (n.stylesheets === null && (n.stylesheets = new Map()),
              n.stylesheets.set(t, e),
              (e = t.state.preload) &&
                (t.state.loading & 3) === 0 &&
                (n.count++,
                (t = Ns.bind(n)),
                e.addEventListener('load', t),
                e.addEventListener('error', t)));
          }
        }
        function Tb() {
          if (al === null) throw Error(r(475));
          var e = al;
          return (
            e.stylesheets && e.count === 0 && ic(e, e.stylesheets),
            0 < e.count
              ? function (t) {
                  var a = setTimeout(function () {
                    if ((e.stylesheets && ic(e, e.stylesheets), e.unsuspend)) {
                      var n = e.unsuspend;
                      ((e.unsuspend = null), n());
                    }
                  }, 6e4);
                  return (
                    (e.unsuspend = t),
                    function () {
                      ((e.unsuspend = null), clearTimeout(a));
                    }
                  );
                }
              : null
          );
        }
        function Ns() {
          if ((this.count--, this.count === 0)) {
            if (this.stylesheets) ic(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              ((this.unsuspend = null), e());
            }
          }
        }
        var _s = null;
        function ic(e, t) {
          ((e.stylesheets = null),
            e.unsuspend !== null &&
              (e.count++,
              (_s = new Map()),
              t.forEach(wb, e),
              (_s = null),
              Ns.call(e)));
        }
        function wb(e, t) {
          if (!(t.state.loading & 4)) {
            var a = _s.get(e);
            if (a) var n = a.get(null);
            else {
              ((a = new Map()), _s.set(e, a));
              for (
                var o = e.querySelectorAll(
                    'link[data-precedence],style[data-precedence]'
                  ),
                  d = 0;
                d < o.length;
                d++
              ) {
                var b = o[d];
                (b.nodeName === 'LINK' ||
                  b.getAttribute('media') !== 'not all') &&
                  (a.set(b.dataset.precedence, b), (n = b));
              }
              n && a.set(null, n);
            }
            ((o = t.instance),
              (b = o.getAttribute('data-precedence')),
              (d = a.get(b) || n),
              d === n && a.set(null, o),
              a.set(b, o),
              this.count++,
              (n = Ns.bind(this)),
              o.addEventListener('load', n),
              o.addEventListener('error', n),
              d
                ? d.parentNode.insertBefore(o, d.nextSibling)
                : ((e = e.nodeType === 9 ? e.head : e),
                  e.insertBefore(o, e.firstChild)),
              (t.state.loading |= 4));
          }
        }
        var il = {
          $$typeof: H,
          Provider: null,
          Consumer: null,
          _currentValue: K,
          _currentValue2: K,
          _threadCount: 0,
        };
        function Eb(e, t, a, n, o, d, b, v) {
          ((this.tag = 1),
            (this.containerInfo = e),
            (this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = Fs(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = Fs(0)),
            (this.hiddenUpdates = Fs(null)),
            (this.identifierPrefix = n),
            (this.onUncaughtError = o),
            (this.onCaughtError = d),
            (this.onRecoverableError = b),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = v),
            (this.incompleteTransitions = new Map()));
        }
        function Bh(e, t, a, n, o, d, b, v, E, O, V, P) {
          return (
            (e = new Eb(e, t, a, b, v, E, O, P)),
            (t = 1),
            d === !0 && (t |= 24),
            (d = _t(3, null, null, t)),
            (e.current = d),
            (d.stateNode = e),
            (t = Hr()),
            t.refCount++,
            (e.pooledCache = t),
            t.refCount++,
            (d.memoizedState = { element: n, isDehydrated: a, cache: t }),
            Vr(d),
            e
          );
        }
        function Rh(e) {
          return e ? ((e = Hi), e) : Hi;
        }
        function Dh(e, t, a, n, o, d) {
          ((o = Rh(o)),
            n.context === null ? (n.context = o) : (n.pendingContext = o),
            (n = ja(t)),
            (n.payload = { element: a }),
            (d = d === void 0 ? null : d),
            d !== null && (n.callback = d),
            (a = Ca(e, n, t)),
            a !== null && (Ot(a, e, t), Rn(a, e, t)));
        }
        function Lh(e, t) {
          if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
            var a = e.retryLane;
            e.retryLane = a !== 0 && a < t ? a : t;
          }
        }
        function nc(e, t) {
          (Lh(e, t), (e = e.alternate) && Lh(e, t));
        }
        function zh(e) {
          if (e.tag === 13) {
            var t = zi(e, 67108864);
            (t !== null && Ot(t, e, 67108864), nc(e, 67108864));
          }
        }
        var As = !0;
        function Nb(e, t, a, n) {
          var o = z.T;
          z.T = null;
          var d = Q.p;
          try {
            ((Q.p = 2), lc(e, t, a, n));
          } finally {
            ((Q.p = d), (z.T = o));
          }
        }
        function _b(e, t, a, n) {
          var o = z.T;
          z.T = null;
          var d = Q.p;
          try {
            ((Q.p = 8), lc(e, t, a, n));
          } finally {
            ((Q.p = d), (z.T = o));
          }
        }
        function lc(e, t, a, n) {
          if (As) {
            var o = sc(n);
            if (o === null) (Yo(e, t, n, Ms, a), Uh(e, n));
            else if (Mb(o, e, t, a, n)) n.stopPropagation();
            else if ((Uh(e, n), t & 4 && -1 < Ab.indexOf(e))) {
              for (; o !== null; ) {
                var d = Ei(o);
                if (d !== null)
                  switch (d.tag) {
                    case 3:
                      if (
                        ((d = d.stateNode),
                        d.current.memoizedState.isDehydrated)
                      ) {
                        var b = Ja(d.pendingLanes);
                        if (b !== 0) {
                          var v = d;
                          for (
                            v.pendingLanes |= 2, v.entangledLanes |= 2;
                            b;
                          ) {
                            var E = 1 << (31 - Et(b));
                            ((v.entanglements[1] |= E), (b &= ~E));
                          }
                          (ta(d), (Ae & 6) === 0 && ((ds = Zt() + 500), Zn(0)));
                        }
                      }
                      break;
                    case 13:
                      ((v = zi(d, 2)),
                        v !== null && Ot(v, d, 2),
                        hs(),
                        nc(d, 2));
                  }
                if (((d = sc(n)), d === null && Yo(e, t, n, Ms, a), d === o))
                  break;
                o = d;
              }
              o !== null && n.stopPropagation();
            } else Yo(e, t, n, null, a);
          }
        }
        function sc(e) {
          return ((e = ur(e)), rc(e));
        }
        var Ms = null;
        function rc(e) {
          if (((Ms = null), (e = wi(e)), e !== null)) {
            var t = u(e);
            if (t === null) e = null;
            else {
              var a = t.tag;
              if (a === 13) {
                if (((e = h(t)), e !== null)) return e;
                e = null;
              } else if (a === 3) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return t.tag === 3 ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return ((Ms = e), null);
        }
        function Hh(e) {
          switch (e) {
            case 'beforetoggle':
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'toggle':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            case 'beforeblur':
            case 'afterblur':
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
              return 2;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'touchmove':
            case 'wheel':
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
              return 8;
            case 'message':
              switch (fp()) {
                case Zc:
                  return 2;
                case Wc:
                  return 8;
                case Sl:
                case hp:
                  return 32;
                case Fc:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var oc = !1,
          $a = null,
          qa = null,
          Pa = null,
          nl = new Map(),
          ll = new Map(),
          Ya = [],
          Ab =
            'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
              ' '
            );
        function Uh(e, t) {
          switch (e) {
            case 'focusin':
            case 'focusout':
              $a = null;
              break;
            case 'dragenter':
            case 'dragleave':
              qa = null;
              break;
            case 'mouseover':
            case 'mouseout':
              Pa = null;
              break;
            case 'pointerover':
            case 'pointerout':
              nl.delete(t.pointerId);
              break;
            case 'gotpointercapture':
            case 'lostpointercapture':
              ll.delete(t.pointerId);
          }
        }
        function sl(e, t, a, n, o, d) {
          return e === null || e.nativeEvent !== d
            ? ((e = {
                blockedOn: t,
                domEventName: a,
                eventSystemFlags: n,
                nativeEvent: d,
                targetContainers: [o],
              }),
              t !== null && ((t = Ei(t)), t !== null && zh(t)),
              e)
            : ((e.eventSystemFlags |= n),
              (t = e.targetContainers),
              o !== null && t.indexOf(o) === -1 && t.push(o),
              e);
        }
        function Mb(e, t, a, n, o) {
          switch (t) {
            case 'focusin':
              return (($a = sl($a, e, t, a, n, o)), !0);
            case 'dragenter':
              return ((qa = sl(qa, e, t, a, n, o)), !0);
            case 'mouseover':
              return ((Pa = sl(Pa, e, t, a, n, o)), !0);
            case 'pointerover':
              var d = o.pointerId;
              return (nl.set(d, sl(nl.get(d) || null, e, t, a, n, o)), !0);
            case 'gotpointercapture':
              return (
                (d = o.pointerId),
                ll.set(d, sl(ll.get(d) || null, e, t, a, n, o)),
                !0
              );
          }
          return !1;
        }
        function Ih(e) {
          var t = wi(e.target);
          if (t !== null) {
            var a = u(t);
            if (a !== null) {
              if (((t = a.tag), t === 13)) {
                if (((t = h(a)), t !== null)) {
                  ((e.blockedOn = t),
                    xp(e.priority, function () {
                      if (a.tag === 13) {
                        var n = Ct();
                        n = Js(n);
                        var o = zi(a, n);
                        (o !== null && Ot(o, a, n), nc(a, n));
                      }
                    }));
                  return;
                }
              } else if (
                t === 3 &&
                a.stateNode.current.memoizedState.isDehydrated
              ) {
                e.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
                return;
              }
            }
          }
          e.blockedOn = null;
        }
        function js(e) {
          if (e.blockedOn !== null) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var a = sc(e.nativeEvent);
            if (a === null) {
              a = e.nativeEvent;
              var n = new a.constructor(a.type, a);
              ((cr = n), a.target.dispatchEvent(n), (cr = null));
            } else
              return ((t = Ei(a)), t !== null && zh(t), (e.blockedOn = a), !1);
            t.shift();
          }
          return !0;
        }
        function Gh(e, t, a) {
          js(e) && a.delete(t);
        }
        function jb() {
          ((oc = !1),
            $a !== null && js($a) && ($a = null),
            qa !== null && js(qa) && (qa = null),
            Pa !== null && js(Pa) && (Pa = null),
            nl.forEach(Gh),
            ll.forEach(Gh));
        }
        function Cs(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            oc ||
              ((oc = !0),
              i.unstable_scheduleCallback(i.unstable_NormalPriority, jb)));
        }
        var Os = null;
        function Vh(e) {
          Os !== e &&
            ((Os = e),
            i.unstable_scheduleCallback(i.unstable_NormalPriority, function () {
              Os === e && (Os = null);
              for (var t = 0; t < e.length; t += 3) {
                var a = e[t],
                  n = e[t + 1],
                  o = e[t + 2];
                if (typeof n != 'function') {
                  if (rc(n || a) === null) continue;
                  break;
                }
                var d = Ei(a);
                d !== null &&
                  (e.splice(t, 3),
                  (t -= 3),
                  so(
                    d,
                    { pending: !0, data: o, method: a.method, action: n },
                    n,
                    o
                  ));
              }
            }));
        }
        function rl(e) {
          function t(E) {
            return Cs(E, e);
          }
          ($a !== null && Cs($a, e),
            qa !== null && Cs(qa, e),
            Pa !== null && Cs(Pa, e),
            nl.forEach(t),
            ll.forEach(t));
          for (var a = 0; a < Ya.length; a++) {
            var n = Ya[a];
            n.blockedOn === e && (n.blockedOn = null);
          }
          for (; 0 < Ya.length && ((a = Ya[0]), a.blockedOn === null); )
            (Ih(a), a.blockedOn === null && Ya.shift());
          if (((a = (e.ownerDocument || e).$$reactFormReplay), a != null))
            for (n = 0; n < a.length; n += 3) {
              var o = a[n],
                d = a[n + 1],
                b = o[mt] || null;
              if (typeof d == 'function') b || Vh(a);
              else if (b) {
                var v = null;
                if (d && d.hasAttribute('formAction')) {
                  if (((o = d), (b = d[mt] || null))) v = b.formAction;
                  else if (rc(o) !== null) continue;
                } else v = b.action;
                (typeof v == 'function'
                  ? (a[n + 1] = v)
                  : (a.splice(n, 3), (n -= 3)),
                  Vh(a));
              }
            }
        }
        function cc(e) {
          this._internalRoot = e;
        }
        ((Bs.prototype.render = cc.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (t === null) throw Error(r(409));
            var a = t.current,
              n = Ct();
            Dh(a, n, e, t, null, null);
          }),
          (Bs.prototype.unmount = cc.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (e !== null) {
                this._internalRoot = null;
                var t = e.containerInfo;
                (Dh(e.current, 2, null, e, null, null), hs(), (t[Ti] = null));
              }
            }));
        function Bs(e) {
          this._internalRoot = e;
        }
        Bs.prototype.unstable_scheduleHydration = function (e) {
          if (e) {
            var t = iu();
            e = { blockedOn: null, target: e, priority: t };
            for (
              var a = 0;
              a < Ya.length && t !== 0 && t < Ya[a].priority;
              a++
            );
            (Ya.splice(a, 0, e), a === 0 && Ih(e));
          }
        };
        var kh = l.version;
        if (kh !== '19.1.1') throw Error(r(527, kh, '19.1.1'));
        Q.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (t === void 0)
            throw typeof e.render == 'function'
              ? Error(r(188))
              : ((e = Object.keys(e).join(',')), Error(r(268, e)));
          return (
            (e = f(t)),
            (e = e !== null ? p(e) : null),
            (e = e === null ? null : e.stateNode),
            e
          );
        };
        var Cb = {
          bundleType: 0,
          version: '19.1.1',
          rendererPackageName: 'react-dom',
          currentDispatcherRef: z,
          reconcilerVersion: '19.1.1',
        };
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
          var Rs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!Rs.isDisabled && Rs.supportsFiber)
            try {
              ((dn = Rs.inject(Cb)), (wt = Rs));
            } catch {}
        }
        return (
          (cl.createRoot = function (e, t) {
            if (!c(e)) throw Error(r(299));
            var a = !1,
              n = '',
              o = nf,
              d = lf,
              b = sf,
              v = null;
            return (
              t != null &&
                (t.unstable_strictMode === !0 && (a = !0),
                t.identifierPrefix !== void 0 && (n = t.identifierPrefix),
                t.onUncaughtError !== void 0 && (o = t.onUncaughtError),
                t.onCaughtError !== void 0 && (d = t.onCaughtError),
                t.onRecoverableError !== void 0 && (b = t.onRecoverableError),
                t.unstable_transitionCallbacks !== void 0 &&
                  (v = t.unstable_transitionCallbacks)),
              (t = Bh(e, 1, !1, null, null, a, n, o, d, b, v, null)),
              (e[Ti] = t.current),
              Po(e),
              new cc(t)
            );
          }),
          (cl.hydrateRoot = function (e, t, a) {
            if (!c(e)) throw Error(r(299));
            var n = !1,
              o = '',
              d = nf,
              b = lf,
              v = sf,
              E = null,
              O = null;
            return (
              a != null &&
                (a.unstable_strictMode === !0 && (n = !0),
                a.identifierPrefix !== void 0 && (o = a.identifierPrefix),
                a.onUncaughtError !== void 0 && (d = a.onUncaughtError),
                a.onCaughtError !== void 0 && (b = a.onCaughtError),
                a.onRecoverableError !== void 0 && (v = a.onRecoverableError),
                a.unstable_transitionCallbacks !== void 0 &&
                  (E = a.unstable_transitionCallbacks),
                a.formState !== void 0 && (O = a.formState)),
              (t = Bh(e, 1, !0, t, a ?? null, n, o, d, b, v, E, O)),
              (t.context = Rh(null)),
              (a = t.current),
              (n = Ct()),
              (n = Js(n)),
              (o = ja(n)),
              (o.callback = null),
              Ca(a, o, n),
              (a = n),
              (t.current.lanes = a),
              hn(t, a),
              ta(t),
              (e[Ti] = t.current),
              Po(e),
              new Bs(t)
            );
          }),
          (cl.version = '19.1.1'),
          cl
        );
      }
      var Fh;
      function Gb() {
        if (Fh) return fc.exports;
        Fh = 1;
        function i() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(i);
            } catch (l) {
              console.error(l);
            }
        }
        return (i(), (fc.exports = Ib()), fc.exports);
      }
      var Jh = Gb();
      const ue = i => typeof i == 'string',
        ul = () => {
          let i, l;
          const s = new Promise((r, c) => {
            ((i = r), (l = c));
          });
          return ((s.resolve = i), (s.reject = l), s);
        },
        em = i => (i == null ? '' : '' + i),
        Vb = (i, l, s) => {
          i.forEach(r => {
            l[r] && (s[r] = l[r]);
          });
        },
        kb = /###/g,
        tm = i => (i && i.indexOf('###') > -1 ? i.replace(kb, '.') : i),
        am = i => !i || ue(i),
        hl = (i, l, s) => {
          const r = ue(l) ? l.split('.') : l;
          let c = 0;
          for (; c < r.length - 1; ) {
            if (am(i)) return {};
            const u = tm(r[c]);
            (!i[u] && s && (i[u] = new s()),
              Object.prototype.hasOwnProperty.call(i, u)
                ? (i = i[u])
                : (i = {}),
              ++c);
          }
          return am(i) ? {} : { obj: i, k: tm(r[c]) };
        },
        im = (i, l, s) => {
          const { obj: r, k: c } = hl(i, l, Object);
          if (r !== void 0 || l.length === 1) {
            r[c] = s;
            return;
          }
          let u = l[l.length - 1],
            h = l.slice(0, l.length - 1),
            m = hl(i, h, Object);
          for (; m.obj === void 0 && h.length; )
            ((u = `${h[h.length - 1]}.${u}`),
              (h = h.slice(0, h.length - 1)),
              (m = hl(i, h, Object)),
              m?.obj && typeof m.obj[`${m.k}.${u}`] < 'u' && (m.obj = void 0));
          m.obj[`${m.k}.${u}`] = s;
        },
        $b = (i, l, s, r) => {
          const { obj: c, k: u } = hl(i, l, Object);
          ((c[u] = c[u] || []), c[u].push(s));
        },
        Is = (i, l) => {
          const { obj: s, k: r } = hl(i, l);
          if (s && Object.prototype.hasOwnProperty.call(s, r)) return s[r];
        },
        qb = (i, l, s) => {
          const r = Is(i, s);
          return r !== void 0 ? r : Is(l, s);
        },
        Dm = (i, l, s) => {
          for (const r in l)
            r !== '__proto__' &&
              r !== 'constructor' &&
              (r in i
                ? ue(i[r]) ||
                  i[r] instanceof String ||
                  ue(l[r]) ||
                  l[r] instanceof String
                  ? s && (i[r] = l[r])
                  : Dm(i[r], l[r], s)
                : (i[r] = l[r]));
          return i;
        },
        on = i => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      var Pb = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
      };
      const Yb = i => (ue(i) ? i.replace(/[&<>"'\/]/g, l => Pb[l]) : i);
      class Kb {
        constructor(l) {
          ((this.capacity = l),
            (this.regExpMap = new Map()),
            (this.regExpQueue = []));
        }
        getRegExp(l) {
          const s = this.regExpMap.get(l);
          if (s !== void 0) return s;
          const r = new RegExp(l);
          return (
            this.regExpQueue.length === this.capacity &&
              this.regExpMap.delete(this.regExpQueue.shift()),
            this.regExpMap.set(l, r),
            this.regExpQueue.push(l),
            r
          );
        }
      }
      const Xb = [' ', ',', '?', '!', ';'],
        Qb = new Kb(20),
        Zb = (i, l, s) => {
          ((l = l || ''), (s = s || ''));
          const r = Xb.filter(h => l.indexOf(h) < 0 && s.indexOf(h) < 0);
          if (r.length === 0) return !0;
          const c = Qb.getRegExp(
            `(${r.map(h => (h === '?' ? '\\?' : h)).join('|')})`
          );
          let u = !c.test(i);
          if (!u) {
            const h = i.indexOf(s);
            h > 0 && !c.test(i.substring(0, h)) && (u = !0);
          }
          return u;
        },
        Mc = (i, l, s = '.') => {
          if (!i) return;
          if (i[l])
            return Object.prototype.hasOwnProperty.call(i, l) ? i[l] : void 0;
          const r = l.split(s);
          let c = i;
          for (let u = 0; u < r.length; ) {
            if (!c || typeof c != 'object') return;
            let h,
              m = '';
            for (let f = u; f < r.length; ++f)
              if (
                (f !== u && (m += s), (m += r[f]), (h = c[m]), h !== void 0)
              ) {
                if (
                  ['string', 'number', 'boolean'].indexOf(typeof h) > -1 &&
                  f < r.length - 1
                )
                  continue;
                u += f - u + 1;
                break;
              }
            c = h;
          }
          return c;
        },
        gl = i => i?.replace('_', '-'),
        Wb = {
          type: 'logger',
          log(i) {
            this.output('log', i);
          },
          warn(i) {
            this.output('warn', i);
          },
          error(i) {
            this.output('error', i);
          },
          output(i, l) {
            console?.[i]?.apply?.(console, l);
          },
        };
      class Gs {
        constructor(l, s = {}) {
          this.init(l, s);
        }
        init(l, s = {}) {
          ((this.prefix = s.prefix || 'i18next:'),
            (this.logger = l || Wb),
            (this.options = s),
            (this.debug = s.debug));
        }
        log(...l) {
          return this.forward(l, 'log', '', !0);
        }
        warn(...l) {
          return this.forward(l, 'warn', '', !0);
        }
        error(...l) {
          return this.forward(l, 'error', '');
        }
        deprecate(...l) {
          return this.forward(l, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(l, s, r, c) {
          return c && !this.debug
            ? null
            : (ue(l[0]) && (l[0] = `${r}${this.prefix} ${l[0]}`),
              this.logger[s](l));
        }
        create(l) {
          return new Gs(this.logger, {
            prefix: `${this.prefix}:${l}:`,
            ...this.options,
          });
        }
        clone(l) {
          return (
            (l = l || this.options),
            (l.prefix = l.prefix || this.prefix),
            new Gs(this.logger, l)
          );
        }
      }
      var ia = new Gs();
      class Ys {
        constructor() {
          this.observers = {};
        }
        on(l, s) {
          return (
            l.split(' ').forEach(r => {
              this.observers[r] || (this.observers[r] = new Map());
              const c = this.observers[r].get(s) || 0;
              this.observers[r].set(s, c + 1);
            }),
            this
          );
        }
        off(l, s) {
          if (this.observers[l]) {
            if (!s) {
              delete this.observers[l];
              return;
            }
            this.observers[l].delete(s);
          }
        }
        emit(l, ...s) {
          (this.observers[l] &&
            Array.from(this.observers[l].entries()).forEach(([c, u]) => {
              for (let h = 0; h < u; h++) c(...s);
            }),
            this.observers['*'] &&
              Array.from(this.observers['*'].entries()).forEach(([c, u]) => {
                for (let h = 0; h < u; h++) c.apply(c, [l, ...s]);
              }));
        }
      }
      class nm extends Ys {
        constructor(l, s = { ns: ['translation'], defaultNS: 'translation' }) {
          (super(),
            (this.data = l || {}),
            (this.options = s),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            this.options.ignoreJSONStructure === void 0 &&
              (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(l) {
          this.options.ns.indexOf(l) < 0 && this.options.ns.push(l);
        }
        removeNamespaces(l) {
          const s = this.options.ns.indexOf(l);
          s > -1 && this.options.ns.splice(s, 1);
        }
        getResource(l, s, r, c = {}) {
          const u =
              c.keySeparator !== void 0
                ? c.keySeparator
                : this.options.keySeparator,
            h =
              c.ignoreJSONStructure !== void 0
                ? c.ignoreJSONStructure
                : this.options.ignoreJSONStructure;
          let m;
          l.indexOf('.') > -1
            ? (m = l.split('.'))
            : ((m = [l, s]),
              r &&
                (Array.isArray(r)
                  ? m.push(...r)
                  : ue(r) && u
                    ? m.push(...r.split(u))
                    : m.push(r)));
          const f = Is(this.data, m);
          return (
            !f &&
              !s &&
              !r &&
              l.indexOf('.') > -1 &&
              ((l = m[0]), (s = m[1]), (r = m.slice(2).join('.'))),
            f || !h || !ue(r) ? f : Mc(this.data?.[l]?.[s], r, u)
          );
        }
        addResource(l, s, r, c, u = { silent: !1 }) {
          const h =
            u.keySeparator !== void 0
              ? u.keySeparator
              : this.options.keySeparator;
          let m = [l, s];
          (r && (m = m.concat(h ? r.split(h) : r)),
            l.indexOf('.') > -1 && ((m = l.split('.')), (c = s), (s = m[1])),
            this.addNamespaces(s),
            im(this.data, m, c),
            u.silent || this.emit('added', l, s, r, c));
        }
        addResources(l, s, r, c = { silent: !1 }) {
          for (const u in r)
            (ue(r[u]) || Array.isArray(r[u])) &&
              this.addResource(l, s, u, r[u], { silent: !0 });
          c.silent || this.emit('added', l, s, r);
        }
        addResourceBundle(l, s, r, c, u, h = { silent: !1, skipCopy: !1 }) {
          let m = [l, s];
          (l.indexOf('.') > -1 &&
            ((m = l.split('.')), (c = r), (r = s), (s = m[1])),
            this.addNamespaces(s));
          let f = Is(this.data, m) || {};
          (h.skipCopy || (r = JSON.parse(JSON.stringify(r))),
            c ? Dm(f, r, u) : (f = { ...f, ...r }),
            im(this.data, m, f),
            h.silent || this.emit('added', l, s, r));
        }
        removeResourceBundle(l, s) {
          (this.hasResourceBundle(l, s) && delete this.data[l][s],
            this.removeNamespaces(s),
            this.emit('removed', l, s));
        }
        hasResourceBundle(l, s) {
          return this.getResource(l, s) !== void 0;
        }
        getResourceBundle(l, s) {
          return (s || (s = this.options.defaultNS), this.getResource(l, s));
        }
        getDataByLanguage(l) {
          return this.data[l];
        }
        hasLanguageSomeTranslations(l) {
          const s = this.getDataByLanguage(l);
          return !!((s && Object.keys(s)) || []).find(
            c => s[c] && Object.keys(s[c]).length > 0
          );
        }
        toJSON() {
          return this.data;
        }
      }
      var Lm = {
        processors: {},
        addPostProcessor(i) {
          this.processors[i.name] = i;
        },
        handle(i, l, s, r, c) {
          return (
            i.forEach(u => {
              l = this.processors[u]?.process(l, s, r, c) ?? l;
            }),
            l
          );
        },
      };
      const zm = Symbol('i18next/PATH_KEY');
      function Fb() {
        const i = [],
          l = Object.create(null);
        let s;
        return (
          (l.get = (r, c) => (
            s?.revoke?.(),
            c === zm ? i : (i.push(c), (s = Proxy.revocable(r, l)), s.proxy)
          )),
          Proxy.revocable(Object.create(null), l).proxy
        );
      }
      function jc(i, l) {
        const { [zm]: s } = i(Fb());
        return s.join(l?.keySeparator ?? '.');
      }
      const lm = {},
        gc = i => !ue(i) && typeof i != 'boolean' && typeof i != 'number';
      class Vs extends Ys {
        constructor(l, s = {}) {
          (super(),
            Vb(
              [
                'resourceStore',
                'languageUtils',
                'pluralResolver',
                'interpolator',
                'backendConnector',
                'i18nFormat',
                'utils',
              ],
              l,
              this
            ),
            (this.options = s),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            (this.logger = ia.create('translator')));
        }
        changeLanguage(l) {
          l && (this.language = l);
        }
        exists(l, s = { interpolation: {} }) {
          const r = { ...s };
          if (l == null) return !1;
          const c = this.resolve(l, r);
          if (c?.res === void 0) return !1;
          const u = gc(c.res);
          return !(r.returnObjects === !1 && u);
        }
        extractFromKey(l, s) {
          let r =
            s.nsSeparator !== void 0 ? s.nsSeparator : this.options.nsSeparator;
          r === void 0 && (r = ':');
          const c =
            s.keySeparator !== void 0
              ? s.keySeparator
              : this.options.keySeparator;
          let u = s.ns || this.options.defaultNS || [];
          const h = r && l.indexOf(r) > -1,
            m =
              !this.options.userDefinedKeySeparator &&
              !s.keySeparator &&
              !this.options.userDefinedNsSeparator &&
              !s.nsSeparator &&
              !Zb(l, r, c);
          if (h && !m) {
            const f = l.match(this.interpolator.nestingRegexp);
            if (f && f.length > 0)
              return { key: l, namespaces: ue(u) ? [u] : u };
            const p = l.split(r);
            ((r !== c || (r === c && this.options.ns.indexOf(p[0]) > -1)) &&
              (u = p.shift()),
              (l = p.join(c)));
          }
          return { key: l, namespaces: ue(u) ? [u] : u };
        }
        translate(l, s, r) {
          let c = typeof s == 'object' ? { ...s } : s;
          if (
            (typeof c != 'object' &&
              this.options.overloadTranslationOptionHandler &&
              (c = this.options.overloadTranslationOptionHandler(arguments)),
            typeof c == 'object' && (c = { ...c }),
            c || (c = {}),
            l == null)
          )
            return '';
          (typeof l == 'function' && (l = jc(l, { ...this.options, ...c })),
            Array.isArray(l) || (l = [String(l)]));
          const u =
              c.returnDetails !== void 0
                ? c.returnDetails
                : this.options.returnDetails,
            h =
              c.keySeparator !== void 0
                ? c.keySeparator
                : this.options.keySeparator,
            { key: m, namespaces: f } = this.extractFromKey(l[l.length - 1], c),
            p = f[f.length - 1];
          let y =
            c.nsSeparator !== void 0 ? c.nsSeparator : this.options.nsSeparator;
          y === void 0 && (y = ':');
          const S = c.lng || this.language,
            w =
              c.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (S?.toLowerCase() === 'cimode')
            return w
              ? u
                ? {
                    res: `${p}${y}${m}`,
                    usedKey: m,
                    exactUsedKey: m,
                    usedLng: S,
                    usedNS: p,
                    usedParams: this.getUsedParamsDetails(c),
                  }
                : `${p}${y}${m}`
              : u
                ? {
                    res: m,
                    usedKey: m,
                    exactUsedKey: m,
                    usedLng: S,
                    usedNS: p,
                    usedParams: this.getUsedParamsDetails(c),
                  }
                : m;
          const x = this.resolve(l, c);
          let T = x?.res;
          const A = x?.usedKey || m,
            j = x?.exactUsedKey || m,
            G = ['[object Number]', '[object Function]', '[object RegExp]'],
            L =
              c.joinArrays !== void 0 ? c.joinArrays : this.options.joinArrays,
            H = !this.i18nFormat || this.i18nFormat.handleAsObject,
            $ = c.count !== void 0 && !ue(c.count),
            D = Vs.hasDefaultValue(c),
            U = $ ? this.pluralResolver.getSuffix(S, c.count, c) : '',
            X =
              c.ordinal && $
                ? this.pluralResolver.getSuffix(S, c.count, { ordinal: !1 })
                : '',
            q = $ && !c.ordinal && c.count === 0,
            se =
              (q && c[`defaultValue${this.options.pluralSeparator}zero`]) ||
              c[`defaultValue${U}`] ||
              c[`defaultValue${X}`] ||
              c.defaultValue;
          let F = T;
          H && !T && D && (F = se);
          const W = gc(F),
            ae = Object.prototype.toString.apply(F);
          if (
            H &&
            F &&
            W &&
            G.indexOf(ae) < 0 &&
            !(ue(L) && Array.isArray(F))
          ) {
            if (!c.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler ||
                this.logger.warn(
                  'accessing an object - but returnObjects options is not enabled!'
                );
              const ye = this.options.returnedObjectHandler
                ? this.options.returnedObjectHandler(A, F, { ...c, ns: f })
                : `key '${m} (${this.language})' returned an object instead of string.`;
              return u
                ? ((x.res = ye),
                  (x.usedParams = this.getUsedParamsDetails(c)),
                  x)
                : ye;
            }
            if (h) {
              const ye = Array.isArray(F),
                Se = ye ? [] : {},
                Ne = ye ? j : A;
              for (const z in F)
                if (Object.prototype.hasOwnProperty.call(F, z)) {
                  const Q = `${Ne}${h}${z}`;
                  (D && !T
                    ? (Se[z] = this.translate(Q, {
                        ...c,
                        defaultValue: gc(se) ? se[z] : void 0,
                        joinArrays: !1,
                        ns: f,
                      }))
                    : (Se[z] = this.translate(Q, {
                        ...c,
                        joinArrays: !1,
                        ns: f,
                      })),
                    Se[z] === Q && (Se[z] = F[z]));
                }
              T = Se;
            }
          } else if (H && ue(L) && Array.isArray(T))
            ((T = T.join(L)), T && (T = this.extendTranslation(T, l, c, r)));
          else {
            let ye = !1,
              Se = !1;
            (!this.isValidLookup(T) && D && ((ye = !0), (T = se)),
              this.isValidLookup(T) || ((Se = !0), (T = m)));
            const z =
                (c.missingKeyNoValueFallbackToKey ||
                  this.options.missingKeyNoValueFallbackToKey) &&
                Se
                  ? void 0
                  : T,
              Q = D && se !== T && this.options.updateMissing;
            if (Se || ye || Q) {
              if (
                (this.logger.log(
                  Q ? 'updateKey' : 'missingKey',
                  S,
                  p,
                  m,
                  Q ? se : T
                ),
                h)
              ) {
                const I = this.resolve(m, { ...c, keySeparator: !1 });
                I &&
                  I.res &&
                  this.logger.warn(
                    'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                  );
              }
              let K = [];
              const ie = this.languageUtils.getFallbackCodes(
                this.options.fallbackLng,
                c.lng || this.language
              );
              if (this.options.saveMissingTo === 'fallback' && ie && ie[0])
                for (let I = 0; I < ie.length; I++) K.push(ie[I]);
              else
                this.options.saveMissingTo === 'all'
                  ? (K = this.languageUtils.toResolveHierarchy(
                      c.lng || this.language
                    ))
                  : K.push(c.lng || this.language);
              const N = (I, ee, J) => {
                const le = D && J !== T ? J : z;
                (this.options.missingKeyHandler
                  ? this.options.missingKeyHandler(I, p, ee, le, Q, c)
                  : this.backendConnector?.saveMissing &&
                    this.backendConnector.saveMissing(I, p, ee, le, Q, c),
                  this.emit('missingKey', I, p, ee, T));
              };
              this.options.saveMissing &&
                (this.options.saveMissingPlurals && $
                  ? K.forEach(I => {
                      const ee = this.pluralResolver.getSuffixes(I, c);
                      (q &&
                        c[`defaultValue${this.options.pluralSeparator}zero`] &&
                        ee.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                        ee.push(`${this.options.pluralSeparator}zero`),
                        ee.forEach(J => {
                          N([I], m + J, c[`defaultValue${J}`] || se);
                        }));
                    })
                  : N(K, m, se));
            }
            ((T = this.extendTranslation(T, l, c, x, r)),
              Se &&
                T === m &&
                this.options.appendNamespaceToMissingKey &&
                (T = `${p}${y}${m}`),
              (Se || ye) &&
                this.options.parseMissingKeyHandler &&
                (T = this.options.parseMissingKeyHandler(
                  this.options.appendNamespaceToMissingKey ? `${p}${y}${m}` : m,
                  ye ? T : void 0,
                  c
                )));
          }
          return u
            ? ((x.res = T), (x.usedParams = this.getUsedParamsDetails(c)), x)
            : T;
        }
        extendTranslation(l, s, r, c, u) {
          if (this.i18nFormat?.parse)
            l = this.i18nFormat.parse(
              l,
              { ...this.options.interpolation.defaultVariables, ...r },
              r.lng || this.language || c.usedLng,
              c.usedNS,
              c.usedKey,
              { resolved: c }
            );
          else if (!r.skipInterpolation) {
            r.interpolation &&
              this.interpolator.init({
                ...r,
                interpolation: {
                  ...this.options.interpolation,
                  ...r.interpolation,
                },
              });
            const f =
              ue(l) &&
              (r?.interpolation?.skipOnVariables !== void 0
                ? r.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables);
            let p;
            if (f) {
              const S = l.match(this.interpolator.nestingRegexp);
              p = S && S.length;
            }
            let y = r.replace && !ue(r.replace) ? r.replace : r;
            if (
              (this.options.interpolation.defaultVariables &&
                (y = { ...this.options.interpolation.defaultVariables, ...y }),
              (l = this.interpolator.interpolate(
                l,
                y,
                r.lng || this.language || c.usedLng,
                r
              )),
              f)
            ) {
              const S = l.match(this.interpolator.nestingRegexp),
                w = S && S.length;
              p < w && (r.nest = !1);
            }
            (!r.lng && c && c.res && (r.lng = this.language || c.usedLng),
              r.nest !== !1 &&
                (l = this.interpolator.nest(
                  l,
                  (...S) =>
                    u?.[0] === S[0] && !r.context
                      ? (this.logger.warn(
                          `It seems you are nesting recursively key: ${S[0]} in key: ${s[0]}`
                        ),
                        null)
                      : this.translate(...S, s),
                  r
                )),
              r.interpolation && this.interpolator.reset());
          }
          const h = r.postProcess || this.options.postProcess,
            m = ue(h) ? [h] : h;
          return (
            l != null &&
              m?.length &&
              r.applyPostProcessor !== !1 &&
              (l = Lm.handle(
                m,
                l,
                s,
                this.options && this.options.postProcessPassResolved
                  ? {
                      i18nResolved: {
                        ...c,
                        usedParams: this.getUsedParamsDetails(r),
                      },
                      ...r,
                    }
                  : r,
                this
              )),
            l
          );
        }
        resolve(l, s = {}) {
          let r, c, u, h, m;
          return (
            ue(l) && (l = [l]),
            l.forEach(f => {
              if (this.isValidLookup(r)) return;
              const p = this.extractFromKey(f, s),
                y = p.key;
              c = y;
              let S = p.namespaces;
              this.options.fallbackNS &&
                (S = S.concat(this.options.fallbackNS));
              const w = s.count !== void 0 && !ue(s.count),
                x = w && !s.ordinal && s.count === 0,
                T =
                  s.context !== void 0 &&
                  (ue(s.context) || typeof s.context == 'number') &&
                  s.context !== '',
                A = s.lngs
                  ? s.lngs
                  : this.languageUtils.toResolveHierarchy(
                      s.lng || this.language,
                      s.fallbackLng
                    );
              S.forEach(j => {
                this.isValidLookup(r) ||
                  ((m = j),
                  !lm[`${A[0]}-${j}`] &&
                    this.utils?.hasLoadedNamespace &&
                    !this.utils?.hasLoadedNamespace(m) &&
                    ((lm[`${A[0]}-${j}`] = !0),
                    this.logger.warn(
                      `key "${c}" for languages "${A.join(', ')}" won't get resolved as namespace "${m}" was not yet loaded`,
                      'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                    )),
                  A.forEach(G => {
                    if (this.isValidLookup(r)) return;
                    h = G;
                    const L = [y];
                    if (this.i18nFormat?.addLookupKeys)
                      this.i18nFormat.addLookupKeys(L, y, G, j, s);
                    else {
                      let $;
                      w && ($ = this.pluralResolver.getSuffix(G, s.count, s));
                      const D = `${this.options.pluralSeparator}zero`,
                        U = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                      if (
                        (w &&
                          (s.ordinal &&
                            $.indexOf(U) === 0 &&
                            L.push(
                              y + $.replace(U, this.options.pluralSeparator)
                            ),
                          L.push(y + $),
                          x && L.push(y + D)),
                        T)
                      ) {
                        const X = `${y}${this.options.contextSeparator || '_'}${s.context}`;
                        (L.push(X),
                          w &&
                            (s.ordinal &&
                              $.indexOf(U) === 0 &&
                              L.push(
                                X + $.replace(U, this.options.pluralSeparator)
                              ),
                            L.push(X + $),
                            x && L.push(X + D)));
                      }
                    }
                    let H;
                    for (; (H = L.pop()); )
                      this.isValidLookup(r) ||
                        ((u = H), (r = this.getResource(G, j, H, s)));
                  }));
              });
            }),
            { res: r, usedKey: c, exactUsedKey: u, usedLng: h, usedNS: m }
          );
        }
        isValidLookup(l) {
          return (
            l !== void 0 &&
            !(!this.options.returnNull && l === null) &&
            !(!this.options.returnEmptyString && l === '')
          );
        }
        getResource(l, s, r, c = {}) {
          return this.i18nFormat?.getResource
            ? this.i18nFormat.getResource(l, s, r, c)
            : this.resourceStore.getResource(l, s, r, c);
        }
        getUsedParamsDetails(l = {}) {
          const s = [
              'defaultValue',
              'ordinal',
              'context',
              'replace',
              'lng',
              'lngs',
              'fallbackLng',
              'ns',
              'keySeparator',
              'nsSeparator',
              'returnObjects',
              'returnDetails',
              'joinArrays',
              'postProcess',
              'interpolation',
            ],
            r = l.replace && !ue(l.replace);
          let c = r ? l.replace : l;
          if (
            (r && typeof l.count < 'u' && (c.count = l.count),
            this.options.interpolation.defaultVariables &&
              (c = { ...this.options.interpolation.defaultVariables, ...c }),
            !r)
          ) {
            c = { ...c };
            for (const u of s) delete c[u];
          }
          return c;
        }
        static hasDefaultValue(l) {
          const s = 'defaultValue';
          for (const r in l)
            if (
              Object.prototype.hasOwnProperty.call(l, r) &&
              s === r.substring(0, s.length) &&
              l[r] !== void 0
            )
              return !0;
          return !1;
        }
      }
      class sm {
        constructor(l) {
          ((this.options = l),
            (this.supportedLngs = this.options.supportedLngs || !1),
            (this.logger = ia.create('languageUtils')));
        }
        getScriptPartFromCode(l) {
          if (((l = gl(l)), !l || l.indexOf('-') < 0)) return null;
          const s = l.split('-');
          return s.length === 2 ||
            (s.pop(), s[s.length - 1].toLowerCase() === 'x')
            ? null
            : this.formatLanguageCode(s.join('-'));
        }
        getLanguagePartFromCode(l) {
          if (((l = gl(l)), !l || l.indexOf('-') < 0)) return l;
          const s = l.split('-');
          return this.formatLanguageCode(s[0]);
        }
        formatLanguageCode(l) {
          if (ue(l) && l.indexOf('-') > -1) {
            let s;
            try {
              s = Intl.getCanonicalLocales(l)[0];
            } catch {}
            return (
              s && this.options.lowerCaseLng && (s = s.toLowerCase()),
              s || (this.options.lowerCaseLng ? l.toLowerCase() : l)
            );
          }
          return this.options.cleanCode || this.options.lowerCaseLng
            ? l.toLowerCase()
            : l;
        }
        isSupportedCode(l) {
          return (
            (this.options.load === 'languageOnly' ||
              this.options.nonExplicitSupportedLngs) &&
              (l = this.getLanguagePartFromCode(l)),
            !this.supportedLngs ||
              !this.supportedLngs.length ||
              this.supportedLngs.indexOf(l) > -1
          );
        }
        getBestMatchFromCodes(l) {
          if (!l) return null;
          let s;
          return (
            l.forEach(r => {
              if (s) return;
              const c = this.formatLanguageCode(r);
              (!this.options.supportedLngs || this.isSupportedCode(c)) &&
                (s = c);
            }),
            !s &&
              this.options.supportedLngs &&
              l.forEach(r => {
                if (s) return;
                const c = this.getScriptPartFromCode(r);
                if (this.isSupportedCode(c)) return (s = c);
                const u = this.getLanguagePartFromCode(r);
                if (this.isSupportedCode(u)) return (s = u);
                s = this.options.supportedLngs.find(h => {
                  if (h === u) return h;
                  if (
                    !(h.indexOf('-') < 0 && u.indexOf('-') < 0) &&
                    ((h.indexOf('-') > 0 &&
                      u.indexOf('-') < 0 &&
                      h.substring(0, h.indexOf('-')) === u) ||
                      (h.indexOf(u) === 0 && u.length > 1))
                  )
                    return h;
                });
              }),
            s || (s = this.getFallbackCodes(this.options.fallbackLng)[0]),
            s
          );
        }
        getFallbackCodes(l, s) {
          if (!l) return [];
          if (
            (typeof l == 'function' && (l = l(s)),
            ue(l) && (l = [l]),
            Array.isArray(l))
          )
            return l;
          if (!s) return l.default || [];
          let r = l[s];
          return (
            r || (r = l[this.getScriptPartFromCode(s)]),
            r || (r = l[this.formatLanguageCode(s)]),
            r || (r = l[this.getLanguagePartFromCode(s)]),
            r || (r = l.default),
            r || []
          );
        }
        toResolveHierarchy(l, s) {
          const r = this.getFallbackCodes(
              (s === !1 ? [] : s) || this.options.fallbackLng || [],
              l
            ),
            c = [],
            u = h => {
              h &&
                (this.isSupportedCode(h)
                  ? c.push(h)
                  : this.logger.warn(
                      `rejecting language code not found in supportedLngs: ${h}`
                    ));
            };
          return (
            ue(l) && (l.indexOf('-') > -1 || l.indexOf('_') > -1)
              ? (this.options.load !== 'languageOnly' &&
                  u(this.formatLanguageCode(l)),
                this.options.load !== 'languageOnly' &&
                  this.options.load !== 'currentOnly' &&
                  u(this.getScriptPartFromCode(l)),
                this.options.load !== 'currentOnly' &&
                  u(this.getLanguagePartFromCode(l)))
              : ue(l) && u(this.formatLanguageCode(l)),
            r.forEach(h => {
              c.indexOf(h) < 0 && u(this.formatLanguageCode(h));
            }),
            c
          );
        }
      }
      const rm = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        om = {
          select: i => (i === 1 ? 'one' : 'other'),
          resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
      class Jb {
        constructor(l, s = {}) {
          ((this.languageUtils = l),
            (this.options = s),
            (this.logger = ia.create('pluralResolver')),
            (this.pluralRulesCache = {}));
        }
        addRule(l, s) {
          this.rules[l] = s;
        }
        clearCache() {
          this.pluralRulesCache = {};
        }
        getRule(l, s = {}) {
          const r = gl(l === 'dev' ? 'en' : l),
            c = s.ordinal ? 'ordinal' : 'cardinal',
            u = JSON.stringify({ cleanedCode: r, type: c });
          if (u in this.pluralRulesCache) return this.pluralRulesCache[u];
          let h;
          try {
            h = new Intl.PluralRules(r, { type: c });
          } catch {
            if (!Intl)
              return (
                this.logger.error(
                  'No Intl support, please use an Intl polyfill!'
                ),
                om
              );
            if (!l.match(/-|_/)) return om;
            const f = this.languageUtils.getLanguagePartFromCode(l);
            h = this.getRule(f, s);
          }
          return ((this.pluralRulesCache[u] = h), h);
        }
        needsPlural(l, s = {}) {
          let r = this.getRule(l, s);
          return (
            r || (r = this.getRule('dev', s)),
            r?.resolvedOptions().pluralCategories.length > 1
          );
        }
        getPluralFormsOfKey(l, s, r = {}) {
          return this.getSuffixes(l, r).map(c => `${s}${c}`);
        }
        getSuffixes(l, s = {}) {
          let r = this.getRule(l, s);
          return (
            r || (r = this.getRule('dev', s)),
            r
              ? r
                  .resolvedOptions()
                  .pluralCategories.sort((c, u) => rm[c] - rm[u])
                  .map(
                    c =>
                      `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ''}${c}`
                  )
              : []
          );
        }
        getSuffix(l, s, r = {}) {
          const c = this.getRule(l, r);
          return c
            ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ''}${c.select(s)}`
            : (this.logger.warn(`no plural rule found for: ${l}`),
              this.getSuffix('dev', s, r));
        }
      }
      const cm = (i, l, s, r = '.', c = !0) => {
          let u = qb(i, l, s);
          return (
            !u &&
              c &&
              ue(s) &&
              ((u = Mc(i, s, r)), u === void 0 && (u = Mc(l, s, r))),
            u
          );
        },
        bc = i => i.replace(/\$/g, '$$$$');
      class ev {
        constructor(l = {}) {
          ((this.logger = ia.create('interpolator')),
            (this.options = l),
            (this.format = l?.interpolation?.format || (s => s)),
            this.init(l));
        }
        init(l = {}) {
          l.interpolation || (l.interpolation = { escapeValue: !0 });
          const {
            escape: s,
            escapeValue: r,
            useRawValueToEscape: c,
            prefix: u,
            prefixEscaped: h,
            suffix: m,
            suffixEscaped: f,
            formatSeparator: p,
            unescapeSuffix: y,
            unescapePrefix: S,
            nestingPrefix: w,
            nestingPrefixEscaped: x,
            nestingSuffix: T,
            nestingSuffixEscaped: A,
            nestingOptionsSeparator: j,
            maxReplaces: G,
            alwaysFormat: L,
          } = l.interpolation;
          ((this.escape = s !== void 0 ? s : Yb),
            (this.escapeValue = r !== void 0 ? r : !0),
            (this.useRawValueToEscape = c !== void 0 ? c : !1),
            (this.prefix = u ? on(u) : h || '{{'),
            (this.suffix = m ? on(m) : f || '}}'),
            (this.formatSeparator = p || ','),
            (this.unescapePrefix = y ? '' : S || '-'),
            (this.unescapeSuffix = this.unescapePrefix ? '' : y || ''),
            (this.nestingPrefix = w ? on(w) : x || on('$t(')),
            (this.nestingSuffix = T ? on(T) : A || on(')')),
            (this.nestingOptionsSeparator = j || ','),
            (this.maxReplaces = G || 1e3),
            (this.alwaysFormat = L !== void 0 ? L : !1),
            this.resetRegExp());
        }
        reset() {
          this.options && this.init(this.options);
        }
        resetRegExp() {
          const l = (s, r) =>
            s?.source === r ? ((s.lastIndex = 0), s) : new RegExp(r, 'g');
          ((this.regexp = l(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
            (this.regexpUnescape = l(
              this.regexpUnescape,
              `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
            )),
            (this.nestingRegexp = l(
              this.nestingRegexp,
              `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
            )));
        }
        interpolate(l, s, r, c) {
          let u, h, m;
          const f =
              (this.options &&
                this.options.interpolation &&
                this.options.interpolation.defaultVariables) ||
              {},
            p = x => {
              if (x.indexOf(this.formatSeparator) < 0) {
                const G = cm(
                  s,
                  f,
                  x,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                );
                return this.alwaysFormat
                  ? this.format(G, void 0, r, {
                      ...c,
                      ...s,
                      interpolationkey: x,
                    })
                  : G;
              }
              const T = x.split(this.formatSeparator),
                A = T.shift().trim(),
                j = T.join(this.formatSeparator).trim();
              return this.format(
                cm(
                  s,
                  f,
                  A,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                ),
                j,
                r,
                { ...c, ...s, interpolationkey: A }
              );
            };
          this.resetRegExp();
          const y =
              c?.missingInterpolationHandler ||
              this.options.missingInterpolationHandler,
            S =
              c?.interpolation?.skipOnVariables !== void 0
                ? c.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables;
          return (
            [
              { regex: this.regexpUnescape, safeValue: x => bc(x) },
              {
                regex: this.regexp,
                safeValue: x => (this.escapeValue ? bc(this.escape(x)) : bc(x)),
              },
            ].forEach(x => {
              for (m = 0; (u = x.regex.exec(l)); ) {
                const T = u[1].trim();
                if (((h = p(T)), h === void 0))
                  if (typeof y == 'function') {
                    const j = y(l, u, c);
                    h = ue(j) ? j : '';
                  } else if (c && Object.prototype.hasOwnProperty.call(c, T))
                    h = '';
                  else if (S) {
                    h = u[0];
                    continue;
                  } else
                    (this.logger.warn(
                      `missed to pass in variable ${T} for interpolating ${l}`
                    ),
                      (h = ''));
                else !ue(h) && !this.useRawValueToEscape && (h = em(h));
                const A = x.safeValue(h);
                if (
                  ((l = l.replace(u[0], A)),
                  S
                    ? ((x.regex.lastIndex += h.length),
                      (x.regex.lastIndex -= u[0].length))
                    : (x.regex.lastIndex = 0),
                  m++,
                  m >= this.maxReplaces)
                )
                  break;
              }
            }),
            l
          );
        }
        nest(l, s, r = {}) {
          let c, u, h;
          const m = (f, p) => {
            const y = this.nestingOptionsSeparator;
            if (f.indexOf(y) < 0) return f;
            const S = f.split(new RegExp(`${y}[ ]*{`));
            let w = `{${S[1]}`;
            ((f = S[0]), (w = this.interpolate(w, h)));
            const x = w.match(/'/g),
              T = w.match(/"/g);
            (((x?.length ?? 0) % 2 === 0 && !T) || T.length % 2 !== 0) &&
              (w = w.replace(/'/g, '"'));
            try {
              ((h = JSON.parse(w)), p && (h = { ...p, ...h }));
            } catch (A) {
              return (
                this.logger.warn(
                  `failed parsing options string in nesting for key ${f}`,
                  A
                ),
                `${f}${y}${w}`
              );
            }
            return (
              h.defaultValue &&
                h.defaultValue.indexOf(this.prefix) > -1 &&
                delete h.defaultValue,
              f
            );
          };
          for (; (c = this.nestingRegexp.exec(l)); ) {
            let f = [];
            ((h = { ...r }),
              (h = h.replace && !ue(h.replace) ? h.replace : h),
              (h.applyPostProcessor = !1),
              delete h.defaultValue);
            const p = /{.*}/.test(c[1])
              ? c[1].lastIndexOf('}') + 1
              : c[1].indexOf(this.formatSeparator);
            if (
              (p !== -1 &&
                ((f = c[1]
                  .slice(p)
                  .split(this.formatSeparator)
                  .map(y => y.trim())
                  .filter(Boolean)),
                (c[1] = c[1].slice(0, p))),
              (u = s(m.call(this, c[1].trim(), h), h)),
              u && c[0] === l && !ue(u))
            )
              return u;
            (ue(u) || (u = em(u)),
              u ||
                (this.logger.warn(`missed to resolve ${c[1]} for nesting ${l}`),
                (u = '')),
              f.length &&
                (u = f.reduce(
                  (y, S) =>
                    this.format(y, S, r.lng, {
                      ...r,
                      interpolationkey: c[1].trim(),
                    }),
                  u.trim()
                )),
              (l = l.replace(c[0], u)),
              (this.regexp.lastIndex = 0));
          }
          return l;
        }
      }
      const tv = i => {
          let l = i.toLowerCase().trim();
          const s = {};
          if (i.indexOf('(') > -1) {
            const r = i.split('(');
            l = r[0].toLowerCase().trim();
            const c = r[1].substring(0, r[1].length - 1);
            l === 'currency' && c.indexOf(':') < 0
              ? s.currency || (s.currency = c.trim())
              : l === 'relativetime' && c.indexOf(':') < 0
                ? s.range || (s.range = c.trim())
                : c.split(';').forEach(h => {
                    if (h) {
                      const [m, ...f] = h.split(':'),
                        p = f
                          .join(':')
                          .trim()
                          .replace(/^'+|'+$/g, ''),
                        y = m.trim();
                      (s[y] || (s[y] = p),
                        p === 'false' && (s[y] = !1),
                        p === 'true' && (s[y] = !0),
                        isNaN(p) || (s[y] = parseInt(p, 10)));
                    }
                  });
          }
          return { formatName: l, formatOptions: s };
        },
        um = i => {
          const l = {};
          return (s, r, c) => {
            let u = c;
            c &&
              c.interpolationkey &&
              c.formatParams &&
              c.formatParams[c.interpolationkey] &&
              c[c.interpolationkey] &&
              (u = { ...u, [c.interpolationkey]: void 0 });
            const h = r + JSON.stringify(u);
            let m = l[h];
            return (m || ((m = i(gl(r), c)), (l[h] = m)), m(s));
          };
        },
        av = i => (l, s, r) => i(gl(s), r)(l);
      class iv {
        constructor(l = {}) {
          ((this.logger = ia.create('formatter')),
            (this.options = l),
            this.init(l));
        }
        init(l, s = { interpolation: {} }) {
          this.formatSeparator = s.interpolation.formatSeparator || ',';
          const r = s.cacheInBuiltFormats ? um : av;
          this.formats = {
            number: r((c, u) => {
              const h = new Intl.NumberFormat(c, { ...u });
              return m => h.format(m);
            }),
            currency: r((c, u) => {
              const h = new Intl.NumberFormat(c, { ...u, style: 'currency' });
              return m => h.format(m);
            }),
            datetime: r((c, u) => {
              const h = new Intl.DateTimeFormat(c, { ...u });
              return m => h.format(m);
            }),
            relativetime: r((c, u) => {
              const h = new Intl.RelativeTimeFormat(c, { ...u });
              return m => h.format(m, u.range || 'day');
            }),
            list: r((c, u) => {
              const h = new Intl.ListFormat(c, { ...u });
              return m => h.format(m);
            }),
          };
        }
        add(l, s) {
          this.formats[l.toLowerCase().trim()] = s;
        }
        addCached(l, s) {
          this.formats[l.toLowerCase().trim()] = um(s);
        }
        format(l, s, r, c = {}) {
          const u = s.split(this.formatSeparator);
          if (
            u.length > 1 &&
            u[0].indexOf('(') > 1 &&
            u[0].indexOf(')') < 0 &&
            u.find(m => m.indexOf(')') > -1)
          ) {
            const m = u.findIndex(f => f.indexOf(')') > -1);
            u[0] = [u[0], ...u.splice(1, m)].join(this.formatSeparator);
          }
          return u.reduce((m, f) => {
            const { formatName: p, formatOptions: y } = tv(f);
            if (this.formats[p]) {
              let S = m;
              try {
                const w = c?.formatParams?.[c.interpolationkey] || {},
                  x = w.locale || w.lng || c.locale || c.lng || r;
                S = this.formats[p](m, x, { ...y, ...c, ...w });
              } catch (w) {
                this.logger.warn(w);
              }
              return S;
            } else this.logger.warn(`there was no format function for ${p}`);
            return m;
          }, l);
        }
      }
      const nv = (i, l) => {
        i.pending[l] !== void 0 && (delete i.pending[l], i.pendingCount--);
      };
      class lv extends Ys {
        constructor(l, s, r, c = {}) {
          (super(),
            (this.backend = l),
            (this.store = s),
            (this.services = r),
            (this.languageUtils = r.languageUtils),
            (this.options = c),
            (this.logger = ia.create('backendConnector')),
            (this.waitingReads = []),
            (this.maxParallelReads = c.maxParallelReads || 10),
            (this.readingCalls = 0),
            (this.maxRetries = c.maxRetries >= 0 ? c.maxRetries : 5),
            (this.retryTimeout = c.retryTimeout >= 1 ? c.retryTimeout : 350),
            (this.state = {}),
            (this.queue = []),
            this.backend?.init?.(r, c.backend, c));
        }
        queueLoad(l, s, r, c) {
          const u = {},
            h = {},
            m = {},
            f = {};
          return (
            l.forEach(p => {
              let y = !0;
              (s.forEach(S => {
                const w = `${p}|${S}`;
                !r.reload && this.store.hasResourceBundle(p, S)
                  ? (this.state[w] = 2)
                  : this.state[w] < 0 ||
                    (this.state[w] === 1
                      ? h[w] === void 0 && (h[w] = !0)
                      : ((this.state[w] = 1),
                        (y = !1),
                        h[w] === void 0 && (h[w] = !0),
                        u[w] === void 0 && (u[w] = !0),
                        f[S] === void 0 && (f[S] = !0)));
              }),
                y || (m[p] = !0));
            }),
            (Object.keys(u).length || Object.keys(h).length) &&
              this.queue.push({
                pending: h,
                pendingCount: Object.keys(h).length,
                loaded: {},
                errors: [],
                callback: c,
              }),
            {
              toLoad: Object.keys(u),
              pending: Object.keys(h),
              toLoadLanguages: Object.keys(m),
              toLoadNamespaces: Object.keys(f),
            }
          );
        }
        loaded(l, s, r) {
          const c = l.split('|'),
            u = c[0],
            h = c[1];
          (s && this.emit('failedLoading', u, h, s),
            !s &&
              r &&
              this.store.addResourceBundle(u, h, r, void 0, void 0, {
                skipCopy: !0,
              }),
            (this.state[l] = s ? -1 : 2),
            s && r && (this.state[l] = 0));
          const m = {};
          (this.queue.forEach(f => {
            ($b(f.loaded, [u], h),
              nv(f, l),
              s && f.errors.push(s),
              f.pendingCount === 0 &&
                !f.done &&
                (Object.keys(f.loaded).forEach(p => {
                  m[p] || (m[p] = {});
                  const y = f.loaded[p];
                  y.length &&
                    y.forEach(S => {
                      m[p][S] === void 0 && (m[p][S] = !0);
                    });
                }),
                (f.done = !0),
                f.errors.length ? f.callback(f.errors) : f.callback()));
          }),
            this.emit('loaded', m),
            (this.queue = this.queue.filter(f => !f.done)));
        }
        read(l, s, r, c = 0, u = this.retryTimeout, h) {
          if (!l.length) return h(null, {});
          if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
              lng: l,
              ns: s,
              fcName: r,
              tried: c,
              wait: u,
              callback: h,
            });
            return;
          }
          this.readingCalls++;
          const m = (p, y) => {
              if ((this.readingCalls--, this.waitingReads.length > 0)) {
                const S = this.waitingReads.shift();
                this.read(S.lng, S.ns, S.fcName, S.tried, S.wait, S.callback);
              }
              if (p && y && c < this.maxRetries) {
                setTimeout(() => {
                  this.read.call(this, l, s, r, c + 1, u * 2, h);
                }, u);
                return;
              }
              h(p, y);
            },
            f = this.backend[r].bind(this.backend);
          if (f.length === 2) {
            try {
              const p = f(l, s);
              p && typeof p.then == 'function'
                ? p.then(y => m(null, y)).catch(m)
                : m(null, p);
            } catch (p) {
              m(p);
            }
            return;
          }
          return f(l, s, m);
        }
        prepareLoading(l, s, r = {}, c) {
          if (!this.backend)
            return (
              this.logger.warn(
                'No backend was added via i18next.use. Will not load resources.'
              ),
              c && c()
            );
          (ue(l) && (l = this.languageUtils.toResolveHierarchy(l)),
            ue(s) && (s = [s]));
          const u = this.queueLoad(l, s, r, c);
          if (!u.toLoad.length) return (u.pending.length || c(), null);
          u.toLoad.forEach(h => {
            this.loadOne(h);
          });
        }
        load(l, s, r) {
          this.prepareLoading(l, s, {}, r);
        }
        reload(l, s, r) {
          this.prepareLoading(l, s, { reload: !0 }, r);
        }
        loadOne(l, s = '') {
          const r = l.split('|'),
            c = r[0],
            u = r[1];
          this.read(c, u, 'read', void 0, void 0, (h, m) => {
            (h &&
              this.logger.warn(
                `${s}loading namespace ${u} for language ${c} failed`,
                h
              ),
              !h &&
                m &&
                this.logger.log(
                  `${s}loaded namespace ${u} for language ${c}`,
                  m
                ),
              this.loaded(l, h, m));
          });
        }
        saveMissing(l, s, r, c, u, h = {}, m = () => {}) {
          if (
            this.services?.utils?.hasLoadedNamespace &&
            !this.services?.utils?.hasLoadedNamespace(s)
          ) {
            this.logger.warn(
              `did not save key "${r}" as the namespace "${s}" was not yet loaded`,
              'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
            );
            return;
          }
          if (!(r == null || r === '')) {
            if (this.backend?.create) {
              const f = { ...h, isUpdate: u },
                p = this.backend.create.bind(this.backend);
              if (p.length < 6)
                try {
                  let y;
                  (p.length === 5
                    ? (y = p(l, s, r, c, f))
                    : (y = p(l, s, r, c)),
                    y && typeof y.then == 'function'
                      ? y.then(S => m(null, S)).catch(m)
                      : m(null, y));
                } catch (y) {
                  m(y);
                }
              else p(l, s, r, c, m, f);
            }
            !l || !l[0] || this.store.addResource(l[0], s, r, c);
          }
        }
      }
      const dm = () => ({
          debug: !1,
          initAsync: !0,
          ns: ['translation'],
          defaultNS: ['translation'],
          fallbackLng: ['dev'],
          fallbackNS: !1,
          supportedLngs: !1,
          nonExplicitSupportedLngs: !1,
          load: 'all',
          preload: !1,
          simplifyPluralSuffix: !0,
          keySeparator: '.',
          nsSeparator: ':',
          pluralSeparator: '_',
          contextSeparator: '_',
          partialBundledLanguages: !1,
          saveMissing: !1,
          updateMissing: !1,
          saveMissingTo: 'fallback',
          saveMissingPlurals: !0,
          missingKeyHandler: !1,
          missingInterpolationHandler: !1,
          postProcess: !1,
          postProcessPassResolved: !1,
          returnNull: !1,
          returnEmptyString: !0,
          returnObjects: !1,
          joinArrays: !1,
          returnedObjectHandler: !1,
          parseMissingKeyHandler: !1,
          appendNamespaceToMissingKey: !1,
          appendNamespaceToCIMode: !1,
          overloadTranslationOptionHandler: i => {
            let l = {};
            if (
              (typeof i[1] == 'object' && (l = i[1]),
              ue(i[1]) && (l.defaultValue = i[1]),
              ue(i[2]) && (l.tDescription = i[2]),
              typeof i[2] == 'object' || typeof i[3] == 'object')
            ) {
              const s = i[3] || i[2];
              Object.keys(s).forEach(r => {
                l[r] = s[r];
              });
            }
            return l;
          },
          interpolation: {
            escapeValue: !0,
            format: i => i,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
          },
          cacheInBuiltFormats: !0,
        }),
        fm = i => (
          ue(i.ns) && (i.ns = [i.ns]),
          ue(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]),
          ue(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]),
          i.supportedLngs?.indexOf?.('cimode') < 0 &&
            (i.supportedLngs = i.supportedLngs.concat(['cimode'])),
          typeof i.initImmediate == 'boolean' &&
            (i.initAsync = i.initImmediate),
          i
        ),
        Ds = () => {},
        sv = i => {
          Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach(s => {
            typeof i[s] == 'function' && (i[s] = i[s].bind(i));
          });
        };
      class bl extends Ys {
        constructor(l = {}, s) {
          if (
            (super(),
            (this.options = fm(l)),
            (this.services = {}),
            (this.logger = ia),
            (this.modules = { external: [] }),
            sv(this),
            s && !this.isInitialized && !l.isClone)
          ) {
            if (!this.options.initAsync) return (this.init(l, s), this);
            setTimeout(() => {
              this.init(l, s);
            }, 0);
          }
        }
        init(l = {}, s) {
          ((this.isInitializing = !0),
            typeof l == 'function' && ((s = l), (l = {})),
            l.defaultNS == null &&
              l.ns &&
              (ue(l.ns)
                ? (l.defaultNS = l.ns)
                : l.ns.indexOf('translation') < 0 && (l.defaultNS = l.ns[0])));
          const r = dm();
          ((this.options = { ...r, ...this.options, ...fm(l) }),
            (this.options.interpolation = {
              ...r.interpolation,
              ...this.options.interpolation,
            }),
            l.keySeparator !== void 0 &&
              (this.options.userDefinedKeySeparator = l.keySeparator),
            l.nsSeparator !== void 0 &&
              (this.options.userDefinedNsSeparator = l.nsSeparator));
          const c = p => (p ? (typeof p == 'function' ? new p() : p) : null);
          if (!this.options.isClone) {
            this.modules.logger
              ? ia.init(c(this.modules.logger), this.options)
              : ia.init(null, this.options);
            let p;
            this.modules.formatter ? (p = this.modules.formatter) : (p = iv);
            const y = new sm(this.options);
            this.store = new nm(this.options.resources, this.options);
            const S = this.services;
            ((S.logger = ia),
              (S.resourceStore = this.store),
              (S.languageUtils = y),
              (S.pluralResolver = new Jb(y, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix,
              })),
              this.options.interpolation.format &&
                this.options.interpolation.format !== r.interpolation.format &&
                this.logger.deprecate(
                  'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                ),
              p &&
                (!this.options.interpolation.format ||
                  this.options.interpolation.format ===
                    r.interpolation.format) &&
                ((S.formatter = c(p)),
                S.formatter.init && S.formatter.init(S, this.options),
                (this.options.interpolation.format = S.formatter.format.bind(
                  S.formatter
                ))),
              (S.interpolator = new ev(this.options)),
              (S.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
              }),
              (S.backendConnector = new lv(
                c(this.modules.backend),
                S.resourceStore,
                S,
                this.options
              )),
              S.backendConnector.on('*', (x, ...T) => {
                this.emit(x, ...T);
              }),
              this.modules.languageDetector &&
                ((S.languageDetector = c(this.modules.languageDetector)),
                S.languageDetector.init &&
                  S.languageDetector.init(
                    S,
                    this.options.detection,
                    this.options
                  )),
              this.modules.i18nFormat &&
                ((S.i18nFormat = c(this.modules.i18nFormat)),
                S.i18nFormat.init && S.i18nFormat.init(this)),
              (this.translator = new Vs(this.services, this.options)),
              this.translator.on('*', (x, ...T) => {
                this.emit(x, ...T);
              }),
              this.modules.external.forEach(x => {
                x.init && x.init(this);
              }));
          }
          if (
            ((this.format = this.options.interpolation.format),
            s || (s = Ds),
            this.options.fallbackLng &&
              !this.services.languageDetector &&
              !this.options.lng)
          ) {
            const p = this.services.languageUtils.getFallbackCodes(
              this.options.fallbackLng
            );
            p.length > 0 && p[0] !== 'dev' && (this.options.lng = p[0]);
          }
          (!this.services.languageDetector &&
            !this.options.lng &&
            this.logger.warn(
              'init: no languageDetector is used and no lng is defined'
            ),
            [
              'getResource',
              'hasResourceBundle',
              'getResourceBundle',
              'getDataByLanguage',
            ].forEach(p => {
              this[p] = (...y) => this.store[p](...y);
            }),
            [
              'addResource',
              'addResources',
              'addResourceBundle',
              'removeResourceBundle',
            ].forEach(p => {
              this[p] = (...y) => (this.store[p](...y), this);
            }));
          const m = ul(),
            f = () => {
              const p = (y, S) => {
                ((this.isInitializing = !1),
                  this.isInitialized &&
                    !this.initializedStoreOnce &&
                    this.logger.warn(
                      'init: i18next is already initialized. You should call init just once!'
                    ),
                  (this.isInitialized = !0),
                  this.options.isClone ||
                    this.logger.log('initialized', this.options),
                  this.emit('initialized', this.options),
                  m.resolve(S),
                  s(y, S));
              };
              if (this.languages && !this.isInitialized)
                return p(null, this.t.bind(this));
              this.changeLanguage(this.options.lng, p);
            };
          return (
            this.options.resources || !this.options.initAsync
              ? f()
              : setTimeout(f, 0),
            m
          );
        }
        loadResources(l, s = Ds) {
          let r = s;
          const c = ue(l) ? l : this.language;
          if (
            (typeof l == 'function' && (r = l),
            !this.options.resources || this.options.partialBundledLanguages)
          ) {
            if (
              c?.toLowerCase() === 'cimode' &&
              (!this.options.preload || this.options.preload.length === 0)
            )
              return r();
            const u = [],
              h = m => {
                if (!m || m === 'cimode') return;
                this.services.languageUtils.toResolveHierarchy(m).forEach(p => {
                  p !== 'cimode' && u.indexOf(p) < 0 && u.push(p);
                });
              };
            (c
              ? h(c)
              : this.services.languageUtils
                  .getFallbackCodes(this.options.fallbackLng)
                  .forEach(f => h(f)),
              this.options.preload?.forEach?.(m => h(m)),
              this.services.backendConnector.load(u, this.options.ns, m => {
                (!m &&
                  !this.resolvedLanguage &&
                  this.language &&
                  this.setResolvedLanguage(this.language),
                  r(m));
              }));
          } else r(null);
        }
        reloadResources(l, s, r) {
          const c = ul();
          return (
            typeof l == 'function' && ((r = l), (l = void 0)),
            typeof s == 'function' && ((r = s), (s = void 0)),
            l || (l = this.languages),
            s || (s = this.options.ns),
            r || (r = Ds),
            this.services.backendConnector.reload(l, s, u => {
              (c.resolve(), r(u));
            }),
            c
          );
        }
        use(l) {
          if (!l)
            throw new Error(
              'You are passing an undefined module! Please check the object you are passing to i18next.use()'
            );
          if (!l.type)
            throw new Error(
              'You are passing a wrong module! Please check the object you are passing to i18next.use()'
            );
          return (
            l.type === 'backend' && (this.modules.backend = l),
            (l.type === 'logger' || (l.log && l.warn && l.error)) &&
              (this.modules.logger = l),
            l.type === 'languageDetector' &&
              (this.modules.languageDetector = l),
            l.type === 'i18nFormat' && (this.modules.i18nFormat = l),
            l.type === 'postProcessor' && Lm.addPostProcessor(l),
            l.type === 'formatter' && (this.modules.formatter = l),
            l.type === '3rdParty' && this.modules.external.push(l),
            this
          );
        }
        setResolvedLanguage(l) {
          if (
            !(!l || !this.languages) &&
            !(['cimode', 'dev'].indexOf(l) > -1)
          ) {
            for (let s = 0; s < this.languages.length; s++) {
              const r = this.languages[s];
              if (
                !(['cimode', 'dev'].indexOf(r) > -1) &&
                this.store.hasLanguageSomeTranslations(r)
              ) {
                this.resolvedLanguage = r;
                break;
              }
            }
            !this.resolvedLanguage &&
              this.languages.indexOf(l) < 0 &&
              this.store.hasLanguageSomeTranslations(l) &&
              ((this.resolvedLanguage = l), this.languages.unshift(l));
          }
        }
        changeLanguage(l, s) {
          this.isLanguageChangingTo = l;
          const r = ul();
          this.emit('languageChanging', l);
          const c = m => {
              ((this.language = m),
                (this.languages =
                  this.services.languageUtils.toResolveHierarchy(m)),
                (this.resolvedLanguage = void 0),
                this.setResolvedLanguage(m));
            },
            u = (m, f) => {
              (f
                ? this.isLanguageChangingTo === l &&
                  (c(f),
                  this.translator.changeLanguage(f),
                  (this.isLanguageChangingTo = void 0),
                  this.emit('languageChanged', f),
                  this.logger.log('languageChanged', f))
                : (this.isLanguageChangingTo = void 0),
                r.resolve((...p) => this.t(...p)),
                s && s(m, (...p) => this.t(...p)));
            },
            h = m => {
              !l && !m && this.services.languageDetector && (m = []);
              const f = ue(m) ? m : m && m[0],
                p = this.store.hasLanguageSomeTranslations(f)
                  ? f
                  : this.services.languageUtils.getBestMatchFromCodes(
                      ue(m) ? [m] : m
                    );
              (p &&
                (this.language || c(p),
                this.translator.language || this.translator.changeLanguage(p),
                this.services.languageDetector?.cacheUserLanguage?.(p)),
                this.loadResources(p, y => {
                  u(y, p);
                }));
            };
          return (
            !l &&
            this.services.languageDetector &&
            !this.services.languageDetector.async
              ? h(this.services.languageDetector.detect())
              : !l &&
                  this.services.languageDetector &&
                  this.services.languageDetector.async
                ? this.services.languageDetector.detect.length === 0
                  ? this.services.languageDetector.detect().then(h)
                  : this.services.languageDetector.detect(h)
                : h(l),
            r
          );
        }
        getFixedT(l, s, r) {
          const c = (u, h, ...m) => {
            let f;
            (typeof h != 'object'
              ? (f = this.options.overloadTranslationOptionHandler(
                  [u, h].concat(m)
                ))
              : (f = { ...h }),
              (f.lng = f.lng || c.lng),
              (f.lngs = f.lngs || c.lngs),
              (f.ns = f.ns || c.ns),
              f.keyPrefix !== '' &&
                (f.keyPrefix = f.keyPrefix || r || c.keyPrefix));
            const p = this.options.keySeparator || '.';
            let y;
            return (
              f.keyPrefix && Array.isArray(u)
                ? (y = u.map(
                    S => (
                      typeof S == 'function' &&
                        (S = jc(S, { ...this.options, ...h })),
                      `${f.keyPrefix}${p}${S}`
                    )
                  ))
                : (typeof u == 'function' &&
                    (u = jc(u, { ...this.options, ...h })),
                  (y = f.keyPrefix ? `${f.keyPrefix}${p}${u}` : u)),
              this.t(y, f)
            );
          };
          return (
            ue(l) ? (c.lng = l) : (c.lngs = l),
            (c.ns = s),
            (c.keyPrefix = r),
            c
          );
        }
        t(...l) {
          return this.translator?.translate(...l);
        }
        exists(...l) {
          return this.translator?.exists(...l);
        }
        setDefaultNamespace(l) {
          this.options.defaultNS = l;
        }
        hasLoadedNamespace(l, s = {}) {
          if (!this.isInitialized)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18next was not initialized',
                this.languages
              ),
              !1
            );
          if (!this.languages || !this.languages.length)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18n.languages were undefined or empty',
                this.languages
              ),
              !1
            );
          const r = s.lng || this.resolvedLanguage || this.languages[0],
            c = this.options ? this.options.fallbackLng : !1,
            u = this.languages[this.languages.length - 1];
          if (r.toLowerCase() === 'cimode') return !0;
          const h = (m, f) => {
            const p = this.services.backendConnector.state[`${m}|${f}`];
            return p === -1 || p === 0 || p === 2;
          };
          if (s.precheck) {
            const m = s.precheck(this, h);
            if (m !== void 0) return m;
          }
          return !!(
            this.hasResourceBundle(r, l) ||
            !this.services.backendConnector.backend ||
            (this.options.resources && !this.options.partialBundledLanguages) ||
            (h(r, l) && (!c || h(u, l)))
          );
        }
        loadNamespaces(l, s) {
          const r = ul();
          return this.options.ns
            ? (ue(l) && (l = [l]),
              l.forEach(c => {
                this.options.ns.indexOf(c) < 0 && this.options.ns.push(c);
              }),
              this.loadResources(c => {
                (r.resolve(), s && s(c));
              }),
              r)
            : (s && s(), Promise.resolve());
        }
        loadLanguages(l, s) {
          const r = ul();
          ue(l) && (l = [l]);
          const c = this.options.preload || [],
            u = l.filter(
              h =>
                c.indexOf(h) < 0 &&
                this.services.languageUtils.isSupportedCode(h)
            );
          return u.length
            ? ((this.options.preload = c.concat(u)),
              this.loadResources(h => {
                (r.resolve(), s && s(h));
              }),
              r)
            : (s && s(), Promise.resolve());
        }
        dir(l) {
          if (
            (l ||
              (l =
                this.resolvedLanguage ||
                (this.languages?.length > 0
                  ? this.languages[0]
                  : this.language)),
            !l)
          )
            return 'rtl';
          try {
            const c = new Intl.Locale(l);
            if (c && c.getTextInfo) {
              const u = c.getTextInfo();
              if (u && u.direction) return u.direction;
            }
          } catch {}
          const s = [
              'ar',
              'shu',
              'sqr',
              'ssh',
              'xaa',
              'yhd',
              'yud',
              'aao',
              'abh',
              'abv',
              'acm',
              'acq',
              'acw',
              'acx',
              'acy',
              'adf',
              'ads',
              'aeb',
              'aec',
              'afb',
              'ajp',
              'apc',
              'apd',
              'arb',
              'arq',
              'ars',
              'ary',
              'arz',
              'auz',
              'avl',
              'ayh',
              'ayl',
              'ayn',
              'ayp',
              'bbz',
              'pga',
              'he',
              'iw',
              'ps',
              'pbt',
              'pbu',
              'pst',
              'prp',
              'prd',
              'ug',
              'ur',
              'ydd',
              'yds',
              'yih',
              'ji',
              'yi',
              'hbo',
              'men',
              'xmn',
              'fa',
              'jpr',
              'peo',
              'pes',
              'prs',
              'dv',
              'sam',
              'ckb',
            ],
            r = this.services?.languageUtils || new sm(dm());
          return l.toLowerCase().indexOf('-latn') > 1
            ? 'ltr'
            : s.indexOf(r.getLanguagePartFromCode(l)) > -1 ||
                l.toLowerCase().indexOf('-arab') > 1
              ? 'rtl'
              : 'ltr';
        }
        static createInstance(l = {}, s) {
          return new bl(l, s);
        }
        cloneInstance(l = {}, s = Ds) {
          const r = l.forkResourceStore;
          r && delete l.forkResourceStore;
          const c = { ...this.options, ...l, isClone: !0 },
            u = new bl(c);
          if (
            ((l.debug !== void 0 || l.prefix !== void 0) &&
              (u.logger = u.logger.clone(l)),
            ['store', 'services', 'language'].forEach(m => {
              u[m] = this[m];
            }),
            (u.services = { ...this.services }),
            (u.services.utils = {
              hasLoadedNamespace: u.hasLoadedNamespace.bind(u),
            }),
            r)
          ) {
            const m = Object.keys(this.store.data).reduce(
              (f, p) => (
                (f[p] = { ...this.store.data[p] }),
                (f[p] = Object.keys(f[p]).reduce(
                  (y, S) => ((y[S] = { ...f[p][S] }), y),
                  f[p]
                )),
                f
              ),
              {}
            );
            ((u.store = new nm(m, c)), (u.services.resourceStore = u.store));
          }
          return (
            (u.translator = new Vs(u.services, c)),
            u.translator.on('*', (m, ...f) => {
              u.emit(m, ...f);
            }),
            u.init(c, s),
            (u.translator.options = c),
            (u.translator.backendConnector.services.utils = {
              hasLoadedNamespace: u.hasLoadedNamespace.bind(u),
            }),
            u
          );
        }
        toJSON() {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage,
          };
        }
      }
      const Ks = bl.createInstance();
      Ks.createInstance = bl.createInstance;
      const rv = (i, l, s, r) => {
          const c = [s, { code: l, ...(r || {}) }];
          if (i?.services?.logger?.forward)
            return i.services.logger.forward(c, 'warn', 'react-i18next::', !0);
          (bi(c[0]) && (c[0] = `react-i18next:: ${c[0]}`),
            i?.services?.logger?.warn
              ? i.services.logger.warn(...c)
              : console?.warn && console.warn(...c));
        },
        hm = {},
        Cc = (i, l, s, r) => {
          (bi(s) && hm[s]) || (bi(s) && (hm[s] = new Date()), rv(i, l, s, r));
        },
        Hm = (i, l) => () => {
          if (i.isInitialized) l();
          else {
            const s = () => {
              (setTimeout(() => {
                i.off('initialized', s);
              }, 0),
                l());
            };
            i.on('initialized', s);
          }
        },
        Oc = (i, l, s) => {
          i.loadNamespaces(l, Hm(i, s));
        },
        mm = (i, l, s, r) => {
          if (
            (bi(s) && (s = [s]),
            i.options.preload && i.options.preload.indexOf(l) > -1)
          )
            return Oc(i, s, r);
          (s.forEach(c => {
            i.options.ns.indexOf(c) < 0 && i.options.ns.push(c);
          }),
            i.loadLanguages(l, Hm(i, r)));
        },
        ov = (i, l, s = {}) =>
          !l.languages || !l.languages.length
            ? (Cc(l, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                languages: l.languages,
              }),
              !0)
            : l.hasLoadedNamespace(i, {
                lng: s.lng,
                precheck: (r, c) => {
                  if (
                    s.bindI18n &&
                    s.bindI18n.indexOf('languageChanging') > -1 &&
                    r.services.backendConnector.backend &&
                    r.isLanguageChangingTo &&
                    !c(r.isLanguageChangingTo, i)
                  )
                    return !1;
                },
              }),
        bi = i => typeof i == 'string',
        cv = i => typeof i == 'object' && i !== null,
        uv =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        dv = {
          '&amp;': '&',
          '&#38;': '&',
          '&lt;': '<',
          '&#60;': '<',
          '&gt;': '>',
          '&#62;': '>',
          '&apos;': "'",
          '&#39;': "'",
          '&quot;': '"',
          '&#34;': '"',
          '&nbsp;': ' ',
          '&#160;': ' ',
          '&copy;': '©',
          '&#169;': '©',
          '&reg;': '®',
          '&#174;': '®',
          '&hellip;': '…',
          '&#8230;': '…',
          '&#x2F;': '/',
          '&#47;': '/',
        },
        fv = i => dv[i],
        hv = i => i.replace(uv, fv);
      let Bc = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: hv,
      };
      const mv = (i = {}) => {
          Bc = { ...Bc, ...i };
        },
        pv = () => Bc;
      let Um;
      const gv = i => {
          Um = i;
        },
        bv = () => Um,
        vv = {
          type: '3rdParty',
          init(i) {
            (mv(i.options.react), gv(i));
          },
        },
        Im = Y.createContext();
      class yv {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(l) {
          l.forEach(s => {
            this.usedNamespaces[s] || (this.usedNamespaces[s] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      const Sv = (i, l) => {
          const s = Y.useRef();
          return (
            Y.useEffect(() => {
              s.current = i;
            }, [i, l]),
            s.current
          );
        },
        Gm = (i, l, s, r) => i.getFixedT(l, s, r),
        xv = (i, l, s, r) => Y.useCallback(Gm(i, l, s, r), [i, l, s, r]),
        de = (i, l = {}) => {
          const { i18n: s } = l,
            { i18n: r, defaultNS: c } = Y.useContext(Im) || {},
            u = s || r || bv();
          if (
            (u && !u.reportNamespaces && (u.reportNamespaces = new yv()), !u)
          ) {
            Cc(
              u,
              'NO_I18NEXT_INSTANCE',
              'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
            );
            const $ = (U, X) =>
                bi(X)
                  ? X
                  : cv(X) && bi(X.defaultValue)
                    ? X.defaultValue
                    : Array.isArray(U)
                      ? U[U.length - 1]
                      : U,
              D = [$, {}, !1];
            return ((D.t = $), (D.i18n = {}), (D.ready = !1), D);
          }
          u.options.react?.wait &&
            Cc(
              u,
              'DEPRECATED_OPTION',
              'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.'
            );
          const h = { ...pv(), ...u.options.react, ...l },
            { useSuspense: m, keyPrefix: f } = h;
          let p = i || c || u.options?.defaultNS;
          ((p = bi(p) ? [p] : p || ['translation']),
            u.reportNamespaces.addUsedNamespaces?.(p));
          const y =
              (u.isInitialized || u.initializedStoreOnce) &&
              p.every($ => ov($, u, h)),
            S = xv(u, l.lng || null, h.nsMode === 'fallback' ? p : p[0], f),
            w = () => S,
            x = () =>
              Gm(u, l.lng || null, h.nsMode === 'fallback' ? p : p[0], f),
            [T, A] = Y.useState(w);
          let j = p.join();
          l.lng && (j = `${l.lng}${j}`);
          const G = Sv(j),
            L = Y.useRef(!0);
          (Y.useEffect(() => {
            const { bindI18n: $, bindI18nStore: D } = h;
            ((L.current = !0),
              !y &&
                !m &&
                (l.lng
                  ? mm(u, l.lng, p, () => {
                      L.current && A(x);
                    })
                  : Oc(u, p, () => {
                      L.current && A(x);
                    })),
              y && G && G !== j && L.current && A(x));
            const U = () => {
              L.current && A(x);
            };
            return (
              $ && u?.on($, U),
              D && u?.store.on(D, U),
              () => {
                ((L.current = !1),
                  u && $ && $?.split(' ').forEach(X => u.off(X, U)),
                  D && u && D.split(' ').forEach(X => u.store.off(X, U)));
              }
            );
          }, [u, j]),
            Y.useEffect(() => {
              L.current && y && A(w);
            }, [u, f, y]));
          const H = [T, u, y];
          if (((H.t = T), (H.i18n = u), (H.ready = y), y || (!y && !m)))
            return H;
          throw new Promise($ => {
            l.lng ? mm(u, l.lng, p, () => $()) : Oc(u, p, () => $());
          });
        };
      function Tv({ i18n: i, defaultNS: l, children: s }) {
        const r = Y.useMemo(() => ({ i18n: i, defaultNS: l }), [i, l]);
        return Y.createElement(Im.Provider, { value: r }, s);
      }
      const wv = 'page_klbwq',
        Ev = { page: wv };
      function Qt(i = 768) {
        const l = `(max-width: ${i}px)`,
          [s, r] = Y.useState(() =>
            typeof window > 'u' ? !1 : window.matchMedia(l).matches
          );
        return (
          Y.useEffect(() => {
            const c = window.matchMedia(l),
              u = () => r(c.matches);
            return (
              u(),
              c.addEventListener('change', u),
              () => c.removeEventListener('change', u)
            );
          }, [l]),
          s
        );
      }
      function Si(i, l, s, r) {
        return i(r ? s : l);
      }
      const Nv = 'scrollWrap_LtUxi',
        _v = 'stickyHero_wyX5j',
        Av = 'heroBg_xfR9c',
        Mv = 'initialContent_GadfP',
        jv = 'initialInner_rffpK',
        Cv = 'mask_OpIX1',
        Ov = 'maskFull_-9phJ',
        Bv = 'scrollContent_HmpyW',
        Rv = 'badge_8sFrq',
        Dv = 'title_Klsg0',
        Lv = 'subtitle_-Ihim',
        zv = 'scrollTitle_VLWYk',
        Hv = 'scrollSubtitle_OwsPT',
        Bt = {
          scrollWrap: Nv,
          stickyHero: _v,
          heroBg: Av,
          initialContent: Mv,
          initialInner: jv,
          mask: Cv,
          maskFull: Ov,
          scrollContent: Bv,
          badge: Rv,
          title: Dv,
          subtitle: Lv,
          scrollTitle: zv,
          scrollSubtitle: Hv,
        };
      function Uv({ heroBg: i }) {
        const { t: l } = de(),
          s = Y.useRef(null),
          r = Y.useRef(null),
          [c, u] = Y.useState(0);
        Y.useEffect(() => {
          const w = () => {
            const x = s.current,
              T = r.current;
            if (!x || !T) return;
            const A = x.offsetHeight - T.offsetHeight;
            if (A <= 0) {
              u(0);
              return;
            }
            const j = Math.min(A, Math.max(0, -x.getBoundingClientRect().top));
            u(j / A);
          };
          return (
            w(),
            window.addEventListener('scroll', w, { passive: !0 }),
            window.addEventListener('resize', w),
            () => {
              (window.removeEventListener('scroll', w),
                window.removeEventListener('resize', w));
            }
          );
        }, []);
        const m = Math.min(1, c / 0.65),
          f = m >= 0.99,
          p = Math.max(0, 1 - m * 1.4),
          y = `${m * 100}%`,
          S = Math.max(0, Math.min(1, (m - 0.25) / 0.55));
        return g.jsx('section', {
          ref: s,
          className: Bt.scrollWrap,
          children: g.jsxs('div', {
            ref: r,
            className: Bt.stickyHero,
            children: [
              g.jsx('div', {
                className: Bt.heroBg,
                style: { backgroundImage: `url(${i})` },
              }),
              g.jsx('div', {
                className: Bt.initialContent,
                style: { opacity: p },
                children: g.jsxs('div', {
                  className: Bt.initialInner,
                  children: [
                    g.jsx('span', {
                      className: Bt.badge,
                      children: l('section1.badge'),
                    }),
                    g.jsx('h1', {
                      className: Bt.title,
                      children: l('section1.title'),
                    }),
                    g.jsx('p', {
                      className: Bt.subtitle,
                      dangerouslySetInnerHTML: {
                        __html: l('section1.subtitle'),
                      },
                    }),
                  ],
                }),
              }),
              g.jsx('div', {
                className: `${Bt.mask} ${f ? Bt.maskFull : ''}`,
                style: { height: y },
                'aria-hidden': 'true',
              }),
              g.jsxs('div', {
                className: Bt.scrollContent,
                style: { opacity: S },
                children: [
                  g.jsx('p', {
                    className: Bt.scrollTitle,
                    dangerouslySetInnerHTML: {
                      __html: l('section1.scrollTitle'),
                    },
                  }),
                  g.jsx('p', {
                    className: Bt.scrollSubtitle,
                    dangerouslySetInnerHTML: {
                      __html: l('section1.scrollSubtitle'),
                    },
                  }),
                ],
              }),
            ],
          }),
        });
      }
      function Iv() {
        const { t: i } = de('imageUrl'),
          l = Qt(),
          s = Si(i, 'heroBg', 'heroBgMobile', l);
        return g.jsx(Uv, { heroBg: s });
      }
      const it = ({ name: i, className: l = '', style: s, size: r, ...c }) => {
        const u = { lineHeight: '1', fontSize: r, ...s };
        return g.jsx('i', {
          className: `creality-product-info-iconfont ${i} ${l}`,
          style: u,
          ...c,
        });
      };
      /*! lozad.js - v1.16.0 - 2020-09-06
       * https://github.com/ApoorvSaxena/lozad.js
       * Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ const Gv =
          typeof document < 'u' && document.documentMode,
        Vv = {
          rootMargin: '0px',
          threshold: 0,
          load(i) {
            if (i.nodeName.toLowerCase() === 'picture') {
              let s = i.querySelector('img'),
                r = !1;
              (s === null && ((s = document.createElement('img')), (r = !0)),
                Gv &&
                  i.getAttribute('data-iesrc') &&
                  (s.src = i.getAttribute('data-iesrc')),
                i.getAttribute('data-alt') &&
                  (s.alt = i.getAttribute('data-alt')),
                r && i.append(s));
            }
            if (
              i.nodeName.toLowerCase() === 'video' &&
              !i.getAttribute('data-src') &&
              i.children
            ) {
              const s = i.children;
              let r;
              for (let c = 0; c <= s.length - 1; c++)
                ((r = s[c].getAttribute('data-src')), r && (s[c].src = r));
              i.load();
            }
            (i.getAttribute('data-poster') &&
              (i.poster = i.getAttribute('data-poster')),
              i.getAttribute('data-src') &&
                (i.src = i.getAttribute('data-src')),
              i.getAttribute('data-srcset') &&
                i.setAttribute('srcset', i.getAttribute('data-srcset')));
            let l = ',';
            if (
              (i.getAttribute('data-background-delimiter') &&
                (l = i.getAttribute('data-background-delimiter')),
              i.getAttribute('data-background-image'))
            )
              i.style.backgroundImage = `url('${i.getAttribute('data-background-image').split(l).join("'),url('")}')`;
            else if (i.getAttribute('data-background-image-set')) {
              const s = i.getAttribute('data-background-image-set').split(l);
              let r = s[0].substr(0, s[0].indexOf(' ')) || s[0];
              ((r = r.indexOf('url(') === -1 ? `url(${r})` : r),
                s.length === 1
                  ? (i.style.backgroundImage = r)
                  : i.setAttribute(
                      'style',
                      (i.getAttribute('style') || '') +
                        `background-image: ${r}; background-image: -webkit-image-set(${s}); background-image: image-set(${s})`
                    ));
            }
            i.getAttribute('data-toggle-class') &&
              i.classList.toggle(i.getAttribute('data-toggle-class'));
          },
          loaded() {},
        };
      function Rc(i) {
        i.setAttribute('data-loaded', !0);
      }
      function kv(i) {
        i.getAttribute('data-placeholder-background') &&
          (i.style.background = i.getAttribute('data-placeholder-background'));
      }
      const Dc = i => i.getAttribute('data-loaded') === 'true',
        $v = (i, l) => (s, r) => {
          s.forEach(c => {
            (c.intersectionRatio > 0 || c.isIntersecting) &&
              (r.unobserve(c.target),
              Dc(c.target) || (i(c.target), Rc(c.target), l(c.target)));
          });
        },
        pm = (i, l = document) =>
          i instanceof Element
            ? [i]
            : i instanceof NodeList
              ? i
              : l.querySelectorAll(i);
      function qv(i = '.lozad', l = {}) {
        const {
          root: s,
          rootMargin: r,
          threshold: c,
          load: u,
          loaded: h,
        } = Object.assign({}, Vv, l);
        let m;
        typeof window < 'u' &&
          window.IntersectionObserver &&
          (m = new IntersectionObserver($v(u, h), {
            root: s,
            rootMargin: r,
            threshold: c,
          }));
        const f = pm(i, s);
        for (let p = 0; p < f.length; p++) kv(f[p]);
        return {
          observe() {
            const p = pm(i, s);
            for (let y = 0; y < p.length; y++)
              if (!Dc(p[y])) {
                if (m) {
                  m.observe(p[y]);
                  continue;
                }
                (u(p[y]), Rc(p[y]), h(p[y]));
              }
          },
          triggerLoad(p) {
            Dc(p) || (u(p), Rc(p), h(p));
          },
          observer: m,
        };
      }
      const Pv = 'safaImage_VwBX8',
        Yv = { safaImage: Pv };
      function Vm(...i) {
        const l = [];
        for (const s of i)
          if (s) {
            if (typeof s == 'string' || typeof s == 'number') l.push(s);
            else if (Array.isArray(s)) {
              const r = Vm(...s);
              r && l.push(r);
            } else if (typeof s == 'object')
              for (const r in s) s.hasOwnProperty(r) && s[r] && l.push(r);
          }
        return l.join(' ');
      }
      const Kv = () => {
        if (typeof window > 'u') {
          const i = globalThis.__SSR_LANG__;
          if (i) return i;
        }
        return 'de';
      };
      function ft({
        src: i,
        fallback: l,
        showFallbackText: s = !0,
        aspectRatio: r,
        alt: c = '',
        enableLazyLoad: u = !1,
        rootMargin: h = '400px',
        threshold: m = 0,
        ...f
      }) {
        const [p, y] = Y.useState(!1),
          [S, w] = Y.useState(!1),
          x = Y.useRef(null);
        (Y.useEffect(() => {
          w(!0);
        }, []),
          Y.useEffect(() => {
            y(!1);
          }, [i]),
          Y.useEffect(
            () =>
              !u || !S || !x.current
                ? void 0
                : (qv(x.current, {
                    rootMargin: h,
                    threshold: m,
                    loaded: L => {
                      L.classList.add('lozad-loaded');
                    },
                  }).observe(),
                  () => {}),
            [S, u, h, m, i]
          ));
        let T = i;
        (typeof T == 'object' && T !== null && 'src' in T && (T = T.src),
          typeof T == 'string' && T.startsWith('//') && (T = 'https:' + T));
        const A = typeof T == 'string' && T.trim() !== '',
          j = g.jsx('div', {
            style: {
              width: f.width || '100%',
              height: f.height || '100%',
              aspectRatio: r,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(243,244,246)',
              ...f.style,
            },
            children: g.jsx(it, {
              name: 'icon-zhanweifu',
              style: {
                fontSize: '36px',
                lineHeight: '40px',
                color: 'rgba(156,163,175)',
                opacity: 0.2,
              },
            }),
          });
        return A
          ? S && p
            ? l
              ? g.jsx(g.Fragment, { children: l })
              : s
                ? j
                : null
            : g.jsx('img', {
                ref: x,
                'data-src': u ? T : void 0,
                src: u ? void 0 : T,
                alt: c || '',
                className: Vm('lozad', Yv.safaImage, f.className),
                onError: () => y(!0),
                ...f,
                style: {
                  ...(f.width ? { width: f.width } : {}),
                  ...(f.height ? { height: f.height } : {}),
                  ...(r ? { aspectRatio: r } : {}),
                  objectFit: 'cover',
                  display: 'block',
                  ...f.style,
                },
              })
          : l
            ? g.jsx(g.Fragment, { children: l })
            : s
              ? j
              : null;
      }
      const Xv = 'section2_RMzUF',
        Qv = 'title_nHX6n',
        Zv = 'mbGrid_K2rZE',
        Wv = 'mbLaserModules_z2bUb',
        Fv = 'mbRowTall_MmxAK',
        Jv = 'mbRowLifting_1e3yj',
        ey = 'mbRowCamera_c3dvR',
        ty = 'mbAutoFocus_illT-',
        ay = 'mbLifting_dYINt',
        iy = 'mbAiCamera_QhCJ8',
        ny = 'mbHighSpeed_jgBiO',
        ly = 'mbAiExperience_eVwdz',
        sy = 'mbRightCol_ECPe0',
        ry = 'mbIoT_u3mIm',
        oy = 'mbSafety_CtEjk',
        cy = 'cardTitle_gMc3c',
        uy = 'cardAccent_oub2I',
        dy = 'iotTitle_poj6Z',
        fy = 'aiCameraDesc_6tnel',
        hy = 'iotDesc_BTuTy',
        my = 'workingAreaLabel_6jdn1',
        py = 'workingAreaValue_WV4ng',
        gy = 'upTo_jy67B',
        by = 'speedNum_NDQ9d',
        vy = 'speedUnit_wzpfL',
        yy = 'aiExperienceTitle_sHP1z',
        Sy = 'laserBadge_GHUlh',
        xy = 'laserModulesTitle_XG68K',
        Ty = 'laserRow_-TmLG',
        wy = 'laserPower_VOXu2',
        Ey = 'laserType_wkGNi',
        Ny = 'materialsIcon_C22mS',
        _y = 'materialsLabel_k9Ltm',
        Ay = 'speedBlock_-V74l',
        My = 'speedValue_NUxdl',
        jy = 'workingArea_BvQMe',
        Cy = 'safetyTitle_vnAIi',
        Oy = 'grid_Z9hKT',
        By = 'colLeft_Fv-eg',
        Ry = 'colMiddle_9NqRO',
        Dy = 'colRight_hiXYS',
        Ly = 'cardAutoFocus_abFzY',
        zy = 'cardLifting_VX44X',
        Hy = 'cardLaserModules_JzEqN',
        Uy = 'materialsBlock_-1xya',
        Iy = 'bottomRow_wBo7x',
        Gy = 'bottomLeft_gEpK0',
        Vy = 'cardSafety_UfDVk',
        ky = 'class1_n2yf9',
        $y = 'cardIoT_jkRsq',
        qy = 'cardAiCamera_Oummn',
        Py = 'cardHighSpeed_G2S3e',
        Yy = 'cardAiExperience_4Y10E',
        Z = {
          section2: Xv,
          title: Qv,
          mbGrid: Zv,
          mbLaserModules: Wv,
          mbRowTall: Fv,
          mbRowLifting: Jv,
          mbRowCamera: ey,
          mbAutoFocus: ty,
          mbLifting: ay,
          mbAiCamera: iy,
          mbHighSpeed: ny,
          mbAiExperience: ly,
          mbRightCol: sy,
          mbIoT: ry,
          mbSafety: oy,
          cardTitle: cy,
          cardAccent: uy,
          iotTitle: dy,
          aiCameraDesc: fy,
          iotDesc: hy,
          workingAreaLabel: my,
          workingAreaValue: py,
          upTo: gy,
          speedNum: by,
          speedUnit: vy,
          aiExperienceTitle: yy,
          laserBadge: Sy,
          laserModulesTitle: xy,
          laserRow: Ty,
          laserPower: wy,
          laserType: Ey,
          materialsIcon: Ny,
          materialsLabel: _y,
          speedBlock: Ay,
          speedValue: My,
          workingArea: jy,
          safetyTitle: Cy,
          grid: Oy,
          colLeft: By,
          colMiddle: Ry,
          colRight: Dy,
          cardAutoFocus: Ly,
          cardLifting: zy,
          cardLaserModules: Hy,
          materialsBlock: Uy,
          bottomRow: Iy,
          bottomLeft: Gy,
          cardSafety: Vy,
          class1: ky,
          cardIoT: $y,
          cardAiCamera: qy,
          cardHighSpeed: Py,
          cardAiExperience: Yy,
        };
      function Ky() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          r = [
            { power: 'section2.laser5w', type: 'section2.laser5wType' },
            { power: 'section2.laser10w', type: 'section2.laser10wType' },
            { power: 'section2.laserIR', type: 'section2.laserIRType' },
          ],
          c = m => ({ backgroundImage: `url(${l(m)})` }),
          u = m => ({ backgroundImage: `url(${l(`${m}Mobile`)})` }),
          h = Si(l, 'materialsIcon', 'materialsIconMobile', s);
        return s
          ? g.jsxs('section', {
              className: Z.section2,
              children: [
                g.jsx('h2', {
                  className: Z.title,
                  children: i('section2.title'),
                }),
                g.jsxs('div', {
                  className: Z.mbGrid,
                  children: [
                    g.jsxs('div', {
                      className: Z.mbLaserModules,
                      style: u('highlight2'),
                      children: [
                        g.jsx('h3', {
                          className: Z.laserModulesTitle,
                          children: i('section2.laserModulesTitle'),
                        }),
                        g.jsx('div', {
                          className: Z.laserRow,
                          children: r.map(m =>
                            g.jsxs(
                              'div',
                              {
                                className: Z.laserBadge,
                                children: [
                                  g.jsx('span', {
                                    className: Z.laserPower,
                                    children: i(m.power),
                                  }),
                                  g.jsx('span', {
                                    className: Z.laserType,
                                    children: i(m.type),
                                  }),
                                ],
                              },
                              m.power
                            )
                          ),
                        }),
                        g.jsxs('div', {
                          className: Z.materialsBlock,
                          children: [
                            g.jsx(ft, {
                              className: Z.materialsIcon,
                              src: h,
                              alt: '',
                            }),
                            g.jsx('span', {
                              className: Z.materialsLabel,
                              children: i('section2.materials'),
                            }),
                          ],
                        }),
                      ],
                    }),
                    g.jsxs('div', {
                      className: Z.mbRowTall,
                      children: [
                        g.jsx('div', {
                          className: Z.mbAutoFocus,
                          style: u('highlight1'),
                          children: g.jsx('span', {
                            className: Z.cardTitle,
                            children: i('section2.autoFocus'),
                          }),
                        }),
                        g.jsxs('div', {
                          className: Z.mbHighSpeed,
                          style: u('highlight3'),
                          children: [
                            g.jsx('span', {
                              className: Z.cardTitle,
                              children: i('section2.highSpeed'),
                            }),
                            g.jsxs('div', {
                              className: Z.speedBlock,
                              children: [
                                g.jsx('span', {
                                  className: Z.upTo,
                                  children: i('section2.upTo'),
                                }),
                                g.jsxs('div', {
                                  className: Z.speedValue,
                                  children: [
                                    g.jsx('span', {
                                      className: Z.speedNum,
                                      children: i('section2.speedValue'),
                                    }),
                                    g.jsx('span', {
                                      className: Z.speedUnit,
                                      children: i('section2.speedUnit'),
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                    g.jsxs('div', {
                      className: Z.mbRowLifting,
                      children: [
                        g.jsxs('div', {
                          className: Z.mbLifting,
                          style: u('highlight4'),
                          children: [
                            g.jsx('span', {
                              className: Z.cardTitle,
                              children: i('section2.liftingPlatform'),
                            }),
                            g.jsxs('div', {
                              className: Z.workingArea,
                              children: [
                                g.jsx('span', {
                                  className: Z.workingAreaLabel,
                                  children: i('section2.workingAreaLabel'),
                                }),
                                g.jsx('span', {
                                  className: Z.workingAreaValue,
                                  dangerouslySetInnerHTML: {
                                    __html: i('section2.workingAreaValue'),
                                  },
                                }),
                              ],
                            }),
                          ],
                        }),
                        g.jsx('div', {
                          className: Z.mbAiExperience,
                          style: u('highlight8'),
                          children: g.jsxs('div', {
                            className: Z.aiExperienceTitle,
                            children: [
                              g.jsx('span', {
                                className: Z.cardAccent,
                                dangerouslySetInnerHTML: {
                                  __html: i('section2.aiPowered'),
                                },
                              }),
                              g.jsx('span', {
                                children: i('section2.smartExperience'),
                              }),
                            ],
                          }),
                        }),
                      ],
                    }),
                    g.jsxs('div', {
                      className: Z.mbRowCamera,
                      children: [
                        g.jsxs('div', {
                          className: Z.mbAiCamera,
                          style: u('highlight7'),
                          children: [
                            g.jsx('span', {
                              className: Z.cardAccent,
                              children: i('section2.aiCamera'),
                            }),
                            g.jsx('span', {
                              className: Z.aiCameraDesc,
                              children: i('section2.aiCameraDesc'),
                            }),
                          ],
                        }),
                        g.jsxs('div', {
                          className: Z.mbRightCol,
                          children: [
                            g.jsxs('div', {
                              className: Z.mbIoT,
                              style: u('highlight6'),
                              children: [
                                g.jsx('span', {
                                  className: Z.iotTitle,
                                  children: i('section2.smartIoT'),
                                }),
                                g.jsx('p', {
                                  className: Z.iotDesc,
                                  children: i('section2.smartIoTDesc'),
                                }),
                              ],
                            }),
                            g.jsx('div', {
                              className: Z.mbSafety,
                              style: u('highlight5'),
                              children: g.jsx('span', {
                                className: Z.safetyTitle,
                                dangerouslySetInnerHTML: {
                                  __html: i('section2.laserSafety'),
                                },
                              }),
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            })
          : g.jsxs('section', {
              className: Z.section2,
              children: [
                g.jsx('h2', {
                  className: Z.title,
                  children: i('section2.title'),
                }),
                g.jsxs('div', {
                  className: Z.grid,
                  children: [
                    g.jsxs('div', {
                      className: Z.colLeft,
                      children: [
                        g.jsx('div', {
                          className: Z.cardAutoFocus,
                          style: c('highlight1'),
                          children: g.jsx('span', {
                            className: Z.cardTitle,
                            children: i('section2.autoFocus'),
                          }),
                        }),
                        g.jsxs('div', {
                          className: Z.cardLifting,
                          style: c('highlight4'),
                          children: [
                            g.jsx('span', {
                              className: Z.cardAccent,
                              children: i('section2.liftingPlatform'),
                            }),
                            g.jsxs('div', {
                              className: Z.workingArea,
                              children: [
                                g.jsx('span', {
                                  className: Z.workingAreaLabel,
                                  children: i('section2.workingAreaLabel'),
                                }),
                                g.jsx('span', {
                                  className: Z.workingAreaValue,
                                  dangerouslySetInnerHTML: {
                                    __html: i('section2.workingAreaValue'),
                                  },
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                    g.jsxs('div', {
                      className: Z.colMiddle,
                      children: [
                        g.jsxs('div', {
                          className: Z.cardLaserModules,
                          style: c('highlight2'),
                          children: [
                            g.jsx('h3', {
                              className: Z.laserModulesTitle,
                              children: i('section2.laserModulesTitle'),
                            }),
                            g.jsx('div', {
                              className: Z.laserRow,
                              children: r.map(m =>
                                g.jsxs(
                                  'div',
                                  {
                                    className: Z.laserBadge,
                                    children: [
                                      g.jsx('span', {
                                        className: Z.laserPower,
                                        children: i(m.power),
                                      }),
                                      g.jsx('span', {
                                        className: Z.laserType,
                                        children: i(m.type),
                                      }),
                                    ],
                                  },
                                  m.power
                                )
                              ),
                            }),
                            g.jsxs('div', {
                              className: Z.materialsBlock,
                              children: [
                                g.jsx(ft, {
                                  className: Z.materialsIcon,
                                  src: h,
                                  alt: '',
                                }),
                                g.jsx('span', {
                                  className: Z.materialsLabel,
                                  children: i('section2.materials'),
                                }),
                              ],
                            }),
                          ],
                        }),
                        g.jsxs('div', {
                          className: Z.bottomRow,
                          children: [
                            g.jsxs('div', {
                              className: Z.bottomLeft,
                              children: [
                                g.jsxs('div', {
                                  className: Z.cardSafety,
                                  style: c('highlight5'),
                                  children: [
                                    g.jsx('span', {
                                      className: Z.safetyTitle,
                                      dangerouslySetInnerHTML: {
                                        __html: i('section2.laserSafety'),
                                      },
                                    }),
                                    g.jsx('span', {
                                      className: Z.class1,
                                      children: i('section2.class1'),
                                    }),
                                  ],
                                }),
                                g.jsxs('div', {
                                  className: Z.cardIoT,
                                  style: c('highlight6'),
                                  children: [
                                    g.jsx('span', {
                                      className: Z.iotTitle,
                                      children: i('section2.smartIoT'),
                                    }),
                                    g.jsx('p', {
                                      className: Z.iotDesc,
                                      children: i('section2.smartIoTDesc'),
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            g.jsxs('div', {
                              className: Z.cardAiCamera,
                              style: c('highlight7'),
                              children: [
                                g.jsx('span', {
                                  className: Z.cardAccent,
                                  children: i('section2.aiCamera'),
                                }),
                                g.jsx('span', {
                                  className: Z.aiCameraDesc,
                                  children: i('section2.aiCameraDesc'),
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                    g.jsxs('div', {
                      className: Z.colRight,
                      children: [
                        g.jsxs('div', {
                          className: Z.cardHighSpeed,
                          style: c('highlight3'),
                          children: [
                            g.jsx('span', {
                              className: Z.cardTitle,
                              children: i('section2.highSpeed'),
                            }),
                            g.jsxs('div', {
                              className: Z.speedBlock,
                              children: [
                                g.jsx('span', {
                                  className: Z.upTo,
                                  children: i('section2.upTo'),
                                }),
                                g.jsxs('div', {
                                  className: Z.speedValue,
                                  children: [
                                    g.jsx('span', {
                                      className: Z.speedNum,
                                      children: i('section2.speedValue'),
                                    }),
                                    g.jsx('span', {
                                      className: Z.speedUnit,
                                      children: i('section2.speedUnit'),
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                        g.jsx('div', {
                          className: Z.cardAiExperience,
                          style: c('highlight8'),
                          children: g.jsxs('div', {
                            className: Z.aiExperienceTitle,
                            children: [
                              g.jsx('span', {
                                className: Z.cardAccent,
                                dangerouslySetInnerHTML: {
                                  __html: i('section2.aiPowered'),
                                },
                              }),
                              g.jsx('span', {
                                children: i('section2.smartExperience'),
                              }),
                            ],
                          }),
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            });
      }
      const Xy = 'section3_3pMMG',
        Qy = 'title_CtuPS',
        Zy = 'subtitle_GUihv',
        Wy = 'list_Zzaui',
        Fy = 'row_QLaCD',
        Jy = 'image_rYNaF',
        e1 = 'text_2Yr5g',
        Xa = {
          section3: Xy,
          title: Qy,
          subtitle: Zy,
          list: Wy,
          row: Fy,
          image: Jy,
          text: e1,
        },
        gm = ['scenario1', 'scenario2', 'scenario3', 'scenario4'];
      function t1() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = i('section3.scenarios', { returnObjects: !0 });
        return g.jsxs('section', {
          className: Xa.section3,
          children: [
            g.jsx('h2', {
              className: Xa.title,
              dangerouslySetInnerHTML: { __html: i('section3.title') },
            }),
            g.jsx('p', {
              className: Xa.subtitle,
              children: i('section3.subtitle'),
            }),
            g.jsx('div', {
              className: Xa.list,
              children: s.map((r, c) =>
                g.jsxs(
                  'div',
                  {
                    className: Xa.row,
                    style: { backgroundColor: r.bgColor },
                    'data-reverse': r.imagePosition === 'left',
                    children: [
                      r.imagePosition === 'left' &&
                        g.jsx('div', {
                          className: Xa.image,
                          style: { backgroundImage: `url(${l(gm[c])})` },
                        }),
                      g.jsxs('div', {
                        className: Xa.text,
                        children: [
                          g.jsx('h3', {
                            dangerouslySetInnerHTML: { __html: r.title },
                          }),
                          g.jsx('p', {
                            dangerouslySetInnerHTML: { __html: r.description },
                          }),
                        ],
                      }),
                      r.imagePosition === 'right' &&
                        g.jsx('div', {
                          className: Xa.image,
                          style: { backgroundImage: `url(${l(gm[c])})` },
                        }),
                    ],
                  },
                  c
                )
              ),
            }),
          ],
        });
      }
      const a1 = 'carousel_d4d-Z',
        i1 = 'media_EDrkO',
        n1 = 'mediaInner_QGqES',
        l1 = 'mediaAsset_5ZHYL',
        s1 = 'mediaPlaceholder_aqVTr',
        r1 = 'mediaNavBtn_oTUhn',
        o1 = 'mediaNavBtnPrev_N2wfT',
        c1 = 'mediaNavBtnNext_4yF5w',
        u1 = 'panel_-fB-g',
        d1 = 'sideBtn_HTiJq',
        f1 = 'sideBtnLeft_SGAE5',
        h1 = 'sidePill_lqANL',
        m1 = 'sidePlus_9gn2i',
        p1 = 'sideBtnRight_sioAq',
        g1 = 'sideBtnDisabled_W6t8H',
        b1 = 'card_HMZMb',
        v1 = 'cardTitle_rQcuU',
        y1 = 'cardDesc_Fl7Sn',
        ze = {
          carousel: a1,
          media: i1,
          mediaInner: n1,
          mediaAsset: l1,
          mediaPlaceholder: s1,
          mediaNavBtn: r1,
          mediaNavBtnPrev: o1,
          mediaNavBtnNext: c1,
          panel: u1,
          sideBtn: d1,
          sideBtnLeft: f1,
          sidePill: h1,
          sidePlus: m1,
          sideBtnRight: p1,
          sideBtnDisabled: g1,
          card: b1,
          cardTitle: v1,
          cardDesc: y1,
        };
      function bm(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function S1() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          [s, r] = Y.useState(0),
          c = Y.useRef(null),
          u = i('section4.easyUseTabs', { returnObjects: !0 }),
          h = u[s],
          m = bm(h?.video, l),
          f = bm(h?.image, l),
          p = s <= 0,
          y = s >= u.length - 1,
          S = () => {
            p || r(x => Math.max(0, x - 1));
          },
          w = () => {
            y || r(x => Math.min(u.length - 1, x + 1));
          };
        return (
          Y.useEffect(() => {
            const x = c.current;
            if (!x || !m) return;
            const T = requestAnimationFrame(() => {
              x.src !== m && ((x.src = m), x.load(), x.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(T);
          }, [m]),
          g.jsxs('div', {
            className: ze.carousel,
            children: [
              g.jsxs('div', {
                className: ze.media,
                children: [
                  g.jsx('div', {
                    className: ze.mediaInner,
                    children: m
                      ? g.jsx('video', {
                          ref: c,
                          className: ze.mediaAsset,
                          src: m,
                          autoPlay: !0,
                          loop: !0,
                          muted: !0,
                          playsInline: !0,
                        })
                      : f
                        ? g.jsx('div', {
                            className: ze.mediaAsset,
                            style: { backgroundImage: `url(${f})` },
                          })
                        : g.jsx('div', { className: ze.mediaPlaceholder }),
                  }),
                  g.jsx('button', {
                    type: 'button',
                    className: `${ze.mediaNavBtn} ${ze.mediaNavBtnPrev}`,
                    onClick: S,
                    disabled: p,
                    'aria-label': 'Previous slide',
                    children: g.jsx(it, { name: 'icon-left' }),
                  }),
                  g.jsx('button', {
                    type: 'button',
                    className: `${ze.mediaNavBtn} ${ze.mediaNavBtnNext}`,
                    onClick: w,
                    disabled: y,
                    'aria-label': 'Next slide',
                    children: g.jsx(it, { name: 'icon-More' }),
                  }),
                ],
              }),
              g.jsxs('div', {
                className: ze.panel,
                children: [
                  g.jsxs('button', {
                    type: 'button',
                    className: `${ze.sideBtn} ${ze.sideBtnLeft} ${p ? ze.sideBtnDisabled : ''}`,
                    onClick: S,
                    disabled: p,
                    'aria-label': 'Previous feature',
                    children: [
                      g.jsx('span', { className: ze.sidePill }),
                      g.jsx('span', {
                        className: ze.sidePlus,
                        'aria-hidden': 'true',
                      }),
                    ],
                  }),
                  g.jsxs('div', {
                    className: ze.card,
                    children: [
                      g.jsx('h3', {
                        className: ze.cardTitle,
                        dangerouslySetInnerHTML: { __html: h.title },
                      }),
                      g.jsx('p', {
                        className: ze.cardDesc,
                        dangerouslySetInnerHTML: { __html: h.description },
                      }),
                    ],
                  }),
                  g.jsxs('button', {
                    type: 'button',
                    className: `${ze.sideBtn} ${ze.sideBtnRight} ${y ? ze.sideBtnDisabled : ''}`,
                    onClick: w,
                    disabled: y,
                    'aria-label': 'Next feature',
                    children: [
                      g.jsx('span', { className: ze.sidePill }),
                      g.jsx('span', {
                        className: ze.sidePlus,
                        'aria-hidden': 'true',
                      }),
                    ],
                  }),
                ],
              }),
            ],
          })
        );
      }
      const x1 = 'section4_PMrR1',
        T1 = 'title_Yqf9h',
        w1 = 'subtitle_mTLP-',
        E1 = 'content_NrON5',
        N1 = 'features_R6-a9',
        _1 = 'tabItem_BK1BO',
        A1 = 'tabCollapsed_JBrk9',
        M1 = 'plus_Qj2uP',
        j1 = 'tabContent_moWIa',
        C1 = 'tabActive_N-Q--',
        O1 = 'tabTitle_nod0-',
        B1 = 'tabDesc_lDmbx',
        R1 = 'tabDescWrap_BEDxQ',
        D1 = 'tabDescOpen_biW0j',
        L1 = 'plusHidden_LxRBq',
        z1 = 'image_aQwz-',
        H1 = 'imageBg_XRmKR',
        U1 = 'imagePlaceholder_ZtCOa',
        I1 = 'video_EtrPo',
        G1 = 'playPauseBtn_91jGT',
        V1 = 'pauseIcon_-Fu3G',
        k1 = 'playIcon_Exiqw',
        $e = {
          section4: x1,
          title: T1,
          subtitle: w1,
          content: E1,
          features: N1,
          tabItem: _1,
          tabCollapsed: A1,
          plus: M1,
          tabContent: j1,
          tabActive: C1,
          tabTitle: O1,
          tabDesc: B1,
          tabDescWrap: R1,
          tabDescOpen: D1,
          plusHidden: L1,
          image: z1,
          imageBg: H1,
          imagePlaceholder: U1,
          video: I1,
          playPauseBtn: G1,
          pauseIcon: V1,
          playIcon: k1,
        };
      function Ls(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function vc(i, l = 3e3) {
        return typeof window.requestIdleCallback == 'function'
          ? window.requestIdleCallback(i, { timeout: l })
          : window.setTimeout(i, 1500);
      }
      function $1(i) {
        if (typeof window.cancelIdleCallback == 'function') {
          window.cancelIdleCallback(i);
          return;
        }
        window.clearTimeout(i);
      }
      function q1(i) {
        const l = document.createElement('video');
        ((l.preload = 'auto'), (l.muted = !0), (l.src = i), l.load());
      }
      function P1(i) {
        const l = new Image();
        l.src = i;
      }
      function Y1() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          [r, c] = Y.useState(0),
          [u, h] = Y.useState(!0),
          m = Y.useRef(null),
          f = Y.useRef(new Set()),
          p = i('section4.easyUseTabs', { returnObjects: !0 }),
          y = p[r],
          S = Ls(y?.video, l),
          w = Ls(y?.image, l);
        (Y.useEffect(() => {
          h(!0);
        }, [r, S]),
          Y.useEffect(() => {
            const T = m.current;
            if (!T || !S) return;
            const A = requestAnimationFrame(() => {
              T.src !== S && ((T.src = S), T.load(), T.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(A);
          }, [S]),
          Y.useEffect(() => {
            const T = S || w,
              A = p.flatMap(H => {
                const $ = Ls(H.video, l),
                  D = Ls(H.image, l);
                return [
                  $ && $ !== T ? { url: $, type: 'video' } : null,
                  D && D !== T ? { url: D, type: 'image' } : null,
                ].filter(Boolean);
              });
            let j = !1,
              G;
            const L = H => {
              if (j || H >= A.length) return;
              const $ = A[H];
              if (!$ || f.current.has($.url)) {
                G = vc(() => L(H + 1));
                return;
              }
              (f.current.add($.url),
                $.type === 'video' ? q1($.url) : P1($.url),
                (G = vc(() => L(H + 1))));
            };
            return (
              (G = vc(() => L(0))),
              () => {
                ((j = !0), G !== void 0 && $1(G));
              }
            );
          }, [p, S, w, l]));
        const x = () => {
          const T = m.current;
          if (T) {
            if (T.paused) {
              (T.play(), h(!0));
              return;
            }
            (T.pause(), h(!1));
          }
        };
        return g.jsxs('section', {
          className: $e.section4,
          children: [
            g.jsx('h2', { className: $e.title, children: i('section4.title') }),
            g.jsx('p', {
              className: $e.subtitle,
              children: i('section4.subtitle'),
            }),
            s
              ? g.jsx(S1, {})
              : g.jsxs('div', {
                  className: $e.content,
                  children: [
                    g.jsx('div', {
                      className: $e.features,
                      children: p.map((T, A) => {
                        const j = r === A;
                        return g.jsxs(
                          'button',
                          {
                            type: 'button',
                            className: `${$e.tabItem} ${j ? $e.tabActive : $e.tabCollapsed}`,
                            onClick: () => c(A),
                            children: [
                              g.jsx('span', {
                                className: `${$e.plus} ${j ? $e.plusHidden : ''}`,
                                'aria-hidden': 'true',
                              }),
                              g.jsxs('div', {
                                className: $e.tabContent,
                                children: [
                                  g.jsx('h3', {
                                    className: $e.tabTitle,
                                    dangerouslySetInnerHTML: {
                                      __html: T.title,
                                    },
                                  }),
                                  g.jsx('div', {
                                    className: `${$e.tabDescWrap} ${j ? $e.tabDescOpen : ''}`,
                                    children: g.jsx('p', {
                                      className: $e.tabDesc,
                                      dangerouslySetInnerHTML: {
                                        __html: T.description,
                                      },
                                    }),
                                  }),
                                ],
                              }),
                            ],
                          },
                          T.title
                        );
                      }),
                    }),
                    g.jsx('div', {
                      className: $e.image,
                      children: S
                        ? g.jsxs(g.Fragment, {
                            children: [
                              g.jsx('video', {
                                ref: m,
                                className: $e.video,
                                src: S,
                                autoPlay: !0,
                                loop: !0,
                                muted: !0,
                                playsInline: !0,
                              }),
                              g.jsx('button', {
                                type: 'button',
                                className: $e.playPauseBtn,
                                onClick: x,
                                'aria-label': u ? 'Pause video' : 'Play video',
                                children: u
                                  ? g.jsx('span', {
                                      className: $e.pauseIcon,
                                      'aria-hidden': 'true',
                                    })
                                  : g.jsx('span', {
                                      className: $e.playIcon,
                                      'aria-hidden': 'true',
                                    }),
                              }),
                            ],
                          })
                        : w
                          ? g.jsx('div', {
                              className: $e.imageBg,
                              style: { backgroundImage: `url(${w})` },
                            })
                          : g.jsx('div', { className: $e.imagePlaceholder }),
                    }),
                  ],
                }),
          ],
        });
      }
      function vm(i) {
        return (
          i !== null &&
          typeof i == 'object' &&
          'constructor' in i &&
          i.constructor === Object
        );
      }
      function Ic(i = {}, l = {}) {
        const s = ['__proto__', 'constructor', 'prototype'];
        Object.keys(l)
          .filter(r => s.indexOf(r) < 0)
          .forEach(r => {
            typeof i[r] > 'u'
              ? (i[r] = l[r])
              : vm(l[r]) &&
                vm(i[r]) &&
                Object.keys(l[r]).length > 0 &&
                Ic(i[r], l[r]);
          });
      }
      const km = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: '' },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() {} };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
      };
      function xi() {
        const i = typeof document < 'u' ? document : {};
        return (Ic(i, km), i);
      }
      const K1 = {
        document: km,
        navigator: { userAgent: '' },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle() {
          return {
            getPropertyValue() {
              return '';
            },
          };
        },
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia() {
          return {};
        },
        requestAnimationFrame(i) {
          return typeof setTimeout > 'u' ? (i(), null) : setTimeout(i, 0);
        },
        cancelAnimationFrame(i) {
          typeof setTimeout > 'u' || clearTimeout(i);
        },
      };
      function ht() {
        const i = typeof window < 'u' ? window : {};
        return (Ic(i, K1), i);
      }
      function X1(i = '') {
        return i
          .trim()
          .split(' ')
          .filter(l => !!l.trim());
      }
      function Q1(i) {
        const l = i;
        Object.keys(l).forEach(s => {
          try {
            l[s] = null;
          } catch {}
          try {
            delete l[s];
          } catch {}
        });
      }
      function $m(i, l = 0) {
        return setTimeout(i, l);
      }
      function ks() {
        return Date.now();
      }
      function Z1(i) {
        const l = ht();
        let s;
        return (
          l.getComputedStyle && (s = l.getComputedStyle(i, null)),
          !s && i.currentStyle && (s = i.currentStyle),
          s || (s = i.style),
          s
        );
      }
      function W1(i, l = 'x') {
        const s = ht();
        let r, c, u;
        const h = Z1(i);
        return (
          s.WebKitCSSMatrix
            ? ((c = h.transform || h.webkitTransform),
              c.split(',').length > 6 &&
                (c = c
                  .split(', ')
                  .map(m => m.replace(',', '.'))
                  .join(', ')),
              (u = new s.WebKitCSSMatrix(c === 'none' ? '' : c)))
            : ((u =
                h.MozTransform ||
                h.OTransform ||
                h.MsTransform ||
                h.msTransform ||
                h.transform ||
                h
                  .getPropertyValue('transform')
                  .replace('translate(', 'matrix(1, 0, 0, 1,')),
              (r = u.toString().split(','))),
          l === 'x' &&
            (s.WebKitCSSMatrix
              ? (c = u.m41)
              : r.length === 16
                ? (c = parseFloat(r[12]))
                : (c = parseFloat(r[4]))),
          l === 'y' &&
            (s.WebKitCSSMatrix
              ? (c = u.m42)
              : r.length === 16
                ? (c = parseFloat(r[13]))
                : (c = parseFloat(r[5]))),
          c || 0
        );
      }
      function zs(i) {
        return (
          typeof i == 'object' &&
          i !== null &&
          i.constructor &&
          Object.prototype.toString.call(i).slice(8, -1) === 'Object'
        );
      }
      function F1(i) {
        return typeof window < 'u' && typeof window.HTMLElement < 'u'
          ? i instanceof HTMLElement
          : i && (i.nodeType === 1 || i.nodeType === 11);
      }
      function Lt(...i) {
        const l = Object(i[0]),
          s = ['__proto__', 'constructor', 'prototype'];
        for (let r = 1; r < i.length; r += 1) {
          const c = i[r];
          if (c != null && !F1(c)) {
            const u = Object.keys(Object(c)).filter(h => s.indexOf(h) < 0);
            for (let h = 0, m = u.length; h < m; h += 1) {
              const f = u[h],
                p = Object.getOwnPropertyDescriptor(c, f);
              p !== void 0 &&
                p.enumerable &&
                (zs(l[f]) && zs(c[f])
                  ? c[f].__swiper__
                    ? (l[f] = c[f])
                    : Lt(l[f], c[f])
                  : !zs(l[f]) && zs(c[f])
                    ? ((l[f] = {}),
                      c[f].__swiper__ ? (l[f] = c[f]) : Lt(l[f], c[f]))
                    : (l[f] = c[f]));
            }
          }
        }
        return l;
      }
      function Hs(i, l, s) {
        i.style.setProperty(l, s);
      }
      function qm({ swiper: i, targetPosition: l, side: s }) {
        const r = ht(),
          c = -i.translate;
        let u = null,
          h;
        const m = i.params.speed;
        ((i.wrapperEl.style.scrollSnapType = 'none'),
          r.cancelAnimationFrame(i.cssModeFrameID));
        const f = l > c ? 'next' : 'prev',
          p = (S, w) => (f === 'next' && S >= w) || (f === 'prev' && S <= w),
          y = () => {
            ((h = new Date().getTime()), u === null && (u = h));
            const S = Math.max(Math.min((h - u) / m, 1), 0),
              w = 0.5 - Math.cos(S * Math.PI) / 2;
            let x = c + w * (l - c);
            if (
              (p(x, l) && (x = l), i.wrapperEl.scrollTo({ [s]: x }), p(x, l))
            ) {
              ((i.wrapperEl.style.overflow = 'hidden'),
                (i.wrapperEl.style.scrollSnapType = ''),
                setTimeout(() => {
                  ((i.wrapperEl.style.overflow = ''),
                    i.wrapperEl.scrollTo({ [s]: x }));
                }),
                r.cancelAnimationFrame(i.cssModeFrameID));
              return;
            }
            i.cssModeFrameID = r.requestAnimationFrame(y);
          };
        y();
      }
      function na(i, l = '') {
        const s = ht(),
          r = [...i.children];
        return (
          s.HTMLSlotElement &&
            i instanceof HTMLSlotElement &&
            r.push(...i.assignedElements()),
          l ? r.filter(c => c.matches(l)) : r
        );
      }
      function J1(i, l) {
        const s = [l];
        for (; s.length > 0; ) {
          const r = s.shift();
          if (i === r) return !0;
          s.push(
            ...r.children,
            ...(r.shadowRoot ? r.shadowRoot.children : []),
            ...(r.assignedElements ? r.assignedElements() : [])
          );
        }
      }
      function e0(i, l) {
        const s = ht();
        let r = l.contains(i);
        return (
          !r &&
            s.HTMLSlotElement &&
            l instanceof HTMLSlotElement &&
            ((r = [...l.assignedElements()].includes(i)), r || (r = J1(i, l))),
          r
        );
      }
      function $s(i) {
        try {
          console.warn(i);
          return;
        } catch {}
      }
      function qs(i, l = []) {
        const s = document.createElement(i);
        return (s.classList.add(...(Array.isArray(l) ? l : X1(l))), s);
      }
      function t0(i, l) {
        const s = [];
        for (; i.previousElementSibling; ) {
          const r = i.previousElementSibling;
          (l ? r.matches(l) && s.push(r) : s.push(r), (i = r));
        }
        return s;
      }
      function a0(i, l) {
        const s = [];
        for (; i.nextElementSibling; ) {
          const r = i.nextElementSibling;
          (l ? r.matches(l) && s.push(r) : s.push(r), (i = r));
        }
        return s;
      }
      function Za(i, l) {
        return ht().getComputedStyle(i, null).getPropertyValue(l);
      }
      function ym(i) {
        let l = i,
          s;
        if (l) {
          for (s = 0; (l = l.previousSibling) !== null; )
            l.nodeType === 1 && (s += 1);
          return s;
        }
      }
      function i0(i, l) {
        const s = [];
        let r = i.parentElement;
        for (; r; ) (s.push(r), (r = r.parentElement));
        return s;
      }
      function Sm(i, l, s) {
        const r = ht();
        return (
          i[l === 'width' ? 'offsetWidth' : 'offsetHeight'] +
          parseFloat(
            r
              .getComputedStyle(i, null)
              .getPropertyValue(l === 'width' ? 'margin-right' : 'margin-top')
          ) +
          parseFloat(
            r
              .getComputedStyle(i, null)
              .getPropertyValue(l === 'width' ? 'margin-left' : 'margin-bottom')
          )
        );
      }
      function Sa(i) {
        return (Array.isArray(i) ? i : [i]).filter(l => !!l);
      }
      function Lc(i, l = '') {
        typeof trustedTypes < 'u'
          ? (i.innerHTML = trustedTypes
              .createPolicy('html', { createHTML: s => s })
              .createHTML(l))
          : (i.innerHTML = l);
      }
      let yc;
      function n0() {
        const i = ht(),
          l = xi();
        return {
          smoothScroll:
            l.documentElement &&
            l.documentElement.style &&
            'scrollBehavior' in l.documentElement.style,
          touch: !!(
            'ontouchstart' in i ||
            (i.DocumentTouch && l instanceof i.DocumentTouch)
          ),
        };
      }
      function Pm() {
        return (yc || (yc = n0()), yc);
      }
      let Sc;
      function l0({ userAgent: i } = {}) {
        const l = Pm(),
          s = ht(),
          r = s.navigator.platform,
          c = i || s.navigator.userAgent,
          u = { ios: !1, android: !1 },
          h = s.screen.width,
          m = s.screen.height,
          f = c.match(/(Android);?[\s\/]+([\d.]+)?/);
        let p = c.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
        const y = c.match(/(iPod)(.*OS\s([\d_]+))?/),
          S = !p && c.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
          w = r === 'Win32';
        let x = r === 'MacIntel';
        const T = [
          '1024x1366',
          '1366x1024',
          '834x1194',
          '1194x834',
          '834x1112',
          '1112x834',
          '768x1024',
          '1024x768',
          '820x1180',
          '1180x820',
          '810x1080',
          '1080x810',
        ];
        return (
          !p &&
            x &&
            l.touch &&
            T.indexOf(`${h}x${m}`) >= 0 &&
            ((p = c.match(/(Version)\/([\d.]+)/)),
            p || (p = [0, 1, '13_0_0']),
            (x = !1)),
          f && !w && ((u.os = 'android'), (u.android = !0)),
          (p || S || y) && ((u.os = 'ios'), (u.ios = !0)),
          u
        );
      }
      function Ym(i = {}) {
        return (Sc || (Sc = l0(i)), Sc);
      }
      let xc;
      function s0() {
        const i = ht(),
          l = Ym();
        let s = !1;
        function r() {
          const m = i.navigator.userAgent.toLowerCase();
          return (
            m.indexOf('safari') >= 0 &&
            m.indexOf('chrome') < 0 &&
            m.indexOf('android') < 0
          );
        }
        if (r()) {
          const m = String(i.navigator.userAgent);
          if (m.includes('Version/')) {
            const [f, p] = m
              .split('Version/')[1]
              .split(' ')[0]
              .split('.')
              .map(y => Number(y));
            s = f < 16 || (f === 16 && p < 2);
          }
        }
        const c = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            i.navigator.userAgent
          ),
          u = r(),
          h = u || (c && l.ios);
        return {
          isSafari: s || u,
          needPerspectiveFix: s,
          need3dFix: h,
          isWebView: c,
        };
      }
      function Km() {
        return (xc || (xc = s0()), xc);
      }
      function r0({ swiper: i, on: l, emit: s }) {
        const r = ht();
        let c = null,
          u = null;
        const h = () => {
            !i ||
              i.destroyed ||
              !i.initialized ||
              (s('beforeResize'), s('resize'));
          },
          m = () => {
            !i ||
              i.destroyed ||
              !i.initialized ||
              ((c = new ResizeObserver(y => {
                u = r.requestAnimationFrame(() => {
                  const { width: S, height: w } = i;
                  let x = S,
                    T = w;
                  (y.forEach(
                    ({ contentBoxSize: A, contentRect: j, target: G }) => {
                      (G && G !== i.el) ||
                        ((x = j ? j.width : (A[0] || A).inlineSize),
                        (T = j ? j.height : (A[0] || A).blockSize));
                    }
                  ),
                    (x !== S || T !== w) && h());
                });
              })),
              c.observe(i.el));
          },
          f = () => {
            (u && r.cancelAnimationFrame(u),
              c && c.unobserve && i.el && (c.unobserve(i.el), (c = null)));
          },
          p = () => {
            !i || i.destroyed || !i.initialized || s('orientationchange');
          };
        (l('init', () => {
          if (i.params.resizeObserver && typeof r.ResizeObserver < 'u') {
            m();
            return;
          }
          (r.addEventListener('resize', h),
            r.addEventListener('orientationchange', p));
        }),
          l('destroy', () => {
            (f(),
              r.removeEventListener('resize', h),
              r.removeEventListener('orientationchange', p));
          }));
      }
      function o0({ swiper: i, extendParams: l, on: s, emit: r }) {
        const c = [],
          u = ht(),
          h = (p, y = {}) => {
            const S = u.MutationObserver || u.WebkitMutationObserver,
              w = new S(x => {
                if (i.__preventObserver__) return;
                if (x.length === 1) {
                  r('observerUpdate', x[0]);
                  return;
                }
                const T = function () {
                  r('observerUpdate', x[0]);
                };
                u.requestAnimationFrame
                  ? u.requestAnimationFrame(T)
                  : u.setTimeout(T, 0);
              });
            (w.observe(p, {
              attributes: typeof y.attributes > 'u' ? !0 : y.attributes,
              childList:
                i.isElement || (typeof y.childList > 'u' ? !0 : y).childList,
              characterData:
                typeof y.characterData > 'u' ? !0 : y.characterData,
            }),
              c.push(w));
          },
          m = () => {
            if (i.params.observer) {
              if (i.params.observeParents) {
                const p = i0(i.hostEl);
                for (let y = 0; y < p.length; y += 1) h(p[y]);
              }
              (h(i.hostEl, { childList: i.params.observeSlideChildren }),
                h(i.wrapperEl, { attributes: !1 }));
            }
          },
          f = () => {
            (c.forEach(p => {
              p.disconnect();
            }),
              c.splice(0, c.length));
          };
        (l({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          s('init', m),
          s('destroy', f));
      }
      var c0 = {
        on(i, l, s) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof l != 'function')
            return r;
          const c = s ? 'unshift' : 'push';
          return (
            i.split(' ').forEach(u => {
              (r.eventsListeners[u] || (r.eventsListeners[u] = []),
                r.eventsListeners[u][c](l));
            }),
            r
          );
        },
        once(i, l, s) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof l != 'function')
            return r;
          function c(...u) {
            (r.off(i, c),
              c.__emitterProxy && delete c.__emitterProxy,
              l.apply(r, u));
          }
          return ((c.__emitterProxy = l), r.on(i, c, s));
        },
        onAny(i, l) {
          const s = this;
          if (!s.eventsListeners || s.destroyed || typeof i != 'function')
            return s;
          const r = l ? 'unshift' : 'push';
          return (
            s.eventsAnyListeners.indexOf(i) < 0 && s.eventsAnyListeners[r](i),
            s
          );
        },
        offAny(i) {
          const l = this;
          if (!l.eventsListeners || l.destroyed || !l.eventsAnyListeners)
            return l;
          const s = l.eventsAnyListeners.indexOf(i);
          return (s >= 0 && l.eventsAnyListeners.splice(s, 1), l);
        },
        off(i, l) {
          const s = this;
          return (
            !s.eventsListeners ||
              s.destroyed ||
              !s.eventsListeners ||
              i.split(' ').forEach(r => {
                typeof l > 'u'
                  ? (s.eventsListeners[r] = [])
                  : s.eventsListeners[r] &&
                    s.eventsListeners[r].forEach((c, u) => {
                      (c === l ||
                        (c.__emitterProxy && c.__emitterProxy === l)) &&
                        s.eventsListeners[r].splice(u, 1);
                    });
              }),
            s
          );
        },
        emit(...i) {
          const l = this;
          if (!l.eventsListeners || l.destroyed || !l.eventsListeners) return l;
          let s, r, c;
          return (
            typeof i[0] == 'string' || Array.isArray(i[0])
              ? ((s = i[0]), (r = i.slice(1, i.length)), (c = l))
              : ((s = i[0].events), (r = i[0].data), (c = i[0].context || l)),
            r.unshift(c),
            (Array.isArray(s) ? s : s.split(' ')).forEach(h => {
              (l.eventsAnyListeners &&
                l.eventsAnyListeners.length &&
                l.eventsAnyListeners.forEach(m => {
                  m.apply(c, [h, ...r]);
                }),
                l.eventsListeners &&
                  l.eventsListeners[h] &&
                  l.eventsListeners[h].forEach(m => {
                    m.apply(c, r);
                  }));
            }),
            l
          );
        },
      };
      function u0() {
        const i = this;
        let l, s;
        const r = i.el;
        (typeof i.params.width < 'u' && i.params.width !== null
          ? (l = i.params.width)
          : (l = r.clientWidth),
          typeof i.params.height < 'u' && i.params.height !== null
            ? (s = i.params.height)
            : (s = r.clientHeight),
          !((l === 0 && i.isHorizontal()) || (s === 0 && i.isVertical())) &&
            ((l =
              l -
              parseInt(Za(r, 'padding-left') || 0, 10) -
              parseInt(Za(r, 'padding-right') || 0, 10)),
            (s =
              s -
              parseInt(Za(r, 'padding-top') || 0, 10) -
              parseInt(Za(r, 'padding-bottom') || 0, 10)),
            Number.isNaN(l) && (l = 0),
            Number.isNaN(s) && (s = 0),
            Object.assign(i, {
              width: l,
              height: s,
              size: i.isHorizontal() ? l : s,
            })));
      }
      function d0() {
        const i = this;
        function l(F, W) {
          return parseFloat(F.getPropertyValue(i.getDirectionLabel(W)) || 0);
        }
        const s = i.params,
          { wrapperEl: r, slidesEl: c, rtlTranslate: u, wrongRTL: h } = i,
          m = i.virtual && s.virtual.enabled,
          f = m ? i.virtual.slides.length : i.slides.length,
          p = na(c, `.${i.params.slideClass}, swiper-slide`),
          y = m ? i.virtual.slides.length : p.length;
        let S = [];
        const w = [],
          x = [];
        let T = s.slidesOffsetBefore;
        typeof T == 'function' && (T = s.slidesOffsetBefore.call(i));
        let A = s.slidesOffsetAfter;
        typeof A == 'function' && (A = s.slidesOffsetAfter.call(i));
        const j = i.snapGrid.length,
          G = i.slidesGrid.length,
          L = i.size - T - A;
        let H = s.spaceBetween,
          $ = -T,
          D = 0,
          U = 0;
        if (typeof L > 'u') return;
        (typeof H == 'string' && H.indexOf('%') >= 0
          ? (H = (parseFloat(H.replace('%', '')) / 100) * L)
          : typeof H == 'string' && (H = parseFloat(H)),
          (i.virtualSize = -H - T - A),
          p.forEach(F => {
            (u ? (F.style.marginLeft = '') : (F.style.marginRight = ''),
              (F.style.marginBottom = ''),
              (F.style.marginTop = ''));
          }),
          s.centeredSlides &&
            s.cssMode &&
            (Hs(r, '--swiper-centered-offset-before', ''),
            Hs(r, '--swiper-centered-offset-after', '')));
        const X = s.grid && s.grid.rows > 1 && i.grid;
        X ? i.grid.initSlides(p) : i.grid && i.grid.unsetSlides();
        let q;
        const se =
          s.slidesPerView === 'auto' &&
          s.breakpoints &&
          Object.keys(s.breakpoints).filter(
            F => typeof s.breakpoints[F].slidesPerView < 'u'
          ).length > 0;
        for (let F = 0; F < y; F += 1) {
          q = 0;
          const W = p[F];
          if (
            !(
              W &&
              (X && i.grid.updateSlide(F, W, p), Za(W, 'display') === 'none')
            )
          ) {
            if (m && s.slidesPerView === 'auto')
              (s.virtual.slidesPerViewAutoSlideSize &&
                (q = s.virtual.slidesPerViewAutoSlideSize),
                q &&
                  W &&
                  (s.roundLengths && (q = Math.floor(q)),
                  (W.style[i.getDirectionLabel('width')] = `${q}px`)));
            else if (s.slidesPerView === 'auto') {
              se && (W.style[i.getDirectionLabel('width')] = '');
              const ae = getComputedStyle(W),
                ye = W.style.transform,
                Se = W.style.webkitTransform;
              if (
                (ye && (W.style.transform = 'none'),
                Se && (W.style.webkitTransform = 'none'),
                s.roundLengths)
              )
                q = i.isHorizontal() ? Sm(W, 'width') : Sm(W, 'height');
              else {
                const Ne = l(ae, 'width'),
                  z = l(ae, 'padding-left'),
                  Q = l(ae, 'padding-right'),
                  K = l(ae, 'margin-left'),
                  ie = l(ae, 'margin-right'),
                  N = ae.getPropertyValue('box-sizing');
                if (N && N === 'border-box') q = Ne + K + ie;
                else {
                  const { clientWidth: I, offsetWidth: ee } = W;
                  q = Ne + z + Q + K + ie + (ee - I);
                }
              }
              (ye && (W.style.transform = ye),
                Se && (W.style.webkitTransform = Se),
                s.roundLengths && (q = Math.floor(q)));
            } else
              ((q = (L - (s.slidesPerView - 1) * H) / s.slidesPerView),
                s.roundLengths && (q = Math.floor(q)),
                W && (W.style[i.getDirectionLabel('width')] = `${q}px`));
            (W && (W.swiperSlideSize = q),
              x.push(q),
              s.centeredSlides
                ? (($ = $ + q / 2 + D / 2 + H),
                  D === 0 && F !== 0 && ($ = $ - L / 2 - H),
                  F === 0 && ($ = $ - L / 2 - H),
                  Math.abs($) < 1 / 1e3 && ($ = 0),
                  s.roundLengths && ($ = Math.floor($)),
                  U % s.slidesPerGroup === 0 && S.push($),
                  w.push($))
                : (s.roundLengths && ($ = Math.floor($)),
                  (U - Math.min(i.params.slidesPerGroupSkip, U)) %
                    i.params.slidesPerGroup ===
                    0 && S.push($),
                  w.push($),
                  ($ = $ + q + H)),
              (i.virtualSize += q + H),
              (D = q),
              (U += 1));
          }
        }
        if (
          ((i.virtualSize = Math.max(i.virtualSize, L) + A),
          u &&
            h &&
            (s.effect === 'slide' || s.effect === 'coverflow') &&
            (r.style.width = `${i.virtualSize + H}px`),
          s.setWrapperSize &&
            (r.style[i.getDirectionLabel('width')] = `${i.virtualSize + H}px`),
          X && i.grid.updateWrapperSize(q, S),
          !s.centeredSlides)
        ) {
          const F = [];
          for (let W = 0; W < S.length; W += 1) {
            let ae = S[W];
            (s.roundLengths && (ae = Math.floor(ae)),
              S[W] <= i.virtualSize - L && F.push(ae));
          }
          ((S = F),
            Math.floor(i.virtualSize - L) - Math.floor(S[S.length - 1]) > 1 &&
              S.push(i.virtualSize - L));
        }
        if (m && s.loop) {
          const F = x[0] + H;
          if (s.slidesPerGroup > 1) {
            const W = Math.ceil(
                (i.virtual.slidesBefore + i.virtual.slidesAfter) /
                  s.slidesPerGroup
              ),
              ae = F * s.slidesPerGroup;
            for (let ye = 0; ye < W; ye += 1) S.push(S[S.length - 1] + ae);
          }
          for (
            let W = 0;
            W < i.virtual.slidesBefore + i.virtual.slidesAfter;
            W += 1
          )
            (s.slidesPerGroup === 1 && S.push(S[S.length - 1] + F),
              w.push(w[w.length - 1] + F),
              (i.virtualSize += F));
        }
        if ((S.length === 0 && (S = [0]), H !== 0)) {
          const F =
            i.isHorizontal() && u
              ? 'marginLeft'
              : i.getDirectionLabel('marginRight');
          p.filter((W, ae) =>
            !s.cssMode || s.loop ? !0 : ae !== p.length - 1
          ).forEach(W => {
            W.style[F] = `${H}px`;
          });
        }
        if (s.centeredSlides && s.centeredSlidesBounds) {
          let F = 0;
          (x.forEach(ae => {
            F += ae + (H || 0);
          }),
            (F -= H));
          const W = F > L ? F - L : 0;
          S = S.map(ae => (ae <= 0 ? -T : ae > W ? W + A : ae));
        }
        if (s.centerInsufficientSlides) {
          let F = 0;
          (x.forEach(ae => {
            F += ae + (H || 0);
          }),
            (F -= H));
          const W = (T || 0) + (A || 0);
          if (F + W < L) {
            const ae = (L - F - W) / 2;
            (S.forEach((ye, Se) => {
              S[Se] = ye - ae;
            }),
              w.forEach((ye, Se) => {
                w[Se] = ye + ae;
              }));
          }
        }
        if (
          (Object.assign(i, {
            slides: p,
            snapGrid: S,
            slidesGrid: w,
            slidesSizesGrid: x,
          }),
          s.centeredSlides && s.cssMode && !s.centeredSlidesBounds)
        ) {
          (Hs(r, '--swiper-centered-offset-before', `${-S[0]}px`),
            Hs(
              r,
              '--swiper-centered-offset-after',
              `${i.size / 2 - x[x.length - 1] / 2}px`
            ));
          const F = -i.snapGrid[0],
            W = -i.slidesGrid[0];
          ((i.snapGrid = i.snapGrid.map(ae => ae + F)),
            (i.slidesGrid = i.slidesGrid.map(ae => ae + W)));
        }
        if (
          (y !== f && i.emit('slidesLengthChange'),
          S.length !== j &&
            (i.params.watchOverflow && i.checkOverflow(),
            i.emit('snapGridLengthChange')),
          w.length !== G && i.emit('slidesGridLengthChange'),
          s.watchSlidesProgress && i.updateSlidesOffset(),
          i.emit('slidesUpdated'),
          !m && !s.cssMode && (s.effect === 'slide' || s.effect === 'fade'))
        ) {
          const F = `${s.containerModifierClass}backface-hidden`,
            W = i.el.classList.contains(F);
          y <= s.maxBackfaceHiddenSlides
            ? W || i.el.classList.add(F)
            : W && i.el.classList.remove(F);
        }
      }
      function f0(i) {
        const l = this,
          s = [],
          r = l.virtual && l.params.virtual.enabled;
        let c = 0,
          u;
        typeof i == 'number'
          ? l.setTransition(i)
          : i === !0 && l.setTransition(l.params.speed);
        const h = m => (r ? l.slides[l.getSlideIndexByData(m)] : l.slides[m]);
        if (l.params.slidesPerView !== 'auto' && l.params.slidesPerView > 1)
          if (l.params.centeredSlides)
            (l.visibleSlides || []).forEach(m => {
              s.push(m);
            });
          else
            for (u = 0; u < Math.ceil(l.params.slidesPerView); u += 1) {
              const m = l.activeIndex + u;
              if (m > l.slides.length && !r) break;
              s.push(h(m));
            }
        else s.push(h(l.activeIndex));
        for (u = 0; u < s.length; u += 1)
          if (typeof s[u] < 'u') {
            const m = s[u].offsetHeight;
            c = m > c ? m : c;
          }
        (c || c === 0) && (l.wrapperEl.style.height = `${c}px`);
      }
      function h0() {
        const i = this,
          l = i.slides,
          s = i.isElement
            ? i.isHorizontal()
              ? i.wrapperEl.offsetLeft
              : i.wrapperEl.offsetTop
            : 0;
        for (let r = 0; r < l.length; r += 1)
          l[r].swiperSlideOffset =
            (i.isHorizontal() ? l[r].offsetLeft : l[r].offsetTop) -
            s -
            i.cssOverflowAdjustment();
      }
      const xm = (i, l, s) => {
        l && !i.classList.contains(s)
          ? i.classList.add(s)
          : !l && i.classList.contains(s) && i.classList.remove(s);
      };
      function m0(i = (this && this.translate) || 0) {
        const l = this,
          s = l.params,
          { slides: r, rtlTranslate: c, snapGrid: u } = l;
        if (r.length === 0) return;
        typeof r[0].swiperSlideOffset > 'u' && l.updateSlidesOffset();
        let h = -i;
        (c && (h = i), (l.visibleSlidesIndexes = []), (l.visibleSlides = []));
        let m = s.spaceBetween;
        typeof m == 'string' && m.indexOf('%') >= 0
          ? (m = (parseFloat(m.replace('%', '')) / 100) * l.size)
          : typeof m == 'string' && (m = parseFloat(m));
        for (let f = 0; f < r.length; f += 1) {
          const p = r[f];
          let y = p.swiperSlideOffset;
          s.cssMode && s.centeredSlides && (y -= r[0].swiperSlideOffset);
          const S =
              (h + (s.centeredSlides ? l.minTranslate() : 0) - y) /
              (p.swiperSlideSize + m),
            w =
              (h - u[0] + (s.centeredSlides ? l.minTranslate() : 0) - y) /
              (p.swiperSlideSize + m),
            x = -(h - y),
            T = x + l.slidesSizesGrid[f],
            A = x >= 0 && x <= l.size - l.slidesSizesGrid[f],
            j =
              (x >= 0 && x < l.size - 1) ||
              (T > 1 && T <= l.size) ||
              (x <= 0 && T >= l.size);
          (j && (l.visibleSlides.push(p), l.visibleSlidesIndexes.push(f)),
            xm(p, j, s.slideVisibleClass),
            xm(p, A, s.slideFullyVisibleClass),
            (p.progress = c ? -S : S),
            (p.originalProgress = c ? -w : w));
        }
      }
      function p0(i) {
        const l = this;
        if (typeof i > 'u') {
          const y = l.rtlTranslate ? -1 : 1;
          i = (l && l.translate && l.translate * y) || 0;
        }
        const s = l.params,
          r = l.maxTranslate() - l.minTranslate();
        let { progress: c, isBeginning: u, isEnd: h, progressLoop: m } = l;
        const f = u,
          p = h;
        if (r === 0) ((c = 0), (u = !0), (h = !0));
        else {
          c = (i - l.minTranslate()) / r;
          const y = Math.abs(i - l.minTranslate()) < 1,
            S = Math.abs(i - l.maxTranslate()) < 1;
          ((u = y || c <= 0), (h = S || c >= 1), y && (c = 0), S && (c = 1));
        }
        if (s.loop) {
          const y = l.getSlideIndexByData(0),
            S = l.getSlideIndexByData(l.slides.length - 1),
            w = l.slidesGrid[y],
            x = l.slidesGrid[S],
            T = l.slidesGrid[l.slidesGrid.length - 1],
            A = Math.abs(i);
          (A >= w ? (m = (A - w) / T) : (m = (A + T - x) / T),
            m > 1 && (m -= 1));
        }
        (Object.assign(l, {
          progress: c,
          progressLoop: m,
          isBeginning: u,
          isEnd: h,
        }),
          (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
            l.updateSlidesProgress(i),
          u && !f && l.emit('reachBeginning toEdge'),
          h && !p && l.emit('reachEnd toEdge'),
          ((f && !u) || (p && !h)) && l.emit('fromEdge'),
          l.emit('progress', c));
      }
      const Tc = (i, l, s) => {
        l && !i.classList.contains(s)
          ? i.classList.add(s)
          : !l && i.classList.contains(s) && i.classList.remove(s);
      };
      function g0() {
        const i = this,
          { slides: l, params: s, slidesEl: r, activeIndex: c } = i,
          u = i.virtual && s.virtual.enabled,
          h = i.grid && s.grid && s.grid.rows > 1,
          m = S => na(r, `.${s.slideClass}${S}, swiper-slide${S}`)[0];
        let f, p, y;
        if (u)
          if (s.loop) {
            let S = c - i.virtual.slidesBefore;
            (S < 0 && (S = i.virtual.slides.length + S),
              S >= i.virtual.slides.length && (S -= i.virtual.slides.length),
              (f = m(`[data-swiper-slide-index="${S}"]`)));
          } else f = m(`[data-swiper-slide-index="${c}"]`);
        else
          h
            ? ((f = l.find(S => S.column === c)),
              (y = l.find(S => S.column === c + 1)),
              (p = l.find(S => S.column === c - 1)))
            : (f = l[c]);
        (f &&
          (h ||
            ((y = a0(f, `.${s.slideClass}, swiper-slide`)[0]),
            s.loop && !y && (y = l[0]),
            (p = t0(f, `.${s.slideClass}, swiper-slide`)[0]),
            s.loop && !p === 0 && (p = l[l.length - 1]))),
          l.forEach(S => {
            (Tc(S, S === f, s.slideActiveClass),
              Tc(S, S === y, s.slideNextClass),
              Tc(S, S === p, s.slidePrevClass));
          }),
          i.emitSlidesClasses());
      }
      const Us = (i, l) => {
          if (!i || i.destroyed || !i.params) return;
          const s = () =>
              i.isElement ? 'swiper-slide' : `.${i.params.slideClass}`,
            r = l.closest(s());
          if (r) {
            let c = r.querySelector(`.${i.params.lazyPreloaderClass}`);
            (!c &&
              i.isElement &&
              (r.shadowRoot
                ? (c = r.shadowRoot.querySelector(
                    `.${i.params.lazyPreloaderClass}`
                  ))
                : requestAnimationFrame(() => {
                    r.shadowRoot &&
                      ((c = r.shadowRoot.querySelector(
                        `.${i.params.lazyPreloaderClass}`
                      )),
                      c && c.remove());
                  })),
              c && c.remove());
          }
        },
        wc = (i, l) => {
          if (!i.slides[l]) return;
          const s = i.slides[l].querySelector('[loading="lazy"]');
          s && s.removeAttribute('loading');
        },
        zc = i => {
          if (!i || i.destroyed || !i.params) return;
          let l = i.params.lazyPreloadPrevNext;
          const s = i.slides.length;
          if (!s || !l || l < 0) return;
          l = Math.min(l, s);
          const r =
              i.params.slidesPerView === 'auto'
                ? i.slidesPerViewDynamic()
                : Math.ceil(i.params.slidesPerView),
            c = i.activeIndex;
          if (i.params.grid && i.params.grid.rows > 1) {
            const h = c,
              m = [h - l];
            (m.push(...Array.from({ length: l }).map((f, p) => h + r + p)),
              i.slides.forEach((f, p) => {
                m.includes(f.column) && wc(i, p);
              }));
            return;
          }
          const u = c + r - 1;
          if (i.params.rewind || i.params.loop)
            for (let h = c - l; h <= u + l; h += 1) {
              const m = ((h % s) + s) % s;
              (m < c || m > u) && wc(i, m);
            }
          else
            for (
              let h = Math.max(c - l, 0);
              h <= Math.min(u + l, s - 1);
              h += 1
            )
              h !== c && (h > u || h < c) && wc(i, h);
        };
      function b0(i) {
        const { slidesGrid: l, params: s } = i,
          r = i.rtlTranslate ? i.translate : -i.translate;
        let c;
        for (let u = 0; u < l.length; u += 1)
          typeof l[u + 1] < 'u'
            ? r >= l[u] && r < l[u + 1] - (l[u + 1] - l[u]) / 2
              ? (c = u)
              : r >= l[u] && r < l[u + 1] && (c = u + 1)
            : r >= l[u] && (c = u);
        return (
          s.normalizeSlideIndex && (c < 0 || typeof c > 'u') && (c = 0),
          c
        );
      }
      function v0(i) {
        const l = this,
          s = l.rtlTranslate ? l.translate : -l.translate,
          {
            snapGrid: r,
            params: c,
            activeIndex: u,
            realIndex: h,
            snapIndex: m,
          } = l;
        let f = i,
          p;
        const y = x => {
          let T = x - l.virtual.slidesBefore;
          return (
            T < 0 && (T = l.virtual.slides.length + T),
            T >= l.virtual.slides.length && (T -= l.virtual.slides.length),
            T
          );
        };
        if ((typeof f > 'u' && (f = b0(l)), r.indexOf(s) >= 0))
          p = r.indexOf(s);
        else {
          const x = Math.min(c.slidesPerGroupSkip, f);
          p = x + Math.floor((f - x) / c.slidesPerGroup);
        }
        if ((p >= r.length && (p = r.length - 1), f === u && !l.params.loop)) {
          p !== m && ((l.snapIndex = p), l.emit('snapIndexChange'));
          return;
        }
        if (f === u && l.params.loop && l.virtual && l.params.virtual.enabled) {
          l.realIndex = y(f);
          return;
        }
        const S = l.grid && c.grid && c.grid.rows > 1;
        let w;
        if (l.virtual && c.virtual.enabled && c.loop) w = y(f);
        else if (S) {
          const x = l.slides.find(A => A.column === f);
          let T = parseInt(x.getAttribute('data-swiper-slide-index'), 10);
          (Number.isNaN(T) && (T = Math.max(l.slides.indexOf(x), 0)),
            (w = Math.floor(T / c.grid.rows)));
        } else if (l.slides[f]) {
          const x = l.slides[f].getAttribute('data-swiper-slide-index');
          x ? (w = parseInt(x, 10)) : (w = f);
        } else w = f;
        (Object.assign(l, {
          previousSnapIndex: m,
          snapIndex: p,
          previousRealIndex: h,
          realIndex: w,
          previousIndex: u,
          activeIndex: f,
        }),
          l.initialized && zc(l),
          l.emit('activeIndexChange'),
          l.emit('snapIndexChange'),
          (l.initialized || l.params.runCallbacksOnInit) &&
            (h !== w && l.emit('realIndexChange'), l.emit('slideChange')));
      }
      function y0(i, l) {
        const s = this,
          r = s.params;
        let c = i.closest(`.${r.slideClass}, swiper-slide`);
        !c &&
          s.isElement &&
          l &&
          l.length > 1 &&
          l.includes(i) &&
          [...l.slice(l.indexOf(i) + 1, l.length)].forEach(m => {
            !c &&
              m.matches &&
              m.matches(`.${r.slideClass}, swiper-slide`) &&
              (c = m);
          });
        let u = !1,
          h;
        if (c) {
          for (let m = 0; m < s.slides.length; m += 1)
            if (s.slides[m] === c) {
              ((u = !0), (h = m));
              break;
            }
        }
        if (c && u)
          ((s.clickedSlide = c),
            s.virtual && s.params.virtual.enabled
              ? (s.clickedIndex = parseInt(
                  c.getAttribute('data-swiper-slide-index'),
                  10
                ))
              : (s.clickedIndex = h));
        else {
          ((s.clickedSlide = void 0), (s.clickedIndex = void 0));
          return;
        }
        r.slideToClickedSlide &&
          s.clickedIndex !== void 0 &&
          s.clickedIndex !== s.activeIndex &&
          s.slideToClickedSlide();
      }
      var S0 = {
        updateSize: u0,
        updateSlides: d0,
        updateAutoHeight: f0,
        updateSlidesOffset: h0,
        updateSlidesProgress: m0,
        updateProgress: p0,
        updateSlidesClasses: g0,
        updateActiveIndex: v0,
        updateClickedSlide: y0,
      };
      function x0(i = this.isHorizontal() ? 'x' : 'y') {
        const l = this,
          { params: s, rtlTranslate: r, translate: c, wrapperEl: u } = l;
        if (s.virtualTranslate) return r ? -c : c;
        if (s.cssMode) return c;
        let h = W1(u, i);
        return ((h += l.cssOverflowAdjustment()), r && (h = -h), h || 0);
      }
      function T0(i, l) {
        const s = this,
          { rtlTranslate: r, params: c, wrapperEl: u, progress: h } = s;
        let m = 0,
          f = 0;
        const p = 0;
        (s.isHorizontal() ? (m = r ? -i : i) : (f = i),
          c.roundLengths && ((m = Math.floor(m)), (f = Math.floor(f))),
          (s.previousTranslate = s.translate),
          (s.translate = s.isHorizontal() ? m : f),
          c.cssMode
            ? (u[s.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
                s.isHorizontal() ? -m : -f)
            : c.virtualTranslate ||
              (s.isHorizontal()
                ? (m -= s.cssOverflowAdjustment())
                : (f -= s.cssOverflowAdjustment()),
              (u.style.transform = `translate3d(${m}px, ${f}px, ${p}px)`)));
        let y;
        const S = s.maxTranslate() - s.minTranslate();
        (S === 0 ? (y = 0) : (y = (i - s.minTranslate()) / S),
          y !== h && s.updateProgress(i),
          s.emit('setTranslate', s.translate, l));
      }
      function w0() {
        return -this.snapGrid[0];
      }
      function E0() {
        return -this.snapGrid[this.snapGrid.length - 1];
      }
      function N0(i = 0, l = this.params.speed, s = !0, r = !0, c) {
        const u = this,
          { params: h, wrapperEl: m } = u;
        if (u.animating && h.preventInteractionOnTransition) return !1;
        const f = u.minTranslate(),
          p = u.maxTranslate();
        let y;
        if (
          (r && i > f ? (y = f) : r && i < p ? (y = p) : (y = i),
          u.updateProgress(y),
          h.cssMode)
        ) {
          const S = u.isHorizontal();
          if (l === 0) m[S ? 'scrollLeft' : 'scrollTop'] = -y;
          else {
            if (!u.support.smoothScroll)
              return (
                qm({ swiper: u, targetPosition: -y, side: S ? 'left' : 'top' }),
                !0
              );
            m.scrollTo({ [S ? 'left' : 'top']: -y, behavior: 'smooth' });
          }
          return !0;
        }
        return (
          l === 0
            ? (u.setTransition(0),
              u.setTranslate(y),
              s &&
                (u.emit('beforeTransitionStart', l, c),
                u.emit('transitionEnd')))
            : (u.setTransition(l),
              u.setTranslate(y),
              s &&
                (u.emit('beforeTransitionStart', l, c),
                u.emit('transitionStart')),
              u.animating ||
                ((u.animating = !0),
                u.onTranslateToWrapperTransitionEnd ||
                  (u.onTranslateToWrapperTransitionEnd = function (w) {
                    !u ||
                      u.destroyed ||
                      (w.target === this &&
                        (u.wrapperEl.removeEventListener(
                          'transitionend',
                          u.onTranslateToWrapperTransitionEnd
                        ),
                        (u.onTranslateToWrapperTransitionEnd = null),
                        delete u.onTranslateToWrapperTransitionEnd,
                        (u.animating = !1),
                        s && u.emit('transitionEnd')));
                  }),
                u.wrapperEl.addEventListener(
                  'transitionend',
                  u.onTranslateToWrapperTransitionEnd
                ))),
          !0
        );
      }
      var _0 = {
        getTranslate: x0,
        setTranslate: T0,
        minTranslate: w0,
        maxTranslate: E0,
        translateTo: N0,
      };
      function A0(i, l) {
        const s = this;
        (s.params.cssMode ||
          ((s.wrapperEl.style.transitionDuration = `${i}ms`),
          (s.wrapperEl.style.transitionDelay = i === 0 ? '0ms' : '')),
          s.emit('setTransition', i, l));
      }
      function Xm({ swiper: i, runCallbacks: l, direction: s, step: r }) {
        const { activeIndex: c, previousIndex: u } = i;
        let h = s;
        (h || (c > u ? (h = 'next') : c < u ? (h = 'prev') : (h = 'reset')),
          i.emit(`transition${r}`),
          l && h === 'reset'
            ? i.emit(`slideResetTransition${r}`)
            : l &&
              c !== u &&
              (i.emit(`slideChangeTransition${r}`),
              h === 'next'
                ? i.emit(`slideNextTransition${r}`)
                : i.emit(`slidePrevTransition${r}`)));
      }
      function M0(i = !0, l) {
        const s = this,
          { params: r } = s;
        r.cssMode ||
          (r.autoHeight && s.updateAutoHeight(),
          Xm({ swiper: s, runCallbacks: i, direction: l, step: 'Start' }));
      }
      function j0(i = !0, l) {
        const s = this,
          { params: r } = s;
        ((s.animating = !1),
          !r.cssMode &&
            (s.setTransition(0),
            Xm({ swiper: s, runCallbacks: i, direction: l, step: 'End' })));
      }
      var C0 = { setTransition: A0, transitionStart: M0, transitionEnd: j0 };
      function O0(i = 0, l, s = !0, r, c) {
        typeof i == 'string' && (i = parseInt(i, 10));
        const u = this;
        let h = i;
        h < 0 && (h = 0);
        const {
          params: m,
          snapGrid: f,
          slidesGrid: p,
          previousIndex: y,
          activeIndex: S,
          rtlTranslate: w,
          wrapperEl: x,
          enabled: T,
        } = u;
        if (
          (!T && !r && !c) ||
          u.destroyed ||
          (u.animating && m.preventInteractionOnTransition)
        )
          return !1;
        typeof l > 'u' && (l = u.params.speed);
        const A = Math.min(u.params.slidesPerGroupSkip, h);
        let j = A + Math.floor((h - A) / u.params.slidesPerGroup);
        j >= f.length && (j = f.length - 1);
        const G = -f[j];
        if (m.normalizeSlideIndex)
          for (let X = 0; X < p.length; X += 1) {
            const q = -Math.floor(G * 100),
              se = Math.floor(p[X] * 100),
              F = Math.floor(p[X + 1] * 100);
            typeof p[X + 1] < 'u'
              ? q >= se && q < F - (F - se) / 2
                ? (h = X)
                : q >= se && q < F && (h = X + 1)
              : q >= se && (h = X);
          }
        if (
          u.initialized &&
          h !== S &&
          ((!u.allowSlideNext &&
            (w
              ? G > u.translate && G > u.minTranslate()
              : G < u.translate && G < u.minTranslate())) ||
            (!u.allowSlidePrev &&
              G > u.translate &&
              G > u.maxTranslate() &&
              (S || 0) !== h))
        )
          return !1;
        (h !== (y || 0) && s && u.emit('beforeSlideChangeStart'),
          u.updateProgress(G));
        let L;
        h > S ? (L = 'next') : h < S ? (L = 'prev') : (L = 'reset');
        const H = u.virtual && u.params.virtual.enabled;
        if (
          !(H && c) &&
          ((w && -G === u.translate) || (!w && G === u.translate))
        )
          return (
            u.updateActiveIndex(h),
            m.autoHeight && u.updateAutoHeight(),
            u.updateSlidesClasses(),
            m.effect !== 'slide' && u.setTranslate(G),
            L !== 'reset' && (u.transitionStart(s, L), u.transitionEnd(s, L)),
            !1
          );
        if (m.cssMode) {
          const X = u.isHorizontal(),
            q = w ? G : -G;
          if (l === 0)
            (H &&
              ((u.wrapperEl.style.scrollSnapType = 'none'),
              (u._immediateVirtual = !0)),
              H && !u._cssModeVirtualInitialSet && u.params.initialSlide > 0
                ? ((u._cssModeVirtualInitialSet = !0),
                  requestAnimationFrame(() => {
                    x[X ? 'scrollLeft' : 'scrollTop'] = q;
                  }))
                : (x[X ? 'scrollLeft' : 'scrollTop'] = q),
              H &&
                requestAnimationFrame(() => {
                  ((u.wrapperEl.style.scrollSnapType = ''),
                    (u._immediateVirtual = !1));
                }));
          else {
            if (!u.support.smoothScroll)
              return (
                qm({ swiper: u, targetPosition: q, side: X ? 'left' : 'top' }),
                !0
              );
            x.scrollTo({ [X ? 'left' : 'top']: q, behavior: 'smooth' });
          }
          return !0;
        }
        const U = Km().isSafari;
        return (
          H && !c && U && u.isElement && u.virtual.update(!1, !1, h),
          u.setTransition(l),
          u.setTranslate(G),
          u.updateActiveIndex(h),
          u.updateSlidesClasses(),
          u.emit('beforeTransitionStart', l, r),
          u.transitionStart(s, L),
          l === 0
            ? u.transitionEnd(s, L)
            : u.animating ||
              ((u.animating = !0),
              u.onSlideToWrapperTransitionEnd ||
                (u.onSlideToWrapperTransitionEnd = function (q) {
                  !u ||
                    u.destroyed ||
                    (q.target === this &&
                      (u.wrapperEl.removeEventListener(
                        'transitionend',
                        u.onSlideToWrapperTransitionEnd
                      ),
                      (u.onSlideToWrapperTransitionEnd = null),
                      delete u.onSlideToWrapperTransitionEnd,
                      u.transitionEnd(s, L)));
                }),
              u.wrapperEl.addEventListener(
                'transitionend',
                u.onSlideToWrapperTransitionEnd
              )),
          !0
        );
      }
      function B0(i = 0, l, s = !0, r) {
        typeof i == 'string' && (i = parseInt(i, 10));
        const c = this;
        if (c.destroyed) return;
        typeof l > 'u' && (l = c.params.speed);
        const u = c.grid && c.params.grid && c.params.grid.rows > 1;
        let h = i;
        if (c.params.loop)
          if (c.virtual && c.params.virtual.enabled)
            h = h + c.virtual.slidesBefore;
          else {
            let m;
            if (u) {
              const A = h * c.params.grid.rows;
              m = c.slides.find(
                j => j.getAttribute('data-swiper-slide-index') * 1 === A
              ).column;
            } else m = c.getSlideIndexByData(h);
            const f = u
                ? Math.ceil(c.slides.length / c.params.grid.rows)
                : c.slides.length,
              {
                centeredSlides: p,
                slidesOffsetBefore: y,
                slidesOffsetAfter: S,
              } = c.params,
              w = p || !!y || !!S;
            let x = c.params.slidesPerView;
            x === 'auto'
              ? (x = c.slidesPerViewDynamic())
              : ((x = Math.ceil(parseFloat(c.params.slidesPerView, 10))),
                w && x % 2 === 0 && (x = x + 1));
            let T = f - m < x;
            if (
              (w && (T = T || m < Math.ceil(x / 2)),
              r && w && c.params.slidesPerView !== 'auto' && !u && (T = !1),
              T)
            ) {
              const A = w
                ? m < c.activeIndex
                  ? 'prev'
                  : 'next'
                : m - c.activeIndex - 1 < c.params.slidesPerView
                  ? 'next'
                  : 'prev';
              c.loopFix({
                direction: A,
                slideTo: !0,
                activeSlideIndex: A === 'next' ? m + 1 : m - f + 1,
                slideRealIndex: A === 'next' ? c.realIndex : void 0,
              });
            }
            if (u) {
              const A = h * c.params.grid.rows;
              h = c.slides.find(
                j => j.getAttribute('data-swiper-slide-index') * 1 === A
              ).column;
            } else h = c.getSlideIndexByData(h);
          }
        return (
          requestAnimationFrame(() => {
            c.slideTo(h, l, s, r);
          }),
          c
        );
      }
      function R0(i, l = !0, s) {
        const r = this,
          { enabled: c, params: u, animating: h } = r;
        if (!c || r.destroyed) return r;
        typeof i > 'u' && (i = r.params.speed);
        let m = u.slidesPerGroup;
        u.slidesPerView === 'auto' &&
          u.slidesPerGroup === 1 &&
          u.slidesPerGroupAuto &&
          (m = Math.max(r.slidesPerViewDynamic('current', !0), 1));
        const f = r.activeIndex < u.slidesPerGroupSkip ? 1 : m,
          p = r.virtual && u.virtual.enabled;
        if (u.loop) {
          if (h && !p && u.loopPreventsSliding) return !1;
          if (
            (r.loopFix({ direction: 'next' }),
            (r._clientLeft = r.wrapperEl.clientLeft),
            r.activeIndex === r.slides.length - 1 && u.cssMode)
          )
            return (
              requestAnimationFrame(() => {
                r.slideTo(r.activeIndex + f, i, l, s);
              }),
              !0
            );
        }
        return u.rewind && r.isEnd
          ? r.slideTo(0, i, l, s)
          : r.slideTo(r.activeIndex + f, i, l, s);
      }
      function D0(i, l = !0, s) {
        const r = this,
          {
            params: c,
            snapGrid: u,
            slidesGrid: h,
            rtlTranslate: m,
            enabled: f,
            animating: p,
          } = r;
        if (!f || r.destroyed) return r;
        typeof i > 'u' && (i = r.params.speed);
        const y = r.virtual && c.virtual.enabled;
        if (c.loop) {
          if (p && !y && c.loopPreventsSliding) return !1;
          (r.loopFix({ direction: 'prev' }),
            (r._clientLeft = r.wrapperEl.clientLeft));
        }
        const S = m ? r.translate : -r.translate;
        function w(L) {
          return L < 0 ? -Math.floor(Math.abs(L)) : Math.floor(L);
        }
        const x = w(S),
          T = u.map(L => w(L)),
          A = c.freeMode && c.freeMode.enabled;
        let j = u[T.indexOf(x) - 1];
        if (typeof j > 'u' && (c.cssMode || A)) {
          let L;
          (u.forEach((H, $) => {
            x >= H && (L = $);
          }),
            typeof L < 'u' && (j = A ? u[L] : u[L > 0 ? L - 1 : L]));
        }
        let G = 0;
        if (
          (typeof j < 'u' &&
            ((G = h.indexOf(j)),
            G < 0 && (G = r.activeIndex - 1),
            c.slidesPerView === 'auto' &&
              c.slidesPerGroup === 1 &&
              c.slidesPerGroupAuto &&
              ((G = G - r.slidesPerViewDynamic('previous', !0) + 1),
              (G = Math.max(G, 0)))),
          c.rewind && r.isBeginning)
        ) {
          const L =
            r.params.virtual && r.params.virtual.enabled && r.virtual
              ? r.virtual.slides.length - 1
              : r.slides.length - 1;
          return r.slideTo(L, i, l, s);
        } else if (c.loop && r.activeIndex === 0 && c.cssMode)
          return (
            requestAnimationFrame(() => {
              r.slideTo(G, i, l, s);
            }),
            !0
          );
        return r.slideTo(G, i, l, s);
      }
      function L0(i, l = !0, s) {
        const r = this;
        if (!r.destroyed)
          return (
            typeof i > 'u' && (i = r.params.speed),
            r.slideTo(r.activeIndex, i, l, s)
          );
      }
      function z0(i, l = !0, s, r = 0.5) {
        const c = this;
        if (c.destroyed) return;
        typeof i > 'u' && (i = c.params.speed);
        let u = c.activeIndex;
        const h = Math.min(c.params.slidesPerGroupSkip, u),
          m = h + Math.floor((u - h) / c.params.slidesPerGroup),
          f = c.rtlTranslate ? c.translate : -c.translate;
        if (f >= c.snapGrid[m]) {
          const p = c.snapGrid[m],
            y = c.snapGrid[m + 1];
          f - p > (y - p) * r && (u += c.params.slidesPerGroup);
        } else {
          const p = c.snapGrid[m - 1],
            y = c.snapGrid[m];
          f - p <= (y - p) * r && (u -= c.params.slidesPerGroup);
        }
        return (
          (u = Math.max(u, 0)),
          (u = Math.min(u, c.slidesGrid.length - 1)),
          c.slideTo(u, i, l, s)
        );
      }
      function H0() {
        const i = this;
        if (i.destroyed) return;
        const { params: l, slidesEl: s } = i,
          r =
            l.slidesPerView === 'auto'
              ? i.slidesPerViewDynamic()
              : l.slidesPerView;
        let c = i.getSlideIndexWhenGrid(i.clickedIndex),
          u;
        const h = i.isElement ? 'swiper-slide' : `.${l.slideClass}`,
          m = i.grid && i.params.grid && i.params.grid.rows > 1;
        if (l.loop) {
          if (i.animating) return;
          ((u = parseInt(
            i.clickedSlide.getAttribute('data-swiper-slide-index'),
            10
          )),
            l.centeredSlides
              ? i.slideToLoop(u)
              : c >
                  (m
                    ? (i.slides.length - r) / 2 - (i.params.grid.rows - 1)
                    : i.slides.length - r)
                ? (i.loopFix(),
                  (c = i.getSlideIndex(
                    na(s, `${h}[data-swiper-slide-index="${u}"]`)[0]
                  )),
                  $m(() => {
                    i.slideTo(c);
                  }))
                : i.slideTo(c));
        } else i.slideTo(c);
      }
      var U0 = {
        slideTo: O0,
        slideToLoop: B0,
        slideNext: R0,
        slidePrev: D0,
        slideReset: L0,
        slideToClosest: z0,
        slideToClickedSlide: H0,
      };
      function I0(i, l) {
        const s = this,
          { params: r, slidesEl: c } = s;
        if (!r.loop || (s.virtual && s.params.virtual.enabled)) return;
        const u = () => {
            na(c, `.${r.slideClass}, swiper-slide`).forEach((T, A) => {
              T.setAttribute('data-swiper-slide-index', A);
            });
          },
          h = () => {
            const x = na(c, `.${r.slideBlankClass}`);
            (x.forEach(T => {
              T.remove();
            }),
              x.length > 0 && (s.recalcSlides(), s.updateSlides()));
          },
          m = s.grid && r.grid && r.grid.rows > 1;
        r.loopAddBlankSlides && (r.slidesPerGroup > 1 || m) && h();
        const f = r.slidesPerGroup * (m ? r.grid.rows : 1),
          p = s.slides.length % f !== 0,
          y = m && s.slides.length % r.grid.rows !== 0,
          S = x => {
            for (let T = 0; T < x; T += 1) {
              const A = s.isElement
                ? qs('swiper-slide', [r.slideBlankClass])
                : qs('div', [r.slideClass, r.slideBlankClass]);
              s.slidesEl.append(A);
            }
          };
        if (p) {
          if (r.loopAddBlankSlides) {
            const x = f - (s.slides.length % f);
            (S(x), s.recalcSlides(), s.updateSlides());
          } else
            $s(
              'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          u();
        } else if (y) {
          if (r.loopAddBlankSlides) {
            const x = r.grid.rows - (s.slides.length % r.grid.rows);
            (S(x), s.recalcSlides(), s.updateSlides());
          } else
            $s(
              'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          u();
        } else u();
        const w =
          r.centeredSlides || !!r.slidesOffsetBefore || !!r.slidesOffsetAfter;
        s.loopFix({
          slideRealIndex: i,
          direction: w ? void 0 : 'next',
          initial: l,
        });
      }
      function G0({
        slideRealIndex: i,
        slideTo: l = !0,
        direction: s,
        setTranslate: r,
        activeSlideIndex: c,
        initial: u,
        byController: h,
        byMousewheel: m,
      } = {}) {
        const f = this;
        if (!f.params.loop) return;
        f.emit('beforeLoopFix');
        const {
            slides: p,
            allowSlidePrev: y,
            allowSlideNext: S,
            slidesEl: w,
            params: x,
          } = f,
          {
            centeredSlides: T,
            slidesOffsetBefore: A,
            slidesOffsetAfter: j,
            initialSlide: G,
          } = x,
          L = T || !!A || !!j;
        if (
          ((f.allowSlidePrev = !0),
          (f.allowSlideNext = !0),
          f.virtual && x.virtual.enabled)
        ) {
          (l &&
            (!L && f.snapIndex === 0
              ? f.slideTo(f.virtual.slides.length, 0, !1, !0)
              : L && f.snapIndex < x.slidesPerView
                ? f.slideTo(f.virtual.slides.length + f.snapIndex, 0, !1, !0)
                : f.snapIndex === f.snapGrid.length - 1 &&
                  f.slideTo(f.virtual.slidesBefore, 0, !1, !0)),
            (f.allowSlidePrev = y),
            (f.allowSlideNext = S),
            f.emit('loopFix'));
          return;
        }
        let H = x.slidesPerView;
        H === 'auto'
          ? (H = f.slidesPerViewDynamic())
          : ((H = Math.ceil(parseFloat(x.slidesPerView, 10))),
            L && H % 2 === 0 && (H = H + 1));
        const $ = x.slidesPerGroupAuto ? H : x.slidesPerGroup;
        let D = L ? Math.max($, Math.ceil(H / 2)) : $;
        (D % $ !== 0 && (D += $ - (D % $)),
          (D += x.loopAdditionalSlides),
          (f.loopedSlides = D));
        const U = f.grid && x.grid && x.grid.rows > 1;
        p.length < H + D ||
        (f.params.effect === 'cards' && p.length < H + D * 2)
          ? $s(
              'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
            )
          : U &&
            x.grid.fill === 'row' &&
            $s(
              'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
            );
        const X = [],
          q = [],
          se = U ? Math.ceil(p.length / x.grid.rows) : p.length,
          F = u && se - G < H && !L;
        let W = F ? G : f.activeIndex;
        typeof c > 'u'
          ? (c = f.getSlideIndex(
              p.find(K => K.classList.contains(x.slideActiveClass))
            ))
          : (W = c);
        const ae = s === 'next' || !s,
          ye = s === 'prev' || !s;
        let Se = 0,
          Ne = 0;
        const Q =
          (U ? p[c].column : c) + (L && typeof r > 'u' ? -H / 2 + 0.5 : 0);
        if (Q < D) {
          Se = Math.max(D - Q, $);
          for (let K = 0; K < D - Q; K += 1) {
            const ie = K - Math.floor(K / se) * se;
            if (U) {
              const N = se - ie - 1;
              for (let I = p.length - 1; I >= 0; I -= 1)
                p[I].column === N && X.push(I);
            } else X.push(se - ie - 1);
          }
        } else if (Q + H > se - D) {
          ((Ne = Math.max(Q - (se - D * 2), $)),
            F && (Ne = Math.max(Ne, H - se + G + 1)));
          for (let K = 0; K < Ne; K += 1) {
            const ie = K - Math.floor(K / se) * se;
            U
              ? p.forEach((N, I) => {
                  N.column === ie && q.push(I);
                })
              : q.push(ie);
          }
        }
        if (
          ((f.__preventObserver__ = !0),
          requestAnimationFrame(() => {
            f.__preventObserver__ = !1;
          }),
          f.params.effect === 'cards' &&
            p.length < H + D * 2 &&
            (q.includes(c) && q.splice(q.indexOf(c), 1),
            X.includes(c) && X.splice(X.indexOf(c), 1)),
          ye &&
            X.forEach(K => {
              ((p[K].swiperLoopMoveDOM = !0),
                w.prepend(p[K]),
                (p[K].swiperLoopMoveDOM = !1));
            }),
          ae &&
            q.forEach(K => {
              ((p[K].swiperLoopMoveDOM = !0),
                w.append(p[K]),
                (p[K].swiperLoopMoveDOM = !1));
            }),
          f.recalcSlides(),
          x.slidesPerView === 'auto'
            ? f.updateSlides()
            : U &&
              ((X.length > 0 && ye) || (q.length > 0 && ae)) &&
              f.slides.forEach((K, ie) => {
                f.grid.updateSlide(ie, K, f.slides);
              }),
          x.watchSlidesProgress && f.updateSlidesOffset(),
          l)
        ) {
          if (X.length > 0 && ye) {
            if (typeof i > 'u') {
              const K = f.slidesGrid[W],
                N = f.slidesGrid[W + Se] - K;
              m
                ? f.setTranslate(f.translate - N)
                : (f.slideTo(W + Math.ceil(Se), 0, !1, !0),
                  r &&
                    ((f.touchEventsData.startTranslate =
                      f.touchEventsData.startTranslate - N),
                    (f.touchEventsData.currentTranslate =
                      f.touchEventsData.currentTranslate - N)));
            } else if (r) {
              const K = U ? X.length / x.grid.rows : X.length;
              (f.slideTo(f.activeIndex + K, 0, !1, !0),
                (f.touchEventsData.currentTranslate = f.translate));
            }
          } else if (q.length > 0 && ae)
            if (typeof i > 'u') {
              const K = f.slidesGrid[W],
                N = f.slidesGrid[W - Ne] - K;
              m
                ? f.setTranslate(f.translate - N)
                : (f.slideTo(W - Ne, 0, !1, !0),
                  r &&
                    ((f.touchEventsData.startTranslate =
                      f.touchEventsData.startTranslate - N),
                    (f.touchEventsData.currentTranslate =
                      f.touchEventsData.currentTranslate - N)));
            } else {
              const K = U ? q.length / x.grid.rows : q.length;
              f.slideTo(f.activeIndex - K, 0, !1, !0);
            }
        }
        if (
          ((f.allowSlidePrev = y),
          (f.allowSlideNext = S),
          f.controller && f.controller.control && !h)
        ) {
          const K = {
            slideRealIndex: i,
            direction: s,
            setTranslate: r,
            activeSlideIndex: c,
            byController: !0,
          };
          Array.isArray(f.controller.control)
            ? f.controller.control.forEach(ie => {
                !ie.destroyed &&
                  ie.params.loop &&
                  ie.loopFix({
                    ...K,
                    slideTo:
                      ie.params.slidesPerView === x.slidesPerView ? l : !1,
                  });
              })
            : f.controller.control instanceof f.constructor &&
              f.controller.control.params.loop &&
              f.controller.control.loopFix({
                ...K,
                slideTo:
                  f.controller.control.params.slidesPerView === x.slidesPerView
                    ? l
                    : !1,
              });
        }
        f.emit('loopFix');
      }
      function V0() {
        const i = this,
          { params: l, slidesEl: s } = i;
        if (!l.loop || !s || (i.virtual && i.params.virtual.enabled)) return;
        i.recalcSlides();
        const r = [];
        (i.slides.forEach(c => {
          const u =
            typeof c.swiperSlideIndex > 'u'
              ? c.getAttribute('data-swiper-slide-index') * 1
              : c.swiperSlideIndex;
          r[u] = c;
        }),
          i.slides.forEach(c => {
            c.removeAttribute('data-swiper-slide-index');
          }),
          r.forEach(c => {
            s.append(c);
          }),
          i.recalcSlides(),
          i.slideTo(i.realIndex, 0));
      }
      var k0 = { loopCreate: I0, loopFix: G0, loopDestroy: V0 };
      function $0(i) {
        const l = this;
        if (
          !l.params.simulateTouch ||
          (l.params.watchOverflow && l.isLocked) ||
          l.params.cssMode
        )
          return;
        const s =
          l.params.touchEventsTarget === 'container' ? l.el : l.wrapperEl;
        (l.isElement && (l.__preventObserver__ = !0),
          (s.style.cursor = 'move'),
          (s.style.cursor = i ? 'grabbing' : 'grab'),
          l.isElement &&
            requestAnimationFrame(() => {
              l.__preventObserver__ = !1;
            }));
      }
      function q0() {
        const i = this;
        (i.params.watchOverflow && i.isLocked) ||
          i.params.cssMode ||
          (i.isElement && (i.__preventObserver__ = !0),
          (i[
            i.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
          ].style.cursor = ''),
          i.isElement &&
            requestAnimationFrame(() => {
              i.__preventObserver__ = !1;
            }));
      }
      var P0 = { setGrabCursor: $0, unsetGrabCursor: q0 };
      function Y0(i, l = this) {
        function s(r) {
          if (!r || r === xi() || r === ht()) return null;
          r.assignedSlot && (r = r.assignedSlot);
          const c = r.closest(i);
          return !c && !r.getRootNode ? null : c || s(r.getRootNode().host);
        }
        return s(l);
      }
      function Tm(i, l, s) {
        const r = ht(),
          { params: c } = i,
          u = c.edgeSwipeDetection,
          h = c.edgeSwipeThreshold;
        return u && (s <= h || s >= r.innerWidth - h)
          ? u === 'prevent'
            ? (l.preventDefault(), !0)
            : !1
          : !0;
      }
      function K0(i) {
        const l = this,
          s = xi();
        let r = i;
        r.originalEvent && (r = r.originalEvent);
        const c = l.touchEventsData;
        if (r.type === 'pointerdown') {
          if (c.pointerId !== null && c.pointerId !== r.pointerId) return;
          c.pointerId = r.pointerId;
        } else
          r.type === 'touchstart' &&
            r.targetTouches.length === 1 &&
            (c.touchId = r.targetTouches[0].identifier);
        if (r.type === 'touchstart') {
          Tm(l, r, r.targetTouches[0].pageX);
          return;
        }
        const { params: u, touches: h, enabled: m } = l;
        if (
          !m ||
          (!u.simulateTouch && r.pointerType === 'mouse') ||
          (l.animating && u.preventInteractionOnTransition)
        )
          return;
        !l.animating && u.cssMode && u.loop && l.loopFix();
        let f = r.target;
        if (
          (u.touchEventsTarget === 'wrapper' && !e0(f, l.wrapperEl)) ||
          ('which' in r && r.which === 3) ||
          ('button' in r && r.button > 0) ||
          (c.isTouched && c.isMoved)
        )
          return;
        const p = !!u.noSwipingClass && u.noSwipingClass !== '',
          y = r.composedPath ? r.composedPath() : r.path;
        p && r.target && r.target.shadowRoot && y && (f = y[0]);
        const S = u.noSwipingSelector
            ? u.noSwipingSelector
            : `.${u.noSwipingClass}`,
          w = !!(r.target && r.target.shadowRoot);
        if (u.noSwiping && (w ? Y0(S, f) : f.closest(S))) {
          l.allowClick = !0;
          return;
        }
        if (u.swipeHandler && !f.closest(u.swipeHandler)) return;
        ((h.currentX = r.pageX), (h.currentY = r.pageY));
        const x = h.currentX,
          T = h.currentY;
        if (!Tm(l, r, x)) return;
        (Object.assign(c, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
          (h.startX = x),
          (h.startY = T),
          (c.touchStartTime = ks()),
          (l.allowClick = !0),
          l.updateSize(),
          (l.swipeDirection = void 0),
          u.threshold > 0 && (c.allowThresholdMove = !1));
        let A = !0;
        (f.matches(c.focusableElements) &&
          ((A = !1), f.nodeName === 'SELECT' && (c.isTouched = !1)),
          s.activeElement &&
            s.activeElement.matches(c.focusableElements) &&
            s.activeElement !== f &&
            (r.pointerType === 'mouse' ||
              (r.pointerType !== 'mouse' && !f.matches(c.focusableElements))) &&
            s.activeElement.blur());
        const j = A && l.allowTouchMove && u.touchStartPreventDefault;
        ((u.touchStartForcePreventDefault || j) &&
          !f.isContentEditable &&
          r.preventDefault(),
          u.freeMode &&
            u.freeMode.enabled &&
            l.freeMode &&
            l.animating &&
            !u.cssMode &&
            l.freeMode.onTouchStart(),
          l.emit('touchStart', r));
      }
      function X0(i) {
        const l = xi(),
          s = this,
          r = s.touchEventsData,
          { params: c, touches: u, rtlTranslate: h, enabled: m } = s;
        if (!m || (!c.simulateTouch && i.pointerType === 'mouse')) return;
        let f = i;
        if (
          (f.originalEvent && (f = f.originalEvent),
          f.type === 'pointermove' &&
            (r.touchId !== null || f.pointerId !== r.pointerId))
        )
          return;
        let p;
        if (f.type === 'touchmove') {
          if (
            ((p = [...f.changedTouches].find(D => D.identifier === r.touchId)),
            !p || p.identifier !== r.touchId)
          )
            return;
        } else p = f;
        if (!r.isTouched) {
          r.startMoving && r.isScrolling && s.emit('touchMoveOpposite', f);
          return;
        }
        const y = p.pageX,
          S = p.pageY;
        if (f.preventedByNestedSwiper) {
          ((u.startX = y), (u.startY = S));
          return;
        }
        if (!s.allowTouchMove) {
          (f.target.matches(r.focusableElements) || (s.allowClick = !1),
            r.isTouched &&
              (Object.assign(u, {
                startX: y,
                startY: S,
                currentX: y,
                currentY: S,
              }),
              (r.touchStartTime = ks())));
          return;
        }
        if (c.touchReleaseOnEdges && !c.loop)
          if (s.isVertical()) {
            if (
              (S < u.startY && s.translate <= s.maxTranslate()) ||
              (S > u.startY && s.translate >= s.minTranslate())
            ) {
              ((r.isTouched = !1), (r.isMoved = !1));
              return;
            }
          } else {
            if (
              h &&
              ((y > u.startX && -s.translate <= s.maxTranslate()) ||
                (y < u.startX && -s.translate >= s.minTranslate()))
            )
              return;
            if (
              !h &&
              ((y < u.startX && s.translate <= s.maxTranslate()) ||
                (y > u.startX && s.translate >= s.minTranslate()))
            )
              return;
          }
        if (
          (l.activeElement &&
            l.activeElement.matches(r.focusableElements) &&
            l.activeElement !== f.target &&
            f.pointerType !== 'mouse' &&
            l.activeElement.blur(),
          l.activeElement &&
            f.target === l.activeElement &&
            f.target.matches(r.focusableElements))
        ) {
          ((r.isMoved = !0), (s.allowClick = !1));
          return;
        }
        (r.allowTouchCallbacks && s.emit('touchMove', f),
          (u.previousX = u.currentX),
          (u.previousY = u.currentY),
          (u.currentX = y),
          (u.currentY = S));
        const w = u.currentX - u.startX,
          x = u.currentY - u.startY;
        if (
          s.params.threshold &&
          Math.sqrt(w ** 2 + x ** 2) < s.params.threshold
        )
          return;
        if (typeof r.isScrolling > 'u') {
          let D;
          (s.isHorizontal() && u.currentY === u.startY) ||
          (s.isVertical() && u.currentX === u.startX)
            ? (r.isScrolling = !1)
            : w * w + x * x >= 25 &&
              ((D = (Math.atan2(Math.abs(x), Math.abs(w)) * 180) / Math.PI),
              (r.isScrolling = s.isHorizontal()
                ? D > c.touchAngle
                : 90 - D > c.touchAngle));
        }
        if (
          (r.isScrolling && s.emit('touchMoveOpposite', f),
          typeof r.startMoving > 'u' &&
            (u.currentX !== u.startX || u.currentY !== u.startY) &&
            (r.startMoving = !0),
          r.isScrolling ||
            (f.type === 'touchmove' && r.preventTouchMoveFromPointerMove))
        ) {
          r.isTouched = !1;
          return;
        }
        if (!r.startMoving) return;
        ((s.allowClick = !1),
          !c.cssMode && f.cancelable && f.preventDefault(),
          c.touchMoveStopPropagation && !c.nested && f.stopPropagation());
        let T = s.isHorizontal() ? w : x,
          A = s.isHorizontal()
            ? u.currentX - u.previousX
            : u.currentY - u.previousY;
        (c.oneWayMovement &&
          ((T = Math.abs(T) * (h ? 1 : -1)), (A = Math.abs(A) * (h ? 1 : -1))),
          (u.diff = T),
          (T *= c.touchRatio),
          h && ((T = -T), (A = -A)));
        const j = s.touchesDirection;
        ((s.swipeDirection = T > 0 ? 'prev' : 'next'),
          (s.touchesDirection = A > 0 ? 'prev' : 'next'));
        const G = s.params.loop && !c.cssMode,
          L =
            (s.touchesDirection === 'next' && s.allowSlideNext) ||
            (s.touchesDirection === 'prev' && s.allowSlidePrev);
        if (!r.isMoved) {
          if (
            (G && L && s.loopFix({ direction: s.swipeDirection }),
            (r.startTranslate = s.getTranslate()),
            s.setTransition(0),
            s.animating)
          ) {
            const D = new window.CustomEvent('transitionend', {
              bubbles: !0,
              cancelable: !0,
              detail: { bySwiperTouchMove: !0 },
            });
            s.wrapperEl.dispatchEvent(D);
          }
          ((r.allowMomentumBounce = !1),
            c.grabCursor &&
              (s.allowSlideNext === !0 || s.allowSlidePrev === !0) &&
              s.setGrabCursor(!0),
            s.emit('sliderFirstMove', f));
        }
        if (
          (new Date().getTime(),
          c._loopSwapReset !== !1 &&
            r.isMoved &&
            r.allowThresholdMove &&
            j !== s.touchesDirection &&
            G &&
            L &&
            Math.abs(T) >= 1)
        ) {
          (Object.assign(u, {
            startX: y,
            startY: S,
            currentX: y,
            currentY: S,
            startTranslate: r.currentTranslate,
          }),
            (r.loopSwapReset = !0),
            (r.startTranslate = r.currentTranslate));
          return;
        }
        (s.emit('sliderMove', f),
          (r.isMoved = !0),
          (r.currentTranslate = T + r.startTranslate));
        let H = !0,
          $ = c.resistanceRatio;
        if (
          (c.touchReleaseOnEdges && ($ = 0),
          T > 0
            ? (G &&
                L &&
                r.allowThresholdMove &&
                r.currentTranslate >
                  (c.centeredSlides
                    ? s.minTranslate() -
                      s.slidesSizesGrid[s.activeIndex + 1] -
                      (c.slidesPerView !== 'auto' &&
                      s.slides.length - c.slidesPerView >= 2
                        ? s.slidesSizesGrid[s.activeIndex + 1] +
                          s.params.spaceBetween
                        : 0) -
                      s.params.spaceBetween
                    : s.minTranslate()) &&
                s.loopFix({
                  direction: 'prev',
                  setTranslate: !0,
                  activeSlideIndex: 0,
                }),
              r.currentTranslate > s.minTranslate() &&
                ((H = !1),
                c.resistance &&
                  (r.currentTranslate =
                    s.minTranslate() -
                    1 +
                    (-s.minTranslate() + r.startTranslate + T) ** $)))
            : T < 0 &&
              (G &&
                L &&
                r.allowThresholdMove &&
                r.currentTranslate <
                  (c.centeredSlides
                    ? s.maxTranslate() +
                      s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                      s.params.spaceBetween +
                      (c.slidesPerView !== 'auto' &&
                      s.slides.length - c.slidesPerView >= 2
                        ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                          s.params.spaceBetween
                        : 0)
                    : s.maxTranslate()) &&
                s.loopFix({
                  direction: 'next',
                  setTranslate: !0,
                  activeSlideIndex:
                    s.slides.length -
                    (c.slidesPerView === 'auto'
                      ? s.slidesPerViewDynamic()
                      : Math.ceil(parseFloat(c.slidesPerView, 10))),
                }),
              r.currentTranslate < s.maxTranslate() &&
                ((H = !1),
                c.resistance &&
                  (r.currentTranslate =
                    s.maxTranslate() +
                    1 -
                    (s.maxTranslate() - r.startTranslate - T) ** $))),
          H && (f.preventedByNestedSwiper = !0),
          !s.allowSlideNext &&
            s.swipeDirection === 'next' &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !s.allowSlidePrev &&
            s.swipeDirection === 'prev' &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !s.allowSlidePrev &&
            !s.allowSlideNext &&
            (r.currentTranslate = r.startTranslate),
          c.threshold > 0)
        )
          if (Math.abs(T) > c.threshold || r.allowThresholdMove) {
            if (!r.allowThresholdMove) {
              ((r.allowThresholdMove = !0),
                (u.startX = u.currentX),
                (u.startY = u.currentY),
                (r.currentTranslate = r.startTranslate),
                (u.diff = s.isHorizontal()
                  ? u.currentX - u.startX
                  : u.currentY - u.startY));
              return;
            }
          } else {
            r.currentTranslate = r.startTranslate;
            return;
          }
        !c.followFinger ||
          c.cssMode ||
          (((c.freeMode && c.freeMode.enabled && s.freeMode) ||
            c.watchSlidesProgress) &&
            (s.updateActiveIndex(), s.updateSlidesClasses()),
          c.freeMode &&
            c.freeMode.enabled &&
            s.freeMode &&
            s.freeMode.onTouchMove(),
          s.updateProgress(r.currentTranslate),
          s.setTranslate(r.currentTranslate));
      }
      function Q0(i) {
        const l = this,
          s = l.touchEventsData;
        let r = i;
        r.originalEvent && (r = r.originalEvent);
        let c;
        if (r.type === 'touchend' || r.type === 'touchcancel') {
          if (
            ((c = [...r.changedTouches].find(D => D.identifier === s.touchId)),
            !c || c.identifier !== s.touchId)
          )
            return;
        } else {
          if (s.touchId !== null || r.pointerId !== s.pointerId) return;
          c = r;
        }
        if (
          [
            'pointercancel',
            'pointerout',
            'pointerleave',
            'contextmenu',
          ].includes(r.type) &&
          !(
            ['pointercancel', 'contextmenu'].includes(r.type) &&
            (l.browser.isSafari || l.browser.isWebView)
          )
        )
          return;
        ((s.pointerId = null), (s.touchId = null));
        const {
          params: h,
          touches: m,
          rtlTranslate: f,
          slidesGrid: p,
          enabled: y,
        } = l;
        if (!y || (!h.simulateTouch && r.pointerType === 'mouse')) return;
        if (
          (s.allowTouchCallbacks && l.emit('touchEnd', r),
          (s.allowTouchCallbacks = !1),
          !s.isTouched)
        ) {
          (s.isMoved && h.grabCursor && l.setGrabCursor(!1),
            (s.isMoved = !1),
            (s.startMoving = !1));
          return;
        }
        h.grabCursor &&
          s.isMoved &&
          s.isTouched &&
          (l.allowSlideNext === !0 || l.allowSlidePrev === !0) &&
          l.setGrabCursor(!1);
        const S = ks(),
          w = S - s.touchStartTime;
        if (l.allowClick) {
          const D = r.path || (r.composedPath && r.composedPath());
          (l.updateClickedSlide((D && D[0]) || r.target, D),
            l.emit('tap click', r),
            w < 300 &&
              S - s.lastClickTime < 300 &&
              l.emit('doubleTap doubleClick', r));
        }
        if (
          ((s.lastClickTime = ks()),
          $m(() => {
            l.destroyed || (l.allowClick = !0);
          }),
          !s.isTouched ||
            !s.isMoved ||
            !l.swipeDirection ||
            (m.diff === 0 && !s.loopSwapReset) ||
            (s.currentTranslate === s.startTranslate && !s.loopSwapReset))
        ) {
          ((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1));
          return;
        }
        ((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1));
        let x;
        if (
          (h.followFinger
            ? (x = f ? l.translate : -l.translate)
            : (x = -s.currentTranslate),
          h.cssMode)
        )
          return;
        if (h.freeMode && h.freeMode.enabled) {
          l.freeMode.onTouchEnd({ currentPos: x });
          return;
        }
        const T = x >= -l.maxTranslate() && !l.params.loop;
        let A = 0,
          j = l.slidesSizesGrid[0];
        for (
          let D = 0;
          D < p.length;
          D += D < h.slidesPerGroupSkip ? 1 : h.slidesPerGroup
        ) {
          const U = D < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
          typeof p[D + U] < 'u'
            ? (T || (x >= p[D] && x < p[D + U])) &&
              ((A = D), (j = p[D + U] - p[D]))
            : (T || x >= p[D]) &&
              ((A = D), (j = p[p.length - 1] - p[p.length - 2]));
        }
        let G = null,
          L = null;
        h.rewind &&
          (l.isBeginning
            ? (L =
                h.virtual && h.virtual.enabled && l.virtual
                  ? l.virtual.slides.length - 1
                  : l.slides.length - 1)
            : l.isEnd && (G = 0));
        const H = (x - p[A]) / j,
          $ = A < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
        if (w > h.longSwipesMs) {
          if (!h.longSwipes) {
            l.slideTo(l.activeIndex);
            return;
          }
          (l.swipeDirection === 'next' &&
            (H >= h.longSwipesRatio
              ? l.slideTo(h.rewind && l.isEnd ? G : A + $)
              : l.slideTo(A)),
            l.swipeDirection === 'prev' &&
              (H > 1 - h.longSwipesRatio
                ? l.slideTo(A + $)
                : L !== null && H < 0 && Math.abs(H) > h.longSwipesRatio
                  ? l.slideTo(L)
                  : l.slideTo(A)));
        } else {
          if (!h.shortSwipes) {
            l.slideTo(l.activeIndex);
            return;
          }
          l.navigation &&
          (r.target === l.navigation.nextEl || r.target === l.navigation.prevEl)
            ? r.target === l.navigation.nextEl
              ? l.slideTo(A + $)
              : l.slideTo(A)
            : (l.swipeDirection === 'next' && l.slideTo(G !== null ? G : A + $),
              l.swipeDirection === 'prev' && l.slideTo(L !== null ? L : A));
        }
      }
      function wm() {
        const i = this,
          { params: l, el: s } = i;
        if (s && s.offsetWidth === 0) return;
        l.breakpoints && i.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: c, snapGrid: u } = i,
          h = i.virtual && i.params.virtual.enabled;
        ((i.allowSlideNext = !0),
          (i.allowSlidePrev = !0),
          i.updateSize(),
          i.updateSlides(),
          i.updateSlidesClasses());
        const m = h && l.loop;
        ((l.slidesPerView === 'auto' || l.slidesPerView > 1) &&
        i.isEnd &&
        !i.isBeginning &&
        !i.params.centeredSlides &&
        !m
          ? i.slideTo(i.slides.length - 1, 0, !1, !0)
          : i.params.loop && !h
            ? i.slideToLoop(i.realIndex, 0, !1, !0)
            : i.slideTo(i.activeIndex, 0, !1, !0),
          i.autoplay &&
            i.autoplay.running &&
            i.autoplay.paused &&
            (clearTimeout(i.autoplay.resizeTimeout),
            (i.autoplay.resizeTimeout = setTimeout(() => {
              i.autoplay &&
                i.autoplay.running &&
                i.autoplay.paused &&
                i.autoplay.resume();
            }, 500))),
          (i.allowSlidePrev = c),
          (i.allowSlideNext = r),
          i.params.watchOverflow && u !== i.snapGrid && i.checkOverflow());
      }
      function Z0(i) {
        const l = this;
        l.enabled &&
          (l.allowClick ||
            (l.params.preventClicks && i.preventDefault(),
            l.params.preventClicksPropagation &&
              l.animating &&
              (i.stopPropagation(), i.stopImmediatePropagation())));
      }
      function W0() {
        const i = this,
          { wrapperEl: l, rtlTranslate: s, enabled: r } = i;
        if (!r) return;
        ((i.previousTranslate = i.translate),
          i.isHorizontal()
            ? (i.translate = -l.scrollLeft)
            : (i.translate = -l.scrollTop),
          i.translate === 0 && (i.translate = 0),
          i.updateActiveIndex(),
          i.updateSlidesClasses());
        let c;
        const u = i.maxTranslate() - i.minTranslate();
        (u === 0 ? (c = 0) : (c = (i.translate - i.minTranslate()) / u),
          c !== i.progress && i.updateProgress(s ? -i.translate : i.translate),
          i.emit('setTranslate', i.translate, !1));
      }
      function F0(i) {
        const l = this;
        (Us(l, i.target),
          !(
            l.params.cssMode ||
            (l.params.slidesPerView !== 'auto' && !l.params.autoHeight)
          ) && l.update());
      }
      function J0() {
        const i = this;
        i.documentTouchHandlerProceeded ||
          ((i.documentTouchHandlerProceeded = !0),
          i.params.touchReleaseOnEdges && (i.el.style.touchAction = 'auto'));
      }
      const Qm = (i, l) => {
        const s = xi(),
          { params: r, el: c, wrapperEl: u, device: h } = i,
          m = !!r.nested,
          f = l === 'on' ? 'addEventListener' : 'removeEventListener',
          p = l;
        !c ||
          typeof c == 'string' ||
          (s[f]('touchstart', i.onDocumentTouchStart, {
            passive: !1,
            capture: m,
          }),
          c[f]('touchstart', i.onTouchStart, { passive: !1 }),
          c[f]('pointerdown', i.onTouchStart, { passive: !1 }),
          s[f]('touchmove', i.onTouchMove, { passive: !1, capture: m }),
          s[f]('pointermove', i.onTouchMove, { passive: !1, capture: m }),
          s[f]('touchend', i.onTouchEnd, { passive: !0 }),
          s[f]('pointerup', i.onTouchEnd, { passive: !0 }),
          s[f]('pointercancel', i.onTouchEnd, { passive: !0 }),
          s[f]('touchcancel', i.onTouchEnd, { passive: !0 }),
          s[f]('pointerout', i.onTouchEnd, { passive: !0 }),
          s[f]('pointerleave', i.onTouchEnd, { passive: !0 }),
          s[f]('contextmenu', i.onTouchEnd, { passive: !0 }),
          (r.preventClicks || r.preventClicksPropagation) &&
            c[f]('click', i.onClick, !0),
          r.cssMode && u[f]('scroll', i.onScroll),
          r.updateOnWindowResize
            ? i[p](
                h.ios || h.android
                  ? 'resize orientationchange observerUpdate'
                  : 'resize observerUpdate',
                wm,
                !0
              )
            : i[p]('observerUpdate', wm, !0),
          c[f]('load', i.onLoad, { capture: !0 }));
      };
      function eS() {
        const i = this,
          { params: l } = i;
        ((i.onTouchStart = K0.bind(i)),
          (i.onTouchMove = X0.bind(i)),
          (i.onTouchEnd = Q0.bind(i)),
          (i.onDocumentTouchStart = J0.bind(i)),
          l.cssMode && (i.onScroll = W0.bind(i)),
          (i.onClick = Z0.bind(i)),
          (i.onLoad = F0.bind(i)),
          Qm(i, 'on'));
      }
      function tS() {
        Qm(this, 'off');
      }
      var aS = { attachEvents: eS, detachEvents: tS };
      const Em = (i, l) => i.grid && l.grid && l.grid.rows > 1;
      function iS() {
        const i = this,
          { realIndex: l, initialized: s, params: r, el: c } = i,
          u = r.breakpoints;
        if (!u || (u && Object.keys(u).length === 0)) return;
        const h = xi(),
          m =
            r.breakpointsBase === 'window' || !r.breakpointsBase
              ? r.breakpointsBase
              : 'container',
          f =
            ['window', 'container'].includes(r.breakpointsBase) ||
            !r.breakpointsBase
              ? i.el
              : h.querySelector(r.breakpointsBase),
          p = i.getBreakpoint(u, m, f);
        if (!p || i.currentBreakpoint === p) return;
        const S = (p in u ? u[p] : void 0) || i.originalParams,
          w = Em(i, r),
          x = Em(i, S),
          T = i.params.grabCursor,
          A = S.grabCursor,
          j = r.enabled;
        (w && !x
          ? (c.classList.remove(
              `${r.containerModifierClass}grid`,
              `${r.containerModifierClass}grid-column`
            ),
            i.emitContainerClasses())
          : !w &&
            x &&
            (c.classList.add(`${r.containerModifierClass}grid`),
            ((S.grid.fill && S.grid.fill === 'column') ||
              (!S.grid.fill && r.grid.fill === 'column')) &&
              c.classList.add(`${r.containerModifierClass}grid-column`),
            i.emitContainerClasses()),
          T && !A ? i.unsetGrabCursor() : !T && A && i.setGrabCursor(),
          ['navigation', 'pagination', 'scrollbar'].forEach(U => {
            if (typeof S[U] > 'u') return;
            const X = r[U] && r[U].enabled,
              q = S[U] && S[U].enabled;
            (X && !q && i[U].disable(), !X && q && i[U].enable());
          }));
        const G = S.direction && S.direction !== r.direction,
          L = r.loop && (S.slidesPerView !== r.slidesPerView || G),
          H = r.loop;
        (G && s && i.changeDirection(), Lt(i.params, S));
        const $ = i.params.enabled,
          D = i.params.loop;
        (Object.assign(i, {
          allowTouchMove: i.params.allowTouchMove,
          allowSlideNext: i.params.allowSlideNext,
          allowSlidePrev: i.params.allowSlidePrev,
        }),
          j && !$ ? i.disable() : !j && $ && i.enable(),
          (i.currentBreakpoint = p),
          i.emit('_beforeBreakpoint', S),
          s &&
            (L
              ? (i.loopDestroy(), i.loopCreate(l), i.updateSlides())
              : !H && D
                ? (i.loopCreate(l), i.updateSlides())
                : H && !D && i.loopDestroy()),
          i.emit('breakpoint', S));
      }
      function nS(i, l = 'window', s) {
        if (!i || (l === 'container' && !s)) return;
        let r = !1;
        const c = ht(),
          u = l === 'window' ? c.innerHeight : s.clientHeight,
          h = Object.keys(i).map(m => {
            if (typeof m == 'string' && m.indexOf('@') === 0) {
              const f = parseFloat(m.substr(1));
              return { value: u * f, point: m };
            }
            return { value: m, point: m };
          });
        h.sort((m, f) => parseInt(m.value, 10) - parseInt(f.value, 10));
        for (let m = 0; m < h.length; m += 1) {
          const { point: f, value: p } = h[m];
          l === 'window'
            ? c.matchMedia(`(min-width: ${p}px)`).matches && (r = f)
            : p <= s.clientWidth && (r = f);
        }
        return r || 'max';
      }
      var lS = { setBreakpoint: iS, getBreakpoint: nS };
      function sS(i, l) {
        const s = [];
        return (
          i.forEach(r => {
            typeof r == 'object'
              ? Object.keys(r).forEach(c => {
                  r[c] && s.push(l + c);
                })
              : typeof r == 'string' && s.push(l + r);
          }),
          s
        );
      }
      function rS() {
        const i = this,
          { classNames: l, params: s, rtl: r, el: c, device: u } = i,
          h = sS(
            [
              'initialized',
              s.direction,
              { 'free-mode': i.params.freeMode && s.freeMode.enabled },
              { autoheight: s.autoHeight },
              { rtl: r },
              { grid: s.grid && s.grid.rows > 1 },
              {
                'grid-column':
                  s.grid && s.grid.rows > 1 && s.grid.fill === 'column',
              },
              { android: u.android },
              { ios: u.ios },
              { 'css-mode': s.cssMode },
              { centered: s.cssMode && s.centeredSlides },
              { 'watch-progress': s.watchSlidesProgress },
            ],
            s.containerModifierClass
          );
        (l.push(...h), c.classList.add(...l), i.emitContainerClasses());
      }
      function oS() {
        const i = this,
          { el: l, classNames: s } = i;
        !l ||
          typeof l == 'string' ||
          (l.classList.remove(...s), i.emitContainerClasses());
      }
      var cS = { addClasses: rS, removeClasses: oS };
      function uS() {
        const i = this,
          { isLocked: l, params: s } = i,
          { slidesOffsetBefore: r } = s;
        if (r) {
          const c = i.slides.length - 1,
            u = i.slidesGrid[c] + i.slidesSizesGrid[c] + r * 2;
          i.isLocked = i.size > u;
        } else i.isLocked = i.snapGrid.length === 1;
        (s.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked),
          s.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked),
          l && l !== i.isLocked && (i.isEnd = !1),
          l !== i.isLocked && i.emit(i.isLocked ? 'lock' : 'unlock'));
      }
      var dS = { checkOverflow: uS },
        Hc = {
          init: !0,
          direction: 'horizontal',
          oneWayMovement: !1,
          swiperElementNodeName: 'SWIPER-CONTAINER',
          touchEventsTarget: 'wrapper',
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          eventsPrefix: 'swiper',
          enabled: !0,
          focusableElements:
            'input, select, option, textarea, button, video, label',
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: 'slide',
          breakpoints: void 0,
          breakpointsBase: 'window',
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 5,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          loop: !1,
          loopAddBlankSlides: !0,
          loopAdditionalSlides: 0,
          loopPreventsSliding: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: 'swiper-no-swiping',
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: 'swiper-',
          slideClass: 'swiper-slide',
          slideBlankClass: 'swiper-slide-blank',
          slideActiveClass: 'swiper-slide-active',
          slideVisibleClass: 'swiper-slide-visible',
          slideFullyVisibleClass: 'swiper-slide-fully-visible',
          slideNextClass: 'swiper-slide-next',
          slidePrevClass: 'swiper-slide-prev',
          wrapperClass: 'swiper-wrapper',
          lazyPreloaderClass: 'swiper-lazy-preloader',
          lazyPreloadPrevNext: 0,
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function fS(i, l) {
        return function (r = {}) {
          const c = Object.keys(r)[0],
            u = r[c];
          if (typeof u != 'object' || u === null) {
            Lt(l, r);
            return;
          }
          if (
            (i[c] === !0 && (i[c] = { enabled: !0 }),
            c === 'navigation' &&
              i[c] &&
              i[c].enabled &&
              !i[c].prevEl &&
              !i[c].nextEl &&
              (i[c].auto = !0),
            ['pagination', 'scrollbar'].indexOf(c) >= 0 &&
              i[c] &&
              i[c].enabled &&
              !i[c].el &&
              (i[c].auto = !0),
            !(c in i && 'enabled' in u))
          ) {
            Lt(l, r);
            return;
          }
          (typeof i[c] == 'object' &&
            !('enabled' in i[c]) &&
            (i[c].enabled = !0),
            i[c] || (i[c] = { enabled: !1 }),
            Lt(l, r));
        };
      }
      const Ec = {
          eventsEmitter: c0,
          update: S0,
          translate: _0,
          transition: C0,
          slide: U0,
          loop: k0,
          grabCursor: P0,
          events: aS,
          breakpoints: lS,
          checkOverflow: dS,
          classes: cS,
        },
        Nc = {};
      let Gc = class Ta {
        constructor(...l) {
          let s, r;
          (l.length === 1 &&
          l[0].constructor &&
          Object.prototype.toString.call(l[0]).slice(8, -1) === 'Object'
            ? (r = l[0])
            : ([s, r] = l),
            r || (r = {}),
            (r = Lt({}, r)),
            s && !r.el && (r.el = s));
          const c = xi();
          if (
            r.el &&
            typeof r.el == 'string' &&
            c.querySelectorAll(r.el).length > 1
          ) {
            const f = [];
            return (
              c.querySelectorAll(r.el).forEach(p => {
                const y = Lt({}, r, { el: p });
                f.push(new Ta(y));
              }),
              f
            );
          }
          const u = this;
          ((u.__swiper__ = !0),
            (u.support = Pm()),
            (u.device = Ym({ userAgent: r.userAgent })),
            (u.browser = Km()),
            (u.eventsListeners = {}),
            (u.eventsAnyListeners = []),
            (u.modules = [...u.__modules__]),
            r.modules &&
              Array.isArray(r.modules) &&
              u.modules.push(...r.modules));
          const h = {};
          u.modules.forEach(f => {
            f({
              params: r,
              swiper: u,
              extendParams: fS(r, h),
              on: u.on.bind(u),
              once: u.once.bind(u),
              off: u.off.bind(u),
              emit: u.emit.bind(u),
            });
          });
          const m = Lt({}, Hc, h);
          return (
            (u.params = Lt({}, m, Nc, r)),
            (u.originalParams = Lt({}, u.params)),
            (u.passedParams = Lt({}, r)),
            u.params &&
              u.params.on &&
              Object.keys(u.params.on).forEach(f => {
                u.on(f, u.params.on[f]);
              }),
            u.params && u.params.onAny && u.onAny(u.params.onAny),
            Object.assign(u, {
              enabled: u.params.enabled,
              el: s,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return u.params.direction === 'horizontal';
              },
              isVertical() {
                return u.params.direction === 'vertical';
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: u.params.allowSlideNext,
              allowSlidePrev: u.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: u.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null,
              },
              allowClick: !0,
              allowTouchMove: u.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            u.emit('_swiper'),
            u.params.init && u.init(),
            u
          );
        }
        getDirectionLabel(l) {
          return this.isHorizontal()
            ? l
            : {
                width: 'height',
                'margin-top': 'margin-left',
                'margin-bottom ': 'margin-right',
                'margin-left': 'margin-top',
                'margin-right': 'margin-bottom',
                'padding-left': 'padding-top',
                'padding-right': 'padding-bottom',
                marginRight: 'marginBottom',
              }[l];
        }
        getSlideIndex(l) {
          const { slidesEl: s, params: r } = this,
            c = na(s, `.${r.slideClass}, swiper-slide`),
            u = ym(c[0]);
          return ym(l) - u;
        }
        getSlideIndexByData(l) {
          return this.getSlideIndex(
            this.slides.find(
              s => s.getAttribute('data-swiper-slide-index') * 1 === l
            )
          );
        }
        getSlideIndexWhenGrid(l) {
          return (
            this.grid &&
              this.params.grid &&
              this.params.grid.rows > 1 &&
              (this.params.grid.fill === 'column'
                ? (l = Math.floor(l / this.params.grid.rows))
                : this.params.grid.fill === 'row' &&
                  (l =
                    l % Math.ceil(this.slides.length / this.params.grid.rows))),
            l
          );
        }
        recalcSlides() {
          const l = this,
            { slidesEl: s, params: r } = l;
          l.slides = na(s, `.${r.slideClass}, swiper-slide`);
        }
        enable() {
          const l = this;
          l.enabled ||
            ((l.enabled = !0),
            l.params.grabCursor && l.setGrabCursor(),
            l.emit('enable'));
        }
        disable() {
          const l = this;
          l.enabled &&
            ((l.enabled = !1),
            l.params.grabCursor && l.unsetGrabCursor(),
            l.emit('disable'));
        }
        setProgress(l, s) {
          const r = this;
          l = Math.min(Math.max(l, 0), 1);
          const c = r.minTranslate(),
            h = (r.maxTranslate() - c) * l + c;
          (r.translateTo(h, typeof s > 'u' ? 0 : s),
            r.updateActiveIndex(),
            r.updateSlidesClasses());
        }
        emitContainerClasses() {
          const l = this;
          if (!l.params._emitClasses || !l.el) return;
          const s = l.el.className
            .split(' ')
            .filter(
              r =>
                r.indexOf('swiper') === 0 ||
                r.indexOf(l.params.containerModifierClass) === 0
            );
          l.emit('_containerClasses', s.join(' '));
        }
        getSlideClasses(l) {
          const s = this;
          return s.destroyed
            ? ''
            : l.className
                .split(' ')
                .filter(
                  r =>
                    r.indexOf('swiper-slide') === 0 ||
                    r.indexOf(s.params.slideClass) === 0
                )
                .join(' ');
        }
        emitSlidesClasses() {
          const l = this;
          if (!l.params._emitClasses || !l.el) return;
          const s = [];
          (l.slides.forEach(r => {
            const c = l.getSlideClasses(r);
            (s.push({ slideEl: r, classNames: c }),
              l.emit('_slideClass', r, c));
          }),
            l.emit('_slideClasses', s));
        }
        slidesPerViewDynamic(l = 'current', s = !1) {
          const r = this,
            {
              params: c,
              slides: u,
              slidesGrid: h,
              slidesSizesGrid: m,
              size: f,
              activeIndex: p,
            } = r;
          let y = 1;
          if (typeof c.slidesPerView == 'number') return c.slidesPerView;
          if (c.centeredSlides) {
            let S = u[p] ? Math.ceil(u[p].swiperSlideSize) : 0,
              w;
            for (let x = p + 1; x < u.length; x += 1)
              u[x] &&
                !w &&
                ((S += Math.ceil(u[x].swiperSlideSize)),
                (y += 1),
                S > f && (w = !0));
            for (let x = p - 1; x >= 0; x -= 1)
              u[x] &&
                !w &&
                ((S += u[x].swiperSlideSize), (y += 1), S > f && (w = !0));
          } else if (l === 'current')
            for (let S = p + 1; S < u.length; S += 1)
              (s ? h[S] + m[S] - h[p] < f : h[S] - h[p] < f) && (y += 1);
          else for (let S = p - 1; S >= 0; S -= 1) h[p] - h[S] < f && (y += 1);
          return y;
        }
        update() {
          const l = this;
          if (!l || l.destroyed) return;
          const { snapGrid: s, params: r } = l;
          (r.breakpoints && l.setBreakpoint(),
            [...l.el.querySelectorAll('[loading="lazy"]')].forEach(h => {
              h.complete && Us(l, h);
            }),
            l.updateSize(),
            l.updateSlides(),
            l.updateProgress(),
            l.updateSlidesClasses());
          function c() {
            const h = l.rtlTranslate ? l.translate * -1 : l.translate,
              m = Math.min(Math.max(h, l.maxTranslate()), l.minTranslate());
            (l.setTranslate(m), l.updateActiveIndex(), l.updateSlidesClasses());
          }
          let u;
          if (r.freeMode && r.freeMode.enabled && !r.cssMode)
            (c(), r.autoHeight && l.updateAutoHeight());
          else {
            if (
              (r.slidesPerView === 'auto' || r.slidesPerView > 1) &&
              l.isEnd &&
              !r.centeredSlides
            ) {
              const h =
                l.virtual && r.virtual.enabled ? l.virtual.slides : l.slides;
              u = l.slideTo(h.length - 1, 0, !1, !0);
            } else u = l.slideTo(l.activeIndex, 0, !1, !0);
            u || c();
          }
          (r.watchOverflow && s !== l.snapGrid && l.checkOverflow(),
            l.emit('update'));
        }
        changeDirection(l, s = !0) {
          const r = this,
            c = r.params.direction;
          return (
            l || (l = c === 'horizontal' ? 'vertical' : 'horizontal'),
            l === c ||
              (l !== 'horizontal' && l !== 'vertical') ||
              (r.el.classList.remove(`${r.params.containerModifierClass}${c}`),
              r.el.classList.add(`${r.params.containerModifierClass}${l}`),
              r.emitContainerClasses(),
              (r.params.direction = l),
              r.slides.forEach(u => {
                l === 'vertical' ? (u.style.width = '') : (u.style.height = '');
              }),
              r.emit('changeDirection'),
              s && r.update()),
            r
          );
        }
        changeLanguageDirection(l) {
          const s = this;
          (s.rtl && l === 'rtl') ||
            (!s.rtl && l === 'ltr') ||
            ((s.rtl = l === 'rtl'),
            (s.rtlTranslate = s.params.direction === 'horizontal' && s.rtl),
            s.rtl
              ? (s.el.classList.add(`${s.params.containerModifierClass}rtl`),
                (s.el.dir = 'rtl'))
              : (s.el.classList.remove(`${s.params.containerModifierClass}rtl`),
                (s.el.dir = 'ltr')),
            s.update());
        }
        mount(l) {
          const s = this;
          if (s.mounted) return !0;
          let r = l || s.params.el;
          if ((typeof r == 'string' && (r = document.querySelector(r)), !r))
            return !1;
          ((r.swiper = s),
            r.parentNode &&
              r.parentNode.host &&
              r.parentNode.host.nodeName ===
                s.params.swiperElementNodeName.toUpperCase() &&
              (s.isElement = !0));
          const c = () =>
            `.${(s.params.wrapperClass || '').trim().split(' ').join('.')}`;
          let h =
            r && r.shadowRoot && r.shadowRoot.querySelector
              ? r.shadowRoot.querySelector(c())
              : na(r, c())[0];
          return (
            !h &&
              s.params.createElements &&
              ((h = qs('div', s.params.wrapperClass)),
              r.append(h),
              na(r, `.${s.params.slideClass}`).forEach(m => {
                h.append(m);
              })),
            Object.assign(s, {
              el: r,
              wrapperEl: h,
              slidesEl:
                s.isElement && !r.parentNode.host.slideSlots
                  ? r.parentNode.host
                  : h,
              hostEl: s.isElement ? r.parentNode.host : r,
              mounted: !0,
              rtl:
                r.dir.toLowerCase() === 'rtl' || Za(r, 'direction') === 'rtl',
              rtlTranslate:
                s.params.direction === 'horizontal' &&
                (r.dir.toLowerCase() === 'rtl' || Za(r, 'direction') === 'rtl'),
              wrongRTL: Za(h, 'display') === '-webkit-box',
            }),
            !0
          );
        }
        init(l) {
          const s = this;
          if (s.initialized || s.mount(l) === !1) return s;
          (s.emit('beforeInit'),
            s.params.breakpoints && s.setBreakpoint(),
            s.addClasses(),
            s.updateSize(),
            s.updateSlides(),
            s.params.watchOverflow && s.checkOverflow(),
            s.params.grabCursor && s.enabled && s.setGrabCursor(),
            s.params.loop && s.virtual && s.params.virtual.enabled
              ? s.slideTo(
                  s.params.initialSlide + s.virtual.slidesBefore,
                  0,
                  s.params.runCallbacksOnInit,
                  !1,
                  !0
                )
              : s.slideTo(
                  s.params.initialSlide,
                  0,
                  s.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
            s.params.loop && s.loopCreate(void 0, !0),
            s.attachEvents());
          const c = [...s.el.querySelectorAll('[loading="lazy"]')];
          return (
            s.isElement &&
              c.push(...s.hostEl.querySelectorAll('[loading="lazy"]')),
            c.forEach(u => {
              u.complete
                ? Us(s, u)
                : u.addEventListener('load', h => {
                    Us(s, h.target);
                  });
            }),
            zc(s),
            (s.initialized = !0),
            zc(s),
            s.emit('init'),
            s.emit('afterInit'),
            s
          );
        }
        destroy(l = !0, s = !0) {
          const r = this,
            { params: c, el: u, wrapperEl: h, slides: m } = r;
          return (
            typeof r.params > 'u' ||
              r.destroyed ||
              (r.emit('beforeDestroy'),
              (r.initialized = !1),
              r.detachEvents(),
              c.loop && r.loopDestroy(),
              s &&
                (r.removeClasses(),
                u && typeof u != 'string' && u.removeAttribute('style'),
                h && h.removeAttribute('style'),
                m &&
                  m.length &&
                  m.forEach(f => {
                    (f.classList.remove(
                      c.slideVisibleClass,
                      c.slideFullyVisibleClass,
                      c.slideActiveClass,
                      c.slideNextClass,
                      c.slidePrevClass
                    ),
                      f.removeAttribute('style'),
                      f.removeAttribute('data-swiper-slide-index'));
                  })),
              r.emit('destroy'),
              Object.keys(r.eventsListeners).forEach(f => {
                r.off(f);
              }),
              l !== !1 &&
                (r.el && typeof r.el != 'string' && (r.el.swiper = null),
                Q1(r)),
              (r.destroyed = !0)),
            null
          );
        }
        static extendDefaults(l) {
          Lt(Nc, l);
        }
        static get extendedDefaults() {
          return Nc;
        }
        static get defaults() {
          return Hc;
        }
        static installModule(l) {
          Ta.prototype.__modules__ || (Ta.prototype.__modules__ = []);
          const s = Ta.prototype.__modules__;
          typeof l == 'function' && s.indexOf(l) < 0 && s.push(l);
        }
        static use(l) {
          return Array.isArray(l)
            ? (l.forEach(s => Ta.installModule(s)), Ta)
            : (Ta.installModule(l), Ta);
        }
      };
      Object.keys(Ec).forEach(i => {
        Object.keys(Ec[i]).forEach(l => {
          Gc.prototype[l] = Ec[i][l];
        });
      });
      Gc.use([r0, o0]);
      const Zm = [
        'eventsPrefix',
        'injectStyles',
        'injectStylesUrls',
        'modules',
        'init',
        '_direction',
        'oneWayMovement',
        'swiperElementNodeName',
        'touchEventsTarget',
        'initialSlide',
        '_speed',
        'cssMode',
        'updateOnWindowResize',
        'resizeObserver',
        'nested',
        'focusableElements',
        '_enabled',
        '_width',
        '_height',
        'preventInteractionOnTransition',
        'userAgent',
        'url',
        '_edgeSwipeDetection',
        '_edgeSwipeThreshold',
        '_freeMode',
        '_autoHeight',
        'setWrapperSize',
        'virtualTranslate',
        '_effect',
        'breakpoints',
        'breakpointsBase',
        '_spaceBetween',
        '_slidesPerView',
        'maxBackfaceHiddenSlides',
        '_grid',
        '_slidesPerGroup',
        '_slidesPerGroupSkip',
        '_slidesPerGroupAuto',
        '_centeredSlides',
        '_centeredSlidesBounds',
        '_slidesOffsetBefore',
        '_slidesOffsetAfter',
        'normalizeSlideIndex',
        '_centerInsufficientSlides',
        '_watchOverflow',
        'roundLengths',
        'touchRatio',
        'touchAngle',
        'simulateTouch',
        '_shortSwipes',
        '_longSwipes',
        'longSwipesRatio',
        'longSwipesMs',
        '_followFinger',
        'allowTouchMove',
        '_threshold',
        'touchMoveStopPropagation',
        'touchStartPreventDefault',
        'touchStartForcePreventDefault',
        'touchReleaseOnEdges',
        'uniqueNavElements',
        '_resistance',
        '_resistanceRatio',
        '_watchSlidesProgress',
        '_grabCursor',
        'preventClicks',
        'preventClicksPropagation',
        '_slideToClickedSlide',
        '_loop',
        'loopAdditionalSlides',
        'loopAddBlankSlides',
        'loopPreventsSliding',
        '_rewind',
        '_allowSlidePrev',
        '_allowSlideNext',
        '_swipeHandler',
        '_noSwiping',
        'noSwipingClass',
        'noSwipingSelector',
        'passiveListeners',
        'containerModifierClass',
        'slideClass',
        'slideActiveClass',
        'slideVisibleClass',
        'slideFullyVisibleClass',
        'slideNextClass',
        'slidePrevClass',
        'slideBlankClass',
        'wrapperClass',
        'lazyPreloaderClass',
        'lazyPreloadPrevNext',
        'runCallbacksOnInit',
        'observer',
        'observeParents',
        'observeSlideChildren',
        'a11y',
        '_autoplay',
        '_controller',
        'coverflowEffect',
        'cubeEffect',
        'fadeEffect',
        'flipEffect',
        'creativeEffect',
        'cardsEffect',
        'hashNavigation',
        'history',
        'keyboard',
        'mousewheel',
        '_navigation',
        '_pagination',
        'parallax',
        '_scrollbar',
        '_thumbs',
        'virtual',
        'zoom',
        'control',
      ];
      function vi(i) {
        return (
          typeof i == 'object' &&
          i !== null &&
          i.constructor &&
          Object.prototype.toString.call(i).slice(8, -1) === 'Object' &&
          !i.__swiper__
        );
      }
      function cn(i, l) {
        const s = ['__proto__', 'constructor', 'prototype'];
        Object.keys(l)
          .filter(r => s.indexOf(r) < 0)
          .forEach(r => {
            typeof i[r] > 'u'
              ? (i[r] = l[r])
              : vi(l[r]) && vi(i[r]) && Object.keys(l[r]).length > 0
                ? l[r].__swiper__
                  ? (i[r] = l[r])
                  : cn(i[r], l[r])
                : (i[r] = l[r]);
          });
      }
      function Wm(i = {}) {
        return (
          i.navigation &&
          typeof i.navigation.nextEl > 'u' &&
          typeof i.navigation.prevEl > 'u'
        );
      }
      function Fm(i = {}) {
        return i.pagination && typeof i.pagination.el > 'u';
      }
      function Jm(i = {}) {
        return i.scrollbar && typeof i.scrollbar.el > 'u';
      }
      function ep(i = '') {
        const l = i
            .split(' ')
            .map(r => r.trim())
            .filter(r => !!r),
          s = [];
        return (
          l.forEach(r => {
            s.indexOf(r) < 0 && s.push(r);
          }),
          s.join(' ')
        );
      }
      function hS(i = '') {
        return i
          ? i.includes('swiper-wrapper')
            ? i
            : `swiper-wrapper ${i}`
          : 'swiper-wrapper';
      }
      function mS({
        swiper: i,
        slides: l,
        passedParams: s,
        changedParams: r,
        nextEl: c,
        prevEl: u,
        scrollbarEl: h,
        paginationEl: m,
      }) {
        const f = r.filter(
            q => q !== 'children' && q !== 'direction' && q !== 'wrapperClass'
          ),
          {
            params: p,
            pagination: y,
            navigation: S,
            scrollbar: w,
            virtual: x,
            thumbs: T,
          } = i;
        let A, j, G, L, H, $, D, U;
        (r.includes('thumbs') &&
          s.thumbs &&
          s.thumbs.swiper &&
          !s.thumbs.swiper.destroyed &&
          p.thumbs &&
          (!p.thumbs.swiper || p.thumbs.swiper.destroyed) &&
          (A = !0),
          r.includes('controller') &&
            s.controller &&
            s.controller.control &&
            p.controller &&
            !p.controller.control &&
            (j = !0),
          r.includes('pagination') &&
            s.pagination &&
            (s.pagination.el || m) &&
            (p.pagination || p.pagination === !1) &&
            y &&
            !y.el &&
            (G = !0),
          r.includes('scrollbar') &&
            s.scrollbar &&
            (s.scrollbar.el || h) &&
            (p.scrollbar || p.scrollbar === !1) &&
            w &&
            !w.el &&
            (L = !0),
          r.includes('navigation') &&
            s.navigation &&
            (s.navigation.prevEl || u) &&
            (s.navigation.nextEl || c) &&
            (p.navigation || p.navigation === !1) &&
            S &&
            !S.prevEl &&
            !S.nextEl &&
            (H = !0));
        const X = q => {
          i[q] &&
            (i[q].destroy(),
            q === 'navigation'
              ? (i.isElement && (i[q].prevEl.remove(), i[q].nextEl.remove()),
                (p[q].prevEl = void 0),
                (p[q].nextEl = void 0),
                (i[q].prevEl = void 0),
                (i[q].nextEl = void 0))
              : (i.isElement && i[q].el.remove(),
                (p[q].el = void 0),
                (i[q].el = void 0)));
        };
        (r.includes('loop') &&
          i.isElement &&
          (p.loop && !s.loop
            ? ($ = !0)
            : !p.loop && s.loop
              ? (D = !0)
              : (U = !0)),
          f.forEach(q => {
            if (vi(p[q]) && vi(s[q]))
              (Object.assign(p[q], s[q]),
                (q === 'navigation' ||
                  q === 'pagination' ||
                  q === 'scrollbar') &&
                  'enabled' in s[q] &&
                  !s[q].enabled &&
                  X(q));
            else {
              const se = s[q];
              (se === !0 || se === !1) &&
              (q === 'navigation' || q === 'pagination' || q === 'scrollbar')
                ? se === !1 && X(q)
                : (p[q] = s[q]);
            }
          }),
          f.includes('controller') &&
            !j &&
            i.controller &&
            i.controller.control &&
            p.controller &&
            p.controller.control &&
            (i.controller.control = p.controller.control),
          r.includes('children') && l && x && p.virtual.enabled
            ? ((x.slides = l), x.update(!0))
            : r.includes('virtual') &&
              x &&
              p.virtual.enabled &&
              (l && (x.slides = l), x.update(!0)),
          r.includes('children') && l && p.loop && (U = !0),
          A && T.init() && T.update(!0),
          j && (i.controller.control = p.controller.control),
          G &&
            (i.isElement &&
              (!m || typeof m == 'string') &&
              ((m = document.createElement('div')),
              m.classList.add('swiper-pagination'),
              m.part.add('pagination'),
              i.el.appendChild(m)),
            m && (p.pagination.el = m),
            y.init(),
            y.render(),
            y.update()),
          L &&
            (i.isElement &&
              (!h || typeof h == 'string') &&
              ((h = document.createElement('div')),
              h.classList.add('swiper-scrollbar'),
              h.part.add('scrollbar'),
              i.el.appendChild(h)),
            h && (p.scrollbar.el = h),
            w.init(),
            w.updateSize(),
            w.setTranslate()),
          H &&
            (i.isElement &&
              ((!c || typeof c == 'string') &&
                ((c = document.createElement('div')),
                c.classList.add('swiper-button-next'),
                Lc(c, i.hostEl.constructor.nextButtonSvg),
                c.part.add('button-next'),
                i.el.appendChild(c)),
              (!u || typeof u == 'string') &&
                ((u = document.createElement('div')),
                u.classList.add('swiper-button-prev'),
                Lc(u, i.hostEl.constructor.prevButtonSvg),
                u.part.add('button-prev'),
                i.el.appendChild(u))),
            c && (p.navigation.nextEl = c),
            u && (p.navigation.prevEl = u),
            S.init(),
            S.update()),
          r.includes('allowSlideNext') && (i.allowSlideNext = s.allowSlideNext),
          r.includes('allowSlidePrev') && (i.allowSlidePrev = s.allowSlidePrev),
          r.includes('direction') && i.changeDirection(s.direction, !1),
          ($ || U) && i.loopDestroy(),
          (D || U) && i.loopCreate(),
          i.update());
      }
      function pS(i = {}, l = !0) {
        const s = { on: {} },
          r = {},
          c = {};
        (cn(s, Hc), (s._emitClasses = !0), (s.init = !1));
        const u = {},
          h = Zm.map(f => f.replace(/_/, '')),
          m = Object.assign({}, i);
        return (
          Object.keys(m).forEach(f => {
            typeof i[f] > 'u' ||
              (h.indexOf(f) >= 0
                ? vi(i[f])
                  ? ((s[f] = {}), (c[f] = {}), cn(s[f], i[f]), cn(c[f], i[f]))
                  : ((s[f] = i[f]), (c[f] = i[f]))
                : f.search(/on[A-Z]/) === 0 && typeof i[f] == 'function'
                  ? l
                    ? (r[`${f[2].toLowerCase()}${f.substr(3)}`] = i[f])
                    : (s.on[`${f[2].toLowerCase()}${f.substr(3)}`] = i[f])
                  : (u[f] = i[f]));
          }),
          ['navigation', 'pagination', 'scrollbar'].forEach(f => {
            (s[f] === !0 && (s[f] = {}), s[f] === !1 && delete s[f]);
          }),
          { params: s, passedParams: c, rest: u, events: r }
        );
      }
      function gS(
        {
          el: i,
          nextEl: l,
          prevEl: s,
          paginationEl: r,
          scrollbarEl: c,
          swiper: u,
        },
        h
      ) {
        (Wm(h) &&
          l &&
          s &&
          ((u.params.navigation.nextEl = l),
          (u.originalParams.navigation.nextEl = l),
          (u.params.navigation.prevEl = s),
          (u.originalParams.navigation.prevEl = s)),
          Fm(h) &&
            r &&
            ((u.params.pagination.el = r),
            (u.originalParams.pagination.el = r)),
          Jm(h) &&
            c &&
            ((u.params.scrollbar.el = c), (u.originalParams.scrollbar.el = c)),
          u.init(i));
      }
      function bS(i, l, s, r, c) {
        const u = [];
        if (!l) return u;
        const h = f => {
          u.indexOf(f) < 0 && u.push(f);
        };
        if (s && r) {
          const f = r.map(c),
            p = s.map(c);
          (f.join('') !== p.join('') && h('children'),
            r.length !== s.length && h('children'));
        }
        return (
          Zm.filter(f => f[0] === '_')
            .map(f => f.replace(/_/, ''))
            .forEach(f => {
              if (f in i && f in l)
                if (vi(i[f]) && vi(l[f])) {
                  const p = Object.keys(i[f]),
                    y = Object.keys(l[f]);
                  p.length !== y.length
                    ? h(f)
                    : (p.forEach(S => {
                        i[f][S] !== l[f][S] && h(f);
                      }),
                      y.forEach(S => {
                        i[f][S] !== l[f][S] && h(f);
                      }));
                } else i[f] !== l[f] && h(f);
            }),
          u
        );
      }
      const vS = i => {
        !i ||
          i.destroyed ||
          !i.params.virtual ||
          (i.params.virtual && !i.params.virtual.enabled) ||
          (i.updateSlides(),
          i.updateProgress(),
          i.updateSlidesClasses(),
          i.emit('_virtualUpdated'),
          i.parallax &&
            i.params.parallax &&
            i.params.parallax.enabled &&
            i.parallax.setTranslate());
      };
      function Ps() {
        return (
          (Ps = Object.assign
            ? Object.assign.bind()
            : function (i) {
                for (var l = 1; l < arguments.length; l++) {
                  var s = arguments[l];
                  for (var r in s)
                    Object.prototype.hasOwnProperty.call(s, r) && (i[r] = s[r]);
                }
                return i;
              }),
          Ps.apply(this, arguments)
        );
      }
      function tp(i) {
        return (
          i.type &&
          i.type.displayName &&
          i.type.displayName.includes('SwiperSlide')
        );
      }
      function ap(i) {
        const l = [];
        return (
          Fe.Children.toArray(i).forEach(s => {
            tp(s)
              ? l.push(s)
              : s.props &&
                s.props.children &&
                ap(s.props.children).forEach(r => l.push(r));
          }),
          l
        );
      }
      function yS(i) {
        const l = [],
          s = {
            'container-start': [],
            'container-end': [],
            'wrapper-start': [],
            'wrapper-end': [],
          };
        return (
          Fe.Children.toArray(i).forEach(r => {
            if (tp(r)) l.push(r);
            else if (r.props && r.props.slot && s[r.props.slot])
              s[r.props.slot].push(r);
            else if (r.props && r.props.children) {
              const c = ap(r.props.children);
              c.length > 0
                ? c.forEach(u => l.push(u))
                : s['container-end'].push(r);
            } else s['container-end'].push(r);
          }),
          { slides: l, slots: s }
        );
      }
      function SS(i, l, s) {
        if (!s) return null;
        const r = y => {
            let S = y;
            return (
              y < 0 ? (S = l.length + y) : S >= l.length && (S = S - l.length),
              S
            );
          },
          c = i.isHorizontal()
            ? { [i.rtlTranslate ? 'right' : 'left']: `${s.offset}px` }
            : { top: `${s.offset}px` },
          { from: u, to: h } = s,
          m = i.params.loop ? -l.length : 0,
          f = i.params.loop ? l.length * 2 : l.length,
          p = [];
        for (let y = m; y < f; y += 1) y >= u && y <= h && p.push(l[r(y)]);
        return p.map((y, S) =>
          Fe.cloneElement(y, {
            swiper: i,
            style: c,
            key: y.props.virtualIndex || y.key || `slide-${S}`,
          })
        );
      }
      function ml(i, l) {
        return typeof window > 'u'
          ? Y.useEffect(i, l)
          : Y.useLayoutEffect(i, l);
      }
      const Nm = Y.createContext(null),
        xS = Y.createContext(null),
        Wa = Y.forwardRef(
          (
            {
              className: i,
              tag: l = 'div',
              wrapperTag: s = 'div',
              children: r,
              onSwiper: c,
              ...u
            } = {},
            h
          ) => {
            let m = !1;
            const [f, p] = Y.useState('swiper'),
              [y, S] = Y.useState(null),
              [w, x] = Y.useState(!1),
              T = Y.useRef(!1),
              A = Y.useRef(null),
              j = Y.useRef(null),
              G = Y.useRef(null),
              L = Y.useRef(null),
              H = Y.useRef(null),
              $ = Y.useRef(null),
              D = Y.useRef(null),
              U = Y.useRef(null),
              { params: X, passedParams: q, rest: se, events: F } = pS(u),
              { slides: W, slots: ae } = yS(r),
              ye = () => {
                x(!w);
              };
            Object.assign(X.on, {
              _containerClasses(K, ie) {
                p(ie);
              },
            });
            const Se = () => {
              (Object.assign(X.on, F), (m = !0));
              const K = { ...X };
              if (
                (delete K.wrapperClass,
                (j.current = new Gc(K)),
                j.current.virtual && j.current.params.virtual.enabled)
              ) {
                j.current.virtual.slides = W;
                const ie = {
                  cache: !1,
                  slides: W,
                  renderExternal: S,
                  renderExternalUpdate: !1,
                };
                (cn(j.current.params.virtual, ie),
                  cn(j.current.originalParams.virtual, ie));
              }
            };
            (A.current || Se(),
              j.current && j.current.on('_beforeBreakpoint', ye));
            const Ne = () => {
                m ||
                  !F ||
                  !j.current ||
                  Object.keys(F).forEach(K => {
                    j.current.on(K, F[K]);
                  });
              },
              z = () => {
                !F ||
                  !j.current ||
                  Object.keys(F).forEach(K => {
                    j.current.off(K, F[K]);
                  });
              };
            (Y.useEffect(() => () => {
              j.current && j.current.off('_beforeBreakpoint', ye);
            }),
              Y.useEffect(() => {
                !T.current &&
                  j.current &&
                  (j.current.emitSlidesClasses(), (T.current = !0));
              }),
              ml(() => {
                if ((h && (h.current = A.current), !!A.current))
                  return (
                    j.current.destroyed && Se(),
                    gS(
                      {
                        el: A.current,
                        nextEl: H.current,
                        prevEl: $.current,
                        paginationEl: D.current,
                        scrollbarEl: U.current,
                        swiper: j.current,
                      },
                      X
                    ),
                    c && !j.current.destroyed && c(j.current),
                    () => {
                      j.current &&
                        !j.current.destroyed &&
                        j.current.destroy(!0, !1);
                    }
                  );
              }, []),
              ml(() => {
                Ne();
                const K = bS(q, G.current, W, L.current, ie => ie.key);
                return (
                  (G.current = q),
                  (L.current = W),
                  K.length &&
                    j.current &&
                    !j.current.destroyed &&
                    mS({
                      swiper: j.current,
                      slides: W,
                      passedParams: q,
                      changedParams: K,
                      nextEl: H.current,
                      prevEl: $.current,
                      scrollbarEl: U.current,
                      paginationEl: D.current,
                    }),
                  () => {
                    z();
                  }
                );
              }),
              ml(() => {
                vS(j.current);
              }, [y]));
            function Q() {
              return X.virtual
                ? SS(j.current, W, y)
                : W.map((K, ie) =>
                    Fe.cloneElement(K, {
                      swiper: j.current,
                      swiperSlideIndex: ie,
                    })
                  );
            }
            return Fe.createElement(
              l,
              Ps({ ref: A, className: ep(`${f}${i ? ` ${i}` : ''}`) }, se),
              Fe.createElement(
                xS.Provider,
                { value: j.current },
                ae['container-start'],
                Fe.createElement(
                  s,
                  { className: hS(X.wrapperClass) },
                  ae['wrapper-start'],
                  Q(),
                  ae['wrapper-end']
                ),
                Wm(X) &&
                  Fe.createElement(
                    Fe.Fragment,
                    null,
                    Fe.createElement('div', {
                      ref: $,
                      className: 'swiper-button-prev',
                    }),
                    Fe.createElement('div', {
                      ref: H,
                      className: 'swiper-button-next',
                    })
                  ),
                Jm(X) &&
                  Fe.createElement('div', {
                    ref: U,
                    className: 'swiper-scrollbar',
                  }),
                Fm(X) &&
                  Fe.createElement('div', {
                    ref: D,
                    className: 'swiper-pagination',
                  }),
                ae['container-end']
              )
            );
          }
        );
      Wa.displayName = 'Swiper';
      const Fa = Y.forwardRef(
        (
          {
            tag: i = 'div',
            children: l,
            className: s = '',
            swiper: r,
            zoom: c,
            lazy: u,
            virtualIndex: h,
            swiperSlideIndex: m,
            ...f
          } = {},
          p
        ) => {
          const y = Y.useRef(null),
            [S, w] = Y.useState('swiper-slide'),
            [x, T] = Y.useState(!1);
          function A(H, $, D) {
            $ === y.current && w(D);
          }
          (ml(() => {
            if (
              (typeof m < 'u' && (y.current.swiperSlideIndex = m),
              p && (p.current = y.current),
              !(!y.current || !r))
            ) {
              if (r.destroyed) {
                S !== 'swiper-slide' && w('swiper-slide');
                return;
              }
              return (
                r.on('_slideClass', A),
                () => {
                  r && r.off('_slideClass', A);
                }
              );
            }
          }),
            ml(() => {
              r && y.current && !r.destroyed && w(r.getSlideClasses(y.current));
            }, [r]));
          const j = {
              isActive: S.indexOf('swiper-slide-active') >= 0,
              isVisible: S.indexOf('swiper-slide-visible') >= 0,
              isPrev: S.indexOf('swiper-slide-prev') >= 0,
              isNext: S.indexOf('swiper-slide-next') >= 0,
            },
            G = () => (typeof l == 'function' ? l(j) : l),
            L = () => {
              T(!0);
            };
          return Fe.createElement(
            i,
            Ps(
              {
                ref: y,
                className: ep(`${S}${s ? ` ${s}` : ''}`),
                'data-swiper-slide-index': h,
                onLoad: L,
              },
              f
            ),
            c &&
              Fe.createElement(
                Nm.Provider,
                { value: j },
                Fe.createElement(
                  'div',
                  {
                    className: 'swiper-zoom-container',
                    'data-swiper-zoom': typeof c == 'number' ? c : void 0,
                  },
                  G(),
                  u &&
                    !x &&
                    Fe.createElement('div', {
                      className: 'swiper-lazy-preloader',
                    })
                )
              ),
            !c &&
              Fe.createElement(
                Nm.Provider,
                { value: j },
                G(),
                u &&
                  !x &&
                  Fe.createElement('div', {
                    className: 'swiper-lazy-preloader',
                  })
              )
          );
        }
      );
      Fa.displayName = 'SwiperSlide';
      function TS(i, l, s, r) {
        return (
          i.params.createElements &&
            Object.keys(r).forEach(c => {
              if (!s[c] && s.auto === !0) {
                let u = na(i.el, `.${r[c]}`)[0];
                (u ||
                  ((u = qs('div', r[c])), (u.className = r[c]), i.el.append(u)),
                  (s[c] = u),
                  (l[c] = u));
              }
            }),
          s
        );
      }
      const wS =
        '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
      function ES({ swiper: i, extendParams: l, on: s, emit: r }) {
        (l({
          navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: !0,
            hideOnClick: !1,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled',
          },
        }),
          (i.navigation = { nextEl: null, prevEl: null }));
        function c(x) {
          let T;
          return x &&
            typeof x == 'string' &&
            i.isElement &&
            ((T = i.el.querySelector(x) || i.hostEl.querySelector(x)), T)
            ? T
            : (x &&
                (typeof x == 'string' &&
                  (T = [...document.querySelectorAll(x)]),
                i.params.uniqueNavElements &&
                typeof x == 'string' &&
                T &&
                T.length > 1 &&
                i.el.querySelectorAll(x).length === 1
                  ? (T = i.el.querySelector(x))
                  : T && T.length === 1 && (T = T[0])),
              x && !T ? x : T);
        }
        function u(x, T) {
          const A = i.params.navigation;
          ((x = Sa(x)),
            x.forEach(j => {
              j &&
                (j.classList[T ? 'add' : 'remove'](
                  ...A.disabledClass.split(' ')
                ),
                j.tagName === 'BUTTON' && (j.disabled = T),
                i.params.watchOverflow &&
                  i.enabled &&
                  j.classList[i.isLocked ? 'add' : 'remove'](A.lockClass));
            }));
        }
        function h() {
          const { nextEl: x, prevEl: T } = i.navigation;
          if (i.params.loop) {
            (u(T, !1), u(x, !1));
            return;
          }
          (u(T, i.isBeginning && !i.params.rewind),
            u(x, i.isEnd && !i.params.rewind));
        }
        function m(x) {
          (x.preventDefault(),
            !(i.isBeginning && !i.params.loop && !i.params.rewind) &&
              (i.slidePrev(), r('navigationPrev')));
        }
        function f(x) {
          (x.preventDefault(),
            !(i.isEnd && !i.params.loop && !i.params.rewind) &&
              (i.slideNext(), r('navigationNext')));
        }
        function p() {
          const x = i.params.navigation;
          if (
            ((i.params.navigation = TS(
              i,
              i.originalParams.navigation,
              i.params.navigation,
              { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' }
            )),
            !(x.nextEl || x.prevEl))
          )
            return;
          let T = c(x.nextEl),
            A = c(x.prevEl);
          (Object.assign(i.navigation, { nextEl: T, prevEl: A }),
            (T = Sa(T)),
            (A = Sa(A)));
          const j = (G, L) => {
            if (G) {
              if (
                x.addIcons &&
                G.matches('.swiper-button-next,.swiper-button-prev') &&
                !G.querySelector('svg')
              ) {
                const H = document.createElement('div');
                (Lc(H, wS), G.appendChild(H.querySelector('svg')), H.remove());
              }
              G.addEventListener('click', L === 'next' ? f : m);
            }
            !i.enabled && G && G.classList.add(...x.lockClass.split(' '));
          };
          (T.forEach(G => j(G, 'next')), A.forEach(G => j(G, 'prev')));
        }
        function y() {
          let { nextEl: x, prevEl: T } = i.navigation;
          ((x = Sa(x)), (T = Sa(T)));
          const A = (j, G) => {
            (j.removeEventListener('click', G === 'next' ? f : m),
              j.classList.remove(
                ...i.params.navigation.disabledClass.split(' ')
              ));
          };
          (x.forEach(j => A(j, 'next')), T.forEach(j => A(j, 'prev')));
        }
        (s('init', () => {
          i.params.navigation.enabled === !1 ? w() : (p(), h());
        }),
          s('toEdge fromEdge lock unlock', () => {
            h();
          }),
          s('destroy', () => {
            y();
          }),
          s('enable disable', () => {
            let { nextEl: x, prevEl: T } = i.navigation;
            if (((x = Sa(x)), (T = Sa(T)), i.enabled)) {
              h();
              return;
            }
            [...x, ...T]
              .filter(A => !!A)
              .forEach(A => A.classList.add(i.params.navigation.lockClass));
          }),
          s('click', (x, T) => {
            let { nextEl: A, prevEl: j } = i.navigation;
            ((A = Sa(A)), (j = Sa(j)));
            const G = T.target;
            let L = j.includes(G) || A.includes(G);
            if (i.isElement && !L) {
              const H = T.path || (T.composedPath && T.composedPath());
              H && (L = H.find($ => A.includes($) || j.includes($)));
            }
            if (i.params.navigation.hideOnClick && !L) {
              if (
                i.pagination &&
                i.params.pagination &&
                i.params.pagination.clickable &&
                (i.pagination.el === G || i.pagination.el.contains(G))
              )
                return;
              let H;
              (A.length
                ? (H = A[0].classList.contains(i.params.navigation.hiddenClass))
                : j.length &&
                  (H = j[0].classList.contains(
                    i.params.navigation.hiddenClass
                  )),
                r(H === !0 ? 'navigationShow' : 'navigationHide'),
                [...A, ...j]
                  .filter($ => !!$)
                  .forEach($ =>
                    $.classList.toggle(i.params.navigation.hiddenClass)
                  ));
            }
          }));
        const S = () => {
            (i.el.classList.remove(
              ...i.params.navigation.navigationDisabledClass.split(' ')
            ),
              p(),
              h());
          },
          w = () => {
            (i.el.classList.add(
              ...i.params.navigation.navigationDisabledClass.split(' ')
            ),
              y());
          };
        Object.assign(i.navigation, {
          enable: S,
          disable: w,
          update: h,
          init: p,
          destroy: y,
        });
      }
      const Vc = 2,
        vl = 300;
      function aa(i) {
        return !!(
          i &&
          i.el &&
          i.wrapperEl &&
          Array.isArray(i.slides) &&
          i.slides.length > 0 &&
          !i.destroyed
        );
      }
      function kc(i) {
        const l = i.el;
        if (!l) return null;
        let s = l;
        for (; s; ) {
          const { overflow: r, overflowX: c } = getComputedStyle(s);
          if (r === 'hidden' || c === 'hidden') return s;
          s = s.parentElement;
        }
        return l;
      }
      function NS(i) {
        const { params: l } = i,
          s = l.breakpoints ?? {},
          r = Object.keys(s)
            .map(Number)
            .filter(c => i.width >= c)
            .sort((c, u) => u - c);
        if (r.length > 0) {
          const c = s[r[0]];
          if (c?.slidesPerView !== void 0) return c.slidesPerView;
        }
        return l.slidesPerView;
      }
      function $c(i) {
        const l = NS(i);
        return l === 1 || Number(l) === 1;
      }
      function qc(i) {
        const { params: l } = i,
          s = l.breakpoints ?? {},
          r = Object.keys(s)
            .map(Number)
            .filter(c => i.width >= c)
            .sort((c, u) => u - c);
        if (r.length > 0) {
          const c = s[r[0]];
          if (c && typeof c.spaceBetween == 'number') return c.spaceBetween;
        }
        return typeof l.spaceBetween == 'number' ? l.spaceBetween : 0;
      }
      function Pc(i) {
        const l = kc(i),
          s = i.slides;
        if (!l || !s.length)
          return { viewportRect: null, firstRect: void 0, lastRect: void 0 };
        const r = l.getBoundingClientRect(),
          c = s[0]?.getBoundingClientRect(),
          u = s[s.length - 1]?.getBoundingClientRect();
        return { viewportRect: r, firstRect: c, lastRect: u };
      }
      function Yc(i) {
        const l = kc(i);
        if (!l) return i.getTranslate();
        (i.updateSize(), i.updateSlides());
        const s = l.clientWidth,
          r = i.slides.length - 1;
        if (r < 0) return i.getTranslate();
        const c = i.slidesGrid[r] ?? 0,
          u = i.slidesSizesGrid[r] ?? 0,
          h = c + u,
          m = qc(i);
        return h <= s
          ? i.minTranslate()
          : Math.min(i.minTranslate(), s - h - m);
      }
      function Kc(i) {
        if ($c(i)) return i.activeIndex >= i.slides.length - 1;
        const l = Yc(i);
        return Math.abs(i.getTranslate() - l) <= Vc * 2;
      }
      function _S(i) {
        const l = i.slidesSizesGrid[0] ?? 0;
        if (!l) return 1;
        const s = qc(i);
        return Math.max(1, Math.ceil((i.width + s) / (l + s)));
      }
      function Xc(i) {
        if ($c(i)) return i.activeIndex <= 0;
        const { viewportRect: l, firstRect: s } = Pc(i);
        return !l || !s ? !0 : s.left >= l.left - Vc;
      }
      function Qc(i) {
        return Kc(i);
      }
      function AS(i) {
        return { isBeginning: Xc(i), isEnd: Qc(i) };
      }
      function MS(i, l) {
        const s = i;
        i.wrapperEl &&
          (s.setTransition(vl),
          (i.translate = l),
          (i.wrapperEl.style.transitionDuration = `${vl}ms`),
          (i.wrapperEl.style.transform = `translate3d(${l}px, 0px, 0px)`),
          s.updateActiveIndex(),
          i.updateProgress(),
          i.updateSlidesClasses());
      }
      function ip(i) {
        const l = i;
        if (!i.wrapperEl) return;
        const s = i.getTranslate();
        (i.wrapperEl.style.removeProperty('transition-duration'),
          i.wrapperEl.style.removeProperty('transform'),
          l.setTransition(0),
          i.setTranslate(s),
          i.update());
      }
      function jS(i) {
        const { viewportRect: l, lastRect: s } = Pc(i);
        if (!l) return;
        const r = Yc(i);
        let c = r;
        if (s) {
          const h = s.right - l.right;
          if (h > Vc) {
            const m = i.getTranslate() - h;
            c = Math.min(m, r, i.minTranslate());
          }
        }
        MS(i, c);
        const u = i.slides.length - 1;
        u >= 0 &&
          ((i.activeIndex = u), (i.realIndex = u), i.updateSlidesClasses());
      }
      function CS(i) {
        if (Kc(i)) return !1;
        const l = i.slides.length - 1;
        if (_S(i) <= 2 && i.activeIndex < l - 1) return !1;
        const { viewportRect: r, lastRect: c } = Pc(i);
        if (!r || !c) return !1;
        if (c.left < r.right) return !0;
        const u = Yc(i),
          h = Math.abs(u - i.getTranslate()),
          m = i.activeIndex,
          f = (i.slidesSizesGrid[m + 1] ?? i.slidesSizesGrid[m] ?? 0) + qc(i);
        return h <= f * 1.5;
      }
      function OS(i) {
        if (!Qc(i)) {
          if (!$c(i) && CS(i)) {
            jS(i);
            return;
          }
          (np(i) && (ip(i), i.updateSize(), i.updateSlides()), i.slideNext());
        }
      }
      function BS(i) {
        return Kc(i) && !Xc(i);
      }
      function np(i) {
        if (!i.wrapperEl) return !1;
        const { transform: l, transitionDuration: s } = i.wrapperEl.style;
        return l !== '' || s !== '';
      }
      function RS(i, l) {
        const s = Math.max(0, Math.min(l, i.slides.length - 1));
        i.slideTo(s, vl);
      }
      function DS(i) {
        if (!Xc(i)) {
          if ((np(i) && (ip(i), i.updateSize(), i.updateSlides()), BS(i))) {
            RS(i, Math.max(0, i.slides.length - 2));
            return;
          }
          i.slidePrev();
        }
      }
      function yi() {
        const i = Y.useRef(null),
          l = Y.useRef(null),
          [s, r] = Y.useState(!0),
          [c, u] = Y.useState(!1),
          h = Y.useCallback(x => {
            if (!aa(x)) return;
            const T = AS(x);
            (r(T.isBeginning), u(T.isEnd));
          }, []),
          m = Y.useCallback(
            x => {
              aa(x) &&
                (h(x),
                requestAnimationFrame(() => {
                  aa(x) && h(x);
                }));
            },
            [h]
          ),
          f = Y.useCallback(
            x => {
              if ((l.current?.disconnect(), !aa(x))) return;
              const T = kc(x);
              if (!T) return;
              const A = new ResizeObserver(() => {
                aa(i.current) && m(i.current);
              });
              (A.observe(T),
                x.wrapperEl && A.observe(x.wrapperEl),
                (l.current = A));
            },
            [m]
          ),
          p = Y.useCallback(
            x => {
              aa(x) && ((i.current = x), f(x), m(x));
            },
            [f, m]
          );
        Y.useEffect(
          () => () => {
            (l.current?.disconnect(), (i.current = null));
          },
          []
        );
        const y = Y.useCallback(() => {
            const x = i.current;
            !aa(x) ||
              Qc(x) ||
              (OS(x),
              window.setTimeout(() => {
                aa(i.current) && m(i.current);
              }, vl + 50));
          }, [m]),
          S = Y.useCallback(() => {
            const x = i.current;
            aa(x) &&
              (DS(x),
              window.setTimeout(() => {
                aa(i.current) && m(i.current);
              }, vl + 50));
          }, [m]);
        return {
          swiperRef: i,
          isBeginning: s,
          isEnd: c,
          goNext: y,
          goPrev: S,
          swiperNavHandlers: {
            onSwiper: p,
            onSlideChange: m,
            onTransitionEnd: h,
            onSetTranslate: h,
            onResize: m,
            onUpdate: m,
            onDestroy: () => {
              (l.current?.disconnect(), (i.current = null));
            },
          },
          applyNavState: h,
        };
      }
      function un(i, l = 3e3) {
        return typeof window.requestIdleCallback == 'function'
          ? window.requestIdleCallback(i, { timeout: l })
          : window.setTimeout(i, 1500);
      }
      function lp(i) {
        if (typeof window.cancelIdleCallback == 'function') {
          window.cancelIdleCallback(i);
          return;
        }
        window.clearTimeout(i);
      }
      function LS(i) {
        const l = document.createElement('video');
        ((l.preload = 'auto'), (l.muted = !0), (l.src = i), l.load());
      }
      function sp(i) {
        const l = new Image();
        l.src = i;
      }
      function rp(i, l, s) {
        const r = Y.useRef(new Set()),
          c = i.map(u => `${u.video ?? ''}|${u.image ?? ''}`).join(',');
        Y.useEffect(() => {
          const u = i.flatMap(p => {
            const y = s(p.video),
              S = s(p.image);
            return [
              y && y !== l ? { url: y, type: 'video' } : null,
              S && S !== l ? { url: S, type: 'image' } : null,
            ].filter(w => !!w);
          });
          let h = !1,
            m;
          const f = p => {
            if (h || p >= u.length) return;
            const y = u[p];
            if (!y || r.current.has(y.url)) {
              m = un(() => f(p + 1));
              return;
            }
            (r.current.add(y.url),
              y.type === 'video' ? LS(y.url) : sp(y.url),
              (m = un(() => f(p + 1))));
          };
          return (
            (m = un(() => f(0))),
            () => {
              ((h = !0), m !== void 0 && lp(m));
            }
          );
        }, [c, l, s]);
      }
      function op(i) {
        const l = Y.useRef(new Set()),
          s = i.filter(Boolean).join('|');
        Y.useEffect(() => {
          const r = i.filter(m => m && !l.current.has(m));
          let c = !1,
            u;
          const h = m => {
            if (c || m >= r.length) return;
            const f = r[m];
            if (!f) {
              u = un(() => h(m + 1));
              return;
            }
            (l.current.add(f), sp(f), (u = un(() => h(m + 1))));
          };
          return (
            r.length > 0 && (u = un(() => h(0))),
            () => {
              ((c = !0), u !== void 0 && lp(u));
            }
          );
        }, [s]);
      }
      function cp(i) {
        return Y.useCallback(
          l => {
            if (!l) return '';
            if (l.startsWith('http://') || l.startsWith('https://')) return l;
            const s = i(l);
            return s && s !== l ? s : '';
          },
          [i]
        );
      }
      const zS = 'carousel_-Hs1s',
        HS = 'title_Lsegw',
        US = 'subtitle_pUiF1',
        IS = 'tabs_I1kuo',
        GS = 'tab_XKtrX',
        VS = 'tabActive_2R-2m',
        kS = 'mbSwiperArea_Y-4Aq',
        $S = 'mbNavBtn_Jn7Sc',
        qS = 'mbSwiperWrap_nEZV-',
        PS = 'mbSwiper_WFZ6b',
        YS = 'mbSlideImage_8eTW5',
        KS = 'swiperArea_J9Sm-',
        XS = 'swiper_AmXV-',
        QS = 'slideLayout_pH-Bn',
        ZS = 'slideImage_gs6-M',
        WS = 'slideLeft_tXQK-',
        FS = 'slideRight_eEdcx',
        JS = 'slideMiddle_KYSQ9',
        ex = 'navBtn_fe6Aj',
        tx = 'navPrev_vo98m',
        ax = 'navNext_ftl89',
        ix = 'indicators_YxdES',
        nx = 'indicatorScroller_J9mFS',
        lx = 'indicatorTrackWrap_gc2NK',
        sx = 'indicatorTrack_8A-an',
        rx = 'indicator_BAvdV',
        ox = 'indicatorActive_Tyruk',
        cx = 'indicatorLabel_X-AOO',
        ux = 'indicatorDot_4dmfX',
        dx = 'indicatorBar_-vNQl',
        ve = {
          carousel: zS,
          title: HS,
          subtitle: US,
          tabs: IS,
          tab: GS,
          tabActive: VS,
          mbSwiperArea: kS,
          mbNavBtn: $S,
          mbSwiperWrap: qS,
          mbSwiper: PS,
          mbSlideImage: YS,
          swiperArea: KS,
          swiper: XS,
          slideLayout: QS,
          slideImage: ZS,
          slideLeft: WS,
          slideRight: FS,
          slideMiddle: JS,
          navBtn: ex,
          navPrev: tx,
          navNext: ax,
          indicators: ix,
          indicatorScroller: nx,
          indicatorTrackWrap: lx,
          indicatorTrack: sx,
          indicator: rx,
          indicatorActive: ox,
          indicatorLabel: cx,
          indicatorDot: ux,
          indicatorBar: dx,
        };
      function pl(i, l, s) {
        if (!i) return '';
        const r = l === 'mb' ? `${i}Mobile` : i,
          c = s(r);
        return c && c !== r ? c : '';
      }
      function _m(i, l) {
        const s = [];
        for (const r of i) {
          if (r.image) {
            const c = pl(r.image, 'pc', l),
              u = pl(r.image, 'mb', l);
            (c && s.push(c), u && s.push(u));
          }
          if (r.indicator) {
            const c = pl(r.indicator, 'pc', l);
            c && s.push(c);
          }
        }
        return s;
      }
      function fx() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          [s, r] = Y.useState('diode'),
          [c, u] = Y.useState(0),
          [h, m] = Y.useState({ left: 0, width: 0 }),
          f = yi(),
          p = yi(),
          y = Y.useRef(null),
          S = Y.useRef(null),
          w = Y.useRef([]),
          x = i('section5.materialCarousel', { returnObjects: !0 }),
          T = x[s]?.slides ?? [],
          A = x.ir?.slides ?? [],
          j = Y.useMemo(() => {
            const U = _m(A, l);
            if (s === 'diode') return U;
            if (s === 'ir') {
              const X = A[c];
              if (!X) return U;
              const q = new Set(_m([X], l));
              return U.filter(se => !q.has(se));
            }
            return [];
          }, [s, c, A, l]);
        op(j);
        const G = U => s !== 'ir' || U === c,
          L = Y.useCallback(() => {
            const U = y.current,
              X = w.current[c];
            if (!U || !X) {
              m({ left: 0, width: 0 });
              return;
            }
            const se = X.querySelector(`.${ve.indicatorLabel}`) ?? X;
            let F = 0,
              W = se;
            for (; W && W !== U; ) ((F += W.offsetLeft), (W = W.offsetParent));
            m({ left: F, width: se.offsetWidth });
          }, [c]);
        (Y.useLayoutEffect(() => {
          (L(), window.addEventListener('resize', L));
          const U = S.current;
          return (
            U?.addEventListener('scroll', L, { passive: !0 }),
            () => {
              (window.removeEventListener('resize', L),
                U?.removeEventListener('scroll', L));
            }
          );
        }, [c, s, T.length, L]),
          Y.useEffect(() => {
            const U = S.current,
              X = w.current[c];
            if (!X) return;
            if (U && U.scrollWidth > U.clientWidth) {
              const se = U.getBoundingClientRect(),
                F = X.getBoundingClientRect(),
                W =
                  U.scrollLeft +
                  (F.left - se.left) -
                  U.clientWidth / 2 +
                  F.width / 2,
                ae = U.scrollWidth - U.clientWidth;
              U.scrollTo({
                left: Math.max(0, Math.min(W, ae)),
                behavior: 'smooth',
              });
            }
            const q = window.setTimeout(L, 320);
            return () => window.clearTimeout(q);
          }, [c, s, L]));
        const H = U => {
            U !== s &&
              (r(U),
              u(0),
              f.swiperRef.current?.slideTo(0),
              p.swiperRef.current?.slideTo(0));
          },
          $ = U => {
            u(U);
          },
          D = U => {
            (u(U),
              f.swiperRef.current?.slideTo(U),
              p.swiperRef.current?.slideTo(U));
          };
        return g.jsxs('div', {
          className: ve.carousel,
          children: [
            g.jsx('h2', {
              className: ve.title,
              dangerouslySetInnerHTML: { __html: i('section5.materialsTitle') },
            }),
            g.jsx('p', {
              className: ve.subtitle,
              children: i('section5.materialsSubtitle'),
            }),
            g.jsxs('div', {
              className: ve.tabs,
              children: [
                g.jsx('button', {
                  type: 'button',
                  className: `${ve.tab} ${s === 'diode' ? ve.tabActive : ''}`,
                  onClick: () => H('diode'),
                  children: i('section5.tabDiode'),
                }),
                g.jsx('button', {
                  type: 'button',
                  className: `${ve.tab} ${s === 'ir' ? ve.tabActive : ''}`,
                  onClick: () => H('ir'),
                  children: i('section5.tabIR'),
                }),
              ],
            }),
            g.jsxs('div', {
              className: ve.mbSwiperArea,
              children: [
                g.jsx('button', {
                  type: 'button',
                  className: `${ve.mbNavBtn} ${ve.mbNavPrev}`,
                  onClick: p.goPrev,
                  disabled: p.isBeginning,
                  'aria-label': 'Previous slide',
                  children: g.jsx(it, { name: 'icon-left' }),
                }),
                g.jsx('div', {
                  className: ve.mbSwiperWrap,
                  children: g.jsx(
                    Wa,
                    {
                      className: ve.mbSwiper,
                      slidesPerView: 1,
                      spaceBetween: 0,
                      watchOverflow: !0,
                      observer: !0,
                      observeParents: !0,
                      ...p.swiperNavHandlers,
                      onSlideChange: U => {
                        (p.swiperNavHandlers.onSlideChange(U),
                          $(U.activeIndex));
                      },
                      children: T.map((U, X) =>
                        g.jsx(
                          Fa,
                          {
                            children: U.image
                              ? g.jsx('div', {
                                  className: ve.mbSlideImage,
                                  style: G(X)
                                    ? {
                                        backgroundImage: `url(${pl(U.image, 'mb', l)})`,
                                      }
                                    : void 0,
                                })
                              : null,
                          },
                          `mb-${s}-${U.label}-${X}`
                        )
                      ),
                    },
                    `mb-${s}`
                  ),
                }),
                g.jsx('button', {
                  type: 'button',
                  className: `${ve.mbNavBtn} ${ve.mbNavNext}`,
                  onClick: p.goNext,
                  disabled: p.isEnd,
                  'aria-label': 'Next slide',
                  children: g.jsx(it, { name: 'icon-More' }),
                }),
              ],
            }),
            g.jsxs('div', {
              className: ve.swiperArea,
              children: [
                g.jsx('button', {
                  type: 'button',
                  className: `${ve.navBtn} ${ve.navPrev}`,
                  onClick: f.goPrev,
                  disabled: f.isBeginning,
                  'aria-label': 'Previous slide',
                  children: g.jsx(it, { name: 'icon-left' }),
                }),
                g.jsx(
                  Wa,
                  {
                    className: ve.swiper,
                    modules: [ES],
                    slidesPerView: 1,
                    spaceBetween: 0,
                    ...f.swiperNavHandlers,
                    onSlideChange: U => {
                      (f.swiperNavHandlers.onSlideChange(U), $(U.activeIndex));
                    },
                    children: T.map((U, X) =>
                      g.jsx(
                        Fa,
                        {
                          children: U.image
                            ? g.jsx('div', {
                                className: ve.slideImage,
                                style: G(X)
                                  ? {
                                      backgroundImage: `url(${pl(U.image, 'pc', l)})`,
                                    }
                                  : void 0,
                              })
                            : g.jsxs('div', {
                                className: ve.slideLayout,
                                children: [
                                  g.jsx('div', {
                                    className: ve.slideLeft,
                                    style: {
                                      backgroundImage: `url(${l(U.left)})`,
                                    },
                                  }),
                                  g.jsxs('div', {
                                    className: ve.slideMiddle,
                                    children: [
                                      g.jsx(ft, {
                                        src: l(U.midTop),
                                        width: '100%',
                                        height: '100%',
                                        alt: '',
                                      }),
                                      g.jsx(ft, {
                                        src: l(U.midBottom),
                                        width: '100%',
                                        height: '100%',
                                        alt: '',
                                      }),
                                    ],
                                  }),
                                  g.jsx('div', {
                                    className: ve.slideRight,
                                    style: {
                                      backgroundImage: `url(${l(U.right)})`,
                                    },
                                  }),
                                ],
                              }),
                        },
                        `pc-${s}-${U.label}-${X}`
                      )
                    ),
                  },
                  `pc-${s}`
                ),
                g.jsx('button', {
                  type: 'button',
                  className: `${ve.navBtn} ${ve.navNext}`,
                  onClick: f.goNext,
                  disabled: f.isEnd,
                  'aria-label': 'Next slide',
                  children: g.jsx(it, { name: 'icon-More' }),
                }),
              ],
            }),
            g.jsx('div', {
              className: ve.indicators,
              children: g.jsx('div', {
                className: ve.indicatorScroller,
                ref: S,
                children: g.jsx('div', {
                  className: ve.indicatorTrackWrap,
                  children: g.jsxs('div', {
                    className: ve.indicatorTrack,
                    ref: y,
                    children: [
                      T.map((U, X) =>
                        g.jsxs(
                          'button',
                          {
                            ref: q => {
                              w.current[X] = q;
                            },
                            type: 'button',
                            className: `${ve.indicator} ${c === X ? ve.indicatorActive : ''}`,
                            onClick: () => D(X),
                            children: [
                              g.jsx('span', {
                                className: ve.indicatorDot,
                                style: U.indicator
                                  ? {
                                      backgroundImage: `url(${l(U.indicator)})`,
                                    }
                                  : void 0,
                              }),
                              g.jsx('span', {
                                className: ve.indicatorLabel,
                                children: U.label,
                              }),
                            ],
                          },
                          `${s}-indicator-${U.label}`
                        )
                      ),
                      g.jsx('span', {
                        className: ve.indicatorBar,
                        style: { left: h.left, width: h.width },
                      }),
                    ],
                  }),
                }),
              }),
            }),
          ],
        });
      }
      const hx = 'gallery_2L9W5',
        mx = 'title_xml96',
        px = 'swiperWrap_gtjgA',
        gx = 'swiper_esdCt',
        bx = 'slide_rxUk9',
        vx = 'card_YdLi6',
        yx = 'cardImage_Dhgnv',
        Sx = 'cardLabel_4brNk',
        xx = 'footer_kWlIX',
        Tx = 'dots_kXhjH',
        wx = 'dot_Xe9Ne',
        Ex = 'dotActive_-m1iq',
        Nx = 'navBtns_N7eJS',
        _x = 'navBtn_0-XuO',
        dt = {
          gallery: hx,
          title: mx,
          swiperWrap: px,
          swiper: gx,
          slide: bx,
          card: vx,
          cardImage: yx,
          cardLabel: Sx,
          footer: xx,
          dots: Tx,
          dot: wx,
          dotActive: Ex,
          navBtns: Nx,
          navBtn: _x,
        };
      function Ax(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function Mx() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          [s, r] = Y.useState(0),
          {
            swiperRef: c,
            isBeginning: u,
            isEnd: h,
            goNext: m,
            goPrev: f,
            swiperNavHandlers: p,
          } = yi(),
          y = i('section5.gallerySlides', { returnObjects: !0 }),
          S = T => {
            (p.onSwiper(T), r(T.activeIndex));
          },
          w = T => {
            (p.onSlideChange(T), r(T.activeIndex));
          },
          x = T => {
            c.current?.slideTo(T);
          };
        return g.jsxs('div', {
          className: dt.gallery,
          children: [
            g.jsx('h3', {
              className: dt.title,
              children: i('section5.galleryTitle'),
            }),
            g.jsx('div', {
              className: dt.swiperWrap,
              children: g.jsx(Wa, {
                className: dt.swiper,
                slidesPerView: 'auto',
                spaceBetween: 12,
                watchOverflow: !0,
                observer: !0,
                observeParents: !0,
                breakpoints: { 769: { spaceBetween: 19 } },
                onSwiper: S,
                onSlideChange: w,
                onTransitionEnd: p.onTransitionEnd,
                onSetTranslate: p.onSetTranslate,
                onResize: p.onResize,
                onUpdate: p.onUpdate,
                onDestroy: p.onDestroy,
                children: y.map((T, A) => {
                  const j = Ax(T.image, l);
                  return g.jsx(
                    Fa,
                    {
                      className: dt.slide,
                      children: g.jsxs('div', {
                        className: dt.card,
                        children: [
                          g.jsx('div', {
                            className: dt.cardImage,
                            style: j
                              ? { backgroundImage: `url(${j})` }
                              : void 0,
                          }),
                          g.jsx('span', {
                            className: dt.cardLabel,
                            children: T.label,
                          }),
                        ],
                      }),
                    },
                    `${T.label}-${A}`
                  );
                }),
              }),
            }),
            g.jsxs('div', {
              className: dt.footer,
              children: [
                g.jsx('div', {
                  className: dt.dots,
                  'aria-hidden': y.length <= 1,
                  children: y.map((T, A) =>
                    g.jsx(
                      'button',
                      {
                        type: 'button',
                        className: `${dt.dot} ${A === s ? dt.dotActive : ''}`,
                        onClick: () => x(A),
                        'aria-label': `Go to ${T.label}`,
                        'aria-current': A === s ? 'true' : void 0,
                      },
                      `dot-${T.label}-${A}`
                    )
                  ),
                }),
                g.jsxs('div', {
                  className: dt.navBtns,
                  children: [
                    g.jsx('button', {
                      type: 'button',
                      className: dt.navBtn,
                      onClick: f,
                      disabled: u,
                      'aria-label': 'Previous',
                      children: g.jsx(it, { name: 'icon-left' }),
                    }),
                    g.jsx('button', {
                      type: 'button',
                      className: dt.navBtn,
                      onClick: m,
                      disabled: h,
                      'aria-label': 'Next',
                      children: g.jsx(it, { name: 'icon-More' }),
                    }),
                  ],
                }),
              ],
            }),
          ],
        });
      }
      const jx = 'carousel_Cl-jr',
        Cx = 'swiperWrap_inULH',
        Ox = 'swiper_nOCFo',
        Bx = 'slide_LFS8h',
        Rx = 'card_Jxafd',
        Dx = 'cardImage_8uOed',
        Lx = 'cardTitle_4k7-y',
        zx = 'cardDesc_8uCe4',
        Qa = {
          carousel: jx,
          swiperWrap: Cx,
          swiper: Ox,
          slide: Bx,
          card: Rx,
          cardImage: Dx,
          cardTitle: Lx,
          cardDesc: zx,
        },
        Hx = ['stability1', 'stability2', 'stability3'];
      function Ux() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          { swiperNavHandlers: s } = yi(),
          r = i('section5.stabilityCards', { returnObjects: !0 });
        return g.jsx('div', {
          className: Qa.carousel,
          children: g.jsx('div', {
            className: Qa.swiperWrap,
            children: g.jsx(Wa, {
              className: Qa.swiper,
              slidesPerView: 'auto',
              spaceBetween: 8,
              watchOverflow: !0,
              observer: !0,
              observeParents: !0,
              ...s,
              children: r.map((c, u) =>
                g.jsx(
                  Fa,
                  {
                    className: Qa.slide,
                    children: g.jsxs('div', {
                      className: Qa.card,
                      children: [
                        g.jsx('div', {
                          className: Qa.cardImage,
                          style: { backgroundImage: `url(${l(Hx[u])})` },
                        }),
                        g.jsx('h3', {
                          className: Qa.cardTitle,
                          children: c.title,
                        }),
                        g.jsx('p', {
                          className: Qa.cardDesc,
                          dangerouslySetInnerHTML: { __html: c.description },
                        }),
                      ],
                    }),
                  },
                  c.title
                )
              ),
            }),
          }),
        });
      }
      const Ix = 'section5_TCJms',
        Gx = 'hero_iNIy1',
        Vx = 'section5Body_dGQlk',
        kx = 'stabilityMobile_Y-Lyb',
        $x = 'stabilityDesktop_drSgp',
        qx = 'stabilityImages_njk98',
        Px = 'stabilityImage_KAZ1d',
        Yx = 'stabilityTexts_kTM5F',
        Kx = 'stabilityText_u5APJ',
        xa = {
          section5: Ix,
          hero: Gx,
          section5Body: Vx,
          stabilityMobile: kx,
          stabilityDesktop: $x,
          stabilityImages: qx,
          stabilityImage: Px,
          stabilityTexts: Yx,
          stabilityText: Kx,
        },
        Xx = ['stability1', 'stability2', 'stability3'];
      function Qx() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          r = Si(l, 'stabilityHero', 'stabilityHeroMobile', s),
          c = i('section5.stabilityCards', { returnObjects: !0 });
        return g.jsxs('section', {
          className: xa.section5,
          children: [
            g.jsx('div', {
              className: xa.hero,
              style: { backgroundImage: `url(${r})` },
              children: g.jsx('h2', {
                dangerouslySetInnerHTML: { __html: i('section5.heroTitle') },
              }),
            }),
            g.jsxs('div', {
              className: xa.section5Body,
              children: [
                g.jsx('div', {
                  className: xa.stabilityMobile,
                  children: g.jsx(Ux, {}),
                }),
                g.jsxs('div', {
                  className: xa.stabilityDesktop,
                  children: [
                    g.jsx('div', {
                      className: xa.stabilityImages,
                      children: Xx.map(u =>
                        g.jsx(
                          'div',
                          {
                            className: xa.stabilityImage,
                            style: { backgroundImage: `url(${l(u)})` },
                          },
                          u
                        )
                      ),
                    }),
                    g.jsx('div', {
                      className: xa.stabilityTexts,
                      children: c.map((u, h) =>
                        g.jsxs(
                          'div',
                          {
                            className: xa.stabilityText,
                            children: [
                              g.jsx('h3', { children: u.title }),
                              g.jsx('p', {
                                dangerouslySetInnerHTML: {
                                  __html: u.description,
                                },
                              }),
                            ],
                          },
                          h
                        )
                      ),
                    }),
                  ],
                }),
                g.jsx(fx, {}),
                g.jsx(Mx, {}),
              ],
            }),
          ],
        });
      }
      const Zx = 'carousel_WYCfS',
        Wx = 'swiperWrap_Y-9B-',
        Fx = 'swiper_90Ho9',
        Jx = 'slide_kYeyj',
        eT = 'cardImage_AqGgn',
        dl = {
          carousel: Zx,
          swiperWrap: Wx,
          swiper: Fx,
          slide: Jx,
          cardImage: eT,
        },
        tT = ['workspaceCard1', 'workspaceCard2', 'workspaceCard3'];
      function aT() {
        const { t: i } = de('imageUrl'),
          { swiperNavHandlers: l } = yi();
        return g.jsx('div', {
          className: dl.carousel,
          children: g.jsx('div', {
            className: dl.swiperWrap,
            children: g.jsx(Wa, {
              className: dl.swiper,
              slidesPerView: 'auto',
              spaceBetween: 14,
              watchOverflow: !0,
              observer: !0,
              observeParents: !0,
              ...l,
              children: tT.map(s =>
                g.jsx(
                  Fa,
                  {
                    className: dl.slide,
                    children: g.jsx('div', {
                      className: dl.cardImage,
                      style: { backgroundImage: `url(${i(s)})` },
                    }),
                  },
                  s
                )
              ),
            }),
          }),
        });
      }
      const iT = 'section6_jJ2Mj',
        nT = 'textBlock_NSzA7',
        lT = 'title_Zkquq',
        sT = 'subtitleRow_Hx0d4',
        rT = 'workspace_f3UqJ',
        oT = 'subtitle_XM3ml',
        cT = 'description_ZMZpq',
        uT = 'emDash_l27nX',
        dT = 'visualPanel_0M84w',
        fT = 'visual_SG-vg',
        hT = 'cardsMobile_qxiR2',
        mT = 'cardsDesktop_MNd8R',
        pT = 'card_soI27',
        Rt = {
          section6: iT,
          textBlock: nT,
          title: lT,
          subtitleRow: sT,
          workspace: rT,
          subtitle: oT,
          description: cT,
          emDash: uT,
          visualPanel: dT,
          visual: fT,
          cardsMobile: hT,
          cardsDesktop: mT,
          card: pT,
        },
        gT = ['workspaceCard1', 'workspaceCard2', 'workspaceCard3'];
      function bT() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          r = Si(l, 'workspaceBg', 'workspaceBgMobile', s);
        return g.jsxs('section', {
          className: Rt.section6,
          style: s ? void 0 : { backgroundImage: `url(${r})` },
          children: [
            g.jsxs('div', {
              className: Rt.textBlock,
              children: [
                g.jsx('h2', {
                  className: Rt.title,
                  children: i('section6.title'),
                }),
                g.jsxs('div', {
                  className: Rt.subtitleRow,
                  children: [
                    g.jsx('span', {
                      className: Rt.workspace,
                      children: i('section6.workspace'),
                    }),
                    g.jsx('span', {
                      className: Rt.subtitle,
                      children: i('section6.subtitle'),
                    }),
                  ],
                }),
                g.jsxs('p', {
                  className: Rt.description,
                  children: [
                    i('section6.description'),
                    g.jsx('span', {
                      className: Rt.emDash,
                      children: i('section6.emDash'),
                    }),
                    i('section6.descriptionEnd'),
                  ],
                }),
              ],
            }),
            g.jsxs('div', {
              className: Rt.visualPanel,
              children: [
                s
                  ? g.jsx('div', {
                      className: Rt.visual,
                      style: { backgroundImage: `url(${r})` },
                      role: 'img',
                      'aria-hidden': !0,
                    })
                  : null,
                g.jsx('div', {
                  className: Rt.cardsMobile,
                  children: g.jsx(aT, {}),
                }),
              ],
            }),
            g.jsx('div', {
              className: Rt.cardsDesktop,
              children: gT.map(c =>
                g.jsx(
                  'div',
                  {
                    className: Rt.card,
                    style: { backgroundImage: `url(${l(c)})` },
                  },
                  c
                )
              ),
            }),
          ],
        });
      }
      const vT = 'section7_aiRu-',
        yT = 'textBlock_9fZ3F',
        ST = 'title_MpHQX',
        xT = 'subtitle_5N4RW',
        TT = 'visual_xrgUS',
        fl = {
          section7: vT,
          textBlock: yT,
          title: ST,
          subtitle: xT,
          visual: TT,
        };
      function wT() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          r = Si(l, 'speedBg', 'speedBgMobile', s);
        return g.jsxs('section', {
          className: fl.section7,
          style: s ? void 0 : { backgroundImage: `url(${r})` },
          children: [
            g.jsxs('div', {
              className: fl.textBlock,
              children: [
                g.jsx('h2', {
                  className: fl.title,
                  dangerouslySetInnerHTML: { __html: i('section7.title') },
                }),
                g.jsx('p', {
                  className: fl.subtitle,
                  dangerouslySetInnerHTML: { __html: i('section7.subtitle') },
                }),
              ],
            }),
            s
              ? g.jsx('div', {
                  className: fl.visual,
                  style: { backgroundImage: `url(${r})` },
                  role: 'img',
                  'aria-hidden': !0,
                })
              : null,
          ],
        });
      }
      const ET = 'carousel_koCBr',
        NT = 'media_FzN6a',
        _T = 'mediaInner_hN5SG',
        AT = 'mediaAsset_kkZQh',
        MT = 'mediaPlaceholder_4GOhB',
        jT = 'mediaNavBtn_7Z6QO',
        CT = 'mediaNavBtnPrev_H8WAy',
        OT = 'mediaNavBtnNext_OQuae',
        BT = 'panel_NpFTN',
        RT = 'sideBtn_8t7vT',
        DT = 'sideBtnLeft_fnhjC',
        LT = 'sidePill_OLr2Y',
        zT = 'sidePlus_nZNNU',
        HT = 'sideBtnRight_9SgZ5',
        UT = 'sideBtnDisabled_AUz86',
        IT = 'card_WTVaV',
        GT = 'cardTitle_vlyLE',
        VT = 'cardDesc_9BUBp',
        Ie = {
          carousel: ET,
          media: NT,
          mediaInner: _T,
          mediaAsset: AT,
          mediaPlaceholder: MT,
          mediaNavBtn: jT,
          mediaNavBtnPrev: CT,
          mediaNavBtnNext: OT,
          panel: BT,
          sideBtn: RT,
          sideBtnLeft: DT,
          sidePill: LT,
          sidePlus: zT,
          sideBtnRight: HT,
          sideBtnDisabled: UT,
          card: IT,
          cardTitle: GT,
          cardDesc: VT,
        };
      function kT(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function $T() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          [s, r] = Y.useState(0),
          c = i('section8.safetyTabs', { returnObjects: !0 }),
          u = c[s],
          h = kT(u?.image ? `${u.image}Mobile` : void 0, l),
          m = s <= 0,
          f = s >= c.length - 1,
          p = () => {
            m || r(S => Math.max(0, S - 1));
          },
          y = () => {
            f || r(S => Math.min(c.length - 1, S + 1));
          };
        return g.jsxs('div', {
          className: Ie.carousel,
          children: [
            g.jsxs('div', {
              className: Ie.media,
              children: [
                g.jsx('div', {
                  className: Ie.mediaInner,
                  children: h
                    ? g.jsx('div', {
                        className: Ie.mediaAsset,
                        style: { backgroundImage: `url(${h})` },
                      })
                    : g.jsx('div', { className: Ie.mediaPlaceholder }),
                }),
                g.jsx('button', {
                  type: 'button',
                  className: `${Ie.mediaNavBtn} ${Ie.mediaNavBtnPrev}`,
                  onClick: p,
                  disabled: m,
                  'aria-label': 'Previous slide',
                  children: g.jsx(it, { name: 'icon-left' }),
                }),
                g.jsx('button', {
                  type: 'button',
                  className: `${Ie.mediaNavBtn} ${Ie.mediaNavBtnNext}`,
                  onClick: y,
                  disabled: f,
                  'aria-label': 'Next slide',
                  children: g.jsx(it, { name: 'icon-More' }),
                }),
              ],
            }),
            g.jsxs('div', {
              className: Ie.panel,
              children: [
                g.jsxs('button', {
                  type: 'button',
                  className: `${Ie.sideBtn} ${Ie.sideBtnLeft} ${m ? Ie.sideBtnDisabled : ''}`,
                  onClick: p,
                  disabled: m,
                  'aria-label': 'Previous feature',
                  children: [
                    g.jsx('span', { className: Ie.sidePill }),
                    g.jsx('span', {
                      className: Ie.sidePlus,
                      'aria-hidden': 'true',
                    }),
                  ],
                }),
                g.jsxs('div', {
                  className: Ie.card,
                  children: [
                    g.jsx('h3', { className: Ie.cardTitle, children: u.title }),
                    g.jsx('p', {
                      className: Ie.cardDesc,
                      dangerouslySetInnerHTML: { __html: u.description },
                    }),
                  ],
                }),
                g.jsxs('button', {
                  type: 'button',
                  className: `${Ie.sideBtn} ${Ie.sideBtnRight} ${f ? Ie.sideBtnDisabled : ''}`,
                  onClick: y,
                  disabled: f,
                  'aria-label': 'Next feature',
                  children: [
                    g.jsx('span', { className: Ie.sidePill }),
                    g.jsx('span', {
                      className: Ie.sidePlus,
                      'aria-hidden': 'true',
                    }),
                  ],
                }),
              ],
            }),
          ],
        });
      }
      const qT = 'section8_Crot4',
        PT = 'header_uKqUd',
        YT = 'title_zdQGX',
        KT = 'class1_SAbq-',
        XT = 'subtitle_PUHHq',
        QT = 'highlight_YFLtR',
        ZT = 'content_UW5Oe',
        WT = 'leftPanel_NSzas',
        FT = 'tabs_xW-hG',
        JT = 'tab_H38A8',
        e2 = 'tabActive_HLgJJ',
        t2 = 'tabTitle_Wz3qs',
        a2 = 'tabDesc_PDkSh',
        i2 = 'mediaPanel_C4lTH',
        n2 = 'mediaPlaceholder_ZFLEk',
        l2 = 'mediaImage_LAdGA',
        s2 = 'mbBody_euLAN',
        r2 = 'mbHeader_5QVNO',
        Ge = {
          section8: qT,
          header: PT,
          title: YT,
          class1: KT,
          subtitle: XT,
          highlight: QT,
          content: ZT,
          leftPanel: WT,
          tabs: FT,
          tab: JT,
          tabActive: e2,
          tabTitle: t2,
          tabDesc: a2,
          mediaPanel: i2,
          mediaPlaceholder: n2,
          mediaImage: l2,
          mbBody: s2,
          mbHeader: r2,
        };
      function o2(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function c2() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          [r, c] = Y.useState(0),
          u = Si(l, 'safetyHeaderBg', 'safetyHeaderMobile', s),
          h = i('section8.safetyTabs', { returnObjects: !0 }),
          m = h[r],
          f = o2(m?.image, l);
        return s
          ? g.jsxs('section', {
              className: Ge.section8,
              children: [
                g.jsxs('div', {
                  className: Ge.mbHeader,
                  style: { backgroundImage: `url(${u})` },
                  children: [
                    g.jsxs('h2', {
                      className: Ge.title,
                      children: [
                        g.jsx('span', {
                          className: Ge.class1,
                          children: i('section8.class1'),
                        }),
                        i('section8.eyeSafe'),
                      ],
                    }),
                    g.jsxs('p', {
                      className: Ge.subtitle,
                      children: [
                        g.jsx('span', {
                          className: Ge.highlight,
                          children: i('section8.noGoggles'),
                        }),
                        i('section8.noGogglesEnd'),
                      ],
                    }),
                  ],
                }),
                g.jsx('div', { className: Ge.mbBody, children: g.jsx($T, {}) }),
              ],
            })
          : g.jsxs('section', {
              className: Ge.section8,
              children: [
                g.jsxs('div', {
                  className: Ge.header,
                  style: { backgroundImage: `url(${u})` },
                  children: [
                    g.jsxs('h2', {
                      className: Ge.title,
                      children: [
                        g.jsx('span', {
                          className: Ge.class1,
                          children: i('section8.class1'),
                        }),
                        i('section8.eyeSafe'),
                      ],
                    }),
                    g.jsxs('p', {
                      className: Ge.subtitle,
                      children: [
                        g.jsx('span', {
                          className: Ge.highlight,
                          children: i('section8.noGoggles'),
                        }),
                        i('section8.noGogglesEnd'),
                      ],
                    }),
                  ],
                }),
                g.jsxs('div', {
                  className: Ge.content,
                  children: [
                    g.jsx('div', {
                      className: Ge.leftPanel,
                      children: g.jsx('div', {
                        className: Ge.tabs,
                        children: h.map((p, y) =>
                          g.jsxs(
                            'button',
                            {
                              type: 'button',
                              className: `${Ge.tab} ${r === y ? Ge.tabActive : ''}`,
                              onClick: () => c(y),
                              children: [
                                g.jsx('h3', {
                                  className: Ge.tabTitle,
                                  children: p.title,
                                }),
                                r === y &&
                                  g.jsx('p', {
                                    className: Ge.tabDesc,
                                    dangerouslySetInnerHTML: {
                                      __html: p.description,
                                    },
                                  }),
                              ],
                            },
                            p.title
                          )
                        ),
                      }),
                    }),
                    g.jsx(
                      'div',
                      {
                        className: Ge.mediaPanel,
                        children: f
                          ? g.jsx('div', {
                              className: Ge.mediaImage,
                              style: { backgroundImage: `url(${f})` },
                            })
                          : g.jsx('div', { className: Ge.mediaPlaceholder }),
                      },
                      r
                    ),
                  ],
                }),
              ],
            });
      }
      const u2 = 'section9_qBLUR',
        d2 = 'header_91t1a',
        f2 = 'title_nWlx1',
        h2 = 'subtitle_wFI4-',
        m2 = 'fdsTitle_ABVot',
        p2 = 'fdsDesc_ZOvs0',
        g2 = 'mainImage_gR4P0',
        b2 = 'card_XY-f-',
        v2 = 'cardTop_NxjQt',
        y2 = 'pcImage_49Jui',
        S2 = 'appImage_rJqq1',
        x2 = 'features_Oht7n',
        T2 = 'feature_Mu82H',
        Dt = {
          section9: u2,
          header: d2,
          title: f2,
          subtitle: h2,
          fdsTitle: m2,
          fdsDesc: p2,
          mainImage: g2,
          card: b2,
          cardTop: v2,
          pcImage: y2,
          appImage: S2,
          features: x2,
          feature: T2,
        };
      function w2() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          r = Si(l, 'softwareMain', 'softwareMainMobile', s),
          c = l('softwarePC'),
          u = l('softwareDevices'),
          h = i('section9.features', { returnObjects: !0 });
        return g.jsxs('section', {
          className: Dt.section9,
          children: [
            g.jsxs('div', {
              className: Dt.header,
              children: [
                g.jsx('h2', {
                  className: Dt.title,
                  children: i('section9.title'),
                }),
                g.jsx('p', {
                  className: Dt.subtitle,
                  children: i('section9.subtitle'),
                }),
              ],
            }),
            g.jsx('h3', {
              className: Dt.fdsTitle,
              children: i('section9.fdsTitle'),
            }),
            g.jsx('p', {
              className: Dt.fdsDesc,
              dangerouslySetInnerHTML: { __html: i('section9.fdsDesc') },
            }),
            g.jsx(ft, { className: Dt.mainImage, src: r, alt: '' }),
            g.jsxs('div', {
              className: Dt.card,
              children: [
                g.jsxs('div', {
                  className: Dt.cardTop,
                  children: [
                    g.jsx(ft, {
                      className: Dt.pcImage,
                      src: c,
                      alt: '',
                      style: { objectFit: 'contain' },
                    }),
                    g.jsx(ft, {
                      className: Dt.appImage,
                      src: u,
                      alt: '',
                      style: { objectFit: 'contain' },
                    }),
                  ],
                }),
                g.jsx('div', {
                  className: Dt.features,
                  children: h.map((m, f) =>
                    g.jsxs(
                      'div',
                      {
                        className: Dt.feature,
                        children: [
                          g.jsx('h4', { children: m.title }),
                          g.jsx('p', {
                            dangerouslySetInnerHTML: { __html: m.description },
                          }),
                        ],
                      },
                      f
                    )
                  ),
                }),
              ],
            }),
          ],
        });
      }
      const E2 = 'carousel_xaCEp',
        N2 = 'media_Izxvb',
        _2 = 'mediaInner_uSW3A',
        A2 = 'mediaAsset_dVx1r',
        M2 = 'mediaPlaceholder_oPwUA',
        j2 = 'mediaNavBtn_KvToZ',
        C2 = 'mediaNavBtnPrev_C0oNs',
        O2 = 'mediaNavBtnNext_dKGpd',
        B2 = 'panel_7VCfU',
        R2 = 'sideBtn_B9qpS',
        D2 = 'sideBtnLeft_4PbPg',
        L2 = 'sidePill_XEsRw',
        z2 = 'sidePlus_q9fJV',
        H2 = 'sideBtnRight_0cU6w',
        U2 = 'sideBtnDisabled_uG3Xq',
        I2 = 'card_YuErl',
        G2 = 'cardTitle_QLQPg',
        V2 = 'cardDesc_lNXik',
        He = {
          carousel: E2,
          media: N2,
          mediaInner: _2,
          mediaAsset: A2,
          mediaPlaceholder: M2,
          mediaNavBtn: j2,
          mediaNavBtnPrev: C2,
          mediaNavBtnNext: O2,
          panel: B2,
          sideBtn: R2,
          sideBtnLeft: D2,
          sidePill: L2,
          sidePlus: z2,
          sideBtnRight: H2,
          sideBtnDisabled: U2,
          card: I2,
          cardTitle: G2,
          cardDesc: V2,
        };
      function k2() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          [s, r] = Y.useState(0),
          c = Y.useRef(null),
          u = cp(l),
          h = i('section10.aiTabs', { returnObjects: !0 }),
          m = h[s],
          f = u(m?.video),
          p = u(m?.image);
        rp(h, f || p, u);
        const y = s <= 0,
          S = s >= h.length - 1,
          w = () => {
            y || r(T => Math.max(0, T - 1));
          },
          x = () => {
            S || r(T => Math.min(h.length - 1, T + 1));
          };
        return (
          Y.useEffect(() => {
            const T = c.current;
            if (!T || !f) return;
            const A = requestAnimationFrame(() => {
              T.src !== f && ((T.src = f), T.load(), T.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(A);
          }, [f]),
          g.jsxs('div', {
            className: He.carousel,
            children: [
              g.jsxs('div', {
                className: He.media,
                children: [
                  g.jsx('div', {
                    className: He.mediaInner,
                    children: f
                      ? g.jsx('video', {
                          ref: c,
                          className: He.mediaAsset,
                          src: f,
                          autoPlay: !0,
                          loop: !0,
                          muted: !0,
                          playsInline: !0,
                        })
                      : p
                        ? g.jsx('div', {
                            className: He.mediaAsset,
                            style: { backgroundImage: `url(${p})` },
                          })
                        : g.jsx('div', { className: He.mediaPlaceholder }),
                  }),
                  g.jsx('button', {
                    type: 'button',
                    className: `${He.mediaNavBtn} ${He.mediaNavBtnPrev}`,
                    onClick: w,
                    disabled: y,
                    'aria-label': 'Previous slide',
                    children: g.jsx(it, { name: 'icon-left' }),
                  }),
                  g.jsx('button', {
                    type: 'button',
                    className: `${He.mediaNavBtn} ${He.mediaNavBtnNext}`,
                    onClick: x,
                    disabled: S,
                    'aria-label': 'Next slide',
                    children: g.jsx(it, { name: 'icon-More' }),
                  }),
                ],
              }),
              g.jsxs('div', {
                className: He.panel,
                children: [
                  g.jsxs('button', {
                    type: 'button',
                    className: `${He.sideBtn} ${He.sideBtnLeft} ${y ? He.sideBtnDisabled : ''}`,
                    onClick: w,
                    disabled: y,
                    'aria-label': 'Previous feature',
                    children: [
                      g.jsx('span', { className: He.sidePill }),
                      g.jsx('span', {
                        className: He.sidePlus,
                        'aria-hidden': 'true',
                      }),
                    ],
                  }),
                  g.jsxs('div', {
                    className: He.card,
                    children: [
                      g.jsx('h3', {
                        className: He.cardTitle,
                        children: m.title,
                      }),
                      g.jsx('p', {
                        className: He.cardDesc,
                        dangerouslySetInnerHTML: { __html: m.description },
                      }),
                    ],
                  }),
                  g.jsxs('button', {
                    type: 'button',
                    className: `${He.sideBtn} ${He.sideBtnRight} ${S ? He.sideBtnDisabled : ''}`,
                    onClick: x,
                    disabled: S,
                    'aria-label': 'Next feature',
                    children: [
                      g.jsx('span', { className: He.sidePill }),
                      g.jsx('span', {
                        className: He.sidePlus,
                        'aria-hidden': 'true',
                      }),
                    ],
                  }),
                ],
              }),
            ],
          })
        );
      }
      const $2 = 'carousel_DR--m',
        q2 = 'swiperWrap_2VC-u',
        P2 = 'swiper_LQQOr',
        Y2 = 'card_099Ti',
        K2 = 'thumb_Y7tLp',
        X2 = 'cardTitle_FG9wg',
        Q2 = 'cardDesc_u-Zgu',
        Z2 = 'footer_EnEgk',
        W2 = 'dots_YJvsd',
        F2 = 'dot_YIcgL',
        J2 = 'dotActive_NM-s0',
        ew = 'navBtns_DJ5qj',
        tw = 'navBtn_YtTjj',
        yt = {
          carousel: $2,
          swiperWrap: q2,
          swiper: P2,
          card: Y2,
          thumb: K2,
          cardTitle: X2,
          cardDesc: Q2,
          footer: Z2,
          dots: W2,
          dot: F2,
          dotActive: J2,
          navBtns: ew,
          navBtn: tw,
        };
      function aw(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function iw(i, l) {
        if (!i || l <= 1) return l;
        (i.updateSize(), i.updateSlides());
        const s = i.slidesSizesGrid[0] ?? 0;
        if (!s) return l;
        const r =
            typeof i.params.spaceBetween == 'number'
              ? i.params.spaceBetween
              : 0,
          c = Math.max(1, Math.ceil((i.width + r) / (s + r)));
        return Math.max(1, l - c + 1);
      }
      function nw() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          [r, c] = Y.useState(0),
          [u, h] = Y.useState(0),
          {
            swiperRef: m,
            isBeginning: f,
            isEnd: p,
            goNext: y,
            goPrev: S,
            swiperNavHandlers: w,
          } = yi(),
          x = i('section10.featureSlides', { returnObjects: !0 }),
          T = Y.useCallback(
            D => {
              if (!s) {
                h(x.length);
                return;
              }
              h(iw(D, x.length));
            },
            [s, x.length]
          ),
          A = D => {
            (w.onSwiper(D), c(D.activeIndex), T(D));
          },
          j = D => {
            (w.onSlideChange(D), c(D.activeIndex), T(D));
          },
          G = D => {
            (w.onResize(D), T(D));
          },
          L = D => {
            m.current?.slideTo(D);
          },
          H = u || x.length,
          $ = s && p ? H - 1 : Math.min(r, H - 1);
        return g.jsxs('div', {
          className: yt.carousel,
          children: [
            g.jsx('div', {
              className: yt.swiperWrap,
              children: g.jsx(Wa, {
                className: yt.swiper,
                slidesPerView: 'auto',
                spaceBetween: 6,
                watchOverflow: !0,
                observer: !0,
                observeParents: !0,
                breakpoints: { 769: { spaceBetween: 12 } },
                onSwiper: A,
                onSlideChange: j,
                onTransitionEnd: w.onTransitionEnd,
                onSetTranslate: w.onSetTranslate,
                onResize: G,
                onUpdate: w.onUpdate,
                onDestroy: w.onDestroy,
                children: x.map((D, U) => {
                  const X = aw(D.image, l);
                  return g.jsx(
                    Fa,
                    {
                      children: g.jsxs('div', {
                        className: yt.card,
                        children: [
                          g.jsx('div', {
                            className: yt.thumb,
                            style: X
                              ? { backgroundImage: `url(${X})` }
                              : void 0,
                          }),
                          g.jsx('h4', {
                            className: yt.cardTitle,
                            children: D.title,
                          }),
                          g.jsx('p', {
                            className: yt.cardDesc,
                            dangerouslySetInnerHTML: { __html: D.description },
                          }),
                        ],
                      }),
                    },
                    `${D.title}-${U}`
                  );
                }),
              }),
            }),
            g.jsxs('div', {
              className: yt.footer,
              children: [
                g.jsx('div', {
                  className: yt.dots,
                  'aria-hidden': H <= 1,
                  children: x
                    .slice(0, H)
                    .map((D, U) =>
                      g.jsx(
                        'button',
                        {
                          type: 'button',
                          className: `${yt.dot} ${U === $ ? yt.dotActive : ''}`,
                          onClick: () => L(U),
                          'aria-label': `Go to slide ${U + 1}`,
                          'aria-current': U === $ ? 'true' : void 0,
                        },
                        `dot-${D.title}-${U}`
                      )
                    ),
                }),
                g.jsxs('div', {
                  className: yt.navBtns,
                  children: [
                    g.jsx('button', {
                      type: 'button',
                      className: yt.navBtn,
                      onClick: S,
                      disabled: f,
                      'aria-label': 'Previous',
                      children: g.jsx(it, { name: 'icon-left' }),
                    }),
                    g.jsx('button', {
                      type: 'button',
                      className: yt.navBtn,
                      onClick: y,
                      disabled: p,
                      'aria-label': 'Next',
                      children: g.jsx(it, { name: 'icon-More' }),
                    }),
                  ],
                }),
              ],
            }),
          ],
        });
      }
      const lw = 'section10_7q8-0',
        sw = 'mbBody_VA5fS',
        rw = 'title_yjaWT',
        ow = 'topRow_TVeke',
        cw = 'aiPanel_RivXN',
        uw = 'tabItem_itwDi',
        dw = 'tabActive_CWKOb',
        fw = 'tabContent_RLwcG',
        hw = 'tabCollapsed_puL9o',
        mw = 'plus_nUNuZ',
        pw = 'tabTitle_nZh0M',
        gw = 'tabDescWrap_rSIz5',
        bw = 'tabDescOpen_xyL4-',
        vw = 'tabDesc_-VVJQ',
        yw = 'plusHidden_jYts-',
        Sw = 'aiImage_-g901',
        xw = 'aiImageBg_8lnpx',
        Tw = 'aiImagePlaceholder_RG14I',
        ww = 'video_AIhrQ',
        Ew = 'playPauseBtn_CAn-c',
        Nw = 'pauseIcon_AO2j4',
        _w = 'playBtnIcon_2r1DC',
        qe = {
          section10: lw,
          mbBody: sw,
          title: rw,
          topRow: ow,
          aiPanel: cw,
          tabItem: uw,
          tabActive: dw,
          tabContent: fw,
          tabCollapsed: hw,
          plus: mw,
          tabTitle: pw,
          tabDescWrap: gw,
          tabDescOpen: bw,
          tabDesc: vw,
          plusHidden: yw,
          aiImage: Sw,
          aiImageBg: xw,
          aiImagePlaceholder: Tw,
          video: ww,
          playPauseBtn: Ew,
          pauseIcon: Nw,
          playBtnIcon: _w,
        };
      function Aw() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          [r, c] = Y.useState(0),
          [u, h] = Y.useState(!0),
          m = Y.useRef(null),
          f = cp(l),
          p = i('section10.aiTabs', { returnObjects: !0 }),
          y = p[r],
          S = f(y?.video),
          w = f(y?.image);
        (rp(s ? [] : p, s ? '' : S || w, f),
          Y.useEffect(() => {
            h(!0);
          }, [r, S]),
          Y.useEffect(() => {
            const T = m.current;
            if (!T || !S) return;
            const A = requestAnimationFrame(() => {
              T.src !== S && ((T.src = S), T.load(), T.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(A);
          }, [S]));
        const x = () => {
          const T = m.current;
          if (T) {
            if (T.paused) {
              (T.play(), h(!0));
              return;
            }
            (T.pause(), h(!1));
          }
        };
        return g.jsxs('section', {
          className: qe.section10,
          children: [
            g.jsx('h2', {
              className: qe.title,
              children: i('section10.title'),
            }),
            s
              ? g.jsx('div', { className: qe.mbBody, children: g.jsx(k2, {}) })
              : g.jsxs('div', {
                  className: qe.topRow,
                  children: [
                    g.jsx('div', {
                      className: qe.aiPanel,
                      children: p.map((T, A) => {
                        const j = r === A;
                        return g.jsxs(
                          'button',
                          {
                            type: 'button',
                            className: `${qe.tabItem} ${j ? qe.tabActive : qe.tabCollapsed}`,
                            onClick: () => c(A),
                            children: [
                              g.jsx('span', {
                                className: `${qe.plus} ${j ? qe.plusHidden : ''}`,
                                'aria-hidden': 'true',
                              }),
                              g.jsxs('div', {
                                className: qe.tabContent,
                                children: [
                                  g.jsx('h3', {
                                    className: qe.tabTitle,
                                    children: T.title,
                                  }),
                                  g.jsx('div', {
                                    className: `${qe.tabDescWrap} ${j ? qe.tabDescOpen : ''}`,
                                    children: g.jsx('p', {
                                      className: qe.tabDesc,
                                      dangerouslySetInnerHTML: {
                                        __html: T.description,
                                      },
                                    }),
                                  }),
                                ],
                              }),
                            ],
                          },
                          T.title
                        );
                      }),
                    }),
                    g.jsx('div', {
                      className: qe.aiImage,
                      children: S
                        ? g.jsxs(g.Fragment, {
                            children: [
                              g.jsx('video', {
                                ref: m,
                                className: qe.video,
                                src: S,
                                autoPlay: !0,
                                loop: !0,
                                muted: !0,
                                playsInline: !0,
                              }),
                              g.jsx('button', {
                                type: 'button',
                                className: qe.playPauseBtn,
                                onClick: x,
                                'aria-label': u ? 'Pause video' : 'Play video',
                                children: u
                                  ? g.jsx('span', {
                                      className: qe.pauseIcon,
                                      'aria-hidden': 'true',
                                    })
                                  : g.jsx('span', {
                                      className: qe.playBtnIcon,
                                      'aria-hidden': 'true',
                                    }),
                              }),
                            ],
                          })
                        : w
                          ? g.jsx('div', {
                              className: qe.aiImageBg,
                              style: { backgroundImage: `url(${w})` },
                            })
                          : g.jsx('div', { className: qe.aiImagePlaceholder }),
                    }),
                  ],
                }),
            g.jsx(nw, {}),
          ],
        });
      }
      const Mw = 'gallery_Bs7rE',
        jw = 'title_KivfL',
        Cw = 'desc_4tpC5',
        Ow = 'swiperWrap_PfzpR',
        Bw = 'swiper_yvrEs',
        Rw = 'slide_Y8WtK',
        Dw = 'slideImage_YrLAg',
        Lw = 'footer_PriNt',
        zw = 'dots_jwP2o',
        Hw = 'dot_UFOHP',
        Uw = 'dotActive_CqutD',
        Iw = 'navBtns_BuhKs',
        Gw = 'navBtn_YhRlq',
        Vw = 'panels_57-Lm',
        kw = 'panel_E7XNV',
        $w = 'panelExpanded_2tz6J',
        qw = 'panelCollapsed_Ts1aT',
        Pw = 'panelBg_16-Eq',
        Yw = 'playBtn_z-MeA',
        Kw = 'playIcon_2b4Fq',
        Ke = {
          gallery: Mw,
          title: jw,
          desc: Cw,
          swiperWrap: Ow,
          swiper: Bw,
          slide: Rw,
          slideImage: Dw,
          footer: Lw,
          dots: zw,
          dot: Hw,
          dotActive: Uw,
          navBtns: Iw,
          navBtn: Gw,
          panels: Vw,
          panel: kw,
          panelExpanded: $w,
          panelCollapsed: qw,
          panelBg: Pw,
          playBtn: Yw,
          playIcon: Kw,
        };
      function _c(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
      }
      function Xw(i, l) {
        return i.playIcon ? i.playIcon : l === 2 ? 'portable2' : 'portable1';
      }
      function Qw() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = Qt(),
          [r, c] = Y.useState(0),
          [u, h] = Y.useState(0),
          {
            swiperRef: m,
            isBeginning: f,
            isEnd: p,
            goNext: y,
            goPrev: S,
            swiperNavHandlers: w,
          } = yi(),
          x = i('section11.portablePanels', { returnObjects: !0 }),
          T = G => {
            (w.onSwiper(G), c(G.activeIndex));
          },
          A = G => {
            (w.onSlideChange(G), c(G.activeIndex));
          },
          j = G => {
            m.current?.slideTo(G);
          };
        return g.jsxs('div', {
          className: Ke.gallery,
          children: [
            g.jsx('h3', {
              className: Ke.title,
              children: i('section11.portableTitle'),
            }),
            g.jsx('p', {
              className: Ke.desc,
              children: i('section11.portableDesc'),
            }),
            s
              ? g.jsxs(g.Fragment, {
                  children: [
                    g.jsx('div', {
                      className: Ke.swiperWrap,
                      children: g.jsx(Wa, {
                        className: Ke.swiper,
                        slidesPerView: 'auto',
                        spaceBetween: 7,
                        watchOverflow: !0,
                        observer: !0,
                        observeParents: !0,
                        onSwiper: T,
                        onSlideChange: A,
                        onTransitionEnd: w.onTransitionEnd,
                        onSetTranslate: w.onSetTranslate,
                        onResize: w.onResize,
                        onUpdate: w.onUpdate,
                        onDestroy: w.onDestroy,
                        children: x.map((G, L) => {
                          const H = _c(G.image, l);
                          return g.jsx(
                            Fa,
                            {
                              className: Ke.slide,
                              children: g.jsx('div', {
                                className: Ke.slideImage,
                                style: H
                                  ? { backgroundImage: `url(${H})` }
                                  : void 0,
                              }),
                            },
                            `portable-slide-${L}`
                          );
                        }),
                      }),
                    }),
                    g.jsxs('div', {
                      className: Ke.footer,
                      children: [
                        g.jsx('div', {
                          className: Ke.dots,
                          'aria-hidden': x.length <= 1,
                          children: x.map((G, L) =>
                            g.jsx(
                              'button',
                              {
                                type: 'button',
                                className: `${Ke.dot} ${L === r ? Ke.dotActive : ''}`,
                                onClick: () => j(L),
                                'aria-label': `Go to slide ${L + 1}`,
                                'aria-current': L === r ? 'true' : void 0,
                              },
                              `portable-dot-${L}`
                            )
                          ),
                        }),
                        g.jsxs('div', {
                          className: Ke.navBtns,
                          children: [
                            g.jsx('button', {
                              type: 'button',
                              className: Ke.navBtn,
                              onClick: S,
                              disabled: f,
                              'aria-label': 'Previous',
                              children: g.jsx(it, { name: 'icon-left' }),
                            }),
                            g.jsx('button', {
                              type: 'button',
                              className: Ke.navBtn,
                              onClick: y,
                              disabled: p,
                              'aria-label': 'Next',
                              children: g.jsx(it, { name: 'icon-More' }),
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                })
              : g.jsx('div', {
                  className: Ke.panels,
                  children: x.map((G, L) => {
                    const H = u === L,
                      $ = _c(G.image, l),
                      D = _c(Xw(G, L), l);
                    return g.jsxs(
                      'button',
                      {
                        type: 'button',
                        className: `${Ke.panel} ${H ? Ke.panelExpanded : Ke.panelCollapsed}`,
                        onClick: () => h(L),
                        'aria-label': H ? void 0 : `Expand panel ${L + 1}`,
                        'aria-pressed': H,
                        children: [
                          $ &&
                            g.jsx('div', {
                              className: Ke.panelBg,
                              style: { backgroundImage: `url(${$})` },
                            }),
                          !H &&
                            D &&
                            g.jsx('span', {
                              className: Ke.playBtn,
                              children: g.jsx(ft, {
                                src: D,
                                alt: '',
                                className: Ke.playIcon,
                                style: { objectFit: 'contain' },
                              }),
                            }),
                        ],
                      },
                      L
                    );
                  }),
                }),
          ],
        });
      }
      const Zw = 'section11_jQN2h',
        Ww = 'title_QdFkj',
        Fw = 'row_M-w-r',
        Jw = 'image_h2Bn1',
        eE = 'text_QVhHZ',
        St = { section11: Zw, title: Ww, row: Fw, image: Jw, text: eE };
      function tE() {
        const { t: i } = de(),
          { t: l } = de('imageUrl');
        return g.jsxs('section', {
          className: St.section11,
          children: [
            g.jsx('h2', {
              className: St.title,
              children: i('section11.title'),
            }),
            g.jsxs('div', {
              className: St.row,
              'data-reverse': 'false',
              children: [
                g.jsxs('div', {
                  className: St.text,
                  children: [
                    g.jsx('h3', { children: i('section11.engraveCups') }),
                    g.jsx('p', { children: i('section11.engraveCupsDesc') }),
                  ],
                }),
                g.jsx('div', {
                  className: St.image,
                  children: g.jsx(ft, {
                    src: l('section11EngraveCups'),
                    width: '100%',
                    height: '100%',
                    alt: '',
                    style: { objectFit: 'cover' },
                  }),
                }),
              ],
            }),
            g.jsxs('div', {
              className: St.row,
              'data-reverse': 'true',
              children: [
                g.jsx('div', {
                  className: St.image,
                  children: g.jsx(ft, {
                    src: l('section11Maintenance'),
                    width: '100%',
                    height: '100%',
                    alt: '',
                    style: { objectFit: 'cover' },
                  }),
                }),
                g.jsxs('div', {
                  className: St.text,
                  children: [
                    g.jsx('h3', {
                      dangerouslySetInnerHTML: {
                        __html: i('section11.maintenanceTitle'),
                      },
                    }),
                    g.jsx('p', { children: i('section11.maintenanceDesc') }),
                  ],
                }),
              ],
            }),
            g.jsx(Qw, {}),
            g.jsxs('div', {
              className: St.row,
              'data-reverse': 'false',
              children: [
                g.jsxs('div', {
                  className: St.text,
                  children: [
                    g.jsx('h3', {
                      dangerouslySetInnerHTML: {
                        __html: i('section11.airPurifierTitle'),
                      },
                    }),
                    g.jsx('p', { children: i('section11.airPurifierDesc') }),
                  ],
                }),
                g.jsx('div', {
                  className: St.image,
                  children: g.jsx(ft, {
                    src: l('section11AirPurifier'),
                    width: '100%',
                    height: '100%',
                    alt: '',
                    style: { objectFit: 'cover' },
                  }),
                }),
              ],
            }),
            g.jsxs('div', {
              className: St.row,
              'data-reverse': 'true',
              children: [
                g.jsx('div', {
                  className: St.image,
                  children: g.jsx(ft, {
                    src: l('section11Fixture'),
                    width: '100%',
                    height: '100%',
                    alt: '',
                    style: { objectFit: 'cover' },
                  }),
                }),
                g.jsxs('div', {
                  className: St.text,
                  children: [
                    g.jsx('h3', { children: i('section11.fixtureTitle') }),
                    g.jsx('p', { children: i('section11.fixtureDesc') }),
                  ],
                }),
              ],
            }),
          ],
        });
      }
      const aE = [
          'inBoxVariantPg5w',
          'inBoxVariantWhite5w',
          'inBoxVariantPg10w',
          'inBoxVariantWhite10w',
          'inBoxItem1',
          'inBoxItem2',
          'inBoxItem3',
          'inBoxItem4',
          'inBoxItem5',
          'inBoxItem6',
          'inBoxItem7',
          'inBoxItem8',
          'inBoxItem9',
          'inBoxItem10',
          'inBoxItem11',
          'inBoxItem12',
          'inBoxItem13',
          'inBoxItem14',
          'inBoxItem15',
          'inBoxItem16',
          'inBoxItem17',
        ],
        iE = {
          inBoxVariantPg5w:
            'https://cdn.creality.com/ow/a1c/177723b2-f75d-4158-8e78-ac6fbf80119e.png',
          inBoxVariantWhite5w:
            'https://cdn.creality.com/ow/a1c/4cae0768-105f-47dd-9179-3b026ce58c1b.png',
          inBoxVariantPg10w:
            'https://cdn.creality.com/ow/a1c/177723b2-f75d-4158-8e78-ac6fbf80119e.png',
          inBoxVariantWhite10w:
            'https://cdn.creality.com/ow/a1c/4cae0768-105f-47dd-9179-3b026ce58c1b.png',
          inBoxItem1:
            'https://cdn.creality.com/ow/a1c/94cd0f55-449c-4a66-87a8-7d696d1c2060.png',
          inBoxItem2:
            'https://cdn.creality.com/ow/a1c/d8b231c1-cb07-45ef-bfcb-c754262dc7c3.png',
          inBoxItem3:
            'https://cdn.creality.com/ow/a1c/8c705410-a233-4360-b4b7-81fc5d362632.png',
          inBoxItem4:
            'https://cdn.creality.com/ow/a1c/d9d7febd-a17a-4144-8bfc-d503540f2d79.png',
          inBoxItem5:
            'https://cdn.creality.com/ow/a1c/b38d74b3-c79b-44e0-9264-9dfea82a103a.png',
          inBoxItem6:
            'https://cdn.creality.com/ow/a1c/6a2249db-9137-4c8b-a4e0-984b878c4ced.png',
          inBoxItem7:
            'https://cdn.creality.com/ow/a1c/cb2a9ba7-b031-4412-9395-298b41895a03.png',
          inBoxItem8:
            'https://cdn.creality.com/ow/a1c/bb4f8747-c695-4ed0-bccc-115c16ee2860.png',
          inBoxItem9:
            'https://cdn.creality.com/ow/a1c/64d7de35-c9ea-4d0a-9b8c-26ed7776781b.png',
          inBoxItem10:
            'https://cdn.creality.com/ow/a1c/dcecef01-02dc-40a7-bf4b-897d9207d44e.png',
          inBoxItem11:
            'https://cdn.creality.com/ow/a1c/7bbcc6ca-9873-402c-9170-6e02e3ebaea5.png',
          inBoxItem12:
            'https://cdn.creality.com/ow/a1c/57f05fcf-2979-41b2-8c88-272af7a587fd.png',
          inBoxItem13:
            'https://cdn.creality.com/ow/a1c/37a6f0e7-7d9f-4e31-ad12-6764eae4c0b5.png',
          inBoxItem14:
            'https://cdn.creality.com/ow/a1c/cf9cf227-4cd6-4022-ac93-ad442131ebe9.png',
          inBoxItem15:
            'https://cdn.creality.com/ow/a1c/11b940e8-ce56-459e-82ba-21ac1b9ac253.png',
          inBoxItem16:
            'https://cdn.creality.com/ow/a1c/c795271b-9ee8-46c7-bf73-c6da69d9436e.png',
          inBoxItem17:
            'https://cdn.creality.com/ow/a1c/33fb660c-eee8-483f-b61c-8e34e5f03227.png',
        };
      var nE = Rm();
      const lE = 'overlay_zpPdo',
        sE = 'panel_yXkRm',
        rE = 'closeBtn_mxtAU',
        oE = 'closeBtnIcon_dAZlE',
        cE = 'scrollArea_VxTVs',
        uE = 'scaleShell_DNgVB',
        dE = 'designRoot_LWnmy',
        fE = 'title_yqfrB',
        hE = 'compareSection_PaKDL',
        mE = 'machineRow_Ah-41',
        pE = 'tableRow_c6HnT',
        gE = 'machineLabel_g-Mt7',
        bE = 'itemName_tpD--',
        vE = 'iconCol_0eXxs',
        yE = 'variantList_VPOT4',
        SE = 'valueList_4VTAM',
        xE = 'variantItem_mNJHi',
        TE = 'variantImageWrap_5K-te',
        wE = 'variantImage_6QTxR',
        EE = 'variantLabel_8b9Za',
        NE = 'table_uavhh',
        _E = 'itemIconWrap_qg9gd',
        AE = 'itemIcon_cgQYm',
        ME = 'itemValue_9qY-6',
        jE = 'itemValueHighlight_D31h3',
        CE = 'itemNameHighlight_EUoNG',
        OE = 'iconNameGap_ypQw7',
        BE = 'nameValueGap_FdIQt',
        Ee = {
          overlay: lE,
          panel: sE,
          closeBtn: rE,
          closeBtnIcon: oE,
          scrollArea: cE,
          scaleShell: uE,
          designRoot: dE,
          title: fE,
          compareSection: hE,
          machineRow: mE,
          tableRow: pE,
          machineLabel: gE,
          itemName: bE,
          iconCol: vE,
          variantList: yE,
          valueList: SE,
          variantItem: xE,
          variantImageWrap: TE,
          variantImage: wE,
          variantLabel: EE,
          table: NE,
          itemIconWrap: _E,
          itemIcon: AE,
          itemValue: ME,
          itemValueHighlight: jE,
          itemNameHighlight: CE,
          iconNameGap: OE,
          nameValueGap: BE,
        },
        RE = 1200,
        DE = 1031.25,
        LE = () => (window.matchMedia('(max-width: 768px)').matches ? DE : RE),
        Am = [
          { w: 94, h: 86 },
          { w: 112, h: 83 },
          { w: 87, h: 77 },
          { w: 128, h: 68 },
          { w: 127, h: 68 },
          { w: 105, h: 81 },
          { w: 104, h: 81 },
          { w: 77, h: 70 },
          { w: 92, h: 80 },
          { w: 119, h: 67 },
          { w: 118, h: 68 },
          { w: 117, h: 75 },
          { w: 124, h: 74 },
          { w: 56, h: 52 },
          { w: 124, h: 87 },
          { w: 122, h: 78 },
          { w: 114, h: 72 },
        ],
        Mm = { w: 120, h: 111 },
        zE =
          'https://cdn.creality.com/ow/Feedback/f3a6a6db-dfbc-4b54-852e-8a20ae2d2079.png';
      function HE(i) {
        return i === '√' ? '✓' : i;
      }
      function UE({ open: i, onClose: l }) {
        const s = Y.useRef(null),
          r = Y.useRef(null),
          [c, u] = Y.useState(1),
          [h, m] = Y.useState(0),
          { t: f } = de(),
          { t: p } = de('imageUrl'),
          y = f('section12.inBoxModal.variants', { returnObjects: !0 }),
          S = f('section12.inBoxModal.items', { returnObjects: !0 });
        return (
          Y.useEffect(() => {
            if (!i) return;
            const w = document.body.style.overflow;
            return (
              (document.body.style.overflow = 'hidden'),
              () => {
                document.body.style.overflow = w;
              }
            );
          }, [i]),
          Y.useEffect(() => {
            if (!i) return;
            const w = x => {
              x.key === 'Escape' && l();
            };
            return (
              window.addEventListener('keydown', w),
              () => window.removeEventListener('keydown', w)
            );
          }, [i, l]),
          Y.useEffect(() => {
            if (!i) {
              (u(1), m(0));
              return;
            }
            const w = s.current,
              x = r.current;
            if (!w || !x) return;
            const T = () => {
              const j = w.clientWidth / LE();
              (u(j), m(x.offsetHeight * j));
            };
            T();
            const A = new ResizeObserver(T);
            return (
              A.observe(w),
              A.observe(x),
              window.addEventListener('resize', T),
              () => {
                (A.disconnect(), window.removeEventListener('resize', T));
              }
            );
          }, [i, y.length, S.length]),
          i
            ? nE.createPortal(
                g.jsx('div', {
                  className: Ee.overlay,
                  onClick: w => {
                    w.target === w.currentTarget && l();
                  },
                  role: 'presentation',
                  children: g.jsxs('div', {
                    ref: s,
                    className: Ee.panel,
                    role: 'dialog',
                    'aria-modal': 'true',
                    'aria-labelledby': 'in-box-modal-title',
                    children: [
                      g.jsx('button', {
                        type: 'button',
                        className: Ee.closeBtn,
                        onClick: l,
                        'aria-label': 'Close',
                        children: g.jsx('img', {
                          className: Ee.closeBtnIcon,
                          src: zE,
                          alt: '',
                          'aria-hidden': 'true',
                        }),
                      }),
                      g.jsx('div', {
                        className: Ee.scrollArea,
                        children: g.jsx('div', {
                          className: Ee.scaleShell,
                          style: { height: h || void 0 },
                          children: g.jsxs('div', {
                            ref: r,
                            className: Ee.designRoot,
                            style: { transform: `scale(${c})` },
                            children: [
                              g.jsx('h2', {
                                id: 'in-box-modal-title',
                                className: Ee.title,
                                children: f('section12.inBoxModal.title'),
                              }),
                              g.jsxs('div', {
                                className: Ee.compareSection,
                                children: [
                                  g.jsxs('div', {
                                    className: Ee.machineRow,
                                    children: [
                                      g.jsx('div', {
                                        className: Ee.iconCol,
                                        'aria-hidden': 'true',
                                      }),
                                      g.jsx('div', {
                                        className: Ee.iconNameGap,
                                        'aria-hidden': 'true',
                                      }),
                                      g.jsx('p', {
                                        className: Ee.machineLabel,
                                        dangerouslySetInnerHTML: {
                                          __html: f(
                                            'section12.inBoxModal.machineLabel'
                                          ),
                                        },
                                      }),
                                      g.jsx('div', {
                                        className: Ee.nameValueGap,
                                        'aria-hidden': 'true',
                                      }),
                                      g.jsx('div', {
                                        className: Ee.variantList,
                                        children: y.map(w =>
                                          g.jsxs(
                                            'div',
                                            {
                                              className: Ee.variantItem,
                                              children: [
                                                g.jsx('div', {
                                                  className:
                                                    Ee.variantImageWrap,
                                                  style: {
                                                    width: Mm.w,
                                                    height: Mm.h,
                                                  },
                                                  children: g.jsx('img', {
                                                    className: Ee.variantImage,
                                                    src: p(w.imageKey),
                                                    alt: '',
                                                    decoding: 'async',
                                                  }),
                                                }),
                                                g.jsx('p', {
                                                  className: Ee.variantLabel,
                                                  dangerouslySetInnerHTML: {
                                                    __html: w.label,
                                                  },
                                                }),
                                              ],
                                            },
                                            w.imageKey
                                          )
                                        ),
                                      }),
                                    ],
                                  }),
                                  g.jsx('div', {
                                    className: Ee.table,
                                    children: S.map((w, x) => {
                                      const T = Am[x] ?? Am[0];
                                      return g.jsxs(
                                        'div',
                                        {
                                          className: Ee.tableRow,
                                          children: [
                                            g.jsx('div', {
                                              className: Ee.iconCol,
                                              children: g.jsx('div', {
                                                className: Ee.itemIconWrap,
                                                style: {
                                                  width: T.w,
                                                  height: T.h,
                                                },
                                                children: g.jsx('img', {
                                                  className: Ee.itemIcon,
                                                  src: p(w.imageKey),
                                                  alt: '',
                                                  decoding: 'async',
                                                }),
                                              }),
                                            }),
                                            g.jsx('div', {
                                              className: Ee.iconNameGap,
                                              'aria-hidden': 'true',
                                            }),
                                            g.jsx('p', {
                                              className: w.highlightValues
                                                ? `${Ee.itemName} ${Ee.itemNameHighlight}`
                                                : Ee.itemName,
                                              dangerouslySetInnerHTML: {
                                                __html: w.name,
                                              },
                                            }),
                                            g.jsx('div', {
                                              className: Ee.nameValueGap,
                                              'aria-hidden': 'true',
                                            }),
                                            g.jsx('div', {
                                              className: Ee.valueList,
                                              children: w.values.map((A, j) =>
                                                g.jsx(
                                                  'span',
                                                  {
                                                    className: w.highlightValues
                                                      ? Ee.itemValueHighlight
                                                      : Ee.itemValue,
                                                    children: HE(A),
                                                  },
                                                  `${w.imageKey}-${j}`
                                                )
                                              ),
                                            }),
                                          ],
                                        },
                                        w.imageKey
                                      );
                                    }),
                                  }),
                                ],
                              }),
                            ],
                          }),
                        }),
                      }),
                    ],
                  }),
                }),
                document.body
              )
            : null
        );
      }
      const IE = 'section12_QFV-T',
        GE = 'inBoxBtn_0jSKs',
        VE = 'inBoxIcon_PAMjU',
        kE = 'inBoxPlus_LVkXO',
        $E = 'title_9Da4j',
        qE = 'grid_MyYq3',
        PE = 'card_uPMmR',
        YE = 'cardImageWrap_xDgrZ',
        KE = 'cardContent_n40VX',
        XE = 'btnActive_U--dt',
        QE = 'btnInactive_n-gpH',
        ZE = 'cardImage_eFyyP',
        Pt = {
          section12: IE,
          inBoxBtn: GE,
          inBoxIcon: VE,
          inBoxPlus: kE,
          title: $E,
          grid: qE,
          card: PE,
          cardImageWrap: YE,
          cardContent: KE,
          btnActive: XE,
          btnInactive: QE,
          cardImage: ZE,
        },
        WE = [
          'accessoryAirPurifier',
          'accessoryFixture',
          'accessoryFan',
          'accessoryRotary',
        ],
        jm = [
          'https://de.crealityfalcon.com/products/creality-falcon-intelligenter-luftreiniger-ap1-mini',
          'https://de.crealityfalcon.com/products/creality-falcon-flexible-halterung',
          'https://de.crealityfalcon.com/products/creality-falcon-flexible-halterung',
        ];
      function FE() {
        const [i, l] = Y.useState(!1),
          { t: s } = de(),
          { t: r } = de('imageUrl'),
          c = s('section12.accessories', { returnObjects: !0 }),
          u = Y.useMemo(() => aE.map(h => r(h)).filter(Boolean), [r]);
        return (
          op(u),
          g.jsxs('section', {
            className: Pt.section12,
            children: [
              g.jsxs('button', {
                type: 'button',
                className: Pt.inBoxBtn,
                onClick: () => l(!0),
                children: [
                  g.jsx('div', {
                    className: Pt.inBoxIcon,
                    children: g.jsx(it, {
                      name: 'icon-add',
                      className: Pt.inBoxPlus,
                      'aria-hidden': 'true',
                    }),
                  }),
                  g.jsx('span', { children: s('section12.inBox') }),
                ],
              }),
              g.jsx(UE, { open: i, onClose: () => l(!1) }),
              g.jsx('h2', {
                className: Pt.title,
                dangerouslySetInnerHTML: {
                  __html: s('section12.accessoriesTitle'),
                },
              }),
              g.jsx('div', {
                className: Pt.grid,
                children: c.map((h, m) =>
                  g.jsxs(
                    'div',
                    {
                      className: Pt.card,
                      children: [
                        g.jsx('div', {
                          className: Pt.cardImageWrap,
                          children: g.jsx(ft, {
                            className: Pt.cardImage,
                            src: r(WE[m]),
                            width: 'auto',
                            height: 'auto',
                            alt: h.title,
                          }),
                        }),
                        g.jsxs('div', {
                          className: Pt.cardContent,
                          children: [
                            g.jsx('h3', { children: h.title }),
                            g.jsx('p', { children: h.description }),
                            jm[m]
                              ? g.jsx('a', {
                                  href: jm[m],
                                  className: Pt.btnActive,
                                  target: '_blank',
                                  rel: 'noopener noreferrer',
                                  children: s('section12.learnMore'),
                                })
                              : g.jsx('button', {
                                  type: 'button',
                                  className: Pt.btnInactive,
                                  disabled: !0,
                                  children: s('section12.learnMore'),
                                }),
                          ],
                        }),
                      ],
                    },
                    h.title
                  )
                ),
              }),
            ],
          })
        );
      }
      const JE = 'section13_X06Vo',
        eN = 'title_WatHA',
        tN = 'specLayout_FHcNm',
        aN = 'specRow_UB90X',
        iN = 'rowTall_57A98',
        nN = 'colValue_SNfIf',
        lN = 'imageRow_68gPo',
        sN = 'colLabel_3TlxQ',
        rN = 'valueSymbol_tkEy6',
        xt = {
          section13: JE,
          title: eN,
          specLayout: tN,
          specRow: aN,
          rowTall: iN,
          colValue: nN,
          imageRow: lN,
          colLabel: sN,
          valueSymbol: rN,
        };
      function oN() {
        const { t: i } = de(),
          { t: l } = de('imageUrl'),
          s = i('section13.labels', { returnObjects: !0 }),
          r = i('section13.variants', { returnObjects: !0 }),
          c = [
            { label: s[0], render: m => m.name },
            { label: s[1], render: m => m.color },
            { label: s[2], render: m => m.laserModules },
            { label: s[3], render: m => m.interchangeable },
            { label: s[4], render: m => m.engravingArea },
            { label: s[5], render: m => m.maxHeight },
            { label: s[6], render: m => m.laserSafety },
            { label: s[7], render: m => m.maxSpeed },
            { label: s[8], render: m => m.focusMode },
            { label: s[9], render: m => m.camera },
            { label: s[10], render: m => m.cameraAssist },
            { label: s[11], render: m => m.aiFill },
            { label: s[12], render: m => m.optionalPackages },
            { label: s[13], render: m => m.iotControl },
            { label: s[14], render: m => m.appControl },
            { label: s[15], render: m => m.machineDim },
            { label: s[16], render: m => m.packageDim },
            { label: s[17], render: m => m.netWeight },
            { label: s[18], render: m => m.grossWeight },
          ],
          u = m =>
            m === !0 || m === '✓'
              ? g.jsx('span', { className: xt.valueSymbol, children: '✓' })
              : m === !1 || m === '×'
                ? g.jsx('span', { className: xt.valueSymbol, children: '×' })
                : m || ' ',
          h = m =>
            m.includes(`
`)
              ? m
                  .split(
                    `
`
                  )
                  .map((f, p) =>
                    g.jsxs(
                      Y.Fragment,
                      { children: [p > 0 && g.jsx('br', {}), f] },
                      p
                    )
                  )
              : m;
        return g.jsxs('section', {
          className: xt.section13,
          children: [
            g.jsx('h2', {
              className: xt.title,
              children: i('section13.title'),
            }),
            g.jsxs('div', {
              className: xt.specLayout,
              children: [
                g.jsxs('div', {
                  className: `${xt.specRow} ${xt.imageRow}`,
                  children: [
                    g.jsx('div', { className: xt.colLabel }),
                    g.jsx('div', {
                      className: xt.colValue,
                      children: g.jsx(ft, {
                        src: l('specTable1'),
                        width: 'auto',
                        height: 'auto',
                        alt: '',
                      }),
                    }),
                    g.jsx('div', {
                      className: xt.colValue,
                      children: g.jsx(ft, {
                        src: l('specTable2'),
                        width: 'auto',
                        height: 'auto',
                        alt: '',
                      }),
                    }),
                  ],
                }),
                c.map((m, f) =>
                  g.jsxs(
                    'div',
                    {
                      className: `${xt.specRow} ${f === 6 || f === 17 ? xt.rowTall : ''}`,
                      children: [
                        g.jsx('div', {
                          className: xt.colLabel,
                          children: h(m.label),
                        }),
                        r.map(p =>
                          g.jsx(
                            'div',
                            {
                              className: xt.colValue,
                              children: u(m.render(p)),
                            },
                            p.color
                          )
                        ),
                      ],
                    },
                    m.label
                  )
                ),
              ],
            }),
          ],
        });
      }
      function cN() {
        const { i18n: i } = de();
        return g.jsxs('div', {
          className: Ev.page,
          'data-lang': i.language,
          style: { color: 'var(--a1c-text-dark)' },
          children: [
            g.jsx(Iv, {}),
            g.jsx(Ky, {}),
            g.jsx(t1, {}),
            g.jsx(Y1, {}),
            g.jsx(Qx, {}),
            g.jsx(bT, {}),
            g.jsx(wT, {}),
            g.jsx(c2, {}),
            g.jsx(w2, {}),
            g.jsx(Aw, {}),
            g.jsx(tE, {}),
            g.jsx(FE, {}),
            g.jsx(oN, {}),
          ],
        });
      }
      const uN = {
          title: 'Creality Falcon A1C',
          section1: {
            badge: 'Neu',
            title: 'Creality Falcon A1C',
            subtitle: 'The Perfect First Laser Engraver<br/>for Your Home.',
            scrollTitle:
              'Lightweight & easy to use,<br/>unlock home creativity for<br/>all beginners.',
            scrollSubtitle: 'Your all-in-one household<br/>creativity engine.',
          },
          section2: {
            title: 'Highlights',
            autoFocus: 'True Auto Focus',
            liftingPlatform: 'Smart Lifting Platform',
            workingAreaLabel: 'Working Area:',
            workingAreaValue: '150 × 150 × <strong>148 mm</strong>',
            laserModulesTitle: '3 Interchangeable Laser Modules',
            laser5w: '5W',
            laser5wType: 'Diode',
            laser10w: '10W',
            laser10wType: 'Diode',
            laserIR: '1.2W',
            laserIRType: 'IR',
            materialsCount: '300+',
            materials: 'Materials',
            laserSafety: 'Laser<br/>Safety',
            class1: 'Class 1',
            smartIoT: 'Smart IoT Control',
            smartIoTDesc: `Seamless control
across devices`,
            aiCamera: 'AI Camera Assist',
            aiCameraDesc: 'Easier Positioning and Filling',
            highSpeed: 'High-Speed Engraving',
            upTo: 'up to',
            speedValue: '15,000',
            speedUnit: ' mm/min',
            aiPowered: 'AI-Powered<br/>',
            smartExperience: 'Smart Experience',
          },
          section3: {
            title: 'Experience Fun in<br class="br_mb"/>Various Scenarios',
            subtitle: 'A1C fits perfectly into your lifestyle',
            scenarios: [
              {
                title: 'Everyday DIY &<br class="br_pc"/>Creative Moments',
                description:
                  'Create decorations, gifts, and keepsakes that<br class="br_mb"/>add a personal touch to daily life.',
                imagePosition: 'right',
                bgColor: '#ebedfa',
              },
              {
                title:
                  'Holidays, Parties &<br class="br_pc"/>Special Occasions',
                description:
                  'Make instant, personalized creations for birthdays,<br class="br_mb"/>holidays, and gatherings.',
                imagePosition: 'left',
                bgColor: '#faf5eb',
              },
              {
                title:
                  'Turn Creativity<br class="br_pc"/>into Meaningful Gifts',
                description:
                  'Engrave names, dates, or messages&#8209;make<br class="br_mb"/>every gift truly one of a kind.',
                imagePosition: 'right',
                bgColor: '#ebfaf2',
              },
              {
                title:
                  'Retail & pop-up store<br class="br_pc"/>on-site engraving',
                description:
                  'Instant personalization for customers&#8209;boost<br class="br_mb"/>engagement and sales.',
                imagePosition: 'left',
                bgColor: '#faf0eb',
              },
            ],
          },
          section4: {
            title: 'Simple and Easy to Use',
            subtitle: 'Start creating right away-no experience required.',
            easyUseTabs: [
              {
                title: 'Interchangeable<br class="br_pc"/>Laser Modules',
                description:
                  'Swap <span class="highlight">5W / 10W / 1.2W</span> lasers<br class="br_mb"/>in seconds without tools.',
                video: 'easyUseVideo1',
              },
              {
                title: 'True Autofocus,<br class="br_pc"/>No manual adjustment',
                description:
                  'Just place the material and click. The machine automatically finds the perfect height.',
                video: 'easyUseVideo2',
              },
              {
                title: 'Clear PC/APP control',
                description:
                  'Control the machine with intuitive software, even as a beginner.',
                video: 'easyUseVideo3',
              },
              {
                title: 'Portable and<br class="br_pc"/>Easy to Carry',
                description:
                  'Easy to move between your living room, classroom, studio, or shop counter.',
                image: 'easyUse4',
              },
            ],
          },
          section5: {
            heroTitle: 'Greater Stability,<br/>Sharper Details',
            stabilityCards: [
              {
                title: 'High Motion Accuracy',
                description:
                  'Precise and smooth<br class="br_mb"/>movement delivers cleaner,<br class="br_mb"/>more consistent lines.',
              },
              {
                title: 'Rigid Structural Design',
                description:
                  'Solid construction effectively<br class="br_mb"/>reduces vibration for stable<br class="br_mb"/>engraving performance.',
              },
              {
                title: 'Fine Laser Spot',
                description:
                  'A smaller laser spot<br class="br_mb"/>produces sharper lines<br class="br_mb"/>and more refined details.',
              },
            ],
            materialsTitle:
              'Precise Engraving on<br class="br_mb"/>Various Materials',
            materialsSubtitle: 'One machine, endless possibilities',
            tabDiode: '5W / 10W Diode',
            tabIR: '1.2W IR',
            materialCarousel: {
              diode: {
                slides: [
                  {
                    label: 'Wood',
                    image: 'diodeSlide1',
                    indicator: 'diodeIndicator1',
                  },
                  {
                    label: 'Bamboo',
                    image: 'diodeSlide2',
                    indicator: 'diodeIndicator2',
                  },
                  {
                    label: 'Paper',
                    image: 'diodeSlide3',
                    indicator: 'diodeIndicator3',
                  },
                  {
                    label: 'Cork/Cardboard',
                    image: 'diodeSlide4',
                    indicator: 'diodeIndicator4',
                  },
                  {
                    label: 'Rock',
                    image: 'diodeSlide5',
                    indicator: 'diodeIndicator5',
                  },
                  {
                    label: 'Leather',
                    image: 'diodeSlide6',
                    indicator: 'diodeIndicator6',
                  },
                  {
                    label: 'Glass',
                    image: 'diodeSlide7',
                    indicator: 'diodeIndicator7',
                  },
                  {
                    label: 'Fabric',
                    image: 'diodeSlide8',
                    indicator: 'diodeIndicator8',
                  },
                ],
              },
              ir: {
                slides: [
                  {
                    label: 'Brass & Gold',
                    image: 'irSlide1',
                    indicator: 'irIndicator1',
                  },
                  {
                    label: 'Silver & Platinum',
                    image: 'irSlide2',
                    indicator: 'irIndicator2',
                  },
                  {
                    label: 'Acrylic & Plastic',
                    image: 'irSlide3',
                    indicator: 'irIndicator3',
                  },
                  {
                    label: 'Aluminum & Stainless Steel',
                    image: 'irSlide4',
                    indicator: 'irIndicator4',
                  },
                ],
              },
            },
            galleryTitle: 'Start Creating Today with Falcon A1C',
            gallerySlides: [
              { label: 'Home', image: 'gallerySlide1' },
              { label: 'Gifts', image: 'gallerySlide2' },
              { label: 'Holiday', image: 'gallerySlide3' },
              { label: 'Events', image: 'gallerySlide4' },
              { label: 'Apparel', image: 'gallerySlide5' },
              { label: 'Pet', image: 'gallerySlide6' },
            ],
          },
          section6: {
            title: 'Auto Lifting',
            workspace: '150×150×148 mm',
            subtitle: 'Bigger Workspace in a Compact Body',
            description:
              'Despite its compact size, A1C delivers an impressively large 150 × 150 mm workspace',
            emDash: '—',
            descriptionEnd:
              'big enough for real, practical projects. Create coasters, leather goods, small ornaments, and personalized gifts with ease.',
          },
          section7: {
            title: "15,000 mm/min<br class='br_mb' /> High-Speed Engraving",
            subtitle:
              "Leading speed in its class-less waiting,<br class='br_mb' /> smoother creation.",
          },
          section8: {
            class1: 'Class 1',
            eyeSafe: ' Eye-Safe Design',
            noGoggles: 'No protective goggles',
            noGogglesEnd: ' required for everyday use.',
            safetyTabs: [
              {
                title: 'Fully Enclosed Protective Design',
                description:
                  'Effectively blocks harmful laser exposure while keeping a clear, visible workspace.',
                image: 'safetyTab1',
              },
              {
                title: 'Smart Flame Detection for Safer Engraving',
                description:
                  'Automatically stops operation if flames are detected, with buzzer alerts and instant notifications sent to PC and App.',
                image: 'safetyTab2',
              },
              {
                title: 'Tilt Protection',
                description:
                  'Automatically shuts down the machine if abnormal tilting is detected.',
                image: 'safetyTab3',
              },
              {
                title: 'USB Safety Lock',
                description:
                  'Prevents accidental operation and keeps children safe.',
                image: 'safetyTab4',
              },
            ],
          },
          section9: {
            title: 'Easy Free Software Studio',
            subtitle: 'Powerful tools that stay friendly for beginners',
            fdsTitle: 'Free FDS Studio',
            fdsDesc:
              'Clean interface, intuitive controls, and real-time<br class="br_mb"/>preview for effortless creation.',
            features: [
              {
                title: 'Full LightBurn compatibility',
                description:
                  'Advanced tools for creators who want deeper control and professional results.',
              },
              {
                title: 'Multi-Device Control',
                description:
                  'Operate via PC or mobile<br class="br_mb"/>App, with Wi-Fi, Bluetooth,<br class="br_mb"/>and USB connectivity for<br class="br_mb"/>flexible workflow.',
              },
            ],
          },
          section10: {
            title: 'Smart Tech That Elevates Everything',
            aiTabs: [
              {
                title: 'AI Filter Lab',
                description:
                  'Switch between a variety of professional styles and refresh your creative assets with one click.',
                video: 'aiVideo1',
              },
              {
                title: 'AI Contour Extraction',
                description:
                  'Automatically detects colors and separates layers, converting images into color vector layers ideal for multi-color engraving—making color engraving faster and easier.',
                video: 'aiVideo2',
              },
              {
                title: 'AI Background Removal',
                description:
                  'Automatically identifies object edges to create smooth, high-quality transparent images for faster workflows.',
                video: 'aiVideo3',
              },
              {
                title: 'AI Smart Fill & Layout',
                description:
                  'Automatically detects identical materials and applies optimized patterns for 60% faster batch engraving.',
                video: 'aiVideo4',
              },
            ],
            featureSlides: [
              {
                title: 'Rich Project Library, Endless Inspiration',
                description:
                  'The Caftseek library offers thousands of free, high-quality project designs. Download with one click and start creating—your creativity never runs out!',
                image: 'featureSlide1',
              },
              {
                title: 'APP AI One-Tap Engraving',
                description:
                  'Upload a photo or take one with your phone. AI automatically converts it into engraving-ready styles like line art or illustration, optimizes the image, and matches the right material settings. Start with one tap-beginners can easily create high-quality engravings.',
                image: 'featureSlide2',
              },
              {
                title: 'AI Support Assistant',
                description:
                  'When the device detects an alert, the AI assistant automatically provides the right solution.<br/>AI + human support ensures a worry-free experience from setup to production.',
                image: 'featureSlide3',
              },
              {
                title: 'Cloud Storage',
                description:
                  'Supports cloud-based file storage with seamless access across devices.<br/>Your designs can be downloaded directly to the touchscreen anytime-start engraving whenever inspiration strikes.',
                image: 'featureSlide4',
              },
              {
                title: 'Material Test Array',
                description:
                  'Automatically generates a grid with multiple power and speed combinations in a single job, helping you quickly identify the best settings for new materials while reducing trial and error.',
                image: 'featureSlide5',
              },
              {
                title: 'Intelligent Split & Fill',
                description:
                  'Split oversized designs into joinable parts with precision joints, and use intelligent fill to optimize layouts for efficient material usage.',
                image: 'featureSlide6',
              },
            ],
          },
          section11: {
            title: 'Portable, Flexible & Easy to Maintain',
            engraveCups: 'Engrave Cups & Spheres',
            engraveCupsDesc:
              'Easily engrave tumblers, mugs, spherical ornaments, and various curved or cylindrical items.',
            maintenanceTitle: 'Easy Maintenance,<br/>Easy Cleaning',
            maintenanceDesc:
              'Quick-release fan design makes daily cleaning simple and hassle-free.',
            portableTitle: 'Portable & Ready to Go',
            portableDesc:
              'Lightweight and easy to move-start creating anytime in your living room, garage, or studio.',
            portablePanels: [
              { image: 'portablePanel1', playIcon: 'portable1' },
              { image: 'portablePanel2', playIcon: 'portable1' },
              { image: 'portablePanel3', playIcon: 'portable2' },
            ],
            airPurifierTitle:
              'Optional Air Purifier for<br/>Worry-Free Creation',
            airPurifierDesc:
              'Effectively filters smoke and odors generated during engraving, making it ideal for home and indoor use.',
            fixtureTitle: 'Flexible Fixture Expansion',
            fixtureDesc:
              'Unlock more creative scenarios and explore new possibilities with flexible workholding options.',
          },
          section12: {
            inBox: 'What in box',
            inBoxModal: {
              title: 'What in box',
              machineLabel: 'Laser Cutter and Engraver:',
              variants: [
                { label: 'Purple Gray<br />5W', imageKey: 'inBoxVariantPg5w' },
                { label: 'White<br />5W', imageKey: 'inBoxVariantWhite5w' },
                {
                  label: 'Purple Gray<br />10W',
                  imageKey: 'inBoxVariantPg10w',
                },
                { label: 'White<br />10W', imageKey: 'inBoxVariantWhite10w' },
              ],
              items: [
                {
                  name: 'Power Adapter:',
                  imageKey: 'inBoxItem1',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Power Cord:',
                  imageKey: 'inBoxItem2',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Exhaust Pipe:',
                  imageKey: 'inBoxItem3',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Type-A to<br />Type-C Cable:',
                  imageKey: 'inBoxItem4',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Lint-free Brush:',
                  imageKey: 'inBoxItem5',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'M2/M2.5<br />Hex Key:',
                  imageKey: 'inBoxItem6',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Type-A to<br />Type-C Adapter:',
                  imageKey: 'inBoxItem7',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Hose Clamp:',
                  imageKey: 'inBoxItem8',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Dust-free Cloth:',
                  imageKey: 'inBoxItem9',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Quick Start<br />Guide:',
                  imageKey: 'inBoxItem10',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Safety<br />Instructions:',
                  imageKey: 'inBoxItem11',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Camera<br />Calibration Card:',
                  imageKey: 'inBoxItem12',
                  values: ['√', '/', '√', '/'],
                  highlightValues: !0,
                },
                {
                  name: 'Cutting Plate:',
                  imageKey: 'inBoxItem13',
                  values: ['/', '/', '√', '√'],
                  highlightValues: !0,
                },
                {
                  name: 'Materials<br />retention screw:',
                  imageKey: 'inBoxItem14',
                  values: ['2', '2', '2', '2'],
                },
                {
                  name: 'Safety Key:',
                  imageKey: 'inBoxItem15',
                  values: ['2', '2', '2', '2'],
                },
                {
                  name: 'Basswood board:',
                  imageKey: 'inBoxItem16',
                  values: ['3', '3', '3', '3'],
                },
                {
                  name: 'Laser Engrave<br />Photo Paper:',
                  imageKey: 'inBoxItem17',
                  values: ['7', '3', '7', '3'],
                  highlightValues: !0,
                },
              ],
            },
            accessoriesTitle:
              'Adapt to Any Job.<br class="br_mb"/>Master Every Objects',
            learnMore: 'Learn More',
            accessories: [
              {
                title: 'Air Purifier',
                description:
                  'Purifies smoke and odors generated during engraving, helps improve engraving quality, and maintains a cleaner indoor environment.',
                active: !0,
              },
              {
                title: 'Flexible Fixture',
                description:
                  'Fast one-step clamping for irregular and specially shaped objects, with no repeated adjustments required for batch engraving.',
                active: !0,
              },
              {
                title: 'Exhaust Fan',
                description:
                  'Powerfully removes fumes generated during engraving, helping improve engraving quality.',
                active: !0,
              },
              {
                title: 'Rotary kits',
                description:
                  'Supports stable rotary engraving for cylindrical and round objects such as cups, rings, bracelets, and more.',
                active: !1,
              },
            ],
          },
          section13: {
            title: 'Specifications',
            labels: [
              'Product Name:',
              'Product Color:',
              'Laser Modules Support:',
              `Interchangeable
Laser Modules:`,
              'Engraving Area:',
              'Max. Processing Height:',
              'Laser Safety:',
              'Max. Working Speed:',
              'Focus Mode:',
              'Camera:',
              `Camera-Assisted
Positioning:`,
              'AI Smart Fill & Layout:',
              'Optional Packages:',
              'IoT Control:',
              'APP Control:',
              'Machine Dimension:',
              'Package Dimension:',
              `Net Weight:
(Machine Only)`,
              'Gross Weight:',
            ],
            variants: [
              {
                name: 'Falcon A1C',
                color: 'Purple-Gray',
                laserModules: '5W Diode | 10W Diode | 1.2W IR',
                interchangeable: '✓',
                engravingArea: '150 × 150 mm',
                maxHeight: '148 mm',
                laserSafety:
                  'Class 1 Laser Safety Flame Detection Tilt Detection USB Safety Lock',
                maxSpeed: '15000mm/min',
                focusMode: 'Auto Focus',
                camera: '✓',
                cameraAssist: '✓',
                aiFill: '✓',
                optionalPackages: 'Rotary Kit, Air Pufier',
                iotControl: 'Wi-Fi + BLE, IoT Control',
                appControl: 'Wireless APP Control',
                machineDim: '336 mm * 377 mm * 341 mm',
                packageDim: '470 mm * 395 mm * 410 mm',
                netWeight: '9.8 kg',
                grossWeight: '13 kg - 13.3 kg',
              },
              {
                name: 'Falcon A1C',
                color: 'White',
                laserModules: '5W Diode | 10W Diode | 1.2W IR',
                interchangeable: '✓',
                engravingArea: '150 × 150 mm',
                maxHeight: '148 mm',
                laserSafety:
                  'Class 1 Laser Safety Flame Detection Tilt Detection USB Safety Lock',
                maxSpeed: '15000mm/min',
                focusMode: 'Auto Focus',
                camera: '×',
                cameraAssist: '×',
                aiFill: '×',
                optionalPackages: 'Rotary Kit, Air Pufier',
                iotControl: 'Wi-Fi + BLE, IoT Control',
                appControl: 'Wireless APP Control',
                machineDim: '336 mm * 377 mm * 341 mm',
                packageDim: '470 mm * 395 mm * 410 mm',
                netWeight: '9.7 kg',
                grossWeight: '12.9 kg - 13.2 kg',
              },
            ],
          },
        },
        dN = {
          title: 'Creality Falcon A1C',
          section1: {
            badge: 'NEW',
            title: 'Creality Falcon A1C',
            subtitle: 'Der perfekte Lasergravierer<br/>für dein Zuhause.',
            scrollTitle:
              'Leicht und einfach zu bedienen – wecke die Kreativität<br/>zu Hause für alle Anfänger.',
            scrollSubtitle: 'Deine All-in-One-<br/>Heimkreativitätsmaschine.',
          },
          section2: {
            title: 'Highlights',
            autoFocus: 'Echtes Autofokussieren',
            liftingPlatform: 'Intelligente Hubplattform',
            workingAreaLabel: 'Arbeitsbereich:',
            workingAreaValue: '150 × 150 × <strong>148 mm</strong>',
            laserModulesTitle: '3 austauschbare Lasermodule',
            laser5w: '5W',
            laser5wType: 'Diode',
            laser10w: '10W',
            laser10wType: 'Diode',
            laserIR: '1.2W',
            laserIRType: 'IR',
            materialsCount: '300+',
            materials: 'Materialien',
            laserSafety: 'Laser-<br/>Sicherheit',
            class1: 'Class 1',
            smartIoT: 'Smarte IoT-Steuerung',
            smartIoTDesc: 'Nahtlose Steuerung über alle Geräte',
            aiCamera: 'KI-Kamera-Assistenz',
            aiCameraDesc: 'Einfachere Positionierung und Füllung',
            highSpeed: 'Hochgeschwindigkeits-Gravieren',
            upTo: 'bis',
            speedValue: '15.000',
            speedUnit: ' mm/min',
            aiPowered: 'KI-gestütztes<br/>',
            smartExperience: 'Smart-Erlebnis',
          },
          section3: {
            title: 'Erlebe Spaß in verschiedenen Szenarien',
            subtitle: 'Der A1C passt perfekt in jeden Alltag',
            scenarios: [
              {
                title:
                  'Alltägliches DIY und<br class="br_pc"/>kreative Momente',
                description:
                  'Gestalte Dekorationen, Geschenke und Erinnerungsstücke<br class="br_mb"/>mit persönlicher Note.',
                imagePosition: 'right',
                bgColor: '#ebedfa',
              },
              {
                title:
                  'Feiertage, Partys und<br class="br_pc"/>besondere Anlässe',
                description:
                  'Erstelle im Handumdrehen personalisierte Kreationen<br class="br_mb"/>für Geburtstage, Feiertage und Feste.',
                imagePosition: 'left',
                bgColor: '#faf5eb',
              },
              {
                title:
                  'Kreativität in bedeutungsvolle<br class="br_pc"/>Geschenke verwandeln',
                description:
                  'Graviere Namen, Daten oder Botschaften &#8209;und mache <br class="br_mb"/>jedes Geschenk zu einem Unikat.',
                imagePosition: 'right',
                bgColor: '#ebfaf2',
              },
              {
                title:
                  'Gravieren vor Ort im Einzelhandel<br class="br_pc"/>und Pop-up-Store',
                description:
                  'Sofortige Personalisierung für Kunden&#8209;mehr Interaktion<br class="br_mb"/>und Umsatz.',
                imagePosition: 'left',
                bgColor: '#faf0eb',
              },
            ],
          },
          section4: {
            title: 'Einfach und leicht zu bedienen',
            subtitle:
              'Beginne sofort mit der Erstellung – keine Erfahrung erforderlich.',
            easyUseTabs: [
              {
                title: 'Austauschbare<br class="br_pc"/>Lasermodule',
                description:
                  'Wechsle <span class="highlight">5-W- / 10-W- / 1,2-W-Laser</span><br class="br_mb"/>in Sekunden ohne Werkzeuge.',
                video: 'easyUseVideo1',
              },
              {
                title:
                  'Echte Autofokussierung,<br class="br_pc"/>keine manuelle Einstellung',
                description:
                  'Legen Sie das Material einfach auf und klicken Sie. Die Maschine findet automatisch die perfekte Höhe.',
                video: 'easyUseVideo2',
              },
              {
                title: 'Klare PC/APP-Steuerung',
                description:
                  'Bedienen Sie die Maschine mit intuitiver Software, auch als Anfänger.',
                video: 'easyUseVideo3',
              },
              {
                title: 'Tragbar und leicht<br class="br_pc"/>zu transportieren',
                description:
                  'Einfach zu bewegen zwischen Wohnzimmer, Klassenzimmer, Studio oder Ladentisch.',
                image: 'easyUse4',
              },
            ],
          },
          section5: {
            heroTitle: 'Mehr Stabilität,<br/>schärfere Details',
            stabilityCards: [
              {
                title: 'Hohe Bewegungspräzision',
                description:
                  'Präzise, gleichmäßige Bewegungen sorgen für sauberere,<br class="br_mb"/>konsistentere Linien.',
              },
              {
                title: 'Robuste Konstruktion',
                description:
                  'Die solide Bauweise reduziert Vibrationen effektiv<br class="br_mb"/>für eine stabile Gravurleistung.',
              },
              {
                title: 'Feiner Laserpunkt',
                description:
                  'Ein kleinerer Laserpunkt erzeugt schärfere Linien<br class="br_mb"/>und feinere Details.',
              },
            ],
            materialsTitle:
              'Präzises Gravieren auf<br class="br_mb"/>verschiedenen Materialien',
            materialsSubtitle: 'Eine Maschine, endlose Möglichkeiten',
            tabDiode: '5-W/10-W-Diode',
            tabIR: '1,2 W IR',
            materialCarousel: {
              diode: {
                slides: [
                  {
                    label: 'Holz',
                    image: 'diodeSlide1',
                    indicator: 'diodeIndicator1',
                  },
                  {
                    label: 'Bambus',
                    image: 'diodeSlide2',
                    indicator: 'diodeIndicator2',
                  },
                  {
                    label: 'Papier',
                    image: 'diodeSlide3',
                    indicator: 'diodeIndicator3',
                  },
                  {
                    label: 'Kork/Karton',
                    image: 'diodeSlide4',
                    indicator: 'diodeIndicator4',
                  },
                  {
                    label: 'Stein',
                    image: 'diodeSlide5',
                    indicator: 'diodeIndicator5',
                  },
                  {
                    label: 'Leder',
                    image: 'diodeSlide6',
                    indicator: 'diodeIndicator6',
                  },
                  {
                    label: 'Glas',
                    image: 'diodeSlide7',
                    indicator: 'diodeIndicator7',
                  },
                  {
                    label: 'Stoff',
                    image: 'diodeSlide8',
                    indicator: 'diodeIndicator8',
                  },
                ],
              },
              ir: {
                slides: [
                  {
                    label: 'Messing & Gold',
                    image: 'irSlide1',
                    indicator: 'irIndicator1',
                  },
                  {
                    label: 'Silber & Platin',
                    image: 'irSlide2',
                    indicator: 'irIndicator2',
                  },
                  {
                    label: 'Acryl & Kunststoff',
                    image: 'irSlide3',
                    indicator: 'irIndicator3',
                  },
                  {
                    label: 'Aluminium & Edelstahl',
                    image: 'irSlide4',
                    indicator: 'irIndicator4',
                  },
                ],
              },
            },
            galleryTitle: 'Beginne heute mit dem Falcon A1C zu schaffen',
            gallerySlides: [
              { label: 'Heim', image: 'gallerySlide1' },
              { label: 'Geschenke', image: 'gallerySlide2' },
              { label: 'Feiertage', image: 'gallerySlide3' },
              { label: 'Veranstaltungen', image: 'gallerySlide4' },
              { label: 'Kleidung', image: 'gallerySlide5' },
              { label: 'Haustier', image: 'gallerySlide6' },
            ],
          },
          section6: {
            title: 'Automatische Höhenverstellung',
            workspace: '150 x 150 x 148 mm',
            subtitle: 'Größerer Arbeitsbereich in kompaktem Gehäuse',
            description:
              'Trotz seiner kompakten Größe bietet der A1C einen beeindruckend großen Arbeitsbereich von 150 x 150 mm',
            emDash: '—',
            descriptionEnd:
              'groß genug für echte, praktische Projekte. Erstelle Untersetzer, Lederwaren, kleine Ornamente und personalisierte Geschenke mit Leichtigkeit.',
          },
          section7: {
            title:
              "15.000 mm/min<br class='br_mb' /> Hochgeschwindigkeits-Gravieren",
            subtitle:
              "Führende Geschwindigkeit in seiner Klasse –<br class='br_mb' /> weniger Wartezeit, flüssigere Erstellung.",
          },
          section8: {
            class1: 'Klasse 1',
            eyeSafe: ' augenschonend',
            noGoggles: 'Keine Schutzbrille erforderlich',
            noGogglesEnd: ' für die tägliche Nutzung.',
            safetyTabs: [
              {
                title: 'Vollständig geschlossenes Schutzdesign',
                description:
                  'Blockiert effektiv schädliche Laserexposition und behält gleichzeitig einen klaren, sichtbaren Arbeitsbereich.',
                image: 'safetyTab1',
              },
              {
                title: 'Intelligente Flammenerkennung für sicheres Gravieren',
                description:
                  'Stoppt den Betrieb automatisch, wenn Flammen erkannt werden, mit Summerwarnungen und sofortigen Benachrichtigungen an PC und App.',
                image: 'safetyTab2',
              },
              {
                title: 'Kippschutz',
                description:
                  'Schaltet die Maschine automatisch aus, wenn abnormales Kippen erkannt wird.',
                image: 'safetyTab3',
              },
              {
                title: 'USB-Sicherheitssperre',
                description:
                  'Verhindert versehentliche Bedienung und schützt Kinder.',
                image: 'safetyTab4',
              },
            ],
          },
          section9: {
            title: 'Kostenlose, benutzerfreundliche Software-Studio',
            subtitle:
              'Leistungsstarke Werkzeuge, die für Anfänger benutzerfreundlich bleiben',
            fdsTitle: 'Kostenloses FDS Studio',
            fdsDesc:
              'Saubere Oberfläche, intuitive Bedienelemente und Echtzeit-Vorschau<br class="br_mb"/>für mühelose Erstellung.',
            features: [
              {
                title: 'Vollständige LightBurn-Kompatibilität',
                description:
                  'Erweiterte Werkzeuge für Ersteller, die tiefere Kontrolle und professionelle Ergebnisse wünschen.',
              },
              {
                title: 'Multi-Geräte-Steuerung',
                description:
                  'Bedienung über PC oder Mobile App mit WLAN-, Bluetooth-<br class="br_mb"/>und USB-Konnektivität für flexible Arbeitsabläufe.',
              },
            ],
          },
          section10: {
            title: 'Smarte Technologie, die alles verbessert',
            aiTabs: [
              {
                title: 'KI-Filterlabor',
                description:
                  'Wechsle zwischen verschiedenen professionellen Stilen und aktualisiere deine kreativen Ressourcen mit einem Klick.',
                video: 'aiVideo1',
              },
              {
                title: 'KI-Konturerkennung',
                description:
                  'Erkennt automatisch Farben und trennt Ebenen, wandelt Bilder in farbige Vektorebenen um, die ideal für mehrfarbige Gravuren sind – Farbgravur wird schneller und einfacher.',
                video: 'aiVideo2',
              },
              {
                title: 'KI-Hintergrundentfernung',
                description:
                  'Erkennt automatisch Objektkanten, um glatte, hochwertige transparente Bilder für schnellere Arbeitsabläufe zu erstellen.',
                video: 'aiVideo3',
              },
              {
                title: 'KI-Smart-Fill & Layout',
                description:
                  'Erkennt automatisch identische Materialien und wendet optimierte Muster für 60 % schnellere Stapelgravur an.',
                video: 'aiVideo4',
              },
            ],
            featureSlides: [
              {
                title: 'Umfangreiche Projektbibliothek, endlose Inspiration',
                description:
                  'Die Craftseek-Bibliothek bietet Tausende kostenloser, hochwertiger Projektdesigns. Mit einem Klick herunterladen und loslegen – Ihrer Kreativität geht nie die Inspiration aus!',
                image: 'featureSlide1',
              },
              {
                title: 'App KI-Ein-Tippen-Gravur',
                description:
                  'Laden Sie ein Foto hoch oder machen Sie eines mit Ihrem Handy. KI wandelt es automatisch in gravierfertige Stile wie Strichzeichnungen oder Illustrationen um, optimiert das Bild und wählt die richtigen Materialeinstellungen. Mit einem Tippen starten – Anfänger können mühelos hochwertige Gravuren erstellen.',
                image: 'featureSlide2',
              },
              {
                title: 'KI-Support-Assistent',
                description:
                  'Wenn das Gerät einen Alarm erkennt, stellt der KI-Assistent automatisch die richtige Lösung bereit. KI + menschlicher Support gewährleistet eine sorgenfreie Erfahrung von der Einrichtung bis zur Produktion.',
                image: 'featureSlide3',
              },
              {
                title: 'Cloud-Speicher',
                description:
                  'Unterstützt cloudbasierte Dateispeicherung mit nahtlosem Zugriff über Geräte hinweg. Ihre Designs können jederzeit direkt auf den Touchscreen heruntergeladen werden – beginnen Sie mit dem Gravieren, wann immer die Inspiration zuschlägt.',
                image: 'featureSlide4',
              },
              {
                title: 'Materialtest-Anordnung',
                description:
                  'Generiert automatisch ein Raster mit mehreren Leistungs- und Geschwindigkeitskombinationen in einem einzigen Auftrag und hilft Ihnen, schnell die besten Einstellungen für neue Materialien zu finden und Versuch und Irrtum zu reduzieren.',
                image: 'featureSlide5',
              },
              {
                title: 'Bildtrennung und -schließung',
                description:
                  'Trennt automatisch komplexe Grafiken in unabhängige Elemente und repariert nicht geschlossene Vektorlinien, um genaue Laserpfade und zuverlässige, hochwertige Verarbeitung sicherzustellen.',
                image: 'featureSlide6',
              },
            ],
          },
          section11: {
            title: 'Tragbar, flexibel und wartungsarm',
            engraveCups: 'Graviere Tassen und Kugeln',
            engraveCupsDesc:
              'Graviere mühelos Trinkbecher, Tassen, kugelförmige Ornamente und verschiedene gebogene oder zylindrische Gegenstände.',
            maintenanceTitle: 'Einfache Wartung,<br/>einfache Reinigung',
            maintenanceDesc:
              'Das Schnellspanner-Lüfterdesign macht die tägliche Reinigung einfach und unkompliziert.',
            portableTitle: 'Tragbar und einsatzbereit',
            portableDesc:
              'Leicht und einfach zu bewegen – Beginne jederzeit in deinem Wohnzimmer, einer Garage oder einem Studio zu schaffen.',
            portablePanels: [
              { image: 'portablePanel1', playIcon: 'portable1' },
              { image: 'portablePanel2', playIcon: 'portable1' },
              { image: 'portablePanel3', playIcon: 'portable2' },
            ],
            airPurifierTitle:
              'Optionaler Luftreiniger<br/>für sorgenfreies Schaffen',
            airPurifierDesc:
              'Filtert effektiv Rauch und Gerüche, die beim Gravieren entstehen, ideal für den Heim- und Innenbereich.',
            fixtureTitle: 'Flexible Vorrichtungserweiterung',
            fixtureDesc:
              'Erschließe mehr kreative Szenarien und erkunde neue Möglichkeiten mit flexiblen Spannvorrichtungsoptionen.',
          },
          section12: {
            inBox: 'Lieferumfang',
            inBoxModal: {
              title: 'Lieferumfang',
              machineLabel: 'Laserschneider und -gravierer:',
              variants: [
                { label: 'Purpurgrau<br />5W', imageKey: 'inBoxVariantPg5w' },
                { label: 'Weiß<br />5W', imageKey: 'inBoxVariantWhite5w' },
                { label: 'Purpurgrau<br />10W', imageKey: 'inBoxVariantPg10w' },
                { label: 'Weiß<br />10W', imageKey: 'inBoxVariantWhite10w' },
              ],
              items: [
                {
                  name: 'Netzteil:',
                  imageKey: 'inBoxItem1',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Netzkabel:',
                  imageKey: 'inBoxItem2',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Abluftschlauch:',
                  imageKey: 'inBoxItem3',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Type-A auf<br />Type-C-Kabel:',
                  imageKey: 'inBoxItem4',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Staubfreie Bürste:',
                  imageKey: 'inBoxItem5',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'M2/M2.5<br />Inbusschlüssel:',
                  imageKey: 'inBoxItem6',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Type-A auf<br />Type-C-Adapter:',
                  imageKey: 'inBoxItem7',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Schlauchschelle:',
                  imageKey: 'inBoxItem8',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Staubfreies Tuch:',
                  imageKey: 'inBoxItem9',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Schnellstart-<br />anleitung:',
                  imageKey: 'inBoxItem10',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Sicherheits-<br />hinweise:',
                  imageKey: 'inBoxItem11',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Kamera-<br />Kalibrierungskarte:',
                  imageKey: 'inBoxItem12',
                  values: ['√', '/', '√', '/'],
                  highlightValues: !0,
                },
                {
                  name: 'Schneidplatte:',
                  imageKey: 'inBoxItem13',
                  values: ['/', '/', '√', '√'],
                  highlightValues: !0,
                },
                {
                  name: 'Materialhalte-<br />schraube:',
                  imageKey: 'inBoxItem14',
                  values: ['2', '2', '2', '2'],
                },
                {
                  name: 'Sicherheitsschlüssel:',
                  imageKey: 'inBoxItem15',
                  values: ['2', '2', '2', '2'],
                },
                {
                  name: 'Lindenholzplatte:',
                  imageKey: 'inBoxItem16',
                  values: ['3', '3', '3', '3'],
                },
                {
                  name: 'Lasergravur-<br />Fotopapier:',
                  imageKey: 'inBoxItem17',
                  values: ['7', '3', '7', '3'],
                  highlightValues: !0,
                },
              ],
            },
            accessoriesTitle:
              'Gebaut zum Anpassen.<br class="br_mb"/>Gemacht für mehr Kreativität.',
            learnMore: 'Mehr erfahren',
            accessories: [
              {
                title: 'Luftreiniger',
                description:
                  'Reinigt Rauch und Gerüche, die beim Gravieren entstehen, trägt zur Verbesserung der Gravierqualität bei und erhält eine sauberere Innenumgebung.',
                active: !0,
              },
              {
                title: 'Flexible Vorrichtung',
                description:
                  'Schnelles einstufiges Spannen für unregelmäßige und speziell geformte Objekte, ohne wiederholte Einstellungen für die Stapelgravur erforderlich.',
                active: !0,
              },
              {
                title: 'Abluftventilator',
                description:
                  'Entfernt kraftvoll Dämpfe, die beim Gravieren entstehen, und trägt zur Verbesserung der Gravierqualität bei.',
                active: !0,
              },
              {
                title: 'Rotationsvorrichtungen',
                description:
                  'Unterstützt eine stabile Rotationsgravur für zylindrische und runde Objekte wie Tassen, Ringe, Armbänder und mehr.',
                active: !1,
              },
            ],
          },
          section13: {
            title: 'Technische Daten',
            labels: [
              'Produktname:',
              'Produktfarbe',
              'Unterstützte Lasermodule:',
              `Austauschbare
Lasermodule:`,
              'Gravierbereich:',
              'Maximale Verarbeitungshöhe',
              'Lasersicherheit:',
              `Max.
Arbeits-
geschwindigkeit`,
              'Fokusmodus',
              'Kamera:',
              `Kamera-gestützte
Positionierung`,
              'KI-Smart-Fill & Layout',
              'Optionale Pakete:',
              'IoT-Steuerung:',
              'APP-Steuerung:',
              'Geräteabmessungen',
              `Verpackungs-
abmessungen:`,
              `Nettogewicht
(nur Gerät):`,
              `Nettogewicht
(einschließlich Netzteil):`,
            ],
            variants: [
              {
                name: 'Falcon A1C',
                color: 'Purpurgrau',
                laserModules: '5-W-Diode | 10-W-Diode | 1,2 W IR',
                interchangeable: '✓',
                engravingArea: '150 x 150 mm',
                maxHeight: '148 mm',
                laserSafety: `Klasse-1-Lasersicherheit
Flammenerkennung
Kippschutz
USB-Sicherheitssperre`,
                maxSpeed: '15000 mm/min',
                focusMode: 'Autofokussieren',
                camera: '✓',
                cameraAssist: '✓',
                aiFill: '✓',
                optionalPackages: 'Rotationskit, Rauchfilter',
                iotControl: 'Wi-Fi + BLE, IoT-Steuerung',
                appControl: 'Kabellose APP-Steuerung',
                machineDim: '336 mm x 377 mm x 341 mm',
                packageDim: '470 mm x 395 mm x 410 mm',
                netWeight: '9,8 kg',
                grossWeight: '10,5 kg',
              },
              {
                name: 'Falcon A1C',
                color: 'Weiß',
                laserModules: '5-W-Diode | 10-W-Diode | 1,2 W IR',
                interchangeable: '✓',
                engravingArea: '150 x 150 mm',
                maxHeight: '148 mm',
                laserSafety: `Klasse-1-Lasersicherheit
Flammenerkennung
Kippschutz
USB-Sicherheitssperre`,
                maxSpeed: '15000 mm/min',
                focusMode: 'Autofokussieren',
                camera: '×',
                cameraAssist: '×',
                aiFill: '×',
                optionalPackages: 'Rotationskit, Rauchfilter',
                iotControl: 'Wi-Fi + BLE, IoT-Steuerung',
                appControl: 'Kabellose APP-Steuerung',
                machineDim: '336 mm x 377 mm x 341 mm',
                packageDim: '470 mm x 395 mm x 410 mm',
                netWeight: '9,7 kg',
                grossWeight: '10,4 kg',
              },
            ],
          },
        },
        fN = {},
        Cm =
          'https://cdn.creality.com/ow/a1c/d52f62b5-cb48-463a-a676-83b331e1f119.png',
        Om = {
          heroBg:
            'https://cdn.creality.com/ow/a1c/af31945a-c45d-455d-a5ce-f71b35810b5e.jpg',
          heroBgMobile:
            'https://cdn.creality.com/ow/a1c/36cf3045-18e9-4c6b-ac31-cf5a3d55c719.jpg',
          materialsIcon:
            'https://cdn.creality.com/ow/a1c/4e527187-2a3b-427d-8d2d-4c5c14dd5124.png',
          materialsIconMobile:
            'https://cdn.creality.com/ow/a1c/4e527187-2a3b-427d-8d2d-4c5c14dd5124.png',
          scenario1:
            'https://cdn.creality.com/ow/a1c/b045960c-474a-40e0-96e2-31817b3110e3.jpg',
          scenario2:
            'https://cdn.creality.com/ow/a1c/46161c67-3521-4979-8be4-5dd58c3b2e51.jpg',
          scenario3:
            'https://cdn.creality.com/ow/a1c/356a4acf-2fde-429d-9117-e2e6337854c9.jpg',
          scenario4:
            'https://cdn.creality.com/ow/a1c/37ba10d6-54fa-4081-8fdb-f2cf03d9825c.jpg',
          easyUseVideo1:
            'https://compress-file.creality.com/videos/Agent/2ebcbe33-0796-4a03-90f9-694de42ebd61.mp4',
          easyUseVideo2:
            'https://compress-file.creality.com/videos/Agent/d26a36df-f8fc-46fe-b192-0fd23b7e47fe.mp4',
          easyUseVideo3:
            'https://compress-file.creality.com/videos/miulinfeng/fbd76f10-3186-4203-8e79-db77fcaf5cf6.mp4',
          easyUse4:
            'https://cdn.creality.com/ow/a1c/e3d89bd6-e26d-4fe7-a7bb-2672be92dcdf.jpg',
          stability1:
            'https://cdn.creality.com/ow/a1c/353f2e70-64ad-4764-82ee-47f8fe115a38.jpg',
          stability2:
            'https://cdn.creality.com/ow/a1c/8e6737d4-964c-4713-b247-2e550a820fdf.jpg',
          stability3:
            'https://cdn.creality.com/ow/a1c/bd6920ac-1265-4f0b-bde6-a50475697617.jpg',
          speedBg:
            'https://cdn.creality.com/ow/a1c/2d38d0f0-5957-45eb-8ce6-1eea12a725e1.jpg',
          speedBgMobile:
            'https://cdn.creality.com/ow/a1c/a7a0c35c-a007-4abb-9ea3-0021a0ec6bc7.jpg',
          stabilityHero:
            'https://cdn.creality.com/ow/a1c/b4eff893-f97e-47f8-8854-e22f2f7bb9d7.jpg',
          stabilityHeroMobile:
            'https://cdn.creality.com/ow/a1c/8c90d0b4-1d6d-404a-afa1-1abe93e0a60c.jpg',
          workspaceBg:
            'https://cdn.creality.com/ow/a1c/6acb5b47-e6f8-42b9-b779-d7d16fa03b40.jpg',
          workspaceBgMobile:
            'https://cdn.creality.com/ow/a1c/a3d18b2a-591b-4a13-9e57-92a744dc8e47.jpg',
          workspaceCard1:
            'https://cdn.creality.com/ow/a1c/5c428bfc-0734-4464-ae9b-89e7cecb67cb.jpg',
          workspaceCard2:
            'https://cdn.creality.com/ow/a1c/ddd2c3fd-c9b2-401e-a5d4-944a8674e51b.jpg',
          workspaceCard3:
            'https://cdn.creality.com/ow/a1c/0022432a-34f9-441c-a683-eb50476e46ae.jpg',
          safetyHeaderBg:
            'https://cdn.creality.com/ow/a1c/4f258b7a-4314-4010-8e36-5e505e34bdcf.jpg',
          safetyHeaderMobile:
            'https://cdn.creality.com/ow/a1c/fc35f1e5-7c83-4295-8469-aa3a431e642a.jpg',
          safetyTab1:
            'https://cdn.creality.com/ow/a1c/627f4ea2-017a-4cce-b432-2221c5c707f0.jpg',
          safetyTab2:
            'https://cdn.creality.com/ow/a1c/47609cd1-9550-444d-ba03-0d90038776f1.jpg',
          safetyTab3:
            'https://cdn.creality.com/ow/a1c/b137ffca-2fea-4571-9369-7e79caa33d91.jpg',
          safetyTab4:
            'https://cdn.creality.com/ow/a1c/bfb5e6a1-26bf-4b71-ad4d-6af8d53b57b3.jpg',
          safetyTab1Mobile:
            'https://cdn.creality.com/ow/a1c/7ba06344-01a2-4ed9-aba9-634f698a4b3f.jpg',
          safetyTab2Mobile:
            'https://cdn.creality.com/ow/a1c/57510e87-076a-4d67-beef-0743705c8f93.jpg',
          safetyTab3Mobile:
            'https://cdn.creality.com/ow/a1c/a3100381-b1bc-4401-b7f8-1ca44a084bbd.jpg',
          safetyTab4Mobile:
            'https://cdn.creality.com/ow/a1c/c4760806-80c8-47f0-8e44-f1c3e5e706dc.jpg',
          softwareMain:
            'https://cdn.creality.com/ow/a1c/a66ddf29-db1a-4d38-b642-cfa9150deb18.jpg',
          softwareMainMobile:
            'https://cdn.creality.com/ow/a1c/d69acec5-ebd4-440c-bc4a-fee712db354c.jpg',
          softwarePC:
            'https://cdn.creality.com/ow/a1c/ef1fca57-3bc1-43b1-a325-0dff49e2f267.png',
          softwareDevices:
            'https://cdn.creality.com/ow/a1c/b0c3cf8d-2abd-44f8-8462-4ee0a1221301.png',
          aiVideo1:
            'https://compress-file.creality.com/videos/Agent/379b844a-1d94-4dae-aa82-d4083514e0cc.mp4',
          aiVideo2:
            'https://compress-file.creality.com/videos/Agent/90e083c9-1f98-431d-ae26-e89d5f12c624.mp4',
          aiVideo3:
            'https://compress-file.creality.com/videos/Agent/bc7e45e4-8929-4126-a4ae-9962463806be.mp4',
          aiVideo4:
            'https://compress-file.creality.com/videos/Agent/74bef867-1ba8-4e9d-a4fa-6bf95bdf45dc.mp4',
          featureSlide1:
            'https://cdn.creality.com/ow/a1c/11e77808-8031-4361-9424-ce719703636a.jpg',
          featureSlide2:
            'https://cdn.creality.com/ow/a1c/cfbdf454-7a56-4be9-b1a1-c39c69d28aad.jpg',
          featureSlide3:
            'https://cdn.creality.com/ow/a1c/dba8a26d-1825-420a-9a21-c5cfec80a714.jpg',
          featureSlide4:
            'https://cdn.creality.com/ow/a1c/fe99df30-c435-40f7-8b26-8b03330a2e98.jpg',
          featureSlide5:
            'https://cdn.creality.com/ow/a1c/d90650fa-8860-4865-bc3c-d585add8cb3d.jpg',
          featureSlide6:
            'https://cdn.creality.com/ow/a1c/367fded3-8470-4b54-9c21-0229d59491c2.jpg',
          section11EngraveCups:
            'https://cdn.creality.com/ow/a1c/c5fc32ec-552a-44c3-aad4-31470d3bbd9e.jpg',
          section11Maintenance:
            'https://cdn.creality.com/ow/a1c/a3e0aac5-dae1-4e26-90fe-ba5773badc8f.jpg',
          section11AirPurifier:
            'https://cdn.creality.com/ow/a1c/7edf0680-7535-40e0-9f62-8e5da3349898.jpg',
          section11Fixture:
            'https://cdn.creality.com/ow/a1c/65a34776-7279-422c-8257-2221358d9df9.jpg',
          portablePanel1:
            'https://cdn.creality.com/ow/a1c/e467b7e2-d5b7-4b27-b1ea-a94df9544753.jpg',
          portablePanel2:
            'https://cdn.creality.com/ow/a1c/1b412de0-1262-4cd0-af3b-0f62b143310b.jpg',
          portablePanel3:
            'https://cdn.creality.com/ow/a1c/0c2fd857-56de-4a87-9fac-6d5d35f190ba.jpg',
          portable1: Cm,
          portable2: Cm,
          accessoryAirPurifier:
            'https://cdn.creality.com/ow/a1c/f3a7416d-7f4c-443a-898d-049c47a93078.png',
          accessoryFixture:
            'https://cdn.creality.com/ow/a1c/0a8e013a-2634-4923-a03e-adadad3a86b2.png',
          accessoryFan:
            'https://cdn.creality.com/ow/a1c/36d185d2-2849-4ad3-b707-bfd91d1d12a8.png',
          accessoryRotary:
            'https://cdn.creality.com/ow/a1c/81729712-207b-45ff-b72d-a557b7abd9d7.png',
          specTable1:
            'https://cdn.creality.com/ow/a1c/f5c423b4-97d1-4aa7-a05c-ad14c73f4d79.png',
          specTable2:
            'https://cdn.creality.com/ow/a1c/4f6d443a-d609-400e-86f8-c6058ba18238.png',
          diodeSlide1:
            'https://compress-file.creality.com/images/Agent/d4a0f0d3-efa4-4845-bd25-e6edfd7adb7a.webp',
          diodeSlide2:
            'https://compress-file.creality.com/images/Agent/79865372-6529-41db-8c73-6e5ccc11e7ff.webp',
          diodeSlide3:
            'https://compress-file.creality.com/images/Agent/252a5f6c-8b04-43f6-ae41-4bde68dcbb51.webp',
          diodeSlide4:
            'https://compress-file.creality.com/images/Agent/f0684c88-0708-4ce4-8c96-5eba50756b5e.webp',
          diodeSlide5:
            'https://compress-file.creality.com/images/Agent/c8d20dc2-fdbc-418e-81b1-5fddc32409f9.webp',
          diodeSlide6:
            'https://compress-file.creality.com/images/Agent/13de810c-e448-48e6-887a-c3c22e57687a.webp',
          diodeSlide7:
            'https://compress-file.creality.com/images/Agent/ee11082d-4043-4536-8a76-f2aeda18409d.webp',
          diodeSlide8:
            'https://compress-file.creality.com/images/Agent/175c1bd8-bd23-41fa-8091-14d1d4bcf428.webp',
          diodeSlide1Mobile:
            'https://compress-file.creality.com/images/Agent/8756a8c5-9178-47a0-a2ba-42eb8e16213f.webp',
          diodeSlide2Mobile:
            'https://compress-file.creality.com/images/Agent/0b9f30a6-3ce6-4284-8ff2-404bae7bfe55.webp',
          diodeSlide3Mobile:
            'https://compress-file.creality.com/images/Agent/6fe5a1f1-d306-45ac-817d-260aa2769433.webp',
          diodeSlide4Mobile:
            'https://compress-file.creality.com/images/Agent/11fb9822-99b7-4f27-86c8-b8b2e51027e9.webp',
          diodeSlide5Mobile:
            'https://compress-file.creality.com/images/Agent/efe3395e-1af5-400c-bddf-d39dd50c8409.webp',
          diodeSlide6Mobile:
            'https://compress-file.creality.com/images/Agent/e69a771b-c69e-435c-9107-dae61b0bcc61.webp',
          diodeSlide7Mobile:
            'https://compress-file.creality.com/images/Agent/e9d1ad31-197b-4b4d-8ed7-6a82f6a4dc5f.webp',
          diodeSlide8Mobile:
            'https://compress-file.creality.com/images/Agent/4d213209-0777-4c94-b02d-1481daed8bb7.webp',
          diodeIndicator1:
            'https://cdn.creality.com/ow/a1c/fb90f520-372c-4920-b131-2825e93e3e08.png',
          diodeIndicator2:
            'https://cdn.creality.com/ow/a1c/222965ef-8ccc-4a03-8ddc-9494ed1f93fb.png',
          diodeIndicator3:
            'https://cdn.creality.com/ow/a1c/399e5b07-e21d-4d49-b3a8-ab4615cb2df8.png',
          diodeIndicator4:
            'https://cdn.creality.com/ow/a1c/430d636c-b9d0-43d3-bc39-78f92de58d52.png',
          diodeIndicator5:
            'https://cdn.creality.com/ow/a1c/83567a72-1096-4df3-a5f6-b93eeec427c9.png',
          diodeIndicator6:
            'https://cdn.creality.com/ow/a1c/ae1c000b-e30c-4f18-8f6c-2a19438727c7.png',
          diodeIndicator7:
            'https://cdn.creality.com/ow/a1c/593c6e0d-0bce-4cf0-bf4c-3a50840ba637.png',
          diodeIndicator8:
            'https://cdn.creality.com/ow/a1c/9d786fc6-e598-44e1-8a79-eb46eb41a7e7.png',
          irSlide1:
            'https://compress-file.creality.com/images/Agent/e48b0397-a764-4a61-9248-f9dbe889a706.webp',
          irSlide2:
            'https://compress-file.creality.com/images/Agent/7d217b1c-0cd9-448d-9aec-62e5ff6d5a8b.webp',
          irSlide3:
            'https://compress-file.creality.com/images/Agent/c3a29818-72ff-4413-8af8-1523175db94a.webp',
          irSlide4:
            'https://compress-file.creality.com/images/Agent/9804a2e4-5af5-437f-b05c-1b446fab4c74.webp',
          irSlide1Mobile:
            'https://compress-file.creality.com/images/Agent/ef5d0a09-793c-453e-930e-de8786d93e02.webp',
          irSlide2Mobile:
            'https://compress-file.creality.com/images/Agent/444de37a-a53d-4c12-85a4-a4e15f6a6856.webp',
          irSlide3Mobile:
            'https://compress-file.creality.com/images/Agent/b6d02949-27d4-474e-959c-b1959775c85f.webp',
          irSlide4Mobile:
            'https://compress-file.creality.com/images/Agent/ca343ea5-6259-44da-8145-aabcefe7ec95.webp',
          irIndicator1:
            'https://cdn.creality.com/ow/a1c/51f4ff6f-98ab-443d-a251-889c5eb3928e.png',
          irIndicator2:
            'https://cdn.creality.com/ow/a1c/f965744e-f0f5-4bee-be31-93033efd1458.png',
          irIndicator3:
            'https://cdn.creality.com/ow/a1c/a31fef0f-3b9b-4acc-afd1-975479ebdf3e.png',
          irIndicator4:
            'https://cdn.creality.com/ow/a1c/69abb35e-3c91-407b-9ce7-bb928b3ae304.png',
          gallerySlide1:
            'https://cdn.creality.com/ow/a1c/9c9b908b-fb5f-4981-8a53-a99a2ce8b2f5.jpg',
          gallerySlide2:
            'https://cdn.creality.com/ow/a1c/fb511449-6cf8-492c-a1db-b71a73723028.jpg',
          gallerySlide3:
            'https://cdn.creality.com/ow/a1c/9990bb06-415b-48c4-8b6a-2803ac98331f.jpg',
          gallerySlide4:
            'https://cdn.creality.com/ow/a1c/2d2b18aa-8cef-4379-8fee-76eb1dc5310c.jpg',
          gallerySlide5:
            'https://cdn.creality.com/ow/a1c/26cd50dd-6634-4308-9b57-93c80d482713.jpg',
          gallerySlide6:
            'https://cdn.creality.com/ow/a1c/25f7fbc7-70b8-41bf-9735-15b81a91be9a.jpg',
          highlight1:
            'https://cdn.creality.com/ow/a1c/85d0a10b-90b7-4191-94ba-6282643384e9.jpg',
          highlight2:
            'https://cdn.creality.com/ow/a1c/a16d4b59-7d97-40c1-bbb2-e7ad7914d56e.jpg',
          highlight3:
            'https://cdn.creality.com/ow/a1c/f8882d2a-1edc-4987-8729-d475ffafc7a4.jpg',
          highlight4:
            'https://cdn.creality.com/ow/a1c/df9ae666-e4f1-413a-8c95-6192b5f0d04f.jpg',
          highlight5:
            'https://cdn.creality.com/ow/a1c/d4ed4280-53de-4bec-8840-e784dff0e2af.jpg',
          highlight6:
            'https://cdn.creality.com/ow/a1c/2d7fbe02-273d-4458-aa87-850c35ba3508.jpg',
          highlight7:
            'https://cdn.creality.com/ow/a1c/e402112e-9ccb-4867-921b-80f948e358be.jpg',
          highlight8:
            'https://cdn.creality.com/ow/a1c/a0c5ae3b-20bc-40f6-8d17-3a8d9132e03f.jpg',
          highlight1Mobile:
            'https://cdn.creality.com/ow/a1c/9db34ded-2f6e-4b91-b700-5aecb6e2b092.jpg',
          highlight2Mobile:
            'https://cdn.creality.com/ow/a1c/9d6e2c53-cc40-4335-b32d-6887fdf85efe.jpg',
          highlight3Mobile:
            'https://cdn.creality.com/ow/a1c/dbe31ebc-3770-4f56-a0ba-90ae6ad8b790.jpg',
          highlight4Mobile:
            'https://cdn.creality.com/ow/a1c/816b3242-f650-4abf-801f-640b1558f347.jpg',
          highlight5Mobile:
            'https://cdn.creality.com/ow/a1c/69ff284d-23a1-4d83-981e-d09f5e7b2415.jpg',
          highlight6Mobile:
            'https://cdn.creality.com/ow/a1c/4b14d9d1-d7a9-4fd6-b95d-cd1beac4ff2b.jpg',
          highlight7Mobile:
            'https://cdn.creality.com/ow/a1c/e205dcc2-9eb7-4feb-8bab-8678c89920e1.jpg',
          highlight8Mobile:
            'https://cdn.creality.com/ow/a1c/20fcb282-166d-4714-943f-8223870cf891.jpg',
          ...fN,
          ...iE,
        },
        hN = {
          en: { translation: uN, imageUrl: Om },
          de: { translation: dN, imageUrl: Om },
        };
      Ks.use(vv).init({
        resources: hN,
        lng: Kv(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
      });
      function mN(i) {
        const l = {
          cn: 'zh-CN',
          en: 'en-US',
          br: 'pt-BR',
          de: 'de-DE',
          es: 'es-ES',
          fr: 'fr-FR',
          it: 'it-IT',
          jp: 'ja-JP',
          kr: 'ko-KR',
          ru: 'ru-RU',
        };
        document.documentElement.lang = l[i] || 'en-US';
      }
      mN(Ks.language);
      const Ac = document.getElementById('product-detail-a1c'),
        Bm = g.jsx(Y.StrictMode, {
          children: g.jsx(Tv, { i18n: Ks, children: g.jsx(cN, {}) }),
        });
      Ac.hasChildNodes()
        ? Jh.hydrateRoot(Ac, Bm)
        : Jh.createRoot(Ac).render(Bm);
})();